// USA
export const locale = {
	lang: 'en',
	data: {
		WHAT_IF: {
			SIMULATION: { ACTUAL_VALUE: 'Actual Value' },
			GRAPH: {
				BASELINE_TIMESTAMP: 'Baseline timestamp',
				NO_DATA: 'No data found!',
				RUN_SIMULATION_TITLE: 'Run a simulation to see chart results',
				RUN_SIMULATION_HINT: 'Click "Run" after configuring your simulation parameters.',
				RAW_TAG_DEPENDENCY: 'Raw Tag Dependency',
				BASELINE: 'Baseline',
				SIMULATION: 'Simulation',
				SIMULATED: 'Simulated',
			},
			SEARCH: {
				PLACEHOLDER: 'Search facility, system, unit or tag',
				SEARCHING: 'Searching…',
				NO_RESULTS: 'No matches found',
				ERROR: 'Search failed. Please try again.',
			},
			TABLE: {
				DELTA_TOOLTIP: 'Absolute change (Simulated − Baseline)',
				DELTA_PERCENT_TOOLTIP: 'Percentage change from baseline',
				IMPACT_PROGRESS: 'Impact Progress',
				IMPACT: 'Impact',
			},
			IMPACTED_KPI: {
				TITLE: 'Impacted Calculated KPIs ({{count}})',
				NO_IMPACTED_KPIS: 'No impacted KPIs yet',
				EMPTY_HINT: 'Select raw tags on the left to see downstream KPI impact.',
				LOADING: 'Loading calculated tags...',
				SELECTION_HINT: '{{checked}} of {{total}} KPIs selected in primary system — uncheck to exclude from simulation. Driven-by chips show which raw tags impact each KPI. Sibling systems sharing the same tag signature are listed below as read-only cross-system impacts.',
				CROSS_SYSTEM_IMPACT: 'Cross-system impact',
				KPI_COUNT: '{{count}} KPIs',
				TAG_PARAMETER: 'Tag / Parameter',
				CALCULATED_TAG: 'Calculated Tag',
				DRIVEN_BY: 'Driven by:',
			},
			PAGE: {
				TITLE: 'What-If',
				SELECT_RAW_TAGS_TITLE: 'Select Raw tags to Simulate',
				SELECT_RAW_TAGS_SUBTITLE: 'Pick tags from the hierarchy below',
				SIMULATION_SETUP_TITLE: 'Simulation Setup',
				SIMULATION_SETUP_SUBTITLE: 'Select tags above to begin',
				RUN: 'Run',
				RESET: 'Reset',
				NO_TAGS_SELECTED: 'No tags selected',
				NO_TAGS_SELECTED_DESC: 'Pick raw tags above to define changes.',
				CLICK_TIMESTAMP_HINT: 'Click anywhere on the plot to select an operating state timestamp.',
				CLICK_RANGE_HINT: 'Click twice on the plot to select the operating state range.',
				SELECTED_OPERATING_STATE: 'Selected Operating State:',
				SELECTED_OPERATING_RANGE: 'Selected Operating Range:',
				FIRST_POINT_PREFIX: 'First point:',
				FIRST_POINT_SUFFIX: '— click again to set the range end.',
				SIMULATION_RESULTS: 'Simulation Results',
				TABLE_VIEW: 'Table View',
				RUN_SIMULATION_TABLE_TITLE: 'Run a simulation to see table results',
				TABLE_UNAVAILABLE_PERIOD: 'Table View is not available for Period simulations',
				SWITCH_TO_SINGLE_POINT: 'Switch to "Single point" mode or use the Graph View tab.',
				NO_KPI_ROWS: 'No KPI rows to display',
				NO_KPI_ROWS_DESC: 'All impacted KPIs are unchecked. Select KPIs in the Impacted KPIs tab to see them here.',
				GRAPH_VIEW: 'Graph View',
				SIMULATION_TYPE_PERCENT: '% Change',
				SIMULATION_TYPE_ABSOLUTE: 'Absolute Value',
				TIME_CONTEXT_SINGLE: 'Single point',
				TIME_CONTEXT_PERIOD: 'Period',
			},
			IMPACTED_KPIS_TAB_LABEL: 'Impacted KPIs',
			IMPACTED_KPIS_TAB_LABEL_COUNT: 'Impacted KPIs ({{count}})',
			HIERARCHY_TOOLTIP: {
				TAG_NAME: 'Tag Name',
				TAG_ID: 'Tag ID',
				TAG_DESCRIPTION: 'Description',
				ASSET_NAME: 'Asset Name',
				SYSTEM_NAME: 'System Name',
			},
		},
		TRANSLATOR: {
			SELECT: 'Select your language',
		},
		VALIDATION: {
			REQUIRED: 'This field is required',
			PATTERN: 'Invalid format',
			MIN: 'Value is too small',
			MAX: 'Value is too large',
			MIN_LENGTH: 'Value is too short',
			MAX_LENGTH: 'Value is too long',
			SELECT_AT_LEAST_ONE: 'Select at least one option',
			INVALID: 'Invalid value',
			FIELD_REQUIRED: '{{field}} is required',
		},
		COMMON: {
			NO_MATCHES: 'No results found for "{{keyword}}"',
			TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search',
			SELECT_A_SYSTEM: 'Select a system.',
			SELECT_DIFF_UNIT: 'Select a different unit or facility',
			SELECT_DIFF: 'Select a different facility, unit or system',
			NO_TAGS_FOUND: 'No tags found',
			SELECT_FACILITY: 'Select a different facility',
			ADDED_FROM_ROOTY: 'Added from {{name}}',
		},
		COMMENT_POPUP: {
			TITLE: 'Leave Comment',
			ENTER_MESSAGE: 'Enter your message',
			COMMENT_PLACEHOLDER: 'Add a comment, use @ to tag team members',
			FILE_SIZE_LIMIT_ERROR: '{{fileName}} failed to upload due to file size limit.',
			UPLOAD_FAILED_ERROR: '{{fileName}} failed to upload.',
			INVALID_FILES_ERROR: 'No valid files selected. Only files with extensions {{extensions}} are allowed',
		},
		REGENERATE_HYPOTHESES_POPUP: {
			TITLE: 'Regenerate Hypotheses',
			DESCRIPTION: 'All hypotheses will be regenerated using the feedback provided for the causal chain, recommendations, and proposed evidence. The current version will be saved in history.',
			REGENERATION_CONTEXT: 'Regeneration Context',
			TOTAL_FEEDBACKS: 'Total Feedbacks',
			ADDED_AS_EVIDENCE: 'Added as evidence',
			APPROVED: 'Approved',
			RELEARNED: 'Relearned',
			SETTINGS: 'Settings',
			DOCUMENT_INSIGHTS: 'Document Insights',
			SAP_INSIGHTS: 'SAP Insights',
			CONNECTED_SYSTEMS_REVIEW: 'Connected Systems Review',
			ALERT_REVIEW_WINDOW: 'Alert Review Window',
			DAYS: 'Days',
			RESET_AND_RERUN: 'Reset & Re-run',
			RESET_AND_RERUN_INFO: 'Ignore previous hypotheses, feedback, recommendations, and proposed evidence. RCA will be generated from scratch using only the latest available data.',
			VERSION_HISTORY_NOTE: 'Current hypotheses will be saved to version history. You can restore previous versions anytime.',
			USER_CONSENT: 'I understand that previous RCA context will not be used for this run.',
			CANCEL: 'Cancel',
			REGENERATE_ALL: 'Regenerate All',
			REGENERATE_ALL_TOOLTIP: 'Improve current RCA using existing context',
			RESET_AND_RERUN_BTN: 'Reset & Re-run',
			RESET_AND_RERUN_TOOLTIP: 'Generate a new RCA from scratch',
		},
		SHARE_REPORT_POPUP: {
			TITLE: 'Share Report',
			ADD_PEOPLE: 'Add People',
			MESSAGE: 'Message',
			MESSAGE_PLACEHOLDER: 'Enter your message (optional)',
			COPY_LINK: 'Copy link',
			CANCEL: 'Cancel',
			SEND: 'Send',
		},
		FEEDBACK_POPUP: {
			PREVIOUSLY_APPROVED: 'Previously Approved',
			PREVIOUSLY_RELEARNED: 'Previously Relearned',
			SEE_LESS: 'See Less',
			SEE_MORE: 'See More...',
			FEEDBACK_LABEL: 'Feedback',
			FEEDBACK_TOOLTIP: 'This feedback will be used during RCA re-run.',
			CANCEL: 'Cancel',
			CONFIRM: 'Confirm',
			RELEARNED_BY: 'Relearned By:',
			NO_REASON_ADDED: 'No reason added',
		},
		ASK_ROOTY_POPUP: {
			ENTER_MESSAGE_TO_START: 'Enter your message to start a chat',
			MESSAGE_PLACEHOLDER: 'Enter your message...',
		},
		ROOTY_CHAT: {
			FOLLOW_UP_SUGGESTIONS: 'Follow-up suggestions',
			ASK_TITLE: 'Ask {{name}}',
			UPLOAD_TOOLTIP: 'Upload PDF, Word, Excel, PNG, JPG and JPEG files for {{name}} to analyze.',
			DISCLAIMER: '{{name}} provides AI-assisted responses and may not always be accurate. Verify before taking action.',
			FEEDBACK_SUBTITLE: 'Select the main issue so we can improve future {{name}} responses.',
			POPUP_TITLE: 'Ask {{name}}',
			NOT_ENABLED: '{{name}} is not enabled for current user.',
			SHARE: 'Share',
			RENAME: 'Rename',
			DELETE: 'Delete',
			HISTORY: 'History',
			CLOSE: 'Close',
			SEARCH: 'Search...',
			UNSAVED: 'Unsaved',
			NO_HISTORY_HEADING: 'No history available.',
			NO_HISTORY_DESC: 'We couldn\'t find any historical data.',
			START_NEW_CHAT: 'Start New Chat',
			AGENT_CONTEXT_TOOLTIP: 'Agent Context',
			CHAT_HISTORY_TOOLTIP: 'Chat History',
			UNPIN: 'Unpin',
			PIN: 'Pin',
			FULL_SCREEN: 'Full screen',
			EXIT_FULL_SCREEN: 'Exit full screen',
			EXPAND: 'Expand',
			COLLAPSE: 'Collapse',
			INTRO_TITLE: 'Hello! Need help with what you\'re looking at?',
			INTRO_DESC: 'Ask me about anything or I can summarize this screen, explain trends, compare items, and suggest next steps.',
			SUGGESTIONS: 'Suggestions',
			SUGGESTION_1: 'Summarize this RCA in 30 seconds (what happened and why).',
			SUGGESTION_2: 'Which hypothesis is most supported by the evidence shown here?',
			SUGGESTION_3: 'Compare the hypotheses: what\'s the strongest evidence for each?',
			CP_INTRO_TITLE: 'Hello! Need help with Capacity Optimization and Scenario Planning?',
			CP_INTRO_DESC: 'I can help you build planning models, test unit tripping contingencies, simulate peak load growth, and analyze power & water feasibility outcomes.',
			CP_SUGGESTION_1: 'Summarize total generation cost, fuel burn, and station breakdown for this run.',
			CP_SUGGESTION_2: 'What is our spinning reserve headroom and are there any shortfall hours?',
			CP_SUGGESTION_3: 'What if H5_GT trips offline during peak demand?',
			CP_SUGGESTION_4: 'Simulate +5% peak power demand growth on this scenario.',
			LOADING_EARLIER: 'Loading earlier conversation…',
			SHOW_EARLIER: 'Show earlier conversation',
			RESPONSE_STOPPED: 'Response generation stopped',
			LOADING_ALT: 'Loading',
			THINKING: 'Thinking',
			THOUGHT_FOR: 'Thought for {{seconds}}s',
			DOWNLOAD_CSV: 'Download CSV',
			COPY_CSV: 'Copy CSV',
			DOWNLOAD_IMAGE: 'Download Image',
			COPY_IMAGE: 'Copy Image',
			WHAT_IF_SCENARIO_CREATED: 'What-If Scenario Created',
			CHANGE_APPLIED: 'Change applied:',
			NEW_SCENARIO: 'New scenario:',
			VIEW_CONFIGURATION: 'View Configuration',
			RUN_OPTIMIZATION: 'Run Optimization',
			RESULTS_COMPARISON: 'Results Comparison',
			ALL_IMPROVED: 'All improved',
			KPI: 'KPI',
			BASE: 'Base',
			WHAT_IF: 'What-If',
			YES: 'Yes',
			NO: 'No',
			CHANGED: 'changed',
			WHATIF_KPI_POWER_FEASIBLE: 'Power Feasible',
			WHATIF_KPI_WATER_FEASIBLE: 'Water Feasible',
			WHATIF_KPI_EST_COST: 'Est. Cost',
			WHATIF_KPI_POWER_SHORTFALL: 'Power Shortfall',
			WHATIF_KPI_WATER_SHORTFALL: 'Water Shortfall',
			WHATIF_KPI_AVG_GENERATION: 'Avg Generation',
			WHATIF_KPI_AVG_HEADROOM: 'Avg Headroom',
			WHATIF_KPI_TOTAL_STARTS: 'Total Starts',
			WHATIF_KPI_AVG_WATER_OUTPUT: 'Avg Water Output',
			WHATIF_KPI_GAP_PERCENT: 'Gap %',
			WHATIF_POWER_BALANCE: 'Power Balance (MW)',
			WHATIF_TIME_AXIS: 'Time',
			WHATIF_POWER_AXIS: 'Power (MW)',
			WHATIF_WATER_OUTPUT: 'Water Output (MIGD)',
			WHATIF_WATER_AXIS: 'Water (MIGD)',
			WHATIF_TRACE_DEMAND: 'Demand',
			WHATIF_TRACE_GEN: 'Gen',
			WHATIF_TRACE_WATER: 'Water',
			NO_MAJOR_DIFF: 'No KPI changed by more than 5% between the two scenarios.',
			VIEW_FULL_RESULTS: 'View full results',
			APPLY_AS_EVIDENCE: 'Apply as evidence',
			ADDED_AS_EVIDENCE: 'Added as evidence',
			ALREADY_ADDED_AS_EVIDENCE: 'Already added as evidence',
			ADD_AS_EVIDENCE: 'Add as evidence',
			BRANCH_VISIBILITY_NOTICE: 'New messages are visible only to you.',
			CONTINUE: 'Continue',
			SEARCH_SCENARIOS: 'Search scenarios...',
			FILTER_SCENARIOS: 'Filter Scenarios',
			SOURCE: 'Source',
			ALL_SOURCES: 'All Sources',
			HUMAN_MANUAL: 'Human (Manual)',
			AI_GENERATED: 'AI Generated',
			STRATEGY_AUTO: 'Strategy (Auto)',
			DATE_MODIFIED: 'Date Modified',
			ALL_TIME: 'All Time',
			TODAY: 'Today',
			LAST_7_DAYS: 'Last 7 Days',
			RECENT: 'Recent',
			OFFICIAL: 'Official',
			ALL_SCENARIOS: 'All scenarios',
			NO_SCENARIOS_MATCH: 'No scenarios match "{{query}}"',
			DRAFT: 'Draft',
			DISMISS: 'Dismiss',
			CONTEXT_PREFIX: 'Context:',
			REMOVE_CONTEXT: 'Remove context',
			SELECT_A_SCENARIO: 'Select a scenario',
			CLEAR_SCENARIO: 'Clear scenario',
			LATEST_RUN_DEFAULT: 'Latest Run (Default)',
			DROP_FILES_HERE: 'Drop files here',
			COMPOSER_PLACEHOLDER: 'Ask a question or make a request...',
			ADD_FILES_OR_IMAGES: 'Add files or images',
			LANGUAGE: 'Language',
			MIC_BLOCKED: 'Microphone access is blocked. Allow microphone permission',
			USE_VOICE_INPUT: 'Use voice input',
			VOICE_INPUT_ALT: 'Voice input',
			STOP_RECORDING: 'Stop recording',
			STOP_RECORDING_ALT: 'Stop recording',
			STOP_GENERATION: 'Stop generation',
			SEND_ALT: 'Send',
			FEEDBACK_WHAT_WENT_WRONG: 'What went wrong with this response?',
			FEEDBACK_CATEGORY: 'Feedback category',
			SELECT_AN_ISSUE: 'Select an issue',
			SELECT_CATEGORY_TO_CONTINUE: 'Please select a category to continue',
			ADDITIONAL_DETAILS_OPTIONAL: 'Additional details (Optional)',
			FEEDBACK_COMMENT_PLACEHOLDER: 'Tell us more about what was wrong.',
			CANCEL: 'Cancel',
			SUBMIT_FEEDBACK: 'Submit feedback',
			ERROR: 'Error',
			FEEDBACK_SUBMIT_ERROR: 'Feedback could not be submitted. Please try again.',
			TRY_AGAIN: 'Try again',
			OPEN_LINK: 'Open link',
			OPEN_DOCUMENT: 'Open document',
			PAGE_PREFIX: 'Page-{{page}}',
			FEEDBACK_CATEGORY_INCORRECT_ANSWER: 'Incorrect answer',
			FEEDBACK_CATEGORY_DID_NOT_ANSWER: 'Did not answer my question',
			FEEDBACK_CATEGORY_MISSING_DATA: 'Missing relevant data',
			FEEDBACK_CATEGORY_INCORRECT_REASONING: 'Incorrect analysis or reasoning',
			FEEDBACK_CATEGORY_POOR_CHART: 'Poor chart or visualization',
			FEEDBACK_CATEGORY_POOR_DOCUMENT: 'Poor document answer',
			FEEDBACK_CATEGORY_TOO_SLOW: 'Query was too slow',
			FEEDBACK_CATEGORY_INCOMPLETE: 'Response was incomplete',
			FEEDBACK_CATEGORY_OTHER: 'Other',
			CHATBOT_PRIVATE: 'Private',
			CHATBOT_INHOUSE_GPT: 'Inhouse GPT',
			LANGUAGE_ENGLISH_US: 'English-US',
			LANGUAGE_ARABIC: 'Arabic',
			MODE_AUTO: 'Auto',
			MODE_GENERAL: 'General',
			MODE_DOCS: 'Docs',
			MODE_OPTIMIZER: 'Optimizer',
			DATE_TODAY: 'Today',
			DATE_YESTERDAY: 'Yesterday',
			DATE_THIS_WEEK: 'This Week',
			DATE_LAST_WEEK: 'Last Week',
			DATE_THIS_MONTH: 'This Month',
			DATE_LAST_MONTH: 'Last Month',
			DATE_OLDER: 'Older',
			CONTEXT: {
				FROM: 'Context from {{source}}',
				LAUNCHED_FROM: 'Rooty launched from {{source}}',
				UPDATED: 'Context updated',
				REMOVED: 'Context removed',
				APPLIED: 'Context applied',
				GENERAL: 'Now using general chat context',
				MORE: 'More',
				SEE_LESS: 'See less',
				LABEL: {
					ALERT: 'Alert',
					RCA: 'RCA',
					SCOPE: 'Scope',
					SYSTEM: 'System',
					SCENARIO: 'Scenario',
					SIMULATION_TYPE: 'Simulation Type',
					PREVIOUS: 'Previous',
					NEW: 'New',
					SOURCE: 'Source',
				},
				SOURCE: {
					ALERT: 'Alert Details',
					RCA: 'RCA',
					SYSTEM: 'System View',
					WHAT_IF: 'What-if Analysis',
				},
				SUMMARY: {
					ALERT: 'Alert {{value}}',
					RCA: 'RCA for Alert {{value}}',
					SYSTEM: 'System {{value}}',
					WHAT_IF: 'What-if: {{value}}',
				},
			},
			TOAST_FEEDBACK_THANKS: 'Thanks. We\'ll use this to improve Rooty.',
			TOAST_FEEDBACK_POSITIVE_THANKS: 'Thanks for the feedback.',
			TOAST_COPIED_MESSAGE: 'Copied Message.',
			TOAST_LINK_COPIED: 'Copied',
			TOAST_CHAT_DELETED: 'Chat deleted',
			TOAST_CHAT_DELETE_FAILED: 'Failed to delete chat.',
			TOAST_NEW_CHAT_STARTED: 'New chat started',
		},
		AGENT_CONTEXT: {
			CONSIDERED: 'Considered Agent Context',
			ITEMS: 'items',
			ADD: 'Add Agent Context',
			UPDATED: 'Updated',
			DIALOG_DESC: 'Capture reusable operational guidance for {{name}} and RCA.',
			DIALOG_DISCLAIMER: 'This context may influence future {{name}} and RCA responses for matching analyses. It does not affect anomaly detection or predictive models.',
			SIDEPANEL_DESC: 'Reusable operational knowledge available to {{name}} and RCA.',
			SIDEPANEL_EMPTY: 'Capture reusable operational knowledge for {{name}} and RCA, such as reasoning guidance, investigation playbooks, and terminology.',
			REMOVE_CONFIRM: '"<strong>{{title}}</strong>" will be removed and will no longer be considered by {{name}} or RCA.<br>This action cannot be undone.',
			TITLE: 'Agent Context',
			READ_ONLY: 'Read only',
			ADD_SHORT: 'Add',
			CLOSE: 'Close',
			SEARCH_PLACEHOLDER: 'Search by the title or scope...',
			EDIT: 'Edit',
			DELETE: 'Delete',
			EMPTY_HEADING: 'No Agent Context yet',
			LAST_UPDATED_PREFIX: 'Last Updated',
			BY_PREFIX: 'By',
			SECTION_CONTEXT_TYPE: '1. CONTEXT TYPE',
			SECTION_SCOPE: '2. SCOPE',
			SECTION_CONTEXT: '3. CONTEXT',
			SELECT_SCOPE: 'Select Scope',
			CONTEXT_TITLE_LABEL: 'Title',
			CONTEXT_TITLE_PLACEHOLDER: 'Enter context title',
			GUIDANCE_LABEL: 'Guidance description',
			GUIDANCE_PLACEHOLDER: 'Enter guidance description',
			PLAYBOOK_NAME_LABEL: 'Playbook name',
			PLAYBOOK_NAME_PLACEHOLDER: 'Enter playbook name',
			INVESTIGATION_STEPS_LABEL: 'Investigation steps',
			STEP_PLACEHOLDER: 'Enter step description',
			ADD_STEP: '+ Add Step',
			TERM_HEADER: 'Term',
			MEANING_HEADER: 'Meaning',
			TERM_PLACEHOLDER: 'Add Term',
			MEANING_PLACEHOLDER: 'Enter Meaning',
			CANCEL: 'Cancel',
			CARD_REASONING_GUIDANCE_TITLE: 'Reasoning Guidance',
			CARD_REASONING_GUIDANCE_DESC: 'Plant-specific interpretation rules that help AI agents reason about behavior.',
			CARD_INVESTIGATION_PLAYBOOK_TITLE: 'Investigation Playbook',
			CARD_INVESTIGATION_PLAYBOOK_DESC: 'Structured troubleshooting workflow for a recurring operational issue.',
			CARD_TERMINOLOGY_TITLE: 'Terminology',
			CARD_TERMINOLOGY_DESC: 'Plant-specific aliases, abbreviations and naming conventions.',
			SAVE_IN_PROGRESS: 'Save in progress. Please wait.',
			SCOPE_REQUIRED: 'A scope selection is required before saving.',
			TITLE_REQUIRED: 'A title is required before saving.',
			GUIDANCE_DESC_REQUIRED: 'A guidance description is required before saving.',
			PLAYBOOK_NAME_REQUIRED: 'A playbook name is required before saving.',
			STEPS_REQUIRED: 'All investigation steps must be filled in before saving.',
			TERMINOLOGY_REQUIRED: 'All terminology entries must have both a term and a meaning before saving.',
			SOME_ERROR_OCCURRED: 'Some error occurred',
			EDIT_TITLE: 'Edit Agent Context',
			SAVE_CHANGES: 'Save Changes',
			DELETE_CONTEXT_TITLE: 'Delete This Context?',
			DELETED_SUCCESSFULLY: 'Deleted Successfully.',
		SECTION_GUIDANCE: 'Guidance',
		TERMS_LABEL: 'Terms',
		REASONING_LABEL: 'Reasoning',
		PLAYBOOK_LABEL: 'Playbook',
		},
		MENU: {
			NEW: 'new',
			ACTIONS: 'Actions',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
			HOME: 'Home',
			SYSTEM: 'System',
			ANALYSIS: 'Analysis',
			CONFIGURATION: 'Configuration',
			ALERTS: 'Alerts',
			ALERT_TRIAGE: 'Alert Triage',
			KNOWLEDGE_GRAPH: 'Knowledge Graph',
			ASSET_EXPLORER: 'Asset Explorer',
			LIBRARY: 'Library',
			USER_MANAGEMENT: 'User Management',
			MODEL_WIZARD: 'Model Wizard',
			DASHBOARD_WIZARD: 'Dashboard Wizard',
			IOW: 'IOW',
			PROCESS: 'Process',
			GENAI: 'GenAI',
			MAINTENANCE_OPTIMIZATION: 'Maintenance Optimization',
			RCM: 'RCM',
			SETTINGS: 'Settings',
			HAZOP: 'Hazop',
			CASES: 'Cases',
			CAPACITY_OPTIMIZATION: 'Capacity Optimization',
			WHAT_IF: 'What-if',
			HEALTH_METRICS: 'Health Metrics',
			PLATFORM_CONFIGURATION: 'Platform Configuration',
			DATA_MANAGEMENT: 'Data Management',
			PLATFORM_POLICIES: 'Platform Policies',
			CONNECTIONS_APIS: 'Connections & APIs',
			MODULE_CONFIGURATION: 'Module Configuration',
			AI_MANAGEMENT: 'AI Management',
			ROOTY: '{{name}}',
			NOTIFICATION: 'Notification',
			HELP: 'Help',
			PROFILE: 'My Profile',
			LOGOUT: 'Logout',
			LANGUAGE: 'Language',
			BASIC_USER_GUIDE: 'Basic User Guide',
			ADVANCED_USER_GUIDE: 'Advanced User Guide',
		},
		AUTH: {
			PASSWORD_REQUIREMENTS: {
				TITLE: 'Your password must include:',
				MIN_CHARACTERS: 'Minimum 8 characters',
				UPPERCASE_LETTER: 'At least 1 uppercase letter',
				NUMBER: 'At least 1 number',
				SPECIAL_CHARACTER: 'At least 1 special character',
			},
			GENERAL: {
				OR: 'Or',
				SUBMIT_BUTTON: 'Submit',
				NO_ACCOUNT: 'Don\'t have an account?',
				SIGNUP_BUTTON: 'Sign Up',
				FORGOT_BUTTON: 'Forgot Password?',
				BACK_BUTTON: 'Back',
				PRIVACY: 'Privacy',
				LEGAL: 'Legal',
				CONTACT: 'Contact',
				VERIFY_BUTTON: 'Verify',
				ENTER_OTP: 'Enter OTP',
				HAVE_ACCOUNT: 'I have an account',
			},
			LOGIN: {
				TITLE: 'Login Account',
				BUTTON: 'Sign in',
				SIGN_IN_MICROSOFT: 'Sign in with Microsoft',
				SIGN_IN_SAML: 'Sign in with SAML',
				REMEMBER_ME: 'Remember Me',
				SIGNING_IN: 'Signing In. Please wait...',
				BPCL_WELCOME: 'Welcome to BPCL’s AI-Based Asset Performance Solution!',
			},
			RESET: {
				TITLE: 'Reset Password',
				SUCCESS: 'Password changed successfully.',
				NEWPASSWORD: 'New Password',
				REENTERNEWPASSWORD: 'Verify Password',
				VERIFICATION_CODE_SENT: 'Enter the verification code sent to',
				NO_CODE_RECEIVED: 'Didn\'t receive the code?',
				RESEND: 'Resend',
				RESEND_IN: 'in',
			},
			FORGOT: {
				TITLE: 'Forgot your password?',
				DESC: 'Enter your email to reset your password',
				SUCCESS: 'Check your email for OTP.',
				REQUEST_RESET_BUTTON: 'Request Password Reset',
				BACK_TO_SIGNIN: 'Back to Sign in',
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.',
				ORGANIZATION_NAME: 'Organization Name',
				NAME: 'Name',
				AGREE_PREFIX: 'I agree the',
				TERMS_CONDITIONS: 'terms & conditions',
				EMAIL_ALREADY_REGISTERED: 'This email id is already registered.',
			},
			INPUT: {
				EMAIL: 'Email',
				EMAIL_ADDRESS: 'Email address',
				FULLNAME: 'Fullname',
				PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				USERNAME: 'Username'
			},
			PLACEHOLDER:{
				EMAIL: 'Enter Email',
				PASSWORD: 'Enter Password'
			},
			VERIFY:{
				VERIFY_EMAIL: 'Email Verification',
				BACK_TO_SIGNIN: 'Back to sign in',
			},
			SUBSCRIPTION: {
				EXPIRED: 'Your subscription has expired.',
				RENEW: 'Renew now or contact support for help.',
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				INVALID_EMAIL: 'Enter a valid email address',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				INVALID_RESET: 'The OTP entered is incorrect or has expired. Please try again..',
				REQUIRED_FIELD: 'Required field',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
				OTP_REQUIRED: 'Enter the verification code sent to your email.'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		HEALTH_METRICS: {
			TITLE: 'Health Metrics',
			SYSTEM_MODEL_METRICS: 'System & Model Health Metrics',
			DATA_FEED_HEALTH: 'Data Feed Health',
			QC_CHECK: 'QC Check',
			QC: {
				RAW_TAG_QC: 'Raw Tag QC',
				CALCULATED_TAG_QC: 'Calculated Tag QC',
				MODEL_QC: 'Model QC',
				COMING_SOON: 'Coming Soon',
				CONFIGURATION: 'QC Check Configuration',
				ALL_TAGS: 'All Tags',
				PROBLEM_TAGS: 'Problem Tags',
				SEARCH: 'Search...',
				COLUMN_CONFIG: 'Column Configuration',
				ADD_TAG: 'Add Tag',
				EXPORT: 'Export',
				UPLOAD: 'Upload Tags (Excel)',
				DOWNLOAD: 'Download Tags (Excel)',
				VIEW: 'View',
				EDIT: 'Edit',
				NO_TAGS_FOUND: 'No tags found',
				ADD_DESCRIPTION: 'Add Description',
				ADD_UOM: 'Add Unit',
				COL_INDEX: '#',
				COL_SYSTEM_NAME: 'System Name',
				COL_TAG_NAME: 'Tag Name',
				COL_TAG_ID: 'Tag ID',
				COL_TAG_DESCRIPTION: 'Tag Description',
				COL_UOM: 'UOM',
				COL_IR_UPPER: 'IR Upper',
				COL_TRIP_UPPER: 'Trip Upper',
				COL_ALARM_UPPER: 'Alarm Upper',
				COL_THRES_UPPER: 'Thres Upper',
				COL_OPS_UPPER: 'Ops Upper',
				COL_OPS_LOWER: 'Ops Lower',
				COL_THRES_LOWER: 'Thres Lower',
				COL_ALARM_LOWER: 'Alarm Lower',
				COL_TRIP_LOWER: 'Trip Lower',
				COL_IR_LOWER: 'IR Lower',
				COL_FLATLINE: 'Flatline Detection',
				COL_OUTLIER: 'Outlier Detection',
				COL_RANGE: 'Out of Range Detection',
				COL_MISSING_DATA: 'Missing Data Detection',
				COL_FLATLINE_ALERT: 'Flatline Alert Gen',
				COL_OUTLIER_ALERT: 'Outlier Alert Gen',
				COL_RANGE_ALERT: 'Out of Range Alert Gen',
				COL_MISSING_DATA_ALERT: 'Missing Data Alert Gen',
				COL_ATTENTION: 'Attention',
				COL_THRES_NOT: 'Thres Not.',
				COL_KPI: 'KPI',
				COL_DIRECTIONALITY: 'Directionality',
				COL_IOW_LOWER: 'IOW Lower',
				COL_IOW_UPPER: 'IOW Upper',
				COL_ACTIONS: 'Actions',
				COL_DESCRIPTION: 'Description',
				EDIT_TAG: 'Edit Tag',
				LOWER: 'Lower',
				UPPER: 'Upper',
				INSTRUMENT_RANGE: 'Instrument Range',
				TRIP_LIMITS: 'Trip Limits',
				ALARM_LIMITS: 'Alarm Limits',
				THRESHOLD_LIMITS: 'Threshold Limits',
				DIRECTIONALITY: 'Directionality',
				IOW_CRITICALITY: 'IOW Criticality',
				FLATLINE_DETECTION: 'Flatline Detection',
				THRESHOLD_NOTIFICATION: 'Threshold Notification',
				ASSET: 'Asset',
				CALCULATED_FLAG: 'Calculated Flag',
				REMARK: 'Remark',
				REMARK_PLACEHOLDER: 'Enter Remark to Edit',
				CANCEL: 'Cancel',
				SAVE: 'Save',
			},
			DATA_FEED: {
				TITLE: 'Data Feed Health (Historian Monitoring)',
				ALL_TAGS: 'All Tags',
				GOOD_TAGS: 'Good Tags',
				BAD_TAGS: 'Bad Tags',
				GROUP_BY: 'Group by',
				DOWNLOAD: 'Download',
				NO_TAGS_FOUND_TITLE: 'No Tags Found',
				NO_TAGS_FOUND_DESC: 'Check your filters and date range',
				TAGS: 'Tags',
				SHOW: 'Show',
				MORE_TAGS: 'more tags',
				NO_TAGS: 'No tags found.',
				SYSTEM_NAME: 'System Name',
				VALUE: 'Value',
				QUALITY: 'Quality',
				TIMESTAMP: 'Timestamp',
				TAG_NAME: 'Tag Name',
				TAG_ID: 'Tag ID',
			},
			MODEL_HEALTH: {
				TITLE: 'System & Model Health Metrics',
				ALL_SYSTEMS: 'All Systems',
				PROBLEM_SYSTEMS: 'Problem Systems',
				NO_PROBLEM_SYSTEMS: 'No Problem Systems found',
				SEARCH: 'Search...',
				REFRESH: 'Refresh Data',
				DOWNLOAD: 'Download',
				SYSTEM_NAME: 'System Name',
				STATUS: 'Status',
				DEPLOYED_VERSION: 'Deployed Version',
				LAST_DATA_PULL: 'Last Data Pull',
				DATA_HEALTH: 'Data Health',
				MODEL_HEALTH: 'Model Health',
				PREDICTION_TIME: 'Prediction Time',
				LAST_PREDICTION: 'Last Prediction',
				PREDICTIONS_OLDER_THAN_2_HOURS: 'Systems with predictions older than 2 hours are marked as Problem Systems',
				LAST_DATA_WRITTEN: 'Last Data Written',
				LAST_ANOMALY_WRITTEN: 'Last Anomaly Written',
				FETCH_STATUS: 'Fetch Status',
				FETCH_RATE: 'Fetch Rate',
				FETCH_SAMPLING_RATE: 'Fetch Sampling Rate',
				PREDICTION_STATUS: 'Prediction Status',
				PREDICTION_RATE: 'Prediction Rate',
				SAMPLING_RATE: 'Sampling Rate',
				ACTIONS: 'Actions',
				CUSTOMIZE_COLUMNS: 'Customize Columns',
				NO_DATA_MATCHING: 'No data available for the selected asset',
				DEPLOYED_DATE: 'Deployed Date',
				DEPLOYED_BY: 'Deployed By',
				DEPLOYMENT_NOTE: 'Deployment Note',
				ACTIVE_ALERTS: 'Active Alerts',
				RETRAINING_RECOMMENDED: {
					TITLE: 'Retraining Recommended',
					DESCRIPTION: 'Recent evaluation suggests the model may no longer reflect current operating behavior. The following tags are contributing most to this recommendation.',
					CONTRIBUTING_TAGS: 'Contributing Tags',
					TAG_NAME_AND_ID: 'Tag Name & ID',
					TAG_TOOLTIP: 'Name: {{tagName}}\nTagID: {{tagId}}',
					CONTRIBUTION_SCORE: 'Contribution Score',
					LAST_EVALUATED: 'Last Evaluated',
					MODEL_VERSION: 'Model',
					COPY_TAGS: 'Copy Tags',
					COPY_FULL_DETAILS: 'Copy Full Details',
					RETRAIN_MODEL: 'Retrain Model',
					RETRAIN: 'Retrain',
					TIP_PREFIX: 'Tip: Click the',
					TIP_SUFFIX: 'chip in the Model Health column to see why retraining is recommended.',
					NO_TAGS: 'No contributing tags found.',
					TAGS_COPIED: 'Tags Copied.\nAvailable on your clipboard.',
					DETAILS_COPIED: 'Details Copied.\nAvailable on your clipboard.',
					RECOMMENDED_DATE_RANGE: 'Recommended Date Range for Retrain',
					RECOMMENDED_DATE_RANGE_HINT: 'Use this date range to replace and retrain the model with the most relevant data.',
					NO_DATE_RANGE: 'No date range available to retrain the model',
					ADD_COMMENT: 'Add Comment',
					ADD_COMMENT_PLACEHOLDER: 'Add a reason',
					START_RETRAINING: 'Start Retraining',
					BACK: 'Back',
					FORCE_INCLUDE_BANNER: 'Recommended regions have been added automatically as Force Include ranges.',
					TRAINING_PERIOD: 'Training Period',
					EXISTING_TRAINING_REGION: 'Existing training region',
					CURRENT_MODEL_VERSION: 'Current model version',
					RECOMMENDED_REGION: 'Recommended region',
					FROM_MODEL_HEALTH_EVALUATION: 'From model-health evaluation',
					NO_TRAINING_RANGES: 'No training regions available.',
					LOADING_RANGES: 'Loading training regions...',
				}
			}
		},
		SHARED_MODULE: {
			COLUMN_CONFIG: {
				TITLE: 'Show Columns',
				SEARCH: 'Search...',
				SELECT_ALL: 'Select All',
				RESET_TO_DEFAULT: 'Reset to Default',
			},
			CALCULATED_TAG_POPUP: {
				EXPRESSION: 'Expression',
				EXPRESSION_DESCRIPTION: 'Expression Description'
			}
		},
		DATA_MANAGEMENT: {
			QC: {
				RUN_QC: 'Run QC',
				RUN_QC_SELECTED: 'Run QC on Selected',
				RUN_QC_TOOLTIP: 'Run the data quality agent over the current records',
				RUNNING: 'Running QC',
				DETAIL_TITLE: 'Maintenance Record',
				TAB_DETAILS: 'Details',
				TAB_REVIEW: 'Review',
				NO_DETAILS: 'No details available.',
				VIEW_DETAILS: 'View details',
				FIELDS: {
					NOTIFICATION_NO: 'Notification No.',
					ORDER: 'Order',
					TYPE: 'Type',
					EQUIPMENT: 'Equipment',
					EQUIPMENT_DESC: 'Equipment Description',
					FUNCTIONAL_LOC: 'Functional Location',
					PLAN_GROUP: 'Planner Group',
					PLAN_GROUP_DESC: 'Planner Group Description',
					MAINTENANCE_PLANT: 'Maintenance Plant',
					MAINTENANCE_PLANT_DESC: 'Maintenance Plant Description',
					PLANT_SECTION: 'Plant Section',
					PRIORITY: 'Priority',
					DAMAGE: 'Damage',
					DESCRIPTION: 'Description',
					STATUS: 'Status',
					USER_STATUS: 'User Status',
					CREATED_ON: 'Created On',
					COMPLETED_ON: 'Completed On',
					BREAKDOWN_DURATION: 'Breakdown Duration',
					INTERNAL_LABOUR: 'Internal Labour Cost',
					EXTERNAL_LABOUR: 'External Labour Cost',
					EXTERNAL_SERVICE: 'External Service Cost'
				},
				LAST_RUN: 'Last QC run',
				VIEW_FINDINGS: 'View findings',
				FINDINGS_TITLE: 'Data Quality Findings',
				NO_FINDINGS: 'No issues found for this record.',
				BLOCKERS: 'Blockers',
				WARNINGS: 'Warnings',
				RULE: 'Rule',
				FIELD: 'Field',
				EVIDENCE: 'Evidence',
				RECOMMENDATION: 'Recommendation',
				CONFIG_TITLE: 'Data Quality Rules',
				SCOPE_GLOBAL: 'Global',
				SCOPE_SYSTEM: 'This System',
				RULE_MANDATORY_FIELDS: 'Mandatory fields',
				MANDATORY_FIELDS_LABEL: 'Required fields',
				SEVERITY: 'Severity',
				RULE_DESCRIPTION: 'Description length',
				MIN_LENGTH: 'Minimum length (characters)',
				RULE_DATES: 'Date consistency',
				ALLOW_COMPLETION_BEFORE_CREATION: 'Allow completion date before creation date',
				RULE_DUPLICATES: 'Duplicate detection',
				WINDOW_DAYS: 'Duplicate window (days)',
				RULE_PLANNING: 'Planning',
				REQUIRE_LABOR: 'Require labour on work orders',
				RULE_COMPLETION: 'Completion',
				REQUIRE_ROOT_CAUSE: 'Require root cause on completed records',
				RULE_TEXT_QUALITY: 'Text quality (AI)',
				TEXT_QUALITY_HINT: 'Uses the language model to check spelling and description quality',
				CHECK_SPELLING: 'Check spelling',
				CHECK_DESCRIPTION_MEANING: 'Check description is meaningful',
				CHECK_ROOT_CAUSE: 'Check root-cause adequacy',
				RULE_WORK_ORDER: 'Work Order Required',
				WORK_ORDER_HINT: 'Flags a missing work order only once the notification is completed, for the notification types you select below.',
				WORK_ORDER_TYPES_LABEL: 'Notification types that require a work order',
				RULE_SLA: 'SLA / Required Date',
				SLA_CHECK_OVERDUE: 'Flag notifications overdue against their required completion date',
				SLA_CHECK_LATE: 'Flag notifications completed after their required completion date',
				RULE_BREAKDOWN_CONSISTENCY: 'Breakdown Indicator Consistency',
				BREAKDOWN_CONSISTENCY_HINT: 'Checks the breakdown flag (Effect) against recorded downtime. Select the Effect values that mark a breakdown for this site.',
				BREAKDOWN_EFFECT_VALUES_LABEL: 'Effect values that indicate a breakdown',
				RULE_AGING: 'Aging / Stale Backlog',
				MAX_OPEN_DAYS: 'Maximum days a notification may stay open',
				RULE_STATUS_CONSISTENCY: 'Status Closure Consistency',
				STATUS_CONSISTENCY_HINT: 'Checks the completion date against the workflow closure status. Select the status codes that mean \'closed\' for this site.',
				CLOSED_KEYWORDS_LABEL: 'Status codes that mean closed',
				RULE_COST_SANITY: 'Cost Sanity',
			},
			TABS: {
				DOCUMENTS: 'Documents',
				TAGS: 'Tags',
				MAINTENANCE: 'Maintenance',
				PIDS: 'P&IDs',
				RELIABILITY: 'Reliability'
			},
			COMMON: {
				PROCESSING: 'Processing',
				READY: 'Ready',
				REVIEW: 'Review',
				BLOCKED: 'Blocked',
				PENDING: 'Pending',
				SEARCH: 'Search...',
				SEARCH_RECORDS: 'Search records...',
				ADD_DOCUMENT: 'Add Document',
				NO_MATCHING: 'No matching documents found.',
				LOADING: 'Loading data...',
				LOADING_MORE: 'Loading more documents...',
				LOADING_MORE_RECORDS: 'Loading more records...',
				CANCEL: 'Cancel',
				EDIT: 'Edit',
				SAVE: 'Save',
				SAVING: 'Saving...',
				ASK_ROOTY: 'Ask Rooty',
				DOWNLOAD: 'Download',
				IMPORT_DATA: 'Import Data',
				REPLACE_FILE: 'Replace File',
				UPLOAD: 'Upload'
			},
			FILTERS: {
				ALL_ISSUES: 'All Issues',
				CHOOSE_ISSUES: 'Choose Issues to display',
				ALL_CLASSES: 'All Classes',
				CHOOSE_CLASSES: 'Choose Classes to display',
				GROUP_BY: 'Group by',
				ALL_TYPES: 'All Types',
				EVENT_TYPES: 'Event Types',
				FILTER_ISSUE_TYPE: 'Issue Type'
			},
			IMPORT_BANNER: {
				IMPORTING: 'Importing {{ count }} Documents',
				IMPORTING_AUTO: 'Importing {{ uploaded }} Documents, {{ remaining }} Remaining (Total: {{ total }})',
				INITIALIZING_AUTO: 'Initializing document sync...',
				AUTO_TAKE_MINS: 'Please wait while we sync your documents in the background...',
				TAKE_30_MINS: 'This may take up to 30 minutes.',
				IMPORTED_SUCCESS: '{{ count }} documents imported',
				SUMMARY: 'Import summary:',
				NEEDS_REVIEW: 'Needs Review',
				ALREADY_PRESENT: 'Already Present',
				REMOVED_AT_SOURCE: 'Removed at source',
				SYNC_FAILED: 'Failed to sync'
			},
			TABLE_COLUMNS: {
				DOCUMENT: 'Document',
				CLASS: 'Class',
				DOC_TYPE: 'Doc Type',
				STATUS: 'Status',
				SOURCE: 'Source',
				ISSUES: 'Issues',
				LAST_UPDATED: 'Last Updated',
				ACTIONS: 'Actions',
				NOTIFICATION: 'Notification',
				EQUIPMENT: 'Equipment',
				DESCRIPTION: 'Description',
				TYPE: 'Type',
				MAINTENANCE_PLANT: 'Maintenance Plant',
				FAILURE_MODE: 'Failure Mode',
				SECTION: 'Section',
				DATES: 'Dates',
				CONTEXT: 'Context',
				TIME_HRS: 'Time (in hrs)',
				RCA: 'RCA',
				SOURCE_NAME: 'Source Name',
				PATH: 'Path',
				SYNC_FREQUENCY: 'Sync Frequency',
				LAST_SYNCED: 'Last Synced',
			},
			EMPTY_STATE: {
				NO_DOCS_TITLE: 'No documents imported yet',
				NO_DOCS_SUBTITLE: 'Add Documents Manually or use AI uploading tool.',
				NO_MAINT_TITLE: 'No Maintenance Data imported yet.',
				NO_MAINT_SUBTITLE: "Select 'Import Data' to start adding maintenance data."
			},
			ADD_DOC_DIALOG: {
				FILE_UPLOAD: 'File Upload',
				UPLOAD_MANUALLY: 'Upload files manually',
				BULK_UPLOAD_TITLE: 'Bulk upload with folder template',
				BULK_UPLOAD_DESC: 'Download the folder structure, place your documents in the matching folders, then upload the entire folder.',
				DOWNLOAD_TEMPLATE: 'Download Template',
				DRAG_DROP: 'Drag and drop your file here or',
				BROWSE: 'browse',
				SUPPORTS: 'Supports PDF, Word, Excel, images, or a bulk upload ZIP.',
				SELECTED_FILES: 'Selected files',
				APPLY_TO_ALL: 'Apply to All:',
				CLASS: 'Class',
				DOC_TYPE: 'Doc Type',
				LINKED_TO: 'Linked to',
				SELECT_CLASS: 'Select Class',
				SELECT_DOC_TYPE: 'Select Doc Type',
				CHOOSE_LINK: 'Choose where to link',
				FILE_SELECTED: 'File Selected',
				FILES_SELECTED: 'Files Selected',
				CONFIRM_IMPORT: 'Confirm / Import',
				REPLACE_HINT: 'Please upload the correct replacement file for this document. Ideally, this should be the same file as originally intended.',
				DUPLICATE_BADGE: 'Duplicate',
				DUPLICATES_SKIPPED_BANNER: '{{count}} duplicate file(s) detected. They are excluded and won\'t be uploaded.',
				DUPLICATES_SKIPPED_INLINE: '({{count}} duplicate skipped)',
				REMOVE_DUPLICATES: 'Remove duplicates'
			},
			DOC_VIEWER: {
				DOC_DETAILS: 'Document Details',
				PREVIEW: 'Preview',
				FULL_SCREEN: 'Full Screen',
				NO_PREVIEW: 'No Preview Available',
				NO_PREVIEW_DESC: 'This file type cannot be previewed in the browser.',
				METADATA: 'Metadata',
				DOC_IDENTIFICATION: 'Document Identification',
				DOC_NAME: 'Document Name',
				DOC_ID: 'Document ID',
				DOC_CLASS: 'Document Class',
				DOC_TYPE: 'Doc Type',
				MISSING: 'Missing',
				DOC_SOURCE: 'Document Source',
				FILE_SIZE: 'File Size',
				FILE_UPLOAD_SOURCE: 'File Upload',
				EXTERNAL_SOURCE: 'External(Sharepoint, Google Drive etc.)',
				VERSIONING: 'Versioning',
				UPLOADED_ON: 'Uploaded on',
				LAST_MODIFIED: 'Last Modified',
				EFFECTIVE_DATE: 'Effective Date',
				EXPIRY_DATE: 'Expiry Date',
				REVISION: 'Revision',
				VERSION_1: 'Version 1',
				VERSION_2: 'Version 2',
				STATUS: 'Status',
				STATUS_UPLOADING: 'Uploading',
				STATUS_QUEUED: 'Queued',
				STATUS_PROCESSING: 'Processing',
				STATUS_READY: 'Ready',
				STATUS_PENDING: 'Pending',
				LINKED_TO: 'Linked to',
				FACILITIES: 'Facilities',
				UNITS: 'Units',
				SYSTEMS: 'Systems',
				CHOOSE_LINK_DESC: 'Choose where to link (You can link document to Facility or Unit or System)',
				EXTRACTED_DATA: 'Extracted Data',
				NO_EXTRACTED_DATA: 'No extracted data available.'
			},
			TOOLTIPS: {
				ISSUE_FILTER: 'Issue Filter',
				CLASS_FILTER: 'Class Filter',
				CUSTOMIZE_COLUMNS: 'Customize Columns',
				VIEW_DETAILS: 'View Details',
				DELETE_FILE: 'Delete File',
				STATUS_QUEUED_PROCESSING: 'Your document is queued and will be processed shortly.',
				STATUS_READY: 'Your document is processed and is ready to use.'
			},
			DEDUP_MENU: {
				TRIGGER_LABEL: 'Duplicates',
				TITLE: 'Resolved Duplicates',
				SUMMARY: '{{dupes}} of {{total}} selected file(s) have duplicates',
				DESCRIPTION: 'Originals are kept. The Other {{unaffected}} file(s) aren\'t changed.',
				MERGE_TAGS: 'Remove Duplicates, Merge Tags ({{count}})',
				NO_MERGE_TAGS: 'Remove Duplicates, DON\'T merge tags ({{count}})',
				FAILURE: 'Failed to remove some duplicates',
				TOAST_MERGED: '{{count}} duplicate file(s) removed. Tags were merged with the original files.',
				TOAST_NOT_MERGED: '{{count}} duplicate file(s) removed. Original file tags were left unchanged.'
			},
			CONNECTED_SOURCES: {
				CLOSE: 'Close',
				DISCONNECT_MSG: 'Disconnecting {{provider}} will stop document syncing and prevent UptimeAI from accessing files from the connected {{provider}} account.<br/>Documents already imported into UptimeAI will remain available, but they will no longer receive updates from {{provider}}.',
				DISCONNECT_TITLE: 'Disconnect {{provider}} integration?',
				DISCONNECT_OK: 'Disconnect {{provider}}',
				FETCH_SOURCES_FAILED: 'Failed to fetch connected sources.',
				SOURCE_UPDATED_SUCCESS: 'Source updated successfully.',
				SOURCE_CONNECTED_SUCCESS: 'Source connected successfully.',
				TRIGGERING_SYNC: 'Triggering sync...',
				SYNC_STARTED_SUCCESS: 'Sync started successfully.',
				FAILED_TRIGGER_SYNC: 'Failed to trigger sync.',
				INACTIVE_REASON_COVERED: 'Covered by active parent source \'{{name}}\' ({{path}})',
				REAL_TIME: 'Real Time',
				ONE_TIME: 'One Time',
				DAILY: 'Daily',
				HOURLY: 'Hourly',
				WEEKLY: 'Weekly',
				MONTHLY: 'Monthly',
				NA: 'N/A',
				PAUSED: 'Paused',
				INACTIVE: 'Inactive',
				UNKNOWN: 'Unknown',
				TITLE: 'Connected Sources',
				ACTIVE: 'Active',
				CONNECT_SOURCE: 'Connect Source',
				NO_SOURCES_HEADING: 'No connected sources yet.',
				NO_SOURCES_CONTENT: 'Connect a source to browse and import files.',
				NEVER: 'Never',
				SYNC_NOW: 'Sync Now',
				MONITOR: 'Monitor',
				SETTINGS: 'Settings',
				DISCONNECT: 'Disconnect',
				SYNC_ACTIVITY: 'Sync Activity',
				NO_RECENT_ACTIVITY: 'No recent sync activity found.',
				STATUS_SUCCESS: 'Success',
				STATUS_PARTIAL: 'Partial',
				STATUS_FAILED: 'Failed',
				STATUS_RUNNING: 'Running',
				SYNC_FAILED_ERROR: 'Sync failed due to an error.',
				SYNC_STATS: '+ {{new}} new · {{updated}} updated · {{skipped}} unchanged',
				SYNC_STATS_PARTIAL: '+ {{new}} new · {{updated}} updated · {{skipped}} unchanged · {{failed}} failed',
			},
			CONNECT_SOURCE: {
				PROVIDERS: {
					DOCUMENT_LOCATOR: {
						NAME: 'Document Locator',
						DESC: 'Connect to a Document Locator database to continuously sync documents.'
					}
				},
				PROVIDER_FIELDS: {
					DOCUMENT_LOCATOR: {
						DIALECT: 'Database Type',
						HOST: 'Server Host',
						PORT: 'Port',
						DATABASE: 'Database Name',
						USER: 'Username',
						PASSWORD: 'Password',
						ENCRYPT: 'Encrypt Connection',
						TRUST_CERT: 'Trust Server Certificate',
						SP_FILE_INFO: 'File Information Procedure',
						SP_FILE_CONTENT: 'File Content Procedure',
						SP_PLACEHOLDER: 'Enter your stored procedure name'
					}
				},
				TITLE: 'Connect Source',
				STEP_1: 'Connect to Source',
				STEP_2: 'Authenticate to Source',
				STEP_3: 'Source Details',
				SHAREPOINT: 'SharePoint',
				SHAREPOINT_DESC: 'Connect to SharePoint libraries to continuously sync documents.',
				CONNECT_TO_SHAREPOINT: 'Connect to SharePoint',
				CONNECT_TO_PROVIDER: 'Connect to {{provider}}',
				CONNECTION_VERIFIED: 'Connection verified.',
				DESCRIPTOR_LOAD_FAILED: 'Could not load the configuration for this source.',
				TEST_CONNECTION_REQUIRED: "Please test connection successfully before connecting.",
				API_INTEGRATION: 'API Integration',
				API_DESC: 'Connect to document management APIs to sync files automatically.',
				CMMS: 'CMMS',
				CMMS_DESC: 'Connect to your CMMS (SAP PM, Maximo, etc.) for continuous document sync.',
				COMING_SOON: 'Coming soon',
				OAUTH_TAB: 'Sign in with Microsoft (OAuth)',
				TOKEN_TAB: 'Access Token (manual)',
				SIGN_IN_MICROSOFT: 'Sign in with Microsoft',
				OAUTH_DESC: 'Connect your Microsoft account to browse SharePoint libraries and import documents.',
				SECURE_AUTH: 'Secure authentication',
				SECURE_AUTH_DESC: 'Uses Microsoft OAuth. Your Credentials are never stored in this application.',
				READ_ONLY: 'Read-only access',
				READ_ONLY_DESC: 'The application only reads documents. No files will be modified or deleted in SharePoint.',
				TOKEN_PLACEHOLDER: 'Paste your SharePoint Access Token',
				TOKEN_WARNING: 'Access tokens expire. Consider OAuth for uninterrupted sync.',
				MANUAL_AUTH_DESC: 'Enter your Azure App Registration credentials. These are stored securely on the server.',
				TENANT_ID_LABEL: 'Tenant ID',
				TENANT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_ID_LABEL: 'Client ID (Application ID)',
				CLIENT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_SECRET_LABEL: 'Client Secret',
				CLIENT_SECRET_PLACEHOLDER: 'Paste your client secret value',
				SAVE_CREDENTIALS: 'Save & Continue',
				STEP_CONNECTION_CONFIG: 'Connection Config',
				APP_CONNECTION_CONFIG: 'App Connection Configuration',
				NEW_CONNECTION: 'New Connection',
				ACTIVE_CONNECTION_CONFIG: 'Active Connection Configuration',
				PROVIDER: 'Provider',
				MICROSOFT_SHAREPOINT: 'Microsoft SharePoint',
				APP_ID: 'App ID (Client ID)',
				REGISTER_CONFIG_DESC: 'Enter details to register a new App Registration/Client credentials configuration.',
				CONFIG_NAME_LABEL: 'Configuration Name',
				CONFIG_NAME_PLACEHOLDER: 'e.g. SharePoint Production',
				BACK_TO_SELECTION: 'Back to Selection',
				SAVE_CONNECTION_BTN: 'Save Connection',
				PLEASE_SELECT_CONNECTION: 'Please select or register a connection configuration first.',
				RESTORED_SESSION_FOR: 'Restored authenticated session for: {{user}}',
				PLEASE_COMPLETE_SIGNIN: 'Please complete Microsoft sign-in first.',
				SELECT_APP_REGISTRATION: 'Please select or register an App Registration connection first.',
				FAILED_AUTH_URL: 'Failed to obtain Microsoft authorization URL.',
				ERROR_REQ_AUTH_LINK: 'Error requesting authorization link.',
				FILL_ALL_FIELDS: 'Please fill in all connection configuration fields.',
				APP_REG_SAVED: 'App registration configuration saved successfully.',
				FAILED_SAVE_CONFIG: 'Failed to save configuration.',
				SITE_URL_LABEL: 'SharePoint Site URL (The full URL of your SharePoint site collection)',
				SITE_URL_PLACEHOLDER: 'https://company.sharepoint.com/sites/engineering',
				LIBRARY_PATH_LABEL: 'Library Path',
				LIBRARY_PATH_DESC: '(Path to the document library, e.g. /Shared Documents/Equipment)',
				LIBRARY_PATH_PLACEHOLDER: '/Shared Documents/Equipment',
				FILE_TYPE_LABEL: 'File Type Filter (Only import files matching these types; leave empty for all)',
				SYNC_FREQUENCY: 'Sync Frequency',
				SYNC_AUTO: 'Auto (Real-time)',
				SYNC_HOURLY: 'Hourly',
				SYNC_DAILY: 'Daily',
				SYNC_DAILY_DESC: 'Sync every 24 hours at a scheduled time',
				SYNC_WEEKLY: 'Weekly',
				SYNC_BIWEEKLY: 'Biweekly',
				SYNC_MONTHLY: 'Monthly',
				CONFLICT_LABEL: 'Conflict Resolution (How to handle documents that already exist in the system)',
				CONFLICT_KEEP_NEWEST: 'Keep Newest Version',
				TEST_CONNECTION: 'Test Connection',
				TEST_SUCCESS: 'Connection successful - found {{count}} documents matching files',
				CANCEL: 'Cancel',
				CONNECT_AND_SYNC: 'Connect & Start Sync',
				AUTH_SUCCESS: 'You have successfully authenticated. Click Next below to configure source details.',
				APP_ONLY_SYNC_DESC: 'App-only sync runs in the background using the selected application registration configuration. No individual user login is required.',
				FILE_TYPE_FILTER_DESC: 'Only import files matching these types; leave unselected to import all files.',
				NEXT: 'Next',
				AUTHENTICATED_PROFILE: 'Authenticated Microsoft Profile',
				USER_NAME: 'User Name',
				EMAIL_ADDRESS: 'Email Address',
				SIGN_IN_DIFFERENT_ACCOUNT: 'Sign in with a different account'
			}
		},
		MODULE_CONFIGURATION: {
			TABS: {
				TRIAGE: 'Alert Triage', MAINTENANCE: 'Maintenance', COMING_SOON: 'Coming Soon' },
			COMMON: { CANCEL: 'Cancel', SAVE: 'Save', EDIT: 'Edit', DOWNLOAD: 'Download', UPLOAD: 'Upload', DELETE: 'Delete', SELECT_ALL: 'Select all', SEARCH: 'Search Activity...', EDIT_CONFIGURATION: 'Edit Configuration', SAVE_CONFIGURATION: 'Save Configuration', APPLY_TEMPLATE: 'Apply Template', TEMPLATE_MANAGER: 'Template Manager', SAVED_CONFIGURATION: 'Saved Configuration', CONFIGURE: 'Configure', BETA_ANALYTICS: 'β Analytics', UPDATE_TEMPLATE: 'Update Template', SAVE_TEMPLATE: 'Save Template', FINISH_SAVE_PACKAGE: 'Finish & Save Package', DONE: 'Done', RE_GENERATE: 'Re-Generate', YES: 'Yes', NO: 'No', LOADING: 'Loading...', COPY: 'Copy', APPLYING_TEMPLATE: 'Applying Template', LOADING_TEMPLATE: 'Loading Template', TO: 'to' },
			HEADER: { CONFIG_FOR: 'Configure PM, FMEA, CM for:', SELECT_EQUIPMENT: 'Please select an equipment' },
			EQUIPMENT_EMPTY: { TITLE: 'Select Equipment', DESC: 'Select an equipment from the hierarchy panel to configure', ACTIVITIES: 'PM activities, FMEA, CM.', NO_TEMPLATE_TITLE: 'No Template Applied', NO_TEMPLATE_DESC: 'Apply a template to configure PM activities, FMEA & CM for this equipment.' },
			COMING_SOON: { TITLE: 'Coming Soon', DESC: 'This feature is currently under development and will be available in a future update.' },
			MANAGER: { TITLE: 'Template Manager', EDIT_TEMPLATE: 'Edit Template', LINKED_ASSETS: 'linked assets', SUB_HEADER: 'Manage reusable PM, CM, and Failure Mode templates', COL_NAME: 'Template Name', COL_DESC: 'Description', COL_TYPE: 'Type', COL_ASSETS: 'Linked Assets', COL_ASSET: 'Assets', COL_CREATOR: 'Created By', COL_DATE: 'Last Modified', EMPTY_TITLE: 'No templates found', EMPTY_DESC: 'Saved PM, CM, and Failure Mode templates will appear here.', SELECT_DESC: 'Select a pre-built template to apply to your equipment.', SEARCH_TEMPLATE: 'Search Template...', EQ_TEMPLATE_LIBRARY: 'Equipment Template Library', COL_STATUS: 'Status', STATUS_IN_PROGRESS: 'In Progress', STATUS_READY: 'Ready for Use', STATUS_DEPRECATED: 'Deprecated', LIFECYCLE: 'More actions', LOCK: 'Lock & Mark Ready', LOCK_HINT: 'Complete the template to 100% before locking it.', UNLOCK: 'Unlock', DEPRECATE: 'Deprecate', REACTIVATE: 'Reactivate', DUPLICATING: 'Creating duplicate template of {{name}}...' },
			UPLOAD: { TITLE_PM: 'Upload PM Template', TITLE_CM: 'Upload CM Template', TITLE_FM: 'Upload Failure Modes Template', TEMPLATE_NAME: 'Template Name', ENTER_TEMPLATE: 'Enter Template Name', DRAG_DROP: 'Drag and drop your file here or', BROWSE: 'browse', REMOVE_FILE: 'Remove file' },
			PM: { TITLE: 'PM Configuration', CONFIG_FOR: 'Configuring PM Checklist for:', SELECT_HOW: 'Select how you want to configure PM activities', APPLY_TEMPLATE: 'Apply template', IMPORT_SAP: 'Import from SAP', UPLOAD_TEMPLATE: 'Upload Template', DOWNLOAD_TEMPLATE: 'Download Template', CHECKLIST_TEMPLATE: 'PM Checklist Template', SAVE_TEMPLATE: 'Save Template', EDIT_TEMPLATE: 'Edit Template', OVERALL_VARS: 'Overall PM Level Variables', OVERALL_TIME: 'Overall Time (in hours)', MUST_BE_POSITIVE: 'Enter a number greater than 0', OVERALL_MANNING: 'Overall Manning', TECH_COUNT: 'Technician (in Count)', HELPER_COUNT: 'Helper (in Count)', COST_PARTS: 'Cost of Parts (if any) (in USD)', COST_CONS: 'Cost of Consumables (in USD)', PM_INTERVAL: 'Current PM Interval (in days)', PROD_LOSS: 'Production Loss (in USD)', TAB_CHECKLIST: 'PM Checklist', ACTIVITIES_CHECKLIST: 'PM Activities Checklist', ACTIVITIES_CHECKLIST_DESC: 'List of all PM activities defined in this checklist template', ENRICH_ROOTY: 'Enrich Checklist with Rooty', ROOTY_LOADING: 'Rooty is analysing your PM activities...', ROOTY_BUNDLE_TITLE: 'Activity Bundle Suggestions', ROOTY_BUNDLE_DESC: 'Review the suggested bundles below. Confirm to proceed and generate Flags.', ROOTY_CONFIRM_BUNDLES: 'Looks good — Generate Flags', ROOTY_CONFIRM_FLAGS: 'Looks good — Generate Time per activity', ROOTY_FLAGS_READY: 'Build Flags generated. Review the tabs below.', ROOTY_FLAGS_OUTPUT: 'Build Flags Analysis', ROOTY_NO_SYSTEM: 'Save PM Activity to enable enrichment', TAB_BUNDLES: 'Activity Bundles', BUN_TITLE: 'PM Activity Bundles', BUN_DESC: 'Group PM activities into logical bundles for efficient scheduling', TAB_FLAGS: 'Build Flags', FLAG_TITLE: 'Build Flags', FLAG_DESC: 'Classify activities as regulatory, procedural, or operational', TAB_TIME: 'Time per Activity', TIME_TITLE: 'Time per Activity', TIME_DESC: 'Estimate time required for each PM activity', TAB_BETA: 'Define β', BETA_TITLE: 'Define β', BETA_DESC: 'Set sensitivity of CM/failures on PM frequency for each activity', RE_GENERATE: 'Re-Generate', CHECKLIST_CONFIG: 'PM Checklist Configuration', CONFIG_CHECKLIST_FOR: 'Configuring checklist for:', ROOTY_CANNED_1: 'Reading checklist...', ROOTY_CANNED_2: 'Analysing PM activities...', ROOTY_CANNED_3: 'Preparing suggestions...' },
			PM_APPLY: { TITLE: 'PM Checklist Template Library', STEP_1: 'Select Template', STEP_2: 'Select Equipment', STEP_1_DESC: 'Select a pre-built PM Checklist template to apply to your equipment. Templates contain configured pm activities sequences from best practices.', EMPTY: 'No Templates found.', CONFIG_FOR: 'Configured PM Template for', EXEC_SUCCESS: 'executing across interval boundaries successfully.', PM_ACTIVITIES: 'PM Activities', INTERVAL: 'Interval:', APPLIES_TO: 'Applies to:', EQ_TITLE: 'Select Equipment to Apply Template', EQ_SELECTED: 'Equipments Selected', SELECT_TEMPLATE: 'Select Template', APPLY_TEMPLATE: 'Apply Template' },
			CM: { TITLE: 'CM Configuration', CONFIG_FOR: 'Configuring CM activities for:', SELECT_HOW: 'Select how you want to configure CM activities', APPLY_TEMPLATE: 'Apply template', UPLOAD_TEMPLATE: 'Upload Template', DOWNLOAD_TEMPLATE: 'Download Template', CM_VARS: 'CM Level Variables', EQ_REDUNDANCY: 'Equipment Redundancy', PROD_LOSS: 'Production Loss', TECH_COUNT: '# of Technicians Needed', HELP_COUNT: '# of Helpers Needed', COST_CONS: 'Cost of Consumables (if any)', SPARES_COST: 'Consider Spares Cost', YES: 'Yes', NO: 'No', LABOUR_VARS: 'Labour Variables', WRENCH_TIME_VARS: 'Wrench Time Variables', WRENCH_WARNING: 'Breakdown durations may include wait time — wrench time estimates preferred over duration-based values', COL_FAILURE_MODE: 'Failure Mode', COL_ACTIVITY: 'Activity', COL_CM_COUNT: 'CM Count', COL_WRENCH_TIME: 'Est. Wrench Time (hrs)', COL_CONFIDENCE: 'Confidence', COL_OVERRIDE: 'Override (hrs)' },
			FM: { TITLE: 'Failure Modes Configuration', CONFIG_FOR: 'Configuring Failure modes for:', SELECT_HOW: 'Select how you want to configure Failure Modes', SAVED_CONF: 'Saved Configuration', RCM_ANALYSIS: 'RCM Analysis', APPLY_LIB: 'Apply from Template Library', APPLY_LIB_DESC: 'Use pre-built failure mode templates for your equipment class', APPLY_LIB_AVAIL: 'Template available: ACW Pump Template', UPLOAD_RCM: 'Upload Previous RCM Analysis', UPLOAD_RCM_DESC: 'Import failure modes from an existing RCM study file (Excel/CSV)', NEW_STUDY: 'Create New FMEA Study', NEW_STUDY_DESC: 'Start a new FMEA using the guided study wizard', APPLY_TEMPLATE: 'Apply template', CREATE_ROOTY: 'Create via ROOTY', UPLOAD_EXCEL: 'Upload from Excel', DOWNLOAD_TEMPLATE: 'Download template', COL_FM_ID: 'FM ID', COL_SUBSYSTEM: 'Subsystem', COL_COMPONENT: 'Component', COL_FUNCTION: 'Function', COL_FUNC_FAIL: 'Functional Failure', COL_FAILURE_MODE: 'Failure Mode', COL_CONSEQUENCE_CAT: 'Consequence Category', COL_FAILURE_BEHAVIOR: 'Failure Behavior', COL_PDM_APPLICABILITY: 'PdM Applicability', COL_LIKELY_CAUSES: 'Likely Causes', COL_SYMPTOMS: 'Symptoms / Indicators', COL_LOCAL_EFFECTS: 'Local Effects', COL_SYSTEM_EFFECTS: 'System Effects', COL_PLANT_EFFECTS: 'Plant Effects', COL_EFFECTS: 'Effects', COL_IMPACTS: 'Impacts', COL_EFFECT: 'Effect', COL_TYPE: 'Type', COL_STATUS: 'Status', COL_EVIDENCES: 'Evidences', COL_TOTAL_COST: 'Total Cost', COL_CATEGORY: 'Category', COF_RATING: 'CoF Rating', COF_CATEGORY: 'CoF Category', COST_SUMMARY: 'Cost Summary', REPAIR_COST: 'Repair Cost (in USD)', SAFETY_RISK_COST: 'Safety Risk Cost (in USD)', PROD_LOSS: 'Production Loss (in USD)', OUTAGE_DURATION: 'Outage Duration (in Hours)', TOTAL_COST_USD: 'Total Cost (in USD)', CONSEQUENCE_RATING: 'Consequence Rating', SAFETY: 'Safety', OPERATIONAL: 'Operational', ENVIRONMENTAL: 'Environmental', REPUTATIONAL: 'Reputational', CLASSIFICATION_HIDDEN: 'Classification: Hidden Failure', SUPPORTING_EVIDENCE: 'Supporting Evidence', VIEW_EVIDENCE: 'View Full Evidence panel', NO_FM_FOUND: 'No Failure Modes config found...', EXPAND_ADDITIONAL_INFO: 'Additional Information', PERF_STANDARD: 'Performance Standard', FM_ANCHOR_LEVEL: 'FM Anchor Level', FM_TYPE: 'FM Type', SYMPTOM_CHILDREN: 'Symptom Children', CURRENT_CONTROLS: 'Current Controls', EVIDENCE_SOURCE: 'Evidence Source', WO_EVIDENCE_REFS: 'WO Evidence References', VALIDATION_OUTCOME: 'Validation Outcome', UNVALIDATED_JUSTIFICATION: 'Unvalidated Justification', CONFIDENCE: 'Confidence', PF_INTERVAL: 'P-F Interval Estimate' },
			EDITOR: {
				SAVING: 'Saving...',
				SAVE_TEMPLATE: 'Save Template',
				SAVE_ACTIVITY: 'Save Activity',
				SAVE_PACKAGE: 'Save Equipment Package',
				CREATE_TEMPLATE: 'Create Template',
				EMPTY_TEMPLATE: 'Empty Template',
				CREATE_VIA_ROOTY: 'Create Via Rooty',
				SAVE_CONTINUE: 'Save & Continue',
				SAVE_TO_CONFIGURE: 'Save the template to start configuring PM, FMEA & CM.',
				DOWNLOAD: 'Download Template',
				UPLOAD: 'Upload Template',
				PM_CHECKLIST: 'PM Checklist',
				FMEA_CONFIG: 'Failure Modes Configuration',
				CM_CHECKLIST: 'CM Checklist (Soon)',
				DESC: 'Description',
				TEMPLATE_NAME: 'Template Name',
				OVERALL_PM_VARS: 'Overall PM Level Variables',
				SAVE_PM_ACTIVITY: 'Save PM Activity',
				SAVE_FMEA_CONFIG: 'Save FMEA Configuration',
				SAVE_CM_CONFIG: 'Save CM Configuration',
				RE_GENERATE: 'Re-generate',
				SAVED_INTERNALLY: 'successfully saved internally:',
				DEFINE_PM: 'Define PM Checklist',
				DEFINE_FM: 'Define FMEA Configuration',
				DEFINE_CM: 'Define CM Configuration',
				DEFINE_WRENCH_TIME: 'Define Wrench Time Variables',
				DEFINE_DESC: 'Download a sample or upload a completed template to generate.',
				NO_PM_ATTACHED: 'No PM configuration attached',
				NO_FM_ATTACHED: 'No Failure Modes Configuration attached',
				NO_CM_ATTACHED: 'No CM configuration attached',
				PM_CONFIG_TAB: 'PM Configuration',
				FM_CONFIG_TAB: 'FMEA Configuration',
				CM_CONFIG_TAB: 'CM Configuration',
				PM_FM_MAPPING_TAB: 'PM -> FM Mapping',
				DEFINE_PM_FM: 'Define PM-FM Mapping',
				DEFINE_PM_FM_DESC: 'Configure which PM activities mitigate failure modes for this equipment.',
				PM_FM_MAPPING_MATRIX: 'PM-FM Mapping Matrix',
				PM_FM_MAPPING_SUBHEADER: 'Configure which PM activities mitigate failure modes for {{equipment}}',
				PM_FM_SEARCH_PM: 'Search PM Activity...',
				PM_FM_SHOW_ALL: 'Show All',
				PM_FM_SHOW_MAPPED: 'Mapped',
				PM_FM_SHOW_UNMAPPED: 'Unmapped',
				PM_FM_SHOW_ZERO_COVERAGE: 'Zero Coverage',
				PM_FM_LEGEND_FULL: '1 = Fully mapped',
				PM_FM_LEGEND_PARTIAL: '0.1-0.9 = Partial relation',
				PM_FM_LEGEND_EMPTY: 'Empty = Not mapped',
				PM_FM_CONFIRM_ALL: 'Confirm All Remaining',
				PM_FM_CONFIRM_ROW: 'Confirm Mapping',
				PM_FM_UNMAP: 'Unmap',
				PM_FM_NO_PM_ATTACHED: 'No PM activities configured',
				PM_FM_NO_FM_ATTACHED: 'No failure modes configured',
				PM_FM_STALE_BANNER: 'PM or FMEA has changed since this mapping was generated. New or changed activities appear unmapped below — map them directly, or use Regenerate to have Rooty re-analyze everything from scratch (this will overwrite your reviewed mappings).',
				PM_FM_REGENERATE: 'Regenerate',
				PM_FM_UNMAPPED_COUNT: '{{count}} unmapped',
				PM_FM_ZERO_COVERAGE_HEADING: 'Zero-Coverage Failure Modes',
				PM_FM_NEW_PM_PROPOSALS: 'New PM Proposals',
				PM_FM_ACCEPT_PROPOSAL: 'Accept Proposal'
			}
		},
		CONFIGURATION: {
			CASES: {
				TITLE: 'Cases Configuration',
				LAST_UPDATED_BY: 'Last updated by {{name}} - {{date}}',
				MATRIX_TITLE: 'Likelihood Impact Matrix',
				MATRIX_SUBTITLE: '(constant M1 — usable in calculations)',
				VALUE_INPUT_TITLE: 'Value Input',
				VALUE_INPUT_SUBTITLE: '(Values that users can enter into the Value fields for a Case)',
				CALCULATIONS_TITLE: 'Calculations',
				CALCULATIONS_SUBTITLE: '(User configured value calculations inside of a case)',
				OPTIONAL_TITLE: 'Optional',
				OPTIONAL_SUBTITLE: '(Additional fields that can be added into a case for tracking purposes)',
				COL_CONSTANT: 'Constant',
				COL_UNIT_FIELD: 'Unit Field',
				COL_FIELD_UOM: 'Field UoM',
				COL_DEFAULT_VALUE: 'Default Value',
				COL_ACTIONS: 'Actions',
				COL_CALCULATION: 'Calculation',
				COL_UOM: 'UoM',
				COL_FORMULA: 'Formula',
				COL_FIELD: 'Field',
				COL_VALUE: 'Value',
				COL_UNIT_OF_MEASURE: 'Unit of Measure',
				ADD: 'Add',
				ADD_ROW: 'Add Row',
				CANCEL: 'Cancel',
				SAVE: 'Save',
				SAVE_SUCCESS: 'Cases configuration saved successfully',
				IMPACT: 'IMPACT',
				LIKELIHOOD: 'LIKELIHOOD',
				DELETE_ROW: 'Delete Row',
				PLACEHOLDER_UNIT_FIELD: 'Enter unit field',
				PLACEHOLDER_FIELD_UOM: 'Enter field UoM',
				PLACEHOLDER_DEFAULT_VALUE: 'Enter default value',
				PLACEHOLDER_CALCULATION: 'Enter calculation name',
				PLACEHOLDER_UOM: 'Enter UoM',
				PLACEHOLDER_FORMULA: 'Enter formula',
				PLACEHOLDER_FIELD_NAME: 'Enter field name',
				DUPLICATE_FIELD_NAME: 'Field name must be unique',
				PLACEHOLDER_VALUE: 'Enter value',
				PLACEHOLDER_UNIT_OF_MEASURE: 'Enter unit of measure',
				RESET_TO_DEFAULTS: 'Reset to Default',
				RESET_MATRIX_CONFIRM_TITLE: 'Reset to Default?',
				RESET_MATRIX_CONFIRM_DESC: 'This will reset the <strong>Likelihood Impact Matrix</strong> to its original default values. Any custom changes you\'ve made will be lost.',
				RESET_MATRIX_CONFIRM_OK: 'Confirm',
				LOAD_ERROR: 'Failed to load cases configuration',
				SAVE_ERROR: 'Failed to save cases configuration',
				RESET_ERROR: 'Failed to reset cases configuration',
				CONSTANT_USED_IN_FORMULA: 'This constant has been used in a formula',
				FORMULA: {
					UNDEFINED_CONSTANT: 'Constant "{{constant}}" is not defined',
					INVALID_CHARACTER: 'Formula contains an unsupported character or operator',
					UNBALANCED_PARENTHESES: 'Formula has unbalanced parentheses',
					EMPTY_PARENTHESES: 'Formula has empty parentheses',
					MISSING_OPERATOR: 'Formula is missing an operator between values',
					INVALID_OPERATOR_POSITION: 'Formula has an operator in an invalid position',
					TRAILING_OPERATOR: 'Formula cannot end with an operator'
				}
			},
			FILTER: {
				TITLE: 'Filters',
				SEARCH: 'Search'
			},
			ASSET_TEMPLATE: {
				TITLE: 'Asset Template list',
				SEARCH: 'Search',
				TOOLTIP_ADD: 'Add New Asset',
				TOOLTIP_DELETE: 'Delete Asset',
				TOOLTIP_SYNC: 'Sync',
				TOOLTIP_SYNC_PROGRESS: 'Sync in Progress',
				SYNC_STARTED_TOAST: 'Asset template sync started.',
				SYNC_COMPLETED_TOAST: 'Asset template sync completed.',
				SYNC_FAILED_TOAST: 'Asset template sync failed{{errorSuffix}}.',
				COL_INDEX: 'Sl. No.',
				COL_TEMPLATE_NAME: 'Template Name',
				COL_APPLICATION: 'Application',
				COL_CREATED_ON: 'Created On',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'No records found',
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search',
				LOADING: 'Loading...'
			},
			TAGS: {
				TOOLTIP_UPLOAD_SCADA: 'Upload Tag Scada Mapping',
				TITLE: 'Tag list',
				SEARCH: 'Search',
				TOOLTIP_ADD: 'Add New Tag',
				TOOLTIP_UPLOAD: 'Upload Tags',
				TOOLTIP_DOWNLOAD: 'Download Tag List',
				TOOLTIP_TAG_MAPPING: 'Visit for Tag Mapping',
				TOOLTIP_DELETE: 'Delete Tag',
				TOOLTIP_NO_FAILURE_MODES: 'No Associated Failure Modes',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				COL_INDEX: 'Sl. No.',
				COL_NAME: 'Name',
				COL_TAG_ID: 'Tag Id',
				COL_SHARED: 'Shared',
				COL_UNIT: 'Unit',
				COL_FAILURE_MODES: 'Failure Mode(s)',
				COL_MODELLING: 'Used for Modelling',
				COL_CALCULATED: 'Calculated',
				COL_DESCRIPTION: 'Description',
				COL_ASSET: 'Asset',
				COL_ACTIONS: 'Actions',
				NO_TAGS: 'No tags available for the selected asset',
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search'
			},
			FAILURE_MODE: {
				TITLE: 'Failure Mode list',
				SEARCH: 'Search',
				TOOLTIP_UPLOAD: 'Upload Failure Modes',
				TOOLTIP_ADD: 'Add New Failure Mode',
				TOOLTIP_EDIT: 'Edit Failure Mode',
				TOOLTIP_FILTER: 'Filter',
				TOOLTIP_DELETE: 'Delete',
				TOOLTIP_EDIT_DIRECTIONALITY: 'Edit Tag Directionality',
				COL_INDEX: 'Sl. No.',
				COL_NAME: 'Name',
				COL_DESCRIPTION: 'Description',
				COL_TAG: 'Tag',
				COL_ASSET: 'Asset',
				COL_RECOMMENDATIONS: 'Recommendations',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'No records found'
			},
			DIGITIZATION: {
				TITLE: 'Digitization list',
				SEARCH: 'Search',
				TOOLTIP_ADD: 'Add new digitalization',
				TOOLTIP_DELETE: 'Delete Digitization',
				COL_INDEX: 'Sl. No.',
				COL_MANUFACTURER: 'Manufacturer',
				COL_MODEL: 'Model',
				COL_INDUSTRY_TYPE: 'Industry Type',
				COL_MODIFIED_ON: 'Modified On',
				COL_CREATED_ON: 'Created On',
				NO_RECORDS: 'No records found',
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search'
			},
			TABS: {
				ASSET_TEMPLATE: 'Asset Template',
				ASSETS: 'Assets',
				DIGITIZATION: 'Digitization',
				SETTINGS: 'Settings',
				CASES: 'Cases'
			},
			SETTINGS: {
				TITLE: 'Update Settings',
				COL_INDEX: '#',
				COL_PAGE_NAME: 'Page Name',
				COL_LAST_UPDATED: 'Last Updated',
				COL_UPDATED_BY: 'Updated by',
				TOOLTIP_SETTINGS: 'Settings',
				LOADING: 'Loading settings...',
				NO_SETTINGS: 'No settings found'
			},
			ASSETS: {
				TITLE: 'Assets list',
				SEARCH: 'Search',
				TOOLTIP_FILTER: 'Filter Asset',
				TOOLTIP_DELETE: 'Delete Asset',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				COL_INDEX: 'Sl. No.',
				COL_NAME: 'Asset Name',
				COL_TYPE: 'Asset Type',
				COL_UNIT: 'Unit',
				COL_SYSTEM: 'System',
				COL_APPLICATION: 'Application',
				COL_CONFIGURATION: 'Configuration',
				COL_INDUSTRY: 'Industry',
				COL_AUTHOR: 'Author',
				COL_MAKE_MODEL: 'Make & Model',
				COL_MAINTENANCE: 'Maintenance Data',
				NO_RECORDS: 'No records found',
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search',
			},
			FM_MAPPING_MENU: {
				HIGH: 'High',
				LOW: 'Low',
				STABLE: 'Stable',
				REFERENCE: 'Reference',
				UNMAPPED: 'Unmapped',
				TOOLTIP_HIGH_PRIMARY: 'High - Primary Failure Mode',
				TOOLTIP_HIGH_SECONDARY: 'High - Secondary Failure Mode',
				TOOLTIP_LOW_PRIMARY: 'Low - Primary Failure Mode',
				TOOLTIP_LOW_SECONDARY: 'Low - Secondary Failure Mode',
				TOOLTIP_STABLE_PRIMARY: 'Stable - Primary Failure Mode',
				TOOLTIP_STABLE_SECONDARY: 'Stable - Secondary Failure Mode',
				TOOLTIP_REFERENCE: 'Reference Failure Mode',
				FM_LOGIC: 'FM Logic',
				HIGH_INCREASING: 'High/Increasing',
				LOW_DECREASING: 'Low/Decreasing',
				RULE_BASED: 'Rule Based',
				UNMAP: 'Unmap',
				RULE_BASED_CONDITION: 'Rule Based Condition',
				OPERATOR: 'Operator',
				COMPARE_TO: 'Compare To',
				ENTER_VALUE: 'Enter Value',
				NUMERIC_INPUT_ONLY: 'Numeric input only',
				PREFERENCE: 'Preference',
				APPLY: 'Apply'
			},
			QUICK_FILTER: {
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search',
				CLOSE: 'Close',
			},
			DIGITIZATION_POPUP: {
				FORM_ERROR: 'Oh snap! Manufacturer and Model Name already taken. Change a few things up and try submitting again.',
				MANUFACTURER: 'Manufacturer',
				MANUFACTURER_NAME: 'Manufacturer Name',
				MODEL: 'Model',
				MODEL_NAME: 'Model Name',
				INDUSTRY_TYPE: 'Industry Type',
				ENTER: 'Enter',
				SELECT: 'Select',
				IS: 'is',
				CUT_IN_SPEED: 'Cut In Speed(m/s)',
				CUT_IN_SPEED_LABEL: 'Cut in Speed',
				CUT_OFF_SPEED: 'Cut Off Speed(m/s)',
				CUT_OFF_SPEED_LABEL: 'Cut Off Speed',
				CAPACITY_KWH: 'Enter value in KWH',
				CAPACITY: 'Capacity',
				IS_REQUIRED: 'is required',
				SMALLER_THAN_CUTOFF: 'should be smaller than cutoff',
				GREATER_THAN_CUTIN: 'should be greater than cutin',
				GREATER_THAN_ZERO: 'should be greater than 0',
				POWER_CURVE: 'Power Curve',
				REQUIRED: 'required',
				UPLOAD_POWER_CURVE: 'Upload Power Curve',
				DOWNLOAD_SAMPLE: 'Download Sample/Previously Uploaded File',
				VIEW_POWER_CURVE: 'View Uploaded Power Curve Data',
				ERROR_CODE_MAP: 'Error code map',
				UPLOAD_SCADA: 'Upload SCADA Event Code',
				VIEW_SCADA: 'View Uploaded SCADA Event Code Data',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			FAILURE_MODE_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME: 'Name',
				IS: 'is',
				PRIORITY: 'Priority',
				REQUIRED: 'required',
				START_TIME: 'Start Time (in hrs)',
				START_TIME_LABEL: 'Start Time',
				END_TIME: 'End Time (in hrs)',
				END_TIME_LABEL: 'End Time',
				IS_REQUIRED: 'is required',
				TIME_RANGE: 'range should be between 0.1 to 48 hrs',
				DESCRIPTION: 'Description',
				RELIABILITY_SAVINGS: 'Reliability Savings (Potential)',
				MAINTENANCE_SAVINGS: 'Maintenance Savings (Potential)',
				PERFORMANCE_SAVINGS: 'Performance Savings (Potential)',
				REMARK: 'Remark',
				REMARK_TO_EDIT: 'Remark to Edit',
				ENTER: 'Enter',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAG_DIRECTIONALITY_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				TAG_NAME: 'Tag Name',
				DIRECTIONALITY: 'Directionality',
				SELECT: 'Select',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			FM_RECOMMENDATION_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				RECOMMENDATION: 'Recommendation',
				IS: 'is',
				CATEGORY: 'Category',
				SELECT: 'Select',
				SELECT_FAILURE: 'Select Failure',
				FAILURE: 'Failure',
				REMARK: 'Remark',
				REMARK_TO_EDIT: 'Remark to Edit',
				ENTER: 'Enter',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAGS_POPUP: {
				FORECASTING: 'Forecasting',
				PERFORMANCE_DEGRADATION: 'Performance Degradation',
				PERFORMANCE_DEGRADATION_HINT: '(Enable Time to Intervention forecasting for this tag)',
				DYNAMIC_DEVIATION_THRESHOLD: 'Dynamic Deviation Threshold',
				DEVIATION_LOW: 'Low',
				DEVIATION_MEDIUM: 'Medium',
				DEVIATION_HIGH: 'High',
				ERRATIC_DETECTION: 'Erratic Detection',
				ERRATIC_ALERT: 'Erratic Alert',
				MISSING_DATA_DETECTION: 'Missing Data Detection',
				OUTLIER_DETECTION: 'Outlier Detection',
				OUT_OF_RANGE_DETECTION: 'Out of Range Detection',
				DATA_QUALITY_ALERT_GENERATION: 'DATA QUALITY ALERT GENERATION',
				DATA_QUALITY_ALERT_DESC: 'Choose which detected DQ issues should generate alerts. Turning off alert generation does not stop DQ calculation. Values will still appear in the DQ tables.',
				FLATLINE_ALERT: 'Flatline Alert',
				MISSING_DATA_ALERT: 'Missing Data Alert',
				OUTLIER_ALERT: 'Outlier Alert',
				OUT_OF_RANGE_ALERT: 'Out of Range Alert',
				ALERTS_NOTIFICATIONS_KPI: 'Alerts, Notifications & KPI',
				OPERATIONAL_LIMITS: 'Operational Limits',
				ADDITIONAL_SETTINGS: 'Additional Settings',
				NO_TAGS_WITH_TAGID_MAPPED: 'No tags found with TagId mapped.',
				FUNCTION_NAME: 'Function Name',
				DATA_QUALITY_DETECTION: 'Data Quality Detection',
				SELECT_TAG_TO_ADD_MORE: 'Select the first tag to enable adding more tags',
				ENTER_FORMULA: 'Enter Formula*',
				LOWER: 'Lower',
				UPPER: 'Upper',
				START: 'Start',
				END: 'End',
				DEADLINE: 'Deadline',
				FORMULA_PLACEHOLDER: 'Write the formula. e.g (t1+t2)*t3',
				SELECT_TAG: 'Select Tag',
				SELECT_KEY: 'Select Key',
				VALUE: 'Value',
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				TAG_NAME: 'Tag Name',
				DESCRIPTION: 'Description',
				TAG_ID: 'Tag Id',
				UNIT: 'Unit',
				INSTRUMENT_RANGE: 'Instrument Range',
				TRIP_LIMITS: 'Trip Limits',
				THRESHOLD_ALERT: 'Threshold Alert',
				THRESHOLD_ALERT_DELAY: 'Threshold Alert Delay',
				IOW_CRITICALITY: 'IOW Criticality',
				DIRECTIONALITY: 'Directionality',
				DIRECTION: 'Direction',
				FLATLINE_DETECTION: 'Flatline Detection',
				ATTENTION: 'Attention',
				THRESHOLD_NOTIFICATION: 'Threshold Notification',
				KPI: 'KPI',
				STRING_CURRENT: 'String Current',
				STRING_CAPACITY: 'String Capacity',
				SCADA_ERROR_CODES: 'Scada Error Codes',
				COMMA_SEPARATED_ERROR_CODES: 'Add comma separated error codes',
				ASSET: 'Asset',
				CALCULATED_FLAG: 'Calculated Flag',
				REMARK: 'Remark',
				REMARK_TO_EDIT: 'Remark to Edit',
				FUNCTION_TABLE: 'Function Table',
				PARAMETERS: 'Parameters',
				CONSTANTS: 'Constants',
				PLOT_CONTINUOUS: 'Plot as continuous line trend (ignore missing values)',
				ENTER: 'Enter',
				SELECT: 'Select',
				WRITE_CUSTOM_CODE: 'Write Custom Code',
				UPLOAD_TAGS: 'Upload Tags',
				DOWNLOAD_CORRELATION_CSV: 'Download Correlation CSV Format',
				UPLOAD_CORRELATION_CSV: 'Upload Correlation CSV',
				DELETE: 'Delete',
				ADD: 'Add',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes',
				ALARM_LIMITS: 'Alarm Limits',
				THRESHOLD_LIMITS: 'Threshold Limits',
				CORRELATION_CSV_UPLOAD_LABEL: 'Correlation CSV Upload',
				TRIAL_RUN: 'Trial Run',
				SELECT_PYTHON_FUNCTION: 'Select Python Function',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Search functions...',
				NO_MATCHING_FUNCTION_FOUND: 'No matching function found',
				SELECT_FUNCTION_ERROR: 'Please select a Python function',
				DEPRECATED: 'Deprecated',
				DEPRECATED_FORMULA_TOOLTIP: 'This formula is deprecated. Please select the updated formula.',
				DEPRECATED_FORMULA_ERROR: 'This formula is deprecated. Please select the updated formula.',
				CUSTOM_FORMULA_INVALID_VARS: 'Invalid variable(s) used',
				CUSTOM_FORMULA_INVALID_SYNTAX: 'Invalid variable(s)/ mathematical expression',
				CUSTOM_FORMULA_REQUIRED: 'Formula is required',
				SEARCH_ASSETS_PLACEHOLDER: 'Search assets...',
				NO_MATCHING_ASSET_FOUND: 'No matching asset found',
				SEARCH_DOTS: 'Search...',
				NO_MATCHING_TAG_FOUND: 'No matching Tag found',
				NO_TAGS_FOUND_WITH_TAGID_MAPPED: 'No tags found with TagId mapped.',
				SEARCH_PLAIN: 'Search',
				NO_MATCHING_KEY_FOUND: 'No matching Key found',
				PARAMETER_NAME_HINT: 'Parameter Name',
				CONSTANT_NAME_HINT: 'Constant Name',
				DISPLAY_EXPRESSION: 'Display Expression',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Enter expression',
				EXPRESSION_DESCRIPTION: 'Expression Description',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Enter expression description'
			},
			ASSET_TEMPLATE_DELETE: {
				TITLE: 'Asset Delete Confirmation',
				CONFIRM_MSG: 'Are you sure you want to delete the asset?',
				ASSOCIATED_ITEMS_MSG: 'Do you also want to delete the following items associated with the asset?',
				DELETE_TAGS: 'Delete Associated Tags',
				DELETE_FAILURE_MODES: 'Delete Associated Failure Modes',
				DELETING: 'Deleting...',
				CANCEL: 'Cancel',
				DELETE: 'Delete'
			},
			FM_INFO: {
				TITLE: 'Failure Mode Information',
				TOOLTIP_ADD: 'Add',
				TOOLTIP_EDIT: 'Edit',
				TOOLTIP_UPLOAD: 'Upload',
				TOOLTIP_DOWNLOAD: 'Download',
				TOOLTIP_EDIT_MAPPING: 'Edit Mapping',
				TOOLTIP_DELETE: 'Delete',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				UPLOAD_FAILURE_MODES: 'Upload Failure Modes',
				UPLOAD_FM_TAG_MAPPINGS: 'Upload Failure-to-Tag Mappings',
				DOWNLOAD_FAILURE_MODES: 'Download Failure Modes',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Download Failure-to-Tag Mappings',
				COL_FAILURE_MODE: 'Failure mode',
				COL_START_TIME: 'Start Time',
				COL_END_TIME: 'End Time',
				COL_PRIORITY: 'Priority',
				COL_ACTIONS: 'Actions',
				PRIORITY_DESCRIPTION: 'Impact priority description',
				NO_RECORDS: 'No failure modes available for the selected asset'
			},
			RECOMMENDATIONS: {
				TITLE: 'Recommendations',
				TOOLTIP_ADD: 'Add',
				TOOLTIP_EDIT: 'Edit',
				TOOLTIP_UPLOAD: 'Upload',
				TOOLTIP_DOWNLOAD: 'Download',
				TOOLTIP_EDIT_MAPPING: 'Edit Mechanisms to Recommendations Mapping',
				TOOLTIP_DELETE: 'Delete',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				UPLOAD_RECOMMENDATIONS: 'Upload Recommendations',
				UPLOAD_REC_FM_MAPPINGS: 'Upload Recommendation-to-FM Mappings',
				DOWNLOAD_RECOMMENDATIONS: 'Download Recommendations',
				DOWNLOAD_REC_FM_MAPPINGS: 'Download Recommendation-to-FM Mappings',
				COL_RECOMMENDATIONS: 'Recommendations',
				COL_CATEGORY: 'Category',
				NO_RECORDS: 'No recommendations available for the selected asset'
			},
			ASSET_TEMPLATE_SYNC: {
				SYNC_MSG: 'Following changes have been made in the Asset Template. Please verify and decide whether these have to be synced to Assets created using this template or not.',
				ASSETS: 'Assets',
				SELECT_ALL: 'Select All',
				TAGS: 'Tags',
				FAILURES: 'Failures',
				RECOMMENDATIONS: 'Recommendations',
				CLOSE_TOOLTIP: 'Close Popup',
				CANCEL: 'Close',
				DONT_SYNC: 'Don\'t Sync',
				DONT_SYNC_TOOLTIP: 'Don\'t Sync changes',
				SYNC: 'Sync',
				SYNC_TOOLTIP: 'Sync changes'
			},
			TAG_TEMPLATE_LIST: {
				TITLE: 'Tag list',
				SEARCH: 'Search',
				TOOLTIP_SEARCH: 'Search',
				TOOLTIP_ADD: 'Add New Tag',
				TOOLTIP_UPLOAD: 'Upload Tags',
				TOOLTIP_DOWNLOAD: 'Download Tag List',
				TOOLTIP_CLONE: 'Clone Tag',
				TOOLTIP_DELETE: 'Delete Tag',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				COL_INDEX: 'Sl. No.',
				COL_TAG_TYPE: 'Tag Type',
				COL_NAME: 'Name',
				COL_DESCRIPTION: 'Tag Description',
				COL_UNIT: 'Unit',
				COL_FAILURE_MODES: 'Failure Mode(s)',
				COL_DIRECTIONALITY: 'Directionality',
				COL_CALCULATED: 'Calculated',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'No tags available for the selected asset',
				TOOLTIP_NO_FM: 'No Associated Failure Modes',
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search',
				LOADING: 'Loading...'
			},
			SUBSYSTEMS: {
				TITLE: 'Subsystems',
				SEARCH: 'Search'
			},
			ASSET_TEMPLATE_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME: 'Name',
				IS: 'is',
				ALREADY_TAKEN: 'Already taken',
				TEMPLATE_NAME: 'Template Name',
				APPLICATION: 'Application',
				TEMPLATE_APPLICATION: 'Template Application',
				PLEASE_ENTER: 'Please enter',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			ASSETS_FM_INFO: {
				TITLE: 'Failure Mode Information',
				TOOLTIP_ADD: 'Add',
				TOOLTIP_EDIT: 'Edit',
				TOOLTIP_UPLOAD: 'Upload',
				TOOLTIP_DOWNLOAD: 'Download',
				TOOLTIP_EDIT_MAPPING: 'Edit Tag to Mechanisms',
				TOOLTIP_DELETE: 'Delete',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				UPLOAD_FAILURE_MODES: 'Upload Failure Modes',
				UPLOAD_FM_TAG_MAPPINGS: 'Upload Failure-to-Tag Mappings',
				DOWNLOAD_FAILURE_MODES: 'Download Failure Modes',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Download Failure-to-Tag Mappings',
				COL_STATUS: 'Status',
				COL_FAILURE_MODE: 'Failure Mode',
				COL_PRIORITY: 'Priority',
				COL_START_TIME: 'Start Time',
				COL_END_TIME: 'End Time',
				COL_ACTIONS: 'Actions',
				PRIORITY_DESCRIPTION: 'Impact priority description',
				NO_RECORDS: 'No failure modes available for the selected asset'
			},
			TAG_FM_POPUP: {
				TITLE: 'Tag to Mechanisms',
				TAG_NAME: 'Tag Name',
				SEARCH_TAG: 'Search Tag',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes',
				NO_RECORDS: "No tags and failure modes found",
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search',
			},
			ASSETS_RECOMMENDATIONS: {
				TITLE: 'Recommendations',
				TOOLTIP_ADD: 'Add',
				TOOLTIP_EDIT: 'Edit',
				TOOLTIP_UPLOAD: 'Upload',
				TOOLTIP_DOWNLOAD: 'Download',
				TOOLTIP_EDIT_MAPPING: 'Edit Mechanisms to Recommendations Mapping',
				TOOLTIP_DELETE: 'Delete',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				UPLOAD_RECOMMENDATIONS: 'Upload Recommendations',
				UPLOAD_REC_FM_MAPPINGS: 'Upload Recommendation-to-FM Mappings',
				DOWNLOAD_RECOMMENDATIONS: 'Download Recommendations',
				DOWNLOAD_REC_FM_MAPPINGS: 'Download Recommendation-to-FM Mappings',
				COL_RECOMMENDATIONS: 'Recommendations',
				COL_CATEGORY: 'Category',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'No recommendations available for the selected asset'
			},
			REC_FM_POPUP: {
				TITLE: 'Mechanisms to Recommendations',
				RECOMMENDATION: 'Recommendation',
				CATEGORY: 'Category',
				OFFLINE: 'Offline',
				ONLINE: 'Online',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			ASSET_DELETE: {
				TITLE: 'Asset Delete Confirmation',
				CONFIRM_MSG: 'Are you sure you want to delete the asset?',
				ASSOCIATED_ITEMS_MSG: 'Do you also want to delete the following items associated with the asset?',
				DELETE_TAGS: 'Delete Associated Tags',
				DELETE_FAILURE_MODES: 'Delete Associated Failure Modes',
				DELETING: 'Deleting...',
				CANCEL: 'Cancel',
				DELETE: 'Delete'
			},
			ASSET_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				ASSET_NAME: 'Asset Name',
				ASSET_MODEL: 'Asset Model',
				ASSET_ID: 'Asset Id',
				DEPLOYED_DATE: 'Deployed Date',
				SYSTEM: 'System',
				MAINTENANCE_DATA: 'Maintenance Data',
				PROVIDER_DATA: 'Provider Data',
				ENTER: 'Enter',
				SELECT: 'Select',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			NAME_MAPPING: {
				TITLE_TAG_FM: 'Tag to Mechanisms Upload',
				TITLE_REC_FM: 'Recommendation to Mechanisms Upload',
				TAG_NAME_MAPPING: 'Tag Name Mapping',
				REC_NAME_MAPPING: 'Recommendation Name Mapping',
				TAG_NAME: 'Tag Name',
				RECOMMENDATION_NAME: 'Recommendation Name',
				TAG_NAME_OPTIONS: 'Tag Name Options',
				REC_NAME_OPTIONS: 'Recommendation Name Options',
				OPTIONS_PLACEHOLDER: 'Options',
				NO_TAG_SUGGESTIONS: 'No suggestions found. This tag will be not be used in the final mapping.',
				TAG_DELETED_FROM_MAPPING: 'Tag deleted from mapping',
				NO_REC_SUGGESTIONS: 'No suggestions found. This recommendation will be not be used in the final mapping.',
				REC_DELETED_FROM_MAPPING: 'Recommendation deleted from mapping',
				FM_DELETED_FROM_MAPPING: 'FailureMode deleted from mapping',
				ACTIONS: 'Actions',
				FM_MAPPING: 'Failure Mode Mapping',
				FM_NAME: 'FailureMode Name',
				FM_OPTIONS: 'Failure Mode Options',
				TOOLTIP_CLEAR: 'Clear Selection',
				TOOLTIP_DELETE_TAG: 'Delete Tag',
				TOOLTIP_UNDO_TAG: 'Undo Tag delete',
				TOOLTIP_DELETE_FM: 'Delete Failure mode',
				TOOLTIP_UNDO_FM: 'Undo FailureMode delete',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAG_TEMPLATE_POPUP: {
				ERRATIC_DETECTION: 'Erratic Detection',
				ERRATIC_ALERT: 'Erratic Alert',
				MISSING_DATA_DETECTION: 'Missing Data Detection',
				OUTLIER_DETECTION: 'Outlier Detection',
				OUT_OF_RANGE_DETECTION: 'Out of Range Detection',
				DATA_QUALITY_ALERT_GENERATION: 'DATA QUALITY ALERT GENERATION',
				DATA_QUALITY_ALERT_DESC: 'Choose which detected DQ issues should generate alerts. Turning off alert generation does not stop DQ calculation. Values will still appear in the DQ tables.',
				FLATLINE_ALERT: 'Flatline Alert',
				MISSING_DATA_ALERT: 'Missing Data Alert',
				OUTLIER_ALERT: 'Outlier Alert',
				OUT_OF_RANGE_ALERT: 'Out of Range Alert',
				ALERTS_AND_NOTIFICATIONS: 'Alerts & Notifications',
				OPERATIONAL_LIMITS: 'Operational Limits',
				DATA_QUALITY_DETECTION: 'Data Quality Detection',
				SELECT_TAG_TO_ADD_MORE: 'Select the first tag to enable adding more tags',
				LOWER_RANGE: 'Lower Range',
				UPPER_RANGE: 'Upper Range',
				LOWER: 'Lower',
				UPPER: 'Upper',
				ALARM_LIMITS: 'Alarm Limits',
				THRESHOLD_LIMITS: 'Threshold Limits',
				START: 'Start',
				END: 'End',
				FORMULA_PLACEHOLDER: 'Write the formula. e.g (t1+t2)*t3',
				SELECT_TAG: 'Select Tag',
				VALUE: 'Value',
				DELETE: 'Delete',
				ADD: 'Add',
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				TAG_TYPE: 'Tag Type',
				TAG_NAME: 'Tag Name',
				TAG_DESCRIPTION: 'Tag Description',
				DESCRIPTION: 'Description',
				UNIT: 'Unit',
				INSTRUMENT_RANGE: 'Instrument Range',
				TRIP_LIMITS: 'Trip Limits',
				THRESHOLD_ALERT: 'Threshold Alert',
				THRESHOLD_ALERT_DELAY: 'Threshold Alert Delay',
				DESIGN_VALUE: 'Design Value',
				DIRECTIONALITY: 'Directionality',
				DIRECTION: 'Direction',
				IOW_CRITICALITY: 'IOW Criticality',
				FLATLINE_DETECTION: 'Flatline Detection',
				ATTENTION: 'Attention',
				THRESHOLD_NOTIFICATION: 'Threshold Notification',
				CALCULATED_FLAG: 'Calculated Flag',
				PARAMETERS: 'Parameters',
				CONSTANTS: 'Constants',
				UPLOAD_TAGS: 'Upload Tags',
				ENTER: 'Enter',
				SELECT: 'Select',
				SELECT_PYTHON_FUNCTION: 'Select Python Function',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Search functions...',
				NO_MATCHING_FUNCTION_FOUND: 'No matching function found',
				SELECT_FUNCTION_ERROR: 'Please select a Python function',
				SEARCH_TAG_TYPE_PLACEHOLDER: 'Search tag type...',
				NO_MATCHING_TAG_TYPE_FOUND: 'No matching tag type found',
				SEARCH_DOTS: 'Search...',
				NO_MATCHING_TAG_FOUND: 'No matching Tag found',
				PARAMETER_NAME_HINT: 'Parameter Name',
				CONSTANT_NAME_HINT: 'Constant Name',
				DISPLAY_EXPRESSION: 'Display Expression',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Enter expression',
				EXPRESSION_DESCRIPTION: 'Expression Description',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Enter expression description',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			TEMPLATE_NAME_MAPPING: {
				TITLE: 'Tag to Mechanisms',
				TAG_NAME_MAPPING: 'Tag Name Mapping',
				TAG_NAME: 'Tag Name',
				TAG_NAME_OPTIONS: 'Tag Name Options',
				OPTIONS_PLACEHOLDER: 'Options',
				NO_TAG_SUGGESTIONS: 'No suggestions found. This tag will be not be used in the final mapping.',
				TAG_DELETED_FROM_MAPPING: 'Tag deleted from mapping',
				FM_DELETED_FROM_MAPPING: 'FailureMode deleted from mapping',
				ACTIONS: 'Actions',
				FM_MAPPING: 'Failure Mode Mapping',
				FM_NAME: 'FailureMode Name',
				FM_OPTIONS: 'Failure Mode Options',
				TOOLTIP_CLEAR: 'Clear Selection',
				TOOLTIP_DELETE_TAG: 'Delete Tag',
				TOOLTIP_UNDO_TAG: 'Undo Tag delete',
				TOOLTIP_DELETE_FM: 'Delete Failure mode',
				TOOLTIP_UNDO_FM: 'Undo FailureMode delete',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			FM_INFO_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME: 'Name',
				PRIORITY: 'Priority',
				START_TIME: 'Start Time (in hrs)',
				START_TIME_LABEL: 'Start Time',
				END_TIME: 'End Time (in hrs)',
				END_TIME_LABEL: 'End Time',
				IS: 'is',
				REQUIRED: 'required',
				DESCRIPTION: 'Description',
				RELIABILITY_SAVINGS: 'Reliability Savings (Potential)',
				MAINTENANCE_SAVINGS: 'Maintenance Savings (Potential)',
				PERFORMANCE_SAVINGS: 'Performance Savings (Potential)',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAG_FM_INFO_POPUP: {
				TITLE: "Tag Template Failure Mode Mapper",
				TAG_NAME: "Tag Name",
				SEARCH_TAG: "Search Tag",
				NAME: "Name",
				TAG_ID: "Tag ID",
				CANCEL: "Cancel",
				CANCEL_TOOLTIP: "Cancel changes",
				SAVE: "Save",
				SAVE_TOOLTIP: "Save changes",
				NO_RECORDS: "No tags and failure modes found",
				NO_MATCHES: 'No results found for "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Try a different keyword or clear the search',
			},
			RECOMMENDATIONS_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				RECOMMENDATION: 'Recommendation',
				IS: 'is',
				CATEGORY: 'Category',
				SELECT: 'Select',
				SELECT_FAILURE: 'Select Failure',
				FAILURE: 'Failure',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			REC_TEMPLATE_FM_POPUP: {
				TITLE: 'Mechanisms to Recommendations',
				RECOMMENDATION: 'Recommendation',
				CATEGORY: 'Category',
				OFFLINE: 'Offline',
				ONLINE: 'Online',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			},
			SUBSYSTEM_TEMPLATE: {
				TITLE: 'Subsystem Template list',
				SEARCH: 'Search',
				TOOLTIP_ADD: 'Add New Subsystem Template',
				TOOLTIP_EDIT: 'Edit Subsystem Template',
				TOOLTIP_DELETE: 'Delete Subsystem Template',
				COL_INDEX: 'Sl. No.',
				COL_NAME: 'Name',
				COL_DESCRIPTION: 'Description',
				COL_CREATED_ON: 'Created On'
			},
			SUBSYSTEM_TEMPLATE_DELETE: {
				TITLE: 'Subsystem Template Delete Confirmation',
				CONFIRM_MSG: 'Are you sure you want to delete the Subsystem Template ?',
				DELETING: 'Deleting...',
				CANCEL: 'Cancel',
				DELETE: 'Delete'
			},
			SUBSYSTEM_TEMPLATE_POPUP: {
				ADD_TITLE: 'Add Subsystem Template',
				EDIT_TITLE_PREFIX: 'Edit Subsystem Template',
				NAME: 'Name',
				DESCRIPTION: 'Description',
				NAME_TAKEN_ERROR: 'Name is Already taken',
				NAME_REQUIRED_ERROR: 'Name is required',
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				CANCEL: 'Cancel',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Save',
				SAVE_TOOLTIP: 'Save changes'
			}

		},
		ADVANCED_ANALYSIS: {
			TABS: {
				ADVANCED_ANALYSIS: 'Advanced Analysis',
				RENEWABLES: 'Renewables',
				SUMMARY: 'Summary',
				DOWNTIME: 'Downtime',
				UNDERPERFORMANCE: 'Underperformance',
				CURTAILMENT: 'Curtailment',
				SOILING_LOSS: 'Soiling Loss',
				LOSS_BUCKETING: 'Loss Bucketing',
				MAINTENANCE: 'Maintenance'
			},
			TOOLBAR: {
				SELECT_ANALYSIS: 'Select Analysis',
				SEARCH_ANALYSIS: 'Search analysis...',
				NO_MATCHING_ANALYSIS: 'No matching analysis found',
				PUBLIC: 'Public',
				SAVE_ALL: 'Save All',
				TOOLTIP_SAVE_ALL: 'Save All Changes',
				TOOLTIP_DOWNLOAD: 'Download Stats For All Analysis',
				ANALYSIS_TYPE: 'Analysis Type'
			},
			HEADER: {
				CREATED_BY: 'by',
				CREATED_ON: 'Created on:'
			},
			EMPTY_STATE: {
				HEADING: 'Select an existing analysis or create a new one',
				CONTENT: 'Please select or add an Analysis.'
			},
			DESCRIPTION_LABEL: 'Description:',
			POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME_PLACEHOLDER: 'Name',
				NAME_ERROR_TAKEN: 'Already taken',
				NAME_HINT: 'Please enter',
				NAME_HINT_STRONG: 'Analysis Name',
				DESC_PLACEHOLDER: 'Description',
				DESC_ERROR_PREFIX: 'Description is',
				DESC_HINT: 'Please enter',
				DESC_HINT_STRONG: 'Analysis description',
				SELECT_FACILITY: 'Select Facility',
				SEARCH_FACILITY: 'Search',
				NO_MATCHING_FACILITY: 'No matching facility found',
				TOOLTIP_CANCEL: 'Cancel changes',
				TOOLTIP_SAVE: 'Save changes',
				BTN_CANCEL: 'Cancel',
				BTN_SAVE: 'Save'
			},
			SAVE_CONFIRMATION: {
				TITLE: 'Unsaved Changes',
				MESSAGE: 'There are unsaved changes. Do you want to continue?',
				BTN_CANCEL: 'Cancel',
				BTN_SAVE_CONTINUE: 'Save and Continue',
				BTN_DISCARD: 'Discard changes and Continue'
			},
			COMMON: {
				BTN_OK: 'Ok',
				BTN_CANCEL: 'Cancel',
				BTN_CLOSE: 'Close',
				BTN_RESET: 'Reset',
				BTN_SAVE: 'Save',
				LOADING: 'Loading...',
				NO_RECORDS: 'No records found',
				SEARCH: 'Search',
				SEARCH_PLACEHOLDER: 'Search...',
				TOOLTIP_DELETE: 'Delete',
				TOOLTIP_ADD: 'Add',
				TOOLTIP_DOWNLOAD: 'Download',
				TOOLTIP_CANCEL: 'Cancel changes',
				TOOLTIP_SAVE: 'Save changes',
				TOOLTIP_REMOVE_CARD: 'Remove Card',
				DATE_RANGE: 'Date Range'
			},
			FILTER: {
				TITLE: 'Filter',
				UNIT: 'Unit',
				SYSTEM: 'System',
				SEARCH_SYSTEM: 'Search System...',
				NO_MATCHING_SYSTEM: 'No matching system found'
			},
			BUCKETING_FILTER: {
				FACILITY_TYPE: 'Facility Type',
				SELECT_FACILITY: 'Select Facility',
				TOOLTIP_CARD_VIEW: 'Card View',
				TOOLTIP_TABLE_VIEW: 'Table View',
				SEARCH_SYSTEM: 'Search System...',
				NO_SYSTEM_FOUND: 'No system found',
				GROUP_BY: 'Group By:',
				ENABLE_CLUSTERING: 'Enable Clustering',
				SELECT_CLUSTER: 'Select Cluster',
				WIND_DIRECTION: 'Wind Direction',
				SELECTED_DATE_RANGE: 'Selected Date Range',
				START_DATE: 'Start date',
				END_DATE: 'End date',
				CONFIGURE_LOSS: 'Configure Loss',
				SAP_FILTER_TITLE: 'SAP Field(s) Filter:'
			},
			BUCKETING_TABLE: {
				SEARCH: 'Search',
				SORT_BY: 'Sort By',
				SORT_NONE: 'None',
				SORT_ASC: 'Ascending',
				SORT_DESC: 'Descending',
				COL_NAME: 'Name',
				COL_GENERATION: 'Generation (in MWh)',
				COL_EFFICIENCY: 'PERF. Efficiency(%)',
				COL_BREAKDOWN_COUNT: 'Breakdown Count',
				COL_NOTIFICATION_COUNT: 'Notification Count',
				COL_CLOSED: 'Closed',
				COL_OPEN: 'Open',
				COL_BLOCK: 'Block',
				COL_EFF_LOSS: 'EFF. Loss',
				COL_INV: 'Inv',
				COL_TIME: 'Time (hh:mm)',
				COL_CURTAILMENT_LOSS: 'Curtailment Loss(MWh)',
				COL_GEN_LOSS: 'Gen Loss(MWh)',
				COL_GEN_LOSS_NET: 'GEN. Loss (MWh)',
				COL_GEN_LOSS_MWH: 'GEN LOSS (MWh)',
				COL_AVAILABILITY: 'availability',
				COL_REV_LOSS: 'Rev. Loss',
				COL_MAINTENANCE_COST: 'Maintenance Cost',
				COL_DOWNTIME: 'downtime',
				COL_DURATION_PCT: 'Duration %',
				COL_MTTR: 'mttr (hh:mm)',
				COL_ASSET: 'asset',
				COL_MTBF: 'mtbf (hh:mm)',
				COL_IDEAL_GEN: 'Ideal Generation (KWH)',
				COL_SOILING_LOSS: 'Soiling Loss (KWH)',
				COL_SOILING_LOSS_PCT: 'Soiling Loss(% of Ideal Gen.)',
				COL_SCHEDULED_DATE: 'Scheduled Date(To be cleaned)',
				COL_LAST_CLEANED: 'Last Cleaned',
				COL_LAST_CLEANED_DAYS: '(Days ago)',
				COL_NOTIFICATION_NO: 'Notification No',
				COL_EQUIPMENT_ID: 'Equipment ID',
				COL_FUNCTIONAL_LOC: 'FunctionalLoc',
				COL_EQUIPMENT: 'Equipment',
				COL_DESCRIPTION: 'Description',
				COL_CREATED_BY: 'Created By',
				COL_CREATED_ON: 'CREATED ON',
				COL_MAINTENANCE_PLANT: 'Maintenance Plant',
				COL_PLAN_GROUP: 'PlanGroup',
				COL_COMPLETED_ON: 'Completed On',
				COL_COMPLETED_BY: 'Completed By',
				COL_COMPONENT: 'Component'
			},
			POWER_CURVE: {
				TITLE_PREFIX: 'Power Curve Settings for',
				OEM: 'OEM Power Curve',
				CALCULATED: 'Calculated Power Curve',
				START_DATE: 'Start Date',
				STOP_DATE: 'Stop Date',
				DATE_RANGE_ERROR: 'Start date should be less than end date.',
				ADD_COMMENT: 'Add Comment',
				COMMENT_ERROR: 'Please enter a valid comment.'
			},
			FILTER_MIN_MAX: {
				TOOLTIP: 'Filter Min Max',
				GREATER_THAN: 'Greater than',
				LESS_THAN: 'Less than'
			},
			TAG_FILTER: {
				SELECT_TAG: 'Select Tag',
				NO_MATCHING_TAG: 'No matching Tag found'
			},
			LIST_CARD: {
				NO_MATCHING_TAG: 'No matching Tag found'
			},
			LIST_XY_CARD: {
				X_AXIS: 'X-Axis',
				Y_AXIS: 'Y-Axis',
				SEARCH_X: 'Search X...',
				SEARCH_Y: 'Search Y...',
				NO_MATCHING_X: 'No matching X found',
				NO_MATCHING_Y: 'No matching Y found'
			},
			CHART: {
				TOOLTIP_DOWNLOAD_TAG: 'Download Tag Data',
				TOOLTIP_NO_ACCESS: 'You don\'t have access to units & systems used in this analysis item. Hence, it has been disabled.',
				TOOLTIP_REMOVE_FILTER: 'Remove Filter',
				LOCK_X_AXIS: 'Lock x-axis (Date)',
				MULTI_AXIS: 'Multi-axis',
				TRIP_LIMIT: 'Trip Limit',
				ALARM_LIMIT: 'Alarm Limit',
				THRESHOLD_LIMIT: 'Threshold Limit',
				INSTRUMENT_RANGE: 'Instrument Range',
				LOCK_X_AXIS_ALERT_TOOLTIP: 'You cannot unlock in Alert Comparison',
				TYPE_SIGNAL_VS_TIME: 'Signal Vs Time @ Diff Times',
				TYPE_SIGNAL_VS_SIGNAL: 'Signal Vs Signal @ Diff Times',
				TYPE_STATE_SIGNAL: 'Signal Analysis for an Operating States',
				TYPE_STATE_SIGNAL_VS_SIGNAL: 'Signal Vs Signal Over Op States',
				TYPE_MULTISIGNAL: 'Multi-Signal Analysis Over Op States',
				TYPE_MULTISIGNAL_VS_SIGNAL: 'Multi-Signal vs Signal Analysis Over Op States',
				TYPE_FULL_SYSTEM: 'System/Equipment Comparison',
				TYPE_ALERT_COMPARISON: 'Alert Comparison'
			},
			TAG_DIALOG: {
				TITLE_PLACEHOLDER: 'Title',
				DESC_PLACEHOLDER: 'Description',
				PLOT_TYPE_LABEL: 'Plot Type',
				QUICK_PLOT: 'Quick Plot',
				AXIS_TYPE_LABEL: 'Axis Type',
				AXIS_MULTI: 'Multi',
				AXIS_SINGLE: 'Single'
			},
			SUMMARY: {
				LOADING: 'Crunching data like a data-saurus! Hold tight!',
				NO_DATA: 'Ah, an empty vessel, no data to be found.',
				NO_RENEWABLE_ASSETS: 'No renewable assets found',
				NO_RENEWABLE_ASSETS_SUBTITLE: 'No assets match the selected filters',
				NO_SYSTEMS: 'No systems found',
				NO_SYSTEMS_SUBTITLE: 'No systems match the selected filters and date range.',
				NO_DOWNTIME_DATA: 'No downtime data available',
				NO_DOWNTIME_DATA_SUBTITLE: 'Downtime data is not available for selected filters and date range.',
				NO_PERFORMANCE_DATA: 'No performance data available',
				NO_PERFORMANCE_DATA_SUBTITLE: 'Performance data is not available for selected filters and date range.',
				NO_CURTAILMENT_DATA: 'No curtailment data available',
				NO_CURTAILMENT_DATA_SUBTITLE: 'Curtailment data is not available for selected filters and date range.',
				NO_LOSS_DATA: 'No loss data available',
				NO_LOSS_DATA_SUBTITLE: 'Loss data is not available for selected filters and date range.',
				NO_MAINTENANCE_DATA: 'No maintenance time data available',
				NO_MAINTENANCE_DATA_SUBTITLE: 'Maintenance time data is not available for selected filters and date range.',
				NO_SOILING_LOSS_DATA: 'No soiling loss data available',
				NO_SOILING_LOSS_DATA_SUBTITLE: 'Soiling loss data is not available for selected filters and date range.',
			},
			AVAILABILITY: {
				TIME_BASED: 'Time Based Availability',
				ENERGY_BASED: 'Energy Based Availability',
				TARGET_SUFFIX: 'Target',
				TOTAL_LOSS_TITLE: 'Total Loss (MWh)',
				ROW_DOWNTIME: 'Downtime (HH:MM)',
				ROW_LOST_PRODUCTION: 'Lost Production (MWh)',
				ROW_LOST_REVENUE: 'Lost Revenue',
				ROW_MTBF: 'MTBF (Mean Time Between Failure - HH:MM)',
				ROW_MTTR: 'MTTR (Mean Time To Repair - HH:MM)',
				COL_NAME: 'Name',
				COL_VALUE: 'Value'
			},
			PERFORMANCE: {
				LOST_GENERATION: 'Lost Generation (MWh)',
				LOST_REVENUE: 'Lost Revenue',
				BEST_PERFORMING: 'Best Performing',
				WORST_PERFORMING: 'Worst Performing',
				SHOW_TOP: 'Show Top :',
				TOTAL_LOSS_TITLE: 'Total Loss (MWh)',
				PERF_CURVE_TITLE: 'Performance Curve',
				WIND_ROSE_TITLE: 'Wind Rose'
			},
			CURTAILMENT: {
				LOST_GENERATION: 'Lost Generation (MWh)',
				LOST_REVENUE: 'Lost Revenue',
				SHOW_TOP: 'Show Top :',
				TOTAL_LOSS_TITLE: 'Total Loss (MWh)'
			},
			SOILING: {
				TOTAL_LOSS_TITLE: 'Total Loss (MWh)',
				SOILING_CURVE_SUFFIX: 'Soiling Loss Curve',
				TOOLTIP_SAVE: 'Save',
				TOOLTIP_CANCEL: 'Cancel',
				SECTION_SOILING: 'Soiling',
				SECTION_TEMPERATURE: 'Temperature',
				SECTION_OTHERS: 'Others',
				REF_SETTING: 'Reference Setting',
				CRS: 'CRS',
				SRS: 'SRS',
				SELECT_UNIT: 'Select Unit',
				SELECT_SYSTEM: 'Select System',
				SELECT_ASSET: 'Select asset',
				SELECT_TAG: 'Select tag',
				SEARCH: 'Search',
				SEARCH_SYSTEM: 'Search system...',
				NO_MATCHING_UNIT: 'No matching unit found',
				NO_MATCHING_SYSTEM: 'No matching system found',
				NO_MATCHING_ASSET: 'No matching asset found',
				NO_MATCHING_TAG: 'No matching tag found',
				APPLY_ON: 'Apply on',
				CLEANING_CYCLE: 'Cleaning Cycle',
				CLEANING_CYCLE_HINT: '(in days)',
				BTN_START_EXPERIMENT: 'Start Experiment',
				TOOLTIP_FORCE_STOP: 'Force stop ongoing experiment',
				TOOLTIP_UPLOAD_SOILING: 'Upload Soiling Ratio',
				CLEANING_UPDATE: 'Cleaning Update',
				TOOLTIP_UPLOAD_CLEANING: 'Upload Cleaning Schedule',
				TOOLTIP_DOWNLOAD_CLEANING: 'Download cleaning update report',
				CHOOSE_DATE: 'Choose a date',
				DATE_HINT: 'MM/DD/YYYY',
				BTN_UPDATE: 'Update'
			},
			LOSS: {
				LOST_GENERATION: 'Lost Generation (MWh)',
				LOST_REVENUE: 'Lost Revenue',
				EFFECTIVE_PR: 'Effective PR',
				HIGHEST_LOSS_BUCKET: 'Highest Loss Bucket',
				LOSS_BUCKETING_TITLE: 'Loss Bucketing (MWh)'
			},
			MAINTENANCE: {
				CHART_TITLE: 'Maintenance Time (HH:MM)',
				BAD_ACTORS_TITLE: 'Top Bad Actors',
				NOTIFICATION_STATUS: 'Notification Status',
				SHDJ_DISTRIBUTION: 'Unit wise SHDJ distribution',
				PENDING_DEFECTS_TITLE: 'Pending Defects and Aging Reports',
				COL_GROUP_SECTION: 'Group/Section',
				COL_0_30: '0 - 30 Days',
				COL_31_90: '31 - 90 Days',
				COL_91_180: '91 - 180 Days',
				COL_181_365: '181 - 365 Days',
				COL_365_500: '365 - 500 Days',
				COL_GRAND_TOTAL: 'Grand Total',
				MONTHLY_DEFECTS_PREFIX: 'Monthly Defects Status -',
				TOTAL_MTD: 'Total MTD Defects',
				YEARLY_DEFECTS_PREFIX: 'Yearly Defects Status - FY',
				TOTAL_YTD: 'Total YTD Defects',
				PM_COMPLIANCE_PREFIX: 'PM Compliance Report -',
				COL_EQUIPMENT: 'Equipment',
				COL_SCHEDULED: 'Scheduled',
				COL_PENDING: 'Pending',
				COL_COMPLETED: 'Completed',
				COL_COMPLIANCE: 'Compliance (%)'
			},
			MESSAGES: {
				SERVER_ERROR: 'Internal Server error',
				SAVE_SUCCESS: 'Analysis has been successfully saved.',
				UPDATE_SUCCESS: 'Analysis has been updated.',
				ADD_SUCCESS: 'Analysis has been added.',
				COPY_SUCCESS: 'Analysis has been copied.',
				CARD_GENERATED: 'New analysis card has been successfully generated',
				POWER_CURVE_STARTED: 'Power Curve calculation started for',
				POWER_CURVE_FAILED: 'Power Curve calculation failed for'
			}
		},
		NOTIFICATION_WIZARD: {
			HEADER_TITLE: 'Notifications',
			MARK_ALL_READ: 'Mark all as read',
			SETTINGS: 'Settings',
			TAB_ALL: 'All',
			TAB_UNREAD: 'New Unread',
			TAB_ASSIGNED: 'Assigned to me',
			NOTIFICATIONS_SUFFIX: 'notifications',
			TOOLTIP_MARK_READ: 'Mark as read',
			TOOLTIP_MARK_UNREAD: 'Mark as unread',
			TOOLBAR_ITEM: 'item',
			TOOLBAR_ITEMS: 'items',
			TOOLBAR_SELECTED: 'selected',
			TOOLBAR_MARK_READ: 'Mark as read',
			TOOLBAR_MARK_UNREAD: 'Mark as unread',
			TOOLBAR_CLEAR: 'Clear Messages',
			ERROR_TITLE: 'Couldn\'t load notifications',
			ERROR_DESC: 'Something went wrong while fetching notifications. Please try again.',
			NOTIF_OFF_TITLE: 'Notifications are turned off',
			NOTIF_OFF_DESC: 'Enable notifications to receive updates here.',
			EMPTY_DEFAULT_TITLE: 'No Notifications',
			EMPTY_DEFAULT_DESC: 'You don\'t have any notifications yet. Once you receive notifications, they will appear here.',
			EMPTY_CAUGHT_UP_TITLE: 'You\'re all caught up.',
			EMPTY_UNREAD_DESC: 'New notifications for alerts and updates will appear here.',
			EMPTY_ASSIGNED_DESC: 'Notifications assigned to you will appear here.',
			EMPTY_ALL_TITLE: 'No notifications yet',
			EMPTY_ALL_DESC: 'updates will appear here',
			GROUP_TODAY: 'Today',
			GROUP_YESTERDAY: 'Yesterday',
			GROUP_THIS_WEEK: 'Earlier this Week',
			GROUP_THIS_MONTH: 'Earlier this month',
			GROUP_LAST_MONTH: 'Last month',
			GROUP_OLDER: 'Previous month',
			SETTINGS_HEADER: 'User Preference Settings',
			SETTINGS_TAB_NOTIFICATIONS: 'Notifications',
			SETTINGS_TAB_AUDIBLE: 'Audible Alarms',
			SETTINGS_COL_TYPE: 'Type',
			SETTINGS_COL_EMAIL: 'Email',
			SETTINGS_COL_PLATFORM: 'Platform',
			SETTINGS_COL_AUDIBLE: 'Audible',
			SETTINGS_ALERTS_HEADER: 'Alerts',
			SETTINGS_ALERTS_DESC: 'Notifications triggered when a new alert is generated.',
			SETTINGS_AUDIBLE_ALERTS_DESC: 'Play an audible alarm when these alerts are created.',
			SETTINGS_NEW_ANOMALY: 'New Anomaly Alerts',
			SETTINGS_NEW_HIGH_ANOMALY: 'New High Anomaly Alerts',
			SETTINGS_NEW_LOW_ANOMALY: 'New Low Anomaly Alerts',
			SETTINGS_NEW_THRESHOLD: 'New Threshold Alerts',
			SETTINGS_OWNERSHIP_HEADER: 'Alert Ownership & Assignment',
			SETTINGS_OWNERSHIP_DESC: 'Notifications related to alert responsibility.',
			SETTINGS_ALERT_OWNER: 'Assigned as Alert Owner',
			SETTINGS_ALERT_WATCHER: 'Assigned as Alert Watcher',
			SETTINGS_ACTIVITY_HEADER: 'Alert Activity',
			SETTINGS_ACTIVITY_DESC: 'Controls whether users receive ongoing updates after assignment.',
			SETTINGS_OWNED_ALERTS: 'Updates on Owner Alerts',
			SETTINGS_WATCHED_ALERTS: 'Updates on Watched Alerts',
			SETTINGS_SYSTEM_HEADER: 'System Updates',
			SETTINGS_SYSTEM_DESC: 'Notifications related to AI / system operations.',
			SETTINGS_MODEL_RETRAINING: 'Model Retraining Completed',
			SETTINGS_AUDIBLE_FOOTER_NOTE: 'The audible alarm will sound once, or will keep notifying at the selected frequency until you click the alert to view the alert details.',
			PDF_HEADER: 'Case Management - PDF Generated',
			PDF_GENERATED_BEFORE: 'The Case Management PDF has been successfully generated.',
			PDF_DOWNLOAD_LINK: 'Download PDF',
			PDF_GENERATED_AFTER: 'or access it using the link sent to your email. The download link expires on {{expiry}}.',
			PDF_LINK_EXPIRED_TOOLTIP: 'This download link has expired. Generate the PDF again to download.',
			ASSET_TEMPLATE_SYNC_STARTED_TITLE: 'Asset template sync started – {{templateName}}',
			ASSET_TEMPLATE_SYNC_COMPLETED_TITLE: 'Asset template sync completed – {{templateName}}',
			ASSET_TEMPLATE_SYNC_FAILED_TITLE: 'Asset template sync failed – {{templateName}}'
		},
		MAINTENANCE_OPTIMIZATION: {
			// Main component
			HEADER_TITLE: 'Maintenance Optimization',
			TAB_RESULTS: 'Results & Value',
			TAB_SCHEDULES: 'PM Schedules',
			TAB_RUN_HISTORY: 'Run History',

			// Run History
			RH_COL_SL_NO: 'Sl. No.',
			RH_COL_RUN_DATE: 'Run Date',
			RH_COL_NAME: 'Name',
			RH_COL_CREATOR: 'Creator',
			RH_COL_SCOPE: 'Scope',
			RH_COL_STATUS: 'Status',
			RH_COL_TOTAL_VALUE: 'Total Value',
			RH_COL_APPROVED: 'Approved',
			RH_COL_ACTIONS: 'Actions',
			RH_VIEW: 'View',
			RH_EQUIPMENTS: 'equipments',
			RH_SEARCH_PLACEHOLDER: 'Search runs...',
			RH_EMPTY: 'No optimization runs found for the current selection.',
			RH_STATUS_PENDING: 'Pending',
			RH_STATUS_RUNNING: 'Running',
			RH_STATUS_PROCESSING: 'Processing',
			RH_STATUS_COMPLETED: 'Completed',
			RH_STATUS_FAILED: 'Failed',
			BTN_RUN_OPTIMIZATION: 'Run Optimization',
			LAST_RUN_PREFIX: 'Last optimization run:',

			// PM Schedules
			PM_DOWNLOAD_TITLE: 'Download options',
			PM_DOWNLOAD_SUBTITLE: 'Use the buttons below to export PM schedules in a format that can be uploaded into SAP or your CMMS:',
			PM_DOWNLOAD_ALL_TITLE: 'Download ALL (CSV)',
			PM_DOWNLOAD_ALL_DESC: 'Consolidated list of all PM activities',
			PM_DOWNLOAD_PER_EQ_TITLE: 'Per Equipment Reports',
			PM_DOWNLOAD_PER_EQ_DESC: 'Filtered to the asset selected in the hierarchy',
			PM_DOWNLOAD_CONSOLIDATED_TITLE: 'Consolidated Schedules',
			PM_DOWNLOAD_CONSOLIDATED_DESC: 'Grouped by new interval',
			PM_SEARCH_PLACEHOLDER: 'Search...',
			PM_GROUP_BY_INTERVAL: 'Group by: Interval',
			PM_FILTER: 'Filter',
			PM_COL_ID: 'ID',
			PM_COL_NAME: 'PM Schedule Name',
			PM_COL_ACCESS_CLASS: 'Access Class',
			PM_COL_BUNDLE_NAME: 'Bundle Name',
			PM_COL_BUNDLE_ID: 'Bundle ID',
			PM_COL_PREV_INTERVAL: 'Previous PM Interval',
			PM_COL_CURR_INTERVAL: 'Current PM Interval',
			PM_EACH: 'Each',
			PM_DAYS: 'days',

			// Results & Values
			RV_TOTAL: 'Total',
			RV_POTENTIAL_VALUE: 'Potential value',
			RV_PM_SCHEDULING: 'PM Scheduling',
			RV_CM_REDUCTION: 'CM reduction',
			RV_FAILURE_REDUCTION: 'Failure / Breakdown Reduction',
			RV_BY_REC_TYPE: 'By Recommendation Type',
			RV_TOTAL_ACTIVITIES: 'Total Activities Inspected',
			RV_INCREASES: 'Increases',
			RV_DECREASES: 'Decreases',
			RV_NO_CHANGES: 'No Changes',
			RV_REMOVE: 'Remove',
			RV_ADD: 'Add',
			RV_WHERE_VALUE: 'Where The Value Is',
			RV_BY_STATUS: 'By Status',
			RV_TOTAL_SCHEDULES: 'Total Schedules',
			RV_PENDING: 'Pending',
			RV_APPROVED: 'Approved',
			RV_REJECTED: 'Rejected',
			RV_SEARCH_PLACEHOLDER: 'Search...',
			RV_GROUP_BY_SYSTEM: 'Group by: System',
			RV_FILTER: 'Filter',
			RV_COL_FREQ_REC: 'Frequency Recommendation',
			RV_COL_HIERARCHY: 'Hierarchy / PM Names',
			RV_COL_REC_INTERVAL: 'Recommended Interval (days)',
			RV_COL_SAVINGS: 'Total Savings ($/yr)',
			RV_COL_PM: 'PM ($/ yr)',
			RV_COL_CM: 'CM ($/ yr)',
			RV_COL_FAILURE_RISK: 'Failure Risk ($/ yr)',
			RV_COL_APPROVE: 'Approve /Reject',
			RV_COL_PM_ID: 'PM ID',
			RV_COL_ACTIVITY: 'Activity',
			RV_COL_ROLE: 'Role',
			RV_COL_STANDALONE: 'Standalone',
			RV_COL_EFFECTIVE: 'Effective',
			RV_COL_EVIDENCE: 'Evidence',
			RV_COL_VALUE: 'Value',
			RV_COL_STATUS: 'Status',
			RV_BH_CURRENT: 'Current',
			RV_BH_EFFECTIVE: 'Effective',
			RV_BH_OUTCOME: 'Outcome',
			RV_BH_DRIVER: 'Driver(s)',
			RV_BH_VALUE: 'Value',
			RV_BH_CONFIDENCE: 'Confidence',
			RV_BH_STATUS: 'Status',
			RV_BH_ACTIVITIES: 'activities',
			RV_BH_DRIVERS: 'drivers',
			RV_BH_OVERRIDES: 'overrides',
			RV_BH_UNCHANGED: 'unchanged',
			RV_BH_NONE: 'None',
			RV_BH_NO_CHANGE: 'No change',
			RV_BH_NA: 'n/a',
			RV_DEEP_DIVE: 'Deep dive',
			RV_BUNDLE_SUMMARY: 'Bundle summary',
			RV_LAST_RUN: 'Last run',
			RV_NO_RESULTS: 'No optimization results for this selection.',
			RV_SELECT_NODE: 'Select a facility, unit, or system to view results.',
			RV_LOADING: 'Loading results...',

			// MC Recommendation panel
			MC_PANEL_TITLE: 'Deep-Dive Panel — Recommendation',
			MC_ASK_ROOTY: 'Ask Rooty',
			MC_APPROVE: 'Approve',
			MC_REJECT: 'Reject',
			MC_CURRENT_FREQ: 'Current Frequency',
			MC_REC_FREQ: 'Recommendation Frequency',
			MC_SHOW: 'Show',
			MC_COMPACT: 'Compact',
			MC_ADVANCED: 'Advanced',
			MC_TAB_DECISION: 'Decision',
			MC_TAB_OBSERVATIONS: 'Observations',
			MC_TAB_FAILURE_MODES: 'Failure Modes',
			MC_DECISION_TITLE: 'Decision',
			MC_WHY_NOW: 'WHY NOW',
			MC_EXPECTED_VALUE: 'EXPECTED VALUE',
			MC_SECONDARY_ACTION: 'SECONDARY ACTION',
			MC_REC_CONFIDENCE: 'Recommendation Confidence',
			MC_SAVINGS_BREAKDOWN: 'Savings Breakdown',
			MC_TOTAL_ANNUAL_SAVINGS: 'Total annual savings',
			MC_PREDICTIONS: 'Predictions',
			MC_EXPECTED_OUTCOME: 'Expected outcome if recommendation is accepted',
			MC_INTERVAL_SENSITIVITY: 'Interval Sensitivity (β / η)',
			MC_ANNUAL_CM_COUNT: 'Annual CM Count',
			MC_CURRENT_CM_COUNT: 'Current CM count:',
			MC_PREDICTED_CM_COUNT: 'Predicted new CM count:',
			MC_ANNUAL_BD_COUNT: 'Annual Breakdown Count',
			MC_CURRENT_BD_COUNT: 'Current breakdown count:',
			MC_PREDICTED_BD_COUNT: 'Predicted new breakdown count:',
			MC_PM_FREQUENCY: 'PM Frequency',
			MC_CURRENT: 'Current:',
			MC_RECOMMENDED: 'Recommended:',
			MC_FM_LINK: 'Failure Modes tab',
			MC_OBS_REACTIVE_VS_PREVENTIVE: 'Reactive vs Preventive Cost Ratio',
			MC_OBS_CM_TIMING: 'CM Event Timing Analysis',
			MC_OBS_EARLY: 'Early',
			MC_OBS_MID: 'Mid',
			MC_OBS_LATE: 'Late',
			MC_OBS_POST_PM: 'Post-PM Recurrence',
			MC_OBS_EVIDENCE_LOG: 'Open full Evidence Log →',
			MC_FM_SERVED_BY: 'served by this PM',
			MC_FM_SORT: 'Sort',
			MC_FM_BY_ROLE: 'By Role',
			MC_FM_EXPAND_ALL: 'Expand All',
			MC_FM_PRIMARY: 'Primary',
			MC_FM_SUPPORTING: 'Supporting',
			MC_FM_INCIDENTAL: 'Incidental',
			MC_FM_AGG_B: 'Aggregate B',
			MC_FM_CM_COUNT: 'CM Count /YR',
			MC_FM_BREAKDOWNS: 'Breakdowns / YR',
			MC_FM_DIAGNOSIS: 'Diagnosis',
			MC_FM_TIMING: 'Timing',
			MC_FM_SENSITIVITY: 'Sensitivity (β)',
			MC_FM_IMPACT: 'Impact',
			MC_FM_EVENTS: 'Events',
			MC_FM_DATE_COL: 'Date',
			MC_FM_EVENT_COL: 'Event',
			MC_FM_COST_COL: 'Cost',
			MC_FM_CLASS_COL: 'Class',
			MC_TAG_INCREASE_FREQ: 'Increase Freq',
			MC_TAG_TIMING: 'timing-driven',
			MC_TAG_CASE2: 'Case 2',
			MC_TAG_CBM: '+ CBM safety net',
			MCB_OPEN_EVIDENCE_LOG: 'Open Evidence Log',
			MCB_DECISION_STANDALONE: 'Standalone Recommendation',
			MCB_DECISION_EFFECTIVE: 'Effective Bundle Recommendation',
			MCB_EFFECTIVE_IS_STANDALONE: 'Standalone result is also the effective result',
			MCB_EXPECTED_IMPACT: 'Expected impact',
			MCB_EFFECTIVE_BUNDLE_RESULT: 'Effective bundle result',
			MCB_PM_COST: 'PM Cost',
			MCB_PM_COST_SUB: 'Additional annual PM spend',
			MCB_CM_SAVINGS: 'CM Savings',
			MCB_CM_SAVINGS_SUB: 'Expected annual reduction',
			MCB_BD_SAVINGS: 'Breakdown Savings',
			MCB_BD_SAVINGS_SUB: 'Expected annual reduction',
			MCB_NET_VALUE: 'Net Annual Value',
			MCB_NET_VALUE_SUB: 'After bundle propagation',
			MCB_CONFIDENCE: 'Confidence',
			MCB_DRIVER_BASED: 'Driver-based',
			MCB_WHY: 'Why this recommendation',
			MCB_ADVANCED_PENDING: 'Advanced details coming soon.',
			MCB_OBS_WHAT: 'What the engine observed',
			MCB_OBS_ECONOMIC: 'Economic Screen',
			MCB_OBS_TIMING: 'Timing',
			MCB_OBS_POSTPM: 'Post-PM Recurrence',
			MCB_TIMING_DISTRIBUTION: 'Timing distribution',
			MCB_EARLY: 'Early',
			MCB_MIDDLE: 'Middle',
			MCB_LATE: 'Late',
			MCB_FM_BUILDUP: 'Failure-mode buildup',
			MCB_FM_BUILDUP_SUB: 'Compact shows the conclusion. Advanced exposes the diagnostic, prediction, confidence and evidence trace for each FM.',
			MCB_DETAILS: 'Details',
			MCB_FM_DIAGNOSIS: 'Diagnosis',
			MCB_FM_EVIDENCE: 'Evidence',
			MCB_FM_TIMING: 'Timing',
			MCB_FM_CONTRIBUTION: 'Contribution',
			MCB_FM_STANDALONE: 'Standalone',
			MCB_FM_EFFECTIVE: 'Effective',
			MCB_FM_ROUTE: 'Route',
			MCB_FM_INTERVAL_CONTRIB: 'Interval Contribution',
			MCB_FM_VALUE: 'Value',
			MCB_FM_STATUS: 'Status',
			MCB_FM_ADMIN_INTERPRETATION: 'Admin interpretation',
			MCB_FM_INTERVAL_DRIVER: 'Interval Driver',
			MCB_FM_OVERRIDDEN: 'Overridden FM',
			MCB_FM_NON_INTERVAL: 'Non-interval',
			MCB_STANDALONE_NOT_REALIZED: 'The standalone {{code}} saving is not realized and must not be added to equipment or portfolio totals.',
			MCB_CONF_DATA_SUFFICIENCY: 'Data sufficiency',
			MCB_CONF_TIMING_QUALITY: 'Timing quality',
			MCB_CONF_MAPPING_QUALITY: 'Mapping quality',
			MCB_CONF_PRIOR_CONFIRMATION: 'Prior confirmation',
			MCB_OBS_ACTIONABILITY: 'Actionability',
			MCB_OBS_CONDITION_MODIFIER: 'Condition Modifier',
			MCB_OBS_DATA_GATE: 'Data Gate',
			MCB_PRED_DETAILS: 'Prediction details',
			MCB_PRED_B_BASE: 'B Base',
			MCB_PRED_ASSET_MODIFIER: 'Asset Modifier',
			MCB_PRED_B_OPTIMIZATION: 'B Optimization',
			MCB_PRED_CM: 'CM Prediction',
			MCB_PRED_BD: 'BD Prediction',
			MCB_D_SEC_A: 'A. Data Gate & Classification',
			MCB_D_SEC_B: 'B. Timing Pattern',
			MCB_D_SEC_C: 'C. Burden, Condition & Actionability',
			MCB_D_SEC_D: 'D. Economic Screen & Diagnosis',
			MCB_D_SEC_E: 'E. B Buildup',
			MCB_D_SEC_F: 'F. Prediction & Value',
			MCB_D_SEC_G: 'G. Event Evidence',
			MCB_D_ROUTE: 'Route',
			MCB_D_PM_CYCLES: 'PM Cycles',
			MCB_D_QUALIFYING_EVENTS: 'Qualifying Events',
			MCB_D_MAPPING_CONFIDENCE: 'Mapping Confidence',
			MCB_D_MEAN_MX: 'Mean Mx',
			MCB_D_SPREAD: 'Spread Σx',
			MCB_D_EML: 'E/M/L',
			MCB_D_POSTPM: 'PostPM',
			MCB_D_RWCM_RAW: 'RWCM Raw',
			MCB_D_EFF_CM_BURDEN: 'Effective CM Burden',
			MCB_D_HM: 'Hm',
			MCB_D_GM: 'Gm',
			MCB_D_PM_BURDEN: 'PM Burden',
			MCB_D_CM_BD_BURDEN: 'CM + BD Burden',
			MCB_D_RA_COST: 'Ra Cost',
			MCB_D_DIAGNOSIS: 'Diagnosis',
			MCB_D_B_BASE: 'B Base',
			MCB_D_DIRECTION: 'Direction',
			MCB_D_CONCENTRATION: 'Concentration',
			MCB_D_B_OPT: 'B Opt',
			MCB_D_INTERVAL: 'Interval',
			MCB_D_CM_PREDICTION: 'CM Prediction',
			MCB_D_STANDALONE_NET: 'Standalone Net',
			MCB_D_EFF_BUNDLE_NET: 'Effective Bundle Net',
			MCB_D_COL_EVENT: 'Event',
			MCB_D_COL_DATE: 'Date',
			MCB_D_COL_CLASS: 'Class',
			MCB_D_COL_BD: 'BD',
			MCB_D_COL_XE: 'x<sub>e</sub>',
			MCB_D_COL_COST: 'Cost',

			// Run Configuration Dialog
			RC_TITLE: 'Run Configuration',
			RC_TAB_SCOPE: 'Scope',
			RC_TAB_CONFIGURE: 'Configure',
			RC_TAB_IMPORT: 'Import Data',
			RC_TAB_DATA_QC: 'Data QC',
			RC_TAB_MAPPING: 'Mapping',
			RC_SAVE: 'Save',
			RC_CANCEL: 'Cancel',
			RC_PREVIOUS: 'Previous',
			RC_NEXT: 'Next',
			RC_RUN: 'Run',
			RC_CONFIGURE_TITLE: 'Configure Analysis',
			RC_CONFIGURE_DESC: 'Set analysis profile, thresholds, and tuning parameters. Most users should pick a profile and adjust only the main parameters. Advanced parameters control internal algorithm behavior.',
			RC_ASSET_CLASS_TITLE: 'Asset Class Overrides',
			RC_ASSET_CLASS_DESC: 'Per-class A/B/C inputs for risk-tolerance parameters',
			RC_ANALYSIS_WINDOW_TITLE: 'Analysis Window',
			RC_ANALYSIS_WINDOW_DESC: 'Define the time period for CMMS data analysis',
			RC_DURATION: 'Duration',
			RC_INITIAL_DATE: 'Initial Date',
			RC_END_DATE: 'End Date',
			RC_ANALYSIS_PERIOD_PREFIX: 'Analysis Period:',
			RC_MONTHS: 'months',
			RC_SAP_NOTIFICATIONS: 'SAP Notifications:',
			RC_FETCHING: 'Fetching...',
			RC_RECORDS: 'records',
			RC_ANALYSIS_PROFILE_TITLE: 'Analysis Profile',
			RC_ANALYSIS_PROFILE_DESC: 'Sets all parameters to pre-calibrated defaults. You can override individual values below.',
			RC_DATA_SUFFICIENCY_TITLE: 'Data Sufficiency Requirements',
			RC_DATA_SUFFICIENCY_DESC: 'How much evidence is needed before the algorithm acts',
			RC_MIN_PM_CYCLES: 'Minimum PM Cycles',
			RC_MIN_FM_EVENTS: 'Minimum FM Events',
			RC_RECENCY_HALF_LIFE: 'Recency Half-Life (h)',
			RC_POST_PM_WINDOW: 'Post-PM Window (d)',
			RC_CYCLES: 'cycles',
			RC_RESET_TO_BASE: 'Reset to base',
			RC_PM_CM_RATIO_TITLE: 'PM/CM Ratio Thresholds (Ra)',
			RC_PM_CM_RATIO_DESC: 'When is PM spending too high or too low relative to failure burden? Both ratios are always computed and reported.',
			RC_PRIMARY_RATIO_LABEL: 'Primary ratio for diagnosis logic',
			RC_OVER_MAINTAINED: 'Over-Maintained (Case 1)',
			RC_UNDER_MAINTAINED: 'Under-Maintained (Case 2)',
			RC_INTERVAL_ADJ_TITLE: 'Interval Adjustment Limits',
			RC_INTERVAL_ADJ_DESC: 'Maximum interval change per recommendation cycle. Separate limits for extension vs reduction.',
			RC_INTERVAL_ROUNDING: 'Interval Rounding',
			RC_ROUND_TO: 'Round to',
			RC_DIRECTION: 'Direction',
			RC_ADJ_MODE: 'Adjustment Mode: Percentage',
			RC_ADVANCED_PARAMS_TITLE: 'Advanced Parameters',
			RC_ADVANCED_PARAMS_DESC: 'Internal algorithm tuning — timing analysis, routing, sensitivity, confidence tiers',
			RC_ADVANCED_WARNING: 'These parameters control internal signal processing. Changing them without understanding the formulas may produce misleading results. The profile selector above sets sensible defaults for each. Only override if you have a specific reason.',
			RC_PARAM_COL_PARAM: 'Parameter',
			RC_PARAM_COL_DESC: 'Description',
			RC_PARAM_COL_EFFECT: 'EFFECT',
			RC_PARAM_COL_VALUE: 'Value',
			RC_GOAL_SEEKER_TITLE: 'Goal Seeker Mode',
			RC_GOAL_SEEKER_DESC: 'Optimize to achieve a specific budget reduction target',
			RC_GOAL_SEEKER_CURRENT: 'Current',
			RC_GOAL_SEEKER_TARGET: 'Target Reduction:',
			RC_CONSTRAINTS: 'Constraints',
			RC_EXCLUDE_CRITICALITY: 'Exclude Asset Criticalities',
			RC_EXCLUDE_EQ_TYPES: 'Exclude Equipment Types',
			RC_SCOPE_TITLE: 'Scope',
			RC_SCOPE_DESC: 'Define the scope of the optimization run.',
			RC_IMPORT_TITLE: 'Import Data',
			RC_IMPORT_DESC: 'SAP notifications for the selected system over the configured analysis window.',
			RC_PM_EVENTS: 'PM Events',
			RC_CM_EVENTS: 'CM Events',
			RC_FAILURE_EVENTS: 'Failure Events',
			RC_CM_FM_MAPPING: 'CM-FM Mapping',
			RC_NO_RECORDS: 'No records found for this event type in the selected window',
			RC_COL_NOTIFICATION: 'Notification',
			RC_COL_EQUIPMENT: 'Equipment',
			RC_COL_DESCRIPTION: 'Description',
			RC_COL_TYPE: 'Type',
			RC_COL_CREATED_ON: 'Created On',
			RC_COL_COMPLETED_ON: 'Completed On',
			RC_COL_PLAN_GROUP: 'Plan Group',
			RC_DATA_QC_TITLE: 'Data QC',
			RC_DATA_QC_DESC: 'Review data quality checks.',
			RC_MAPPING_TITLE: 'Mapping',
			RC_MAPPING_DESC: 'Configure CM-FM mapping.',
			RC_MAPPING_GROUP_BY: 'Group by',
			RC_MAPPING_GROUP_FM: 'Failure Mode',
			RC_MAPPING_GROUP_PREVENTABILITY: 'Preventability',
			RC_MAPPING_SEARCH_PLACEHOLDER: 'Search notification, order, equipment, description',
			RC_MAPPING_LOW_CONFIDENCE: 'Low confidence',
			RC_MAPPING_EDITED: 'Edited',
			RC_MAPPING_REGENERATE: 'Regenerate',
			RC_MAPPING_DOWNLOAD: 'Download',
			RC_MAPPING_UPLOAD: 'Upload',
			RC_MAPPING_RESET_ALL: 'Reset all',
			RC_MAPPING_COL_ORDER: 'Order #',
			RC_MAPPING_COL_EQUIPMENT_ID: 'Equipment ID',
			RC_MAPPING_COL_WO_DESC: 'WO Description',
			RC_MAPPING_COL_WO_TYPE: 'WO Type',
			RC_MAPPING_COL_MAPPED_FM: 'Mapped Failure Mode',
			RC_MAPPING_COL_PREVENTABILITY: 'Preventability',
			RC_MAPPING_EVENT: 'event',
			RC_MAPPING_EVENTS: 'events',
			RC_MAPPING_AVG_FM_CONF: 'Avg FM conf',
			RC_MAPPING_AVG_PREV_CONF: 'Avg Prev conf',
			RC_MAPPING_NO_RECORDS: 'No CM/BD notifications available for mapping',
			RC_MAPPING_NO_FILTERED_RESULTS: 'No mappings match the current filters',
			RC_MAPPING_GENERATING: 'Mapping CM/Breakdown events to failure modes...',
			RC_MAPPING_GENERATION_ERROR: 'Failed to generate the CM/BD → failure mode mapping.',
			RC_MAPPING_UNMAPPED: 'Unmapped',
			RC_MAPPING_SYMPTOM_ONLY: 'Symptom only',
			RC_MAPPING_SYMPTOM_ONLY_TOOLTIP: 'Could not be re-attributed to a root-cause failure mode — excluded from optimization calculations.',
			RC_MAPPING_UNMAPPED_CONF_TOOLTIP: 'Confidence in the "no match" determination itself, not in a specific failure mode.',
			RC_MAPPING_NO_RATIONALE: 'No rationale provided.',
			RC_MAPPING_DETAIL_IDENTITY_SOURCE: 'Identity & Source',
			RC_MAPPING_DETAIL_WO_CONTENT: 'WO Content',
			RC_MAPPING_DETAIL_DURATION: 'Duration',
			RC_MAPPING_DETAIL_FM_MAPPING: 'FM Mapping',
			RC_MAPPING_DETAIL_PREVENTABILITY: 'Preventability',
			RC_MAPPING_DETAIL_AUDIT: 'Audit',
			RC_MAPPING_DETAIL_EVENT_CLASS: 'Order Type / Event Class',
			RC_MAPPING_DETAIL_SCHED_START: 'Sched Start',
			RC_MAPPING_DETAIL_SCHED_FINISH: 'Sched Finish',
			RC_MAPPING_DETAIL_ACTIVITY_CODE: 'Activity Code',
			RC_MAPPING_DETAIL_DAMAGE_CODE: 'Damage Code',
			RC_MAPPING_DETAIL_CAUSE_CODE: 'Cause Code',
			RC_MAPPING_DETAIL_MATERIAL_COST: 'Material Cost',
			RC_MAPPING_DETAIL_PERMIT_ISSUED: 'Permit Issued',
			RC_MAPPING_DETAIL_PERMIT_CLOSED: 'Permit Closed',
			RC_MAPPING_DETAIL_CM_DURATION: 'CM Duration (h)',
			RC_MAPPING_DETAIL_DURATION_SOURCE: 'Duration Source',
			RC_MAPPING_DETAIL_FM_ID_NAME: 'FM ID / Name',
			RC_MAPPING_DETAIL_FM_TYPE: 'FM Type',
			RC_MAPPING_DETAIL_FAILURE_MODE_TYPE: 'Failure Mode Type',
			RC_MAPPING_DETAIL_CONFIDENCE: 'Confidence',
			RC_MAPPING_DETAIL_SOURCE: 'Source',
			RC_MAPPING_DETAIL_RE_ATTRIBUTED_FROM: 'Re-attributed From',
			RC_MAPPING_DETAIL_SYMPTOM_ONLY: 'Symptom Only',
			RC_MAPPING_DETAIL_RATIONALE: 'Rationale',
			RC_MAPPING_DETAIL_CLASS: 'Class',
			RC_MAPPING_DETAIL_KEY_SIGNALS: 'Key Signals',
			RC_MAPPING_DETAIL_EDITED_BY: 'Edited By',
			RC_MAPPING_DETAIL_EDITED_AT: 'Edited At',
			RC_MAPPING_DETAIL_FM_AGENT_RUN: 'FM Agent Run',
			RC_MAPPING_DETAIL_PREVENTABILITY_AGENT_RUN: 'Preventability Agent Run',
			RC_MAPPING_DETAIL_EXISTING: 'Existing',
			RC_MAPPING_DETAIL_NOT_AVAILABLE: 'Not available',
			RC_MAPPING_REGEN_CONFIRM_TITLE: 'Regenerate mapping?',
			RC_MAPPING_REGEN_CONFIRM_MESSAGE: '{{count}} manually edited row(s) will be regenerated, using your corrections as guidance for the new run.',

			// Select option labels
			OPT_6_MONTHS: '6 Months',
			OPT_12_MONTHS: '12 Months',
			OPT_15_MONTHS: '15 Months',
			OPT_24_MONTHS: '24 Months',
			OPT_36_MONTHS: '36 Months',
			OPT_1_CYCLE: '1 Cycle (Aggressive)',
			OPT_2_CYCLES: '2 Cycles (Base)',
			OPT_3_CYCLES: '3 Cycles (Conservative)',
			OPT_WEEKLY: 'Weekly (7 Days)',
			OPT_BIWEEKLY: 'Biweekly (14 Days)',
			OPT_MONTHLY: 'Monthly (30 Days)',
			OPT_NEAREST: 'Nearest',
			OPT_UP: 'Up',
			OPT_DOWN: 'Down',
			OPT_CRIT_A: 'A (Critical)',
			OPT_CRIT_B: 'B (Important)',
			OPT_CRIT_C: 'C (Standard)',
			OPT_CRIT_D: 'D (Low)',
			OPT_PROFILE_BASE_NAME: 'Base',
			OPT_PROFILE_BASE_SUBTITLE: 'Balanced, default',
			OPT_PROFILE_CONSERVATIVE_NAME: 'Conservative',
			OPT_PROFILE_CONSERVATIVE_SUBTITLE: 'Fewer recommendations, higher trust',
			OPT_PROFILE_AGGRESSIVE_NAME: 'Aggressive',
			OPT_PROFILE_AGGRESSIVE_SUBTITLE: 'More recommendations, higher potential savings',
			OPT_PCT_SHORTER_10: '10% shorter',
			OPT_PCT_SHORTER_20: '20% shorter',
			OPT_PCT_SHORTER_25: '25% shorter',
			OPT_PCT_SHORTER_50: '50% shorter',
			OPT_PCT_LONGER_10: '10% longer',
			OPT_PCT_LONGER_20: '20% longer',
			OPT_PCT_LONGER_25: '25% longer',
			OPT_PCT_LONGER_50: '50% longer'
		},
		USER_MANAGEMENT: {
			FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
			CANCEL: 'Cancel',
			SAVE: 'Save',
			CANCEL_CHANGES: 'Cancel changes',
			SAVE_CHANGES: 'Save changes',
			NO_RECORDS: 'No records found',
			PLEASE_WAIT: 'Please wait....',
			SEARCH: 'Search',
			ACTIONS: 'Actions',
			NAME: 'Name',
			EMAIL: 'Email',
			PHONE: 'Phone',
			FACILITY: 'Facility',
			UNITS: 'Units',
			SYSTEMS: 'Systems',
			SYSTEM: 'System',
			UNIT: 'Unit',
			USER: 'User',
			SELECT_FACILITY: 'Select Facility',
			SELECT_FACILITIES: 'Select Facilities',
			SELECT_UNITS: 'Select Units',
			SELECT_SYSTEMS: 'Select Systems',
			SELECT_SYSTEM: 'Select System',
			SELECT_UNIT: 'Select Unit',
			SELECT_USER: 'Select User',
			SEARCH_UNIT: 'Search unit...',
			NO_MATCHING_UNIT: 'No matching unit found',
			SEARCH_SYSTEM: 'Search system...',
			NO_MATCHING_SYSTEM: 'No matching system found',
			ROLES: {
				LIST_TITLE: 'Roles list',
				NEW_ROLE: 'New Role',
				CREATE_ROLE_TOOLTIP: 'Create new role',
				SEARCH_USER: 'Search user',
				FETCH_SELECTED: 'Fetch Selected',
				FETCH_SELECTED_TOOLTIP: 'Fetch selected roles',
				COL_TITLE: 'Title',
				VIEW_ROLE: 'View',
				EDIT_ROLE: 'Edit',
				ROLE_SUFFIX: 'role',
				DELETE_ROLE: 'Delete role',
				PERMISSIONS_HEADING: 'Permissions:',
				ENTER_TITLE: 'Enter Title',
				TITLE_REQUIRED: 'Title is',
				TITLE_REQUIRED_STRONG: 'required',
				TITLE_HINT: 'Please enter',
				TITLE_HINT_STRONG: 'Title',
			},
			USERS: {
				TAB_USERS: 'Users',
				TAB_USER_GROUPS: 'User Groups',
				USER_LIST: 'User List',
				FILTERED_USER_LIST: 'Filtered User List',
				SHOW_DEACTIVATED: 'Show Deactivated',
				DOWNLOAD_TOOLTIP: 'Download User List',
				DOWNLOAD: 'Download',
				NEW_USER: 'New user',
				NEW_USER_TOOLTIP: 'Create new User',
				UPLOAD_USER: 'Upload User',
				UPLOAD_USER_TOOLTIP: 'Create Multiple Users',
				SEARCH_USER: 'Search user',
				COL_SL_NO: 'Sl. No.',
				COL_USERNAME: 'Username',
				COL_EMAIL: 'Email',
				COL_NAME: 'Name',
				COL_ROLES: 'Roles',
				COL_ADMIN: 'Admin',
				COL_ENTERPRISE_ADMIN: 'Enterprise Admin',
				COL_PHONE: 'Phone',
				COL_LAST_ACTIVE: 'Last Active At',
				COL_STATUS: 'Status',
				STATUS_ACTIVE: 'Active',
				STATUS_DEACTIVATED: 'Deactivated',
				EDIT_USER: 'Edit user',
				DELETE_USER: 'Delete user',
			},
			USER_GROUPS: {
				TITLE: 'Users Group',
				ADD_TOOLTIP: 'Add User Group',
				NEW_GROUP: 'New User Group',
				COL_SL_NO: 'Sl. No.',
				EDIT_TOOLTIP: 'Edit user',
				DELETE_TOOLTIP: 'Delete user',
				NAME_REQUIRED: 'Name is',
				NAME_REQUIRED_STRONG: 'required',
				NAME_HINT: 'Please enter',
				NAME_HINT_STRONG: 'name',
				NO_USER_GROUPS: 'No user groups created yet',
				CREATE_GROUP_GET_STARTED: 'Create a new user group to get started',
			},
			USER_EDIT: {
				USER_INFO_HEADING: 'User information',
				SYSTEM_ACCESS_HEADING: 'System Access',
				FACILITY_ADMIN_HEADING: 'Facility Admin Access',
				MODULE_ACCESS_HEADING: 'Module Access',
				EMAIL_LABEL: 'Email',
				EMAIL_HINT: 'Enter Email',
				PASSWORD_LABEL: 'Password',
				PASSWORD_HINT: '(Min 8 chars, atleast one special char, atleast one UPPERCASE char & atleast one number)',
				PASSWORD_REQUIRED: 'Password is',
				PASSWORD_REQUIRED_STRONG: 'required',
				NAME_LABEL: 'Name',
				NAME_HINT: 'Enter Name',
				PHONE_LABEL: 'Phone',
				PHONE_HINT: 'Enter Phone',
				PHONE_REQUIRED: 'Phone no. is',
				PHONE_REQUIRED_STRONG: 'required',
				ENTERPRISE_ADMIN: 'Enterprise Admin',
				OPT_WHATSAPP: 'Opt for Whatsapp',
				INTERNAL: 'Internal',
				MODEL_RETRAINING: 'Model Retraining',
				FACILITIES_LABEL: 'Facilities',
				SELECT_ALL: 'Select All',
				MODULE_LABEL: 'Module',
				SELECT_MODULES_HINT: 'Select Modules',
				SEARCH_MODULES: 'Search modules...',
				NO_MATCHING_MODULE: 'No matching module found',
				MODULE_REQUIRED: 'At least one module must be selected.',
				SAVE_TOOLTIP: 'Save',
				CANCEL_TOOLTIP: 'Cancel',
			},
			UPLOAD_USERS: {
				TITLE: 'Upload User List',
				SELECT_CSV: 'Select CSV File',
				CSV_REQUIRED: 'CSV file is',
				CSV_REQUIRED_STRONG: 'required',
				SELECT_FILE: 'Select File',
				DOWNLOAD_FORMAT_TOOLTIP: 'Download CSV Format',
				SUBMIT: 'Submit',
			},
			USER_POPUP: {
				EMAIL_REQUIRED: 'Email is',
				EMAIL_REQUIRED_STRONG: 'required',
				EMAIL_HINT: 'Please enter',
				EMAIL_HINT_STRONG: 'Email',
				PASSWORD_REQUIRED: 'Password is',
				PASSWORD_REQUIRED_STRONG: 'required',
				PASSWORD_HINT: 'Enter',
				PASSWORD_HINT_STRONG: 'Password',
				NAME_REQUIRED: 'Name is',
				NAME_REQUIRED_STRONG: 'required',
				NAME_HINT: 'Enter',
				NAME_HINT_STRONG: 'Name',
				PHONE_REQUIRED: 'Phone no. is',
				PHONE_REQUIRED_STRONG: 'required',
				PHONE_HINT: 'Please enter',
				PHONE_HINT_STRONG: 'Phone',
				FACILITY_HINT: 'Select',
				SYSTEM_HINT: 'Select',
				SYSTEMS_PLACEHOLDER: 'Systems',
				SYSTEM_HINT_STRONG: 'System',
				FACILITY_HINT_STRONG: 'Facility',
			},
			CONFIRMATION: {
				REASON_REQUIRED: 'Reason is required.',
			},
			USER_ROLES: {
				SELECT_ROLE: 'Select Role',
				ASSIGN_TOOLTIP: 'Assign role',
				ASSIGN: 'Assign',
				ASSIGNED_ROLES: 'Assigned roles:',
				REMOVE_TOOLTIP: 'Remove role',
			},
			ADDRESS: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				ADDRESS_LINE: 'Enter Address Line',
				ADDRESS_LINE_REQUIRED: 'Address Line is',
				ADDRESS_LINE_REQUIRED_STRONG: 'required',
				ADDRESS_LINE_HINT: 'Please enter',
				ADDRESS_LINE_HINT_STRONG: 'Address Line',
				CITY: 'City',
				CITY_REQUIRED: 'City is',
				CITY_REQUIRED_STRONG: 'required',
				CITY_HINT: 'Please enter',
				CITY_HINT_STRONG: 'City',
				STATE: 'Enter State Line',
				STATE_REQUIRED: 'State is',
				STATE_REQUIRED_STRONG: 'required',
				STATE_HINT: 'Please enter',
				STATE_HINT_STRONG: 'State',
				POSTCODE: 'Enter Postode',
				POSTCODE_REQUIRED: 'Postcode is',
				POSTCODE_REQUIRED_STRONG: 'required',
				POSTCODE_HINT: 'Please enter',
				POSTCODE_HINT_STRONG: 'Postcode',
			},
			SOCIAL: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				LINKEDIN: 'Enter LinkedIn address',
				LINKEDIN_HINT: 'Please enter',
				LINKEDIN_HINT_STRONG: 'Linked In',
				FACEBOOK: 'Enter Facebook address',
				FACEBOOK_HINT: 'Please enter',
				FACEBOOK_HINT_STRONG: 'Facebook',
				TWITTER: 'Enter Twitter address',
				TWITTER_HINT: 'Please enter',
				TWITTER_HINT_STRONG: 'Twitter',
				INSTAGRAM: 'Enter Instagram address',
				INSTAGRAM_HINT: 'Please enter',
				INSTAGRAM_HINT_STRONG: 'Instagram',
				ADDRESS_SUFFIX: 'address',
			},
			CHANGE_PASSWORD: {
				FORM_ERROR: 'Oh snap! Password not match.',
				PASSWORD: 'Enter Password',
				PASSWORD_REQUIRED: 'Password is',
				PASSWORD_REQUIRED_STRONG: 'required',
				PASSWORD_HINT: 'Please enter',
				PASSWORD_HINT_STRONG: 'Password',
				CONFIRM_PASSWORD: 'Confirm password',
				CONFIRM_REQUIRED: 'Confirm password is',
				CONFIRM_REQUIRED_STRONG: 'required',
				CONFIRM_HINT: 'Please conirm',
				CONFIRM_HINT_STRONG: 'Password',
				CHANGE_BUTTON: 'Change password',
				SAVE_CHANGES: 'Save changes',
			},
		},
		SYSTEM_VIEW: {
			PARTS: 'PARTS',
			ACTIVE: 'ACTIVE',
			UNIT: 'Unit',
			SYSTEM: 'System',
			SEARCH_SYSTEM: 'Search System...',
			NO_MATCHING_SYSTEM: 'No matching system found',
			OPEN_ALERTS: 'OPEN ALERTS',
			ACTIVE_ALERTS: 'ACTIVE ALERTS',
			UNACK_ALERTS: 'UNACK. ALERTS',
			RELIABILITY: 'RELIABILITY',
			MEAN_TIME_BETWEEN_ALERTS: 'MEAN TIME BETWEEN ALERTS',
			UPTIME: 'UPTIME',
			DAYS: 'days',
			PERFORMANCE_CURVES: 'PERFORMANCE CURVES',
			OPEN_IN_NEW_TAB: 'Open In New Tab',
			TAB_ANOMALY: 'Anomaly',
			TAB_SYSTEM_DETAILS: 'System Details',
			TAB_DATA_QUALITY: 'Data Quality',
			TAB_PERFORMANCE: 'Performance',
			CLEAR_SIMULATION: 'Clear Simulation',
			SIMULATION: 'Simulation',
			CLICK_TO_START_PREDICTION: 'Click to start prediction',
			PREDICTION_RUNNING: 'Prediction Running',
			NO_OF_DAYS: 'No.of Days',
			OK: 'Ok',
			RESET: 'Reset',
			RETRAINING: 'Retraining',
			MORE: 'More',
			TAGS: 'Tags',
			SEARCH_TAG: 'Search Tag...',
			NO_MATCHING_TAG: 'No matching tag found',
			ASSET_LABEL: 'Asset:',
			NAME_LABEL: 'Name:',
			TAG_ID_LABEL: 'TagId:',
			CANCEL: 'Cancel',
			ASSETS: 'ASSETS',
			SEARCH_ASSET: 'Search Asset...',
			NO_MATCHING_ASSET: 'No matching asset found',
			RESET_ASSET_SELECTION: 'Reset Asset Selection',
			DATA_QUALITY: {
				SEARCH_TAG: 'Search tag',
				DOWNLOAD_TOOLTIP: 'Download Tag Data Quality Report',
				DOWNLOAD: 'Download',
				COL_TAG_NAME: 'Tag Name',
				COL_MISSING_DATA: 'Missing Data',
				COL_FLAT_LINE: 'Flat Line',
				COL_OUTLIER: 'Outlier',
				COL_OUT_OF_RANGE: 'Out of Range',
				COL_TOTAL_INVALID_DATA: 'Total Invalid Data',
				COL_ACTIONS: 'Actions',
				MORE_ACTIONS: 'More actions',
				NO_RECORDS: 'No data quality events found for the selected time range',
				LOADING: 'Loading...',
				SHUTDOWN_TAG: 'Shutdown Tag',
				TRIP: 'Trip',
				TRIP_LIMIT: 'Trip Limit',
				ALARM: 'Alarm',
				ALARM_LIMIT: 'Alarm Limit',
				THRESHOLD: 'Threshold',
				THRESHOLD_LIMIT: 'Threshold Limit',
				INSTRUMENT: 'Instrument',
				INSTRUMENT_RANGE: 'Instrument Range',
			},
			SYSTEM_DETAILS: {
				NO_IMAGE_FOUND: 'No Image Found',
				ASSET_DETAILS: 'Asset Details',
				CURRENT_ALERTS_EQUIPMENT: 'Current Alerts/Equipment',
				EQUIPMENT_DISTRIBUTION: 'Equipment wise distribution',
				TOP_FAILURE_MODES: 'Top Failure Modes per Equipment',
				CUSTOM_INPUTS: 'Custom Inputs',
				SELECT_TAG: 'Select Tag',
				UPDATE: 'Update',
				SPECIFY_VALUE: 'Specify Value',
				TIMESTAMP: 'TimeStamp',
				LAB_DATA: 'Lab Data',
				NO_DATA_FOUND: 'No Data Found',
			},
			ALERT_SETTINGS: {
				TITLE: 'Alert Settings',
				CANCEL: 'Cancel',
				FAILURE_MODE: 'Failure Mode',
				AGGREGATED_ANOMALY_SCORE: 'Aggregated Anomaly Score',
				INSTRUMENT_HEALTH: 'Instrument Health/Data Quality',
				FLATLINE: '1: Flatline',
				MISSING_DATA: '2: Missing Data',
				OUT_OF_RANGE: '3: Out of Range',
				OUTLIERS: '4: Outliers',
			},
			DIAGNOSTICS: {
				TITLE: 'System Diagnostics',
				CANCEL: 'Cancel',
				ROOT_CAUSE_ICON_ALT: 'Root Cause Icon',
				NOT_GENERATED_YET: "You haven't generated System Diagnostics yet.",
				RUN_TO_PROCEED: 'Please run the diagnostics to proceed.',
				GENERATION_FAILED: 'Your last System Diagnostics generation failed.',
				RUN_AGAIN: 'Please run the diagnostics again to proceed.',
				GENERATE_NOW: 'Generate Now',
				REGENERATE: 'Regenerate',
				FAILED_AT: 'Generated System Diagnostics failed at',
				LAST_GENERATED: 'Last generated',
				GENERATING: 'Generating System Diagnostics',
				SEVERITY: 'Severity:',
				ISSUE: 'Issue:',
				IMPACT: 'Impact:',
				ACTION: 'Action:',
				PRIORITY: 'Priority:',
			},
			PERFORMANCE_CURVE: {
				TAG: 'Tag',
				FILTER_TAG_VALUE: 'Filter Tag value',
				SEARCH_TAG: 'Search Tag...',
				NO_TAG_FOUND: 'No Tag found',
				GREATER_THAN: 'Greater than',
				LESS_THAN: 'Less than',
				OK: 'Ok',
				DATE_RANGE: 'Date Range',
				START_DATE: 'Start Date',
				END_DATE: 'End Date',
				SELECT: 'Select',
			},
		},
		PLATFORM_CONFIGURATION: {
			HEADER_TITLE: 'Platform Configuration',
			TABS: {
				ORGANISATION_SETUP: 'Organisation Setup',
				ASSET_REGISTRY: 'Asset Registry',
				MODULE_HIERARCHY: 'Module Hierarchy',
				PROPERTY_TEMPLATES: 'Property Templates',
			},
			COMING_SOON: 'Coming soon',
		},
		CUSTOMER_SETUP: {
			TABS: {
				CLIENT_SETUP: 'Organisation Details',
				FACILITY_SETUP: 'Facilities',
				PLANT_ECONOMICS: 'Economic Parameters',
			},
			COMMON: {
				SAVE_CHANGES: 'Save Changes',
				CANCEL: 'Cancel',
				CONFIRM: 'Confirm',
				EDIT: 'Edit',
				DELETE: 'Delete',
				LOADING: 'Loading...',
				SEARCH: 'Search...',
				CLOSE: 'Close',
				SAVED_SUCCESSFULLY: 'Saved Successfully',
				ERROR_SAVING: 'Error saving changes',
				TIMEZONE: 'Timezone',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				SELECT_TIMEZONE: 'Select Timezone',
			},
			CLIENT: {
				TITLE: 'Organisation Details',
				SUBTITLE: 'Configure organisation details',
				LOGO: 'Logo',
				UPLOAD_LOGO: 'Upload Logo',
				HQ_ADDRESS: 'Head Quarter Address',
				ENTERPRISE_NAME: 'Enterprise Name',
				INDUSTRY_SECTOR: 'Industry Sector',
				STREET_ADDRESS: 'Street Address',
				CITY: 'City',
				STATE: 'State',
				COUNTRY: 'Country',
				ZIP_CODE: 'ZIP Code',
				ZOOM_LEVEL: 'Zoom Level',
				BUSINESS: 'Business',
				NOTES: 'Notes',
				SELECT_INDUSTRY_SECTOR: 'Select Industry Sector',
				PLACEHOLDER_BUSINESS: 'Please enter business details',
				PLACEHOLDER_NOTES: 'Please enter notes',
			},
			FACILITY: {
				TITLE: 'Facilities',
				SUBTITLE: 'Define facility locations and parameters',
				ADD_FACILITY: 'Add Facility',
				GROUP_BY: 'Group by',
				COL_NAME: 'Name',
				COL_LOCATION: 'Location',
				COL_CAPACITY: 'Capacity (MW)',
				COL_REGION: 'Region',
				COL_INDUSTRY: 'Industry',
				NO_FACILITIES_SEARCH: 'No facilities found.',
				TRY_ADJUSTING: 'Try adjusting your search query.',
				NO_FACILITIES_YET: 'No facilities setup yet.',
				CLICK_TO_GET_STARTED: "Click 'Add Facility' to get started.",
				DELETE_TITLE: 'Facility Delete',
				DELETE_DESCRIPTION: 'Are you sure you want to permanently delete the facility "{{name}}"?',
				DELETE_WAIT: 'Deleting facility...',
				DELETED_SUCCESS: 'Facility deleted successfully',
				DELETE_ERROR: 'Error deleting facility',
			},
			ADD_FACILITY_DIALOG: {
				TITLE_ADD: 'Add Facility',
				TITLE_EDIT: 'Edit Facility',
				UPDATED_SUCCESS: 'Facility updated successfully',
				UPDATE_ERROR: 'Error updating facility',
				CREATED_SUCCESS: 'Facility created successfully',
				CREATE_ERROR: 'Error creating facility',
				FACILITY_NAME: 'Facility Name',
				FACILITY_CODE: 'Facility Code',
				LOCATION: 'Location',
				REGION: 'Region',
				CURRENCY: 'Currency',
				INSTALLED_CAPACITY: 'Installed Capacity (MW)',
				INDUSTRY: 'Industry',
				GIS_LOCATION: 'GIS Location',
				PLACEHOLDER_FACILITY_NAME: 'Plant name',
				PLACEHOLDER_LOCATION: 'City, State',
				SELECT_REGION: 'Select Region',
				SELECT_CURRENCY: 'Select Currency',
				SELECT_INDUSTRY: 'Select Industry',
			},
			FACILITY_FORM: {
				TAB_FACILITY_INFO: 'Facility Information',
				TAB_HISTORIAN_INFO: 'Historian Information',
				TAB_SAP_INFO: 'SAP Information',
				ENTERPRISE: 'Enterprise',
				ADDRESS: 'Address',
				CITY: 'City',
				STATE: 'State',
				COUNTRY: 'Country',
				ZIP: 'ZIP',
				ZOOM_LEVEL: 'Zoom Level',
				APPLICATION: 'Application',
				NOTES: 'Notes',
				CUSTOMER_ADVOCATE: 'Customer Advocate',
				HISTORIAN_TYPE: 'Historian Type',
				ACCESS_METHOD: 'Access Method',
				ACCESS_URL: 'Access URL',
				RESOURCE_URL: 'Resource URL',
				DATA_FETCH_SETTINGS: 'Data Fetch settings',
				FORWARD_AGGREGATE: 'Forward aggregate',
				FETCH_RATE: 'Fetch Rate',
				FETCH_RATE_UNIT: 'Fetch Rate Unit',
				ENABLE_SAMPLING: 'Enable sampling',
				SAMPLING_RATE: 'Sampling Rate',
				SAMPLING_RATE_UNIT: 'Sampling Rate Unit',
				PREDICTION_SETTINGS: 'Prediction settings',
				PREDICTION_RATE: 'Prediction Rate',
				PREDICTION_RATE_UNIT: 'Prediction Rate Unit',
				DQ_ALERTS: 'Data quality alerts',
				START_DELAY: 'Start Delay (in hrs)',
				END_DELAY: 'End Delay (in hrs)',
				FUNCTIONAL_LOC_MAPPING: 'FunctionalLoc/EquipmentId Mapping',
				UPLOAD_FUNCTIONAL_LOC: 'Upload FunctionalLoc/EquipmentId Data',
				DOWNLOAD_FUNCTIONAL_LOC: 'Download FunctionalLoc/EquipmentId Mapping',
				SAP_DATA: 'SAP Data',
				UPLOAD_SAP_DATA: 'Upload SAP Data',
				DOWNLOAD_SAP_FORMAT: 'Download SAP Data Format',
				UPDATE_SAP_DATA: 'SAP Permit Data Update',
				UPLOAD_UPDATE_SAP_DATA: 'Upload SAP Permit Data Update',
				DOWNLOAD_UPDATE_SAP_FORMAT: 'Download SAP Permit Data Update Format',
				CMMS_WRITE_INTEGRATION: 'CMMS Write Integration',
				CMMS_LAST_DATA_PULL: 'CMMS Last Data Pull',
				IP_ADDRESS: 'IP Address',
				USER_NAME: 'User Name',
				PASSWORD: 'Password',
				TEST: 'Test',
				TEST_WRITE_INTEGRATION: 'Test Write Integration',
			},
			PLANT_ECONOMICS: {
				TITLE: 'Economic Parameters',
				SUBTITLE: 'Setup economic factors and cost parameters',
				SELECT_FACILITY_MSG: 'Please select a facility to manage its economic parameters.',
				SECTION_TITLE: 'Production Economics Parameters',
				CHOOSE_FACILITY: 'Choose a facility...',
				PRODUCTION_DETAILS: 'Production Details',
				LABOR_SALARY: 'Labor Salary Parameters (per hour)',
				UPDATED_SUCCESS: 'Plant Economics updated successfully',
				UPDATE_ERROR: 'Error updating Plant Economics',
				COST_PER_UNIT: 'Cost/Unit of Production',
				CAPACITY_HOUR: 'Capacity/hour (e.g. MWh)',
				REVENUE_HOUR: 'Revenue/hour',
				MARGIN_PERCENT: 'Margin (%)',
				OTHER_COSTS: 'Other Fixed Idling Costs',
				TECHNICIAN: 'Technician',
				HELPER: 'Helper',
				SUPERVISOR: 'Supervisor',
				MANAGER: 'Manager',
			},
		},
		MODEL_EXPLAIN: {
			TITLE: 'Explain tags',
			SELECTED_TAG: 'Selected Tag',
			CAUSAL_TAGS: 'Causal Tags',
			TAG_SINGULAR: 'tag',
			TAG_PLURAL: 'tags',
			CONTRIBUTOR_SCORE: 'Score',
			NO_CONTRIBUTORS: 'No contributing tags found for this timestamp.',
			LOADING_CAUSAL_TAGS: 'Loading causal tags...',
			CLOSE: 'Close',
			ASSET: 'Asset',
			FULLSCREEN: 'Fullscreen',
			EXIT_FULLSCREEN: 'Exit fullscreen',
			EXPAND: 'Expand',
			COLLAPSE: 'Collapse',
			EXPLAIN: 'Explain',
		},
		FILE_PREVIEW: {
			LOADING_REPORT: "Loading report…",
			REPORT_IN_PROGRESS: "Report generation is in progress. Please come back after 5 minutes.",
			REPORT_FAILED: "The report could not be generated. Please share it again.",
		},
		ALERT_V2: {
			FORECAST: {
				TTF_SHORT: 'TTF',
				TTI_SHORT: 'TTI',
				DETAILS: '{{kind}} details',
				NO_VALUES: 'No valid {{kind}} values available.',
				ON_DEMAND_NO_FORECAST: 'No forecast available from the selected point. Drag the marker to another point and try again.',
				MIN: 'Min =',
				CURRENT_VALUE: 'Current Value',
				VS_BASELINE: 'vs baseline',
				ACTIVE_DURATION: 'Active duration',
				SAMPLE_DENSITY: 'Sample density',
				FORECAST: 'Forecast {{kind}} =',
				TTF: {
					ALERT: {
						TITLE: 'Alert-level TTF',
						DESCRIPTION: 'TTF = min (TTF of each contributing tag). The earliest forecasted breach drives the rolled-up value shown below.',
					},
					ALERT_LIST: {
						TITLE: 'Alert-level TTF',
						DESCRIPTION: 'TTF = min (TTF of each failure mode). The earliest forecasted breach drives the rolled-up value shown below.',
					},
					FAILURE_MODE: {
						TITLE: 'Failure-mode TTF',
						DESCRIPTION: 'TTF = min (TTF of each contributing tag). The earliest forecasted breach drives the rolled-up value shown below',
					},
					TAG: {
						TITLE: 'Tag-level TTF',
						DESCRIPTION: 'Forecast of days until the tag’s projected value crosses its operating threshold, based on the recent rate of change extrapolated forward.',
					},
				},
				TTI: {
					ALERT: {
						TITLE: 'Alert-level Time to Intervention',
						DESCRIPTION: 'This alert\'s earliest intervention forecast across monitored performance degradation metrics.',
					},
					ALERT_LIST: {
						TITLE: 'Alert-level Time to Intervention',
						DESCRIPTION: 'The earliest intervention forecast among this alert\'s failure modes.',
					},
					FAILURE_MODE: {
						TITLE: 'Failure Mode — Time to Intervention',
						DESCRIPTION: 'Earliest predicted operational intervention based on the performance indicators associated with this failure mode.',
					},
					TAG: {
						TITLE: 'Tag-level — Time to Intervention',
						DESCRIPTION: 'Earliest predicted operational intervention for this tag.',
					},
				},
			},
			DQ_SETTINGS: {
				TITLE: "Data Quality Settings",
				DETECTION_TITLE: "Data Quality Detection",
				ALERT_GEN_TITLE: "Data Quality Alert Generation",
				ALERT_GEN_DESC: "Choose which detected DQ issues should generate alerts. Turning off alert generation does not stop DQ calculation.",
				FLATLINE_DETECTION: "Flatline Detection",
				MISSING_DATA_DETECTION: "Missing Data Detection",
				OUTLIER_DETECTION: "Outlier Detection",
				OUT_OF_RANGE_DETECTION: "Out of Range Detection",
				ERRATIC_DETECTION: "Erratic Detection",
				FLATLINE_ALERT: "Flatline Alert",
				MISSING_DATA_ALERT: "Missing Data Alert",
				OUTLIER_ALERT: "Outlier Alert",
				OUT_OF_RANGE_ALERT: "Out of Range Alert",
				ERRATIC_ALERT: "Erratic Alert",
				CLOSE_TOOLTIP: "Close"
			},
			DETAIL: {
				NO_DATA_URL: "No data found for the provided URL.",
				NO_DATA_URL_DESC: "Please verify the entered URL and try again.",
				FAILURE_MODES: "Failure Modes",
				SEARCH: "Search...",
				SORT_FAILURE_SCORE: "Sort by failure score",
				SORT_CREATION_DATE: "Sort by creation date",
				OTHER_ACTIVE_ALERTS: "Other Active Alerts",
				NEW_FAILURE: "New Failure added",
				ALERT_TITLE_PLACEHOLDER: "Alert Title",
				SEARCH_OWNER: "Search Owner...",
				SEARCH_WATCHERS: "Search Watchers..",
				ASSIGN_OWNER: "Assign Owner",
				ADD_WATCHERS: "Add Watchers",
				VERSION_HISTORY: "Version History",
				COPY_LINK: "Copy alert link",
				BOOKMARK: "Bookmark alert",
				REMOVE_BOOKMARK: "Remove bookmark",
				FETCHING_SYSTEM_DETAILS: "Fetching System Details",
				RESTORE_VERSION: "Restore Version",
				CANNOT_DELETE_VERSION: "Cannot delete versions while RCA is in progress",
				DELETE_VERSION: "Delete Version",
				EDIT: "Edit",
				CLOSE: "Close",
				DOWNLOAD: "Download",
				SHARE: "Share",
				ANOMALY_SCORE: "Anomaly Score",
				TIMELINE: "Timeline",
				VERSIONS: "Versions",
				NO_DATA_AVAILABLE: "No data available",
				EXPORT_REPORT: "Export Report",
				TIME_TO_FAILURE_IN: "Time to Failure in {{unit}}",
				TIME_TO_INTERVENTION_IN: "Time to Intervention in {{unit}}",
				SWITCH_TO_FM_VIEW: 'Switch to FM View',
				SWITCH_TO_RCA_VIEW: 'Switch to RCA View',
				CREATED_ON: 'Created On',
				MENU_CREATED_ON: 'Created on',
				STATE: 'State',
				DUE_DATE: 'Due Date',
				STATUS: 'Status',
				OWNER: 'Owner',
				WATCHERS: 'Watchers',
				WATCHER: 'Watcher',
				LAST_RUN_PREFIX: 'Last run:',
				MENU_LAST_RUN: 'Last Run',
				RUN_NOW: 'Run now',
				MENU_RUN_NOW: 'Run Now',
				MORE: 'More',
				REPORT_ISSUE: 'Report Issue',
				NAV: {
					THRESHOLD: 'Threshold',
					DATA_QUALITY: 'Data Quality',
					ACTIVITY_LOGS: 'Activity Logs',
					DISCUSSION: 'Discussion',
					ANALYSIS_VIEWS: 'Analysis & Views',
					RETRAIN_MODEL: 'Retrain Model',
					FEEDBACK: 'Feedback',
					DISPLAY_TAGS: 'Display Tags',
					PREFERRED_SETTINGS: 'Preferred Settings',
					DOCUMENTS: 'Documents',
					WORK_ORDERS: 'Work Orders',
					ROOT_CAUSE_ANALYSIS: 'Root Cause Analysis',
				},
				TAGS_TOOLTIP: "Tags",
				TIME_TO_TRIP: "Time to Failure",
				DAYS: "days",
				CMMS_NUMBER: "CMMS Number",
				STACKED_VIEW: "Stacked View",
				OVERLAY_VIEW: "Overlay View",
				GRID_VIEW: "Grid View",
				NO_RECOMMENDATIONS: "No Recommendations to Show",
				RECOMMENDATIONS: "Recommendations",
				RECOMMENDATION_POPUP: {
					ADD_PLACEHOLDER: "Add recommendation",
					ADD: "Add",
					CANCEL: "Cancel",
					UPDATE: "Update",
					EMPTY_TITLE: "No recommendations available",
					EMPTY_HINT: "Add a recommendation to show it here.",
				},
				SEARCH_CATEGORY: "Search Category...",
				NO_CATEGORY: "No matching category found",
				SELECT_CATEGORY: "Select Category",
				SEARCH_COMPONENT: "Search Component...",
				NO_COMPONENT: "No matching component found",
				SELECT_COMPONENT: "Select Component",
				SEARCH_ERROR: "Search Error...",
				NO_ERROR_FOUND: "No matching error found",
				SELECT_ERROR: "Select Error",
				ALERT_DETAILS_TITLE: "Alert Details",
				EMPTY_DATA_ALT: "Empty Data",
				NO_OPEN_FAILURE_MODES: "No open failure modes.",
				RELATED_ALERTS: "Related Alerts",
				TOP_CONTRIBUTING_TAGS: "Top Contributing Tags to Anomaly Score",
				NO_TAGS_TO_DISPLAY: "No tags to display.",
				NO_DATA_ALT: "No data",
				SELECT_FM_OR_ADD_TAGS: "Select a failure mode or add tags to view graphs.",
				BREAKDOWN_CATEGORY_LABEL: "Breakdown Category",
				BREAKDOWN_COMPONENT_LABEL: "Breakdown Component",
				BREAKDOWN_ERROR_LABEL: "Error",
				SAVE: "Save",
				FILTER_TAGS: "Filter tags",
				NO_MATCHING_RESULT: "No matching result",
				START_TYPING: "Start typing to see matching tags.",
				NO_MATCHING_RESULTS: "No matching results",
				CLOSE_TOOLTIP: "Close",
				EDIT_DISABLED: "You're in view-only mode for this facility",
				MULTI_SELECT_DISABLED: "Only the alert owner can multi-select failure modes",
				SPLIT_MERGE_OWNER: "Only an owner of the alert can separate out failure mode(s).",
				SPLIT_MERGE_STATUS: "Only alerts with the status \"In Process,\" \"On Watch,\" \"No Action Planned,\" or \"Pending Defect Raised\" can be separated into a new alert or merged with an existing one.",
				SPLIT_MERGE_APPROVED: "Only approved or unactioned failure mode(s) can be separated to a new alert or merged with an existing alert.",
				SPLIT_MERGE_ACTION: "Move failure mode(s) to a new alert or merge with an existing alert.",
				SPLIT_MERGE_IN_PROGRESS: "A split or merge is in progress for this alert. Please wait for it to complete.",
				SPLIT_MERGE_DISMISS: "Dismiss",
				TITLE_EMPTY: "Enter a title to proceed.",
				TITLE_TOO_LONG: "Title cannot exceed 60 characters.",
				MAINTENANCE_RECORDS_DIALOG: "Existing maintenance records detected.<br>Do you want to delete them to proceed with relearning?",
				FAILURE_DELETED: "Failure Mode \"{{name}}\" deleted successfully",
				FAILURE_DELETE_ERROR: "Something went wrong while deleting \"{{name}}\". Please try again.",
				FAILURE_ADDED: "Failure Mode \"{{name}}\" added successfully",
				USED_IN_MODEL: "Used in model and calculated tag",
				ONGOING: "Ongoing",
				FAILURE_TIMELINE: {
					TITLE: "Timeline of \"{{name}}\"",
					SORT_BY: "Sort by",
					SORT_TIMELINE: "Timeline",
					SORT_ASSETS: "Assets",
					LIMIT_TO_SYSTEM: "Limit results to this system",
					ASSET: "Asset",
					REASON: "Reason",
					RECOMMENDATIONS: "Recommendations",
					NOT_AVAILABLE: "NA",
					NO_DATA: "No data found.",
					MENU_LABEL: "Failure Timeline",
				},
			},
			RCA: {
				CREATE_WORK_ORDER: "Create Work Order",
				GENERATING: "Generating Root Cause Analysis",
				GENERATE: "Generate Root Cause Analysis",
				PERCENT_COMPLETED: "% Completed",
				GO_BACK: "Go back",
				RUN_NOW: "Run now",
				CANCEL: "Cancel",
				NOTIFY_ME: "Notify Me",
				ALREADY_IN_PROGRESS: "RCA generation is already in progress",
				RERUN: "Re-run",
				VIEW_TRACES: "View Traces",
				TITLE: "Root Cause Analysis",
				HYPOTHESES: "Hypotheses",
				COMMENTS: "comments",
				EVIDENCE_POINTS: "evidence points",
				DISCUSSION_TOOLTIP: "For internal discussion with your team",
				APPROVED: "Approved",
				APPROVE: "Approve",
				EDIT: "Edit",
				RELEARNED: "Relearned",
				RELEARN: "Relearn",
				SUSPECTED_CAUSE: "Suspected cause",
				CAUSAL_CHAIN: "Causal Chain",
				STEPS: "steps",
				RECOMMENDATIONS: "Recommendations",
				CHART_TAGS: "Chart Tags",
				EXPORT_AS_PDF: "Export as PDF",
				PROPOSED_EVIDENCE: "Proposed Evidence",
				ADD_TO_EVIDENCE: "Add to Evidence",
				EVIDENCE_ADDED_BY: "Added on {{date}} at {{time}} by {{user}}",
				EVIDENCE_ADDED: "Added on {{date}} at {{time}}",
				ALREADY_ADDED: "Already added as evidence",
				DRAG_TO_REORDER: "Click and drag to reorder",
				TABS: {
					TAGS: "Tags",
					WORK_ORDERS: "Work Orders",
					DOCUMENTS: "Documents",
					SYSTEM_DETAILS: "System Details",
				},
				EMPTY: {
					NO_TAGS_EVIDENCE: "No tags added as evidence",
					NO_TAGS_EVIDENCE_DESC: "Tag charts and supporting details will appear here when tags are proposed as evidence.",
					NO_WORK_ORDERS: "No work orders linked",
					NO_WORK_ORDERS_DESC: "Work orders will appear here when maintenance records are associated with this root cause.",
					NO_DOCUMENT_EVIDENCE: "No document evidence",
					NO_DOCUMENT_EVIDENCE_DESC: "Add an existing document or upload a new one to use as evidence.",
					UPLOAD_NEW_DOCUMENT: "Upload New Document",
					NO_PROPOSED_EVIDENCE: "No proposed evidence yet",
					NO_PROPOSED_EVIDENCE_DESC: "Add tags, work orders, documents, or P&ID references to support this hypothesis.",
					NO_TAGS_LINKED: "No tags linked",
					NO_TAGS_LINKED_DESC: "Tag charts and supporting details will appear here when tags are added to this hypothesis.",
					SELECT_TAG_HEADING: "No tags selected",
					SELECT_TAG_DESC: "Click a tag from the hypothesis on the left, or drag tags here, to view their charts.",
					NO_DOCUMENTS: "No documents available",
					NO_DOCUMENTS_DESC: "Related technical manuals, reports, and PDFs will appear here when linked to this hypothesis.",
					NO_SYSTEM_DETAILS: "No system details available",
					NO_SYSTEM_DETAILS_DESC: "Associated P&IDs, system specifications, and technical details will appear here when equipment data is linked.",
				},
				WO: {
					WORK_ORDER: "Work Order",
					MANUALLY_ADDED: "Manually Added",
					DESCRIPTION: "Description",
					NOTIFICATION_NO: "Notification #",
					TYPE: "Type",
					EQUIPMENT: "Equipment",
					PLANNING_GROUP: "Planning Group",
					STATUS: "Status",
					USER_STATUS: "User Status",
					CREATED_BY: "Created By",
					COMPLETED_BY: "Completed By",
					CREATED_ON: "Created on",
					COMPLETED_ON: "Completed on",
					CAUSE: "Cause",
					CAUSE_DESC: "Cause Desc.",
					ACTIVITY_GROUP: "Activity Group",
					ACTIVITY_DESC: "Activity Desc.",
					SEE_LESS: "See Less",
					SEE_MORE: "See More",
					ADDED_WITH_ROOTY: "Added with {{name}}",
					ADDED_MANUALLY: "Manually added",
				},
				PDF: {
					ALERT_REPORT: "Alert Report",
					HYPOTHESIS: "Hypothesis",
					TITLE_LABEL: "Title",
					SYSTEM: "System",
					TYPE: "Type",
					CREATED_ON: "Created on",
					OWNER: "Owner",
					STATE: "State",
					DUE_DATE: "Due Date",
					STATUS: "Status",
					WATCHERS: "Watchers",
					HYPOTHESES_PREFIX: "Hypotheses",
					PAGE: "Page",
					ZOOM: "Zoom:",
					SIZE: "Size:",
				},
				FEEDBACK: {
					APPROVE_HEADER: "Approve Hypotheses",
					RELEARN_HEADER: "Relearn Hypotheses",
					COMMENT_PLACEHOLDER: "Add your feedback or notes...",
					REVISION_INFO: "Required for revision",
				},
				SNACKBAR: {
					REPORT_QUEUED: "Report requested. We'll email a download link to {{email}} when it's ready.",
					RCA_COMPLETED: "RCA generation completed successfully.",
					RCA_NOTIFY: "You will be notified once the RCA generation is complete.",
					RCA_FAILED: "Generating RCA failed.",
					REPORT_REQUEST_FAILED: "Could not request the report. Please try again.",
					REMOVE_WO_ERROR: "Error while removing work order from evidence.",
					NO_RCA_DATA_AVAILABLE: "No RCA data available. Please run RCA to generate insights.",
				},
				POPUP: {
					APPROVE_HYPOTHESES: "Approve Hypotheses",
					APPROVE_CAUSAL: "Approve Causal Chain Step",
					APPROVE_RECOMMENDATION: "Approve Recommendation",
					RELEARN_HYPOTHESES: "Relearn Hypotheses",
					RELEARN_CAUSAL: "Relearn Causal Chain Step",
					RELEARN_RECOMMENDATION: "Relearn Recommendation",
				},
				DIALOG: {
				ADD_TAG_EVIDENCE: "Add this tag as proposed evidence?",
				ADD_DOCS_EVIDENCE: "Add {{count}} document(s) as proposed evidence?",
				ADD_WOS_EVIDENCE: "Add this work order as evidence?",
				REMOVE_RC_EVIDENCE_DESC: "Remove this Root Cause Evidence? This can't be undone.",
					REMOVE_EVIDENCE_TITLE: "Confirmation",
					REMOVE_EVIDENCE_DESC: "Remove this evidence? This can’t be undone.",
					ERROR_TITLE: "Error!",
					OK: "Ok",
					CONFIRM: "Confirm",
					CANCEL: "Cancel",
					EVIDENCE_LOCKED: "RCA evidence cannot be moved to the Proposed Evidence section.",
				},
				EVIDENCE_CONTEXT: {
					ADD_TITLE: "Add context for this evidence",
					EDIT_TITLE: "Edit context for this evidence",
					CLOSE: "Close",
					SUBTITLE: "Help RCA understand why this evidence is relevant and how it should be used in the next rerun.",
					FIELD_LABEL: "Why is this evidence relevant?",
					FIELD_LABEL_OPTIONAL: "Why is this evidence relevant? (Optional)",
					FIELD_PLACEHOLDER: "E.g.: This work order mentions seal leakage before the pump trip.",
					FIELD_ERROR: "Please provide context to continue",
					CANCEL: "Cancel",
					UPDATE_CONTEXT: "Update Context",
					ADD_EVIDENCE: "Add Evidence",
					ABORT_TITLE: "Evidence will not be added",
					ABORT_DESC: "RCA needs a short description to understand how this evidence should be used. If you cancel now, this evidence will not be considered in the next RCA rerun.",
					ABORT_CANCEL: "Cancel Evidence Addition",
					ABORT_GO_BACK: "Go Back",
				},
			},
			METRICS2: {
				PENDING_DEFECT: "Pending Defect",
			},
			METRICS: {
				HEALTH_SCORE: "Health Score",
				TOTAL_ALERTS: "Total Alerts",
				UNACKNOWLEDGED: "Unacknowledged",
				REVIEWING: "Reviewing",
				PENDING: "Pending",
				UNKNOWN: "Unknown",
			},
			OVERVIEW: {
				SYSTEM_OVERVIEW: "System Overview",
				SYSTEM_HEALTH_INDICATORS: "System Health Indicators",
				PRIORITY_ACTIONS: "Priority Actions",
				PRIORITY_TOOLTIP: "What needs your attention now. Anomaly Alerts that are Unacknowledged and Pending - Defect Raised.",
				NO_PRIORITY_ACTIONS: "No Priority Actions",
				ALL_CAUGHT_UP: "All caught up - nothing need immediate attention ",
				MONITORING_TRACKING: "Monitoring & Tracking",
				MONITORING_TOOLTIP: "Lower priority items being tracked. Anomaly Alerts with Status In Process and On Watch.",
				IN_PROCESS: "In Process",
				ON_WATCH: "On Watch",
				RUNNING_STATE: "Running State",
				AT_RISK: "At Risk",
				REVIEW: "Review",
				HEALTHY: "Healthy",
				CURRENT: "Current",
				THRESHOLD: "Threshold",
				NO_DATA_FOUND: "No Data Found",
				VIEW_ALL: "View all →",
				NO_ALERTS_ARE: "No alerts are {{title}}",
				NO_DATA: "No data",
			},
			TABLE: {
				HEADERS: {
					STATUS: "Status",
					ALERT_NAME: "Alert Name",
					SYSTEM_NAME: "System name",
					TYPE: "Type",
					LOSS: "Loss (kWh)",
					START: "Start",
					STOP: "Stop",
					DURATION: "Duration",
					LAST_ACTIVE: "Last Active",
					CREATED_ON: "Created on",
					STATE: "State",
					OWNER: "Owner",
					WATCHERS: "Watchers",
					FORECAST: "Forecast",
					CATCH: "Catch",
					UPPER_LIMIT: "Upper Limit",
					VALUE: "Value",
					LOWER_LIMIT: "lower limit",
					LAST_SYSTEM_UPDATE: "Last System Update",
					LAST_USER_UPDATE: "Last User Update",
					DISCUSSION: "Discussion",
					TOTAL_VALUE: "Total Value",
					RELIABILITY_SAVING: "Reliability Saving",
					MAINTENANCE_SAVING: "Maintenance Saving",
					PERFORMANCE_SAVING: "Performance Saving",
					ALERT_DRIVEN_MAINTENANCE: "Alert Driven Maintenance",
				},
				NEW_FAILURE_ADDED: "New Failure added",
				TIME_TO_TRIP_DAYS: "Time to Failure {{n}} days",
				OPEN_IN_NEW_TAB: "Open in new tab",
				RCA_AVAILABLE: "Root Cause Analysis available",
				ASSIGN_OWNER: "Assign Owner",
				ADD_WATCHERS: "Add Watchers",
				SEARCH_OWNER: "Search Owner...",
				SEARCH_WATCHERS: "Search Watchers...",
				NO_APPROVED_FM: "No approved failure modes found",
				EXTRA_MORE: "+ {{count}} more",
				CUSTOMIZE_COLUMNS: "Customize Columns",
				BOOKMARK_ALERT: "Bookmark alert",
				REMOVE_BOOKMARK: "Remove bookmark",
				VIEW_ONLY_MODE: "You're in view-only mode for this facility",
				SYSTEM_TOOLTIP: "System: {{system}}\nUnit: {{unit}}\nFacility: {{facility}}",
			},
			UTILS: {
				STATUS: {
					UNACK: "Unacknowledged",
					IN_PROCESS: "In Process",
					ON_WATCH: "On Watch",
					PENDING_DEFECT: "Pending - Defect Raised",
					CLOSED_MAINT_DEFERRED: "Closed - Maint. Deferred",
					CLOSED_NO_ACTION: "Closed - No Action Planned",
					CLOSED_RESOLVED: "Closed - Resolved",
					REJECTED: "Rejected",
				},
				STATE: {
					TENTATIVE: "Tentative",
					ACTIVE: "Active",
					RETURNED_TO_NORMAL: "Returned to Normal",
					CLOSED: "Closed",
					NOISE_DISCARDED: "Noise/Discarded",
				},
				TYPE: {
					H_ANOMALY: "H. Anomaly",
					L_ANOMALY: "L. Anomaly",
					DATA_QUALITY: "Data Quality",
					USER_REPORTED: "User Reported",
					THRESHOLD: "Threshold",
					DIAGNOSIS: "Diagnosis",
					DIGITAL: "Digital",
				},
				SUBTYPE: {
					OUTLIER: "Outlier",
					OUT_OF_RANGE: "Out of Range",
					FLATLINE: "Flatline",
					MISSING: "Missing",
					UNKNOWN: "Unknown",
					PAINT_BRUSHING: "Paint Brushing",
				},
				THRESHOLD_ALERT: "Threshold Alert",
				DATA_QUALITY_ALERT: "Data Quality Alert",
				TITLE_TOOLTIP: "Title: {{title}}",
				TITLE_ID_TOOLTIP: "Title: {{title}}\nAlert ID: {{id}}",
				DAYS: "{{n}} Days",
				HOURS: "{{n}} Hours",
				DAYS_SHORT: "{{n}}d",
				HOURS_SHORT: "{{n}}h",
				POTENTIAL: "(Potential)",
			},
			DOC_PREVIEW: {
				PREVIEW_DOCUMENT: "Preview Document",
				CLOSE: "Close",
				DOWNLOAD_FILE: "Download File",
			},
			LIST: {
				ALERTS_COUNT: "{{count}} alerts",
				SHOW_MORE_ALERTS: "Show {{count}} more alerts",
				COLUMN_SAVED: "Column view has been saved",
				SOMETHING_WENT_WRONG: "Something went wrong, Please try again",
				TAKES_FEW_SECONDS: "This may take a few seconds...",
				BULK_RESULT: "{{msg}} for {{success}} out of {{total}} alerts.",
				STATUS_CLOSED_NO_ACTION: "Status set to Closed - No action planned",
				ACTION_UPDATED: "{{action}} updated",
				ACTION_STATUS: "Status",
				ACTION_BOOKMARK: "Bookmark",
				ACTION_SUBSCRIBERS: "Subscribers",
			},
			DIALOG: {
				ADD_COMMENT: "Add Comment*",
				COMMENT_REQUIRED: "Please add a comment to continue",
				ADD_A_REASON: "Add a reason",
				SELECTED_FAILURE_MODES: "Selected Failure modes",
				SELECT_ALL: "Select All",
				CANCEL: "Cancel",
				CLOSE: "Close",
				ADD: "Add",
				OK: "OK",
				MARK_AS_CATCH: "Mark as a catch",
			},
			APPROVE: {
				TITLE: "Approve Failure Mode",
				EDIT_TITLE: "Edit - Approve Failure Mode",
				RECOMMENDATIONS_FOR: "Recommendations for {{name}}",
				ADD_RECOMMENDATION_PLACEHOLDER: "Add recommendation...",
				APPROVE: "Approve",
				UPDATE: "Update",
			},
			RELEARN: {
				TITLE: "Relearn Failure Mode",
				RELEARN: "Relearn",
			},
			BULK_UPDATE: {
				PROCESSING: "Processing",
				COMPLETED: "Bulk Update Completed!",
				DOWNLOAD_REPORT: "Download Report",
				SELECT_DUE_DATE: "Select Due Date",
				DUE_DATE_HINT: "The due date defaults to 28 days from today and can be adjusted if required.",
				DUE_DATE_TOOLTIP: "Select a due date for the selected alert",
				UPDATED_SUCCESSFULLY: "Updated Successfully",
				UPDATE_FAILED: "Update Failed",
				SHOWING: "Showing {{shown}}/{{total}}",
			},
			SPLIT_MERGE: {
				TITLE: "Split/Merge Failure Mode",
				SUBTITLE: "Move approved or unactioned failure mode(s) to a new alert or merge with an existing alert.",
				APPROVED: "Approved",
				APPROVED_ON: "Approved on {{date}}",
				APPROVED_FAILURE_MODES: "Approved Failure Modes",
				FAILURE_MODES: "Failure Modes",
				TAB_CREATE: "Create New Alert",
				TAB_MERGE: "Merge to Existing",
				ALERT_TITLE: "Alert Title",
				SYSTEM: "System",
				UNIT: "Unit",
				SEVERITY: "Severity",
				SELECT_SEVERITY: "Select Severity",
				OWNER: "Owner",
				CREATED_ON: "Created On",
				STATUS: "Status",
				SELECT_TARGET_ALERT: "Select Target Alert",
				SEARCH_PLACEHOLDER: "Search...",
				LOADING: "Loading...",
				NOT_OWNER_MESSAGE: "You are not the owner of the alert with a status of 'In Process', 'On Watch', 'No Action Planned', or 'Pending Defect Raised'.",
				PROCESSING_TOOLTIP: "Processing, please wait!",
				PROCESSING: "Processing...",
				SUBMIT_CREATE: "Create New Alert",
				SUBMIT_MERGE: "Merge to Alert",
				VIEW_CREATE: "Open New Alert",
				VIEW_MERGE: "Open Alert",
				GO_BACK: "Go Back",
				SUCCESS_CREATE: "New alert successfully created.",
				SUCCESS_MERGE: "Successfully merged with the existing alert.",
				FAILED_CREATE: "Alert creation was unsuccessful. Please try again.",
				FAILED_MERGE: "Alert merge failed. Please try again.",
				PENDING: "Request queued. It will be processed after the current prediction batch completes.",
				CONFLICT: "A split/merge request is already in progress for this alert.",
				CONFLICT_DESTINATION: "A split/merge request is already in progress for the destination alert.",
				TITLE_PLACEHOLDER_EXAMPLE: 'CESR-C-20250807-IPNK',
				SYSTEM_PLACEHOLDER_EXAMPLE: 'GAS TURBINE TRAIN D',
				UNIT_PLACEHOLDER_EXAMPLE: 'COGEN',
				OWNER_PLACEHOLDER_EXAMPLE: 'Ronald Richards',
				CREATED_ON_PLACEHOLDER_EXAMPLE: 'Aug 25,2025',
			},
			FILTER: {
				FILTER_BY: "Filter by",
				SEARCH_BY_ALERT_NAME: "Search by Alert Name...",
				CLEAR_SEARCH: "Clear search",
				STATE: "State",
				ANOMALY: "Anomaly",
				ACTIVE: "Active",
				RETURNED_TO_NORMAL: "Returned to Normal",
				OTHER_ALERT_TYPES: "Other Alert Types",
				CATCH: "Catch",
				TRUE: "True",
				FALSE: "False",
				AGENTS: "Agents",
				HAS_RCA: "Has Root Cause Analysis",
				NO_RCA: "No Root Cause Analysis",
				BOOKMARK_AND_CASES: "Bookmark and Cases",
				ONLY_TRACKED_CASES: "Only alerts with tracked cases",
				DIAGNOSIS_CONDITIONS: "Diagnosis Conditions",
				TRIP_BREAKDOWN: "Trip/Breakdown",
				UNDER_PERFORMANCE: "Under Performance",
				SMB_DOWN: "SMB Down",
				SMB_UNDER_PERF: "SMB Under Perf",
				CURTAILMENT: "Curtailment",
				OUT_OF_ENV_SCOPE: "Out of Env Scope",
				DATA_QUALITY_TYPE: "Data Quality Type",
				OUTLIER: "Outlier",
				OUT_OF_RANGE: "Out of Range",
				FLATLINE: "Flatline",
				MISSING: "Missing",
				TAG_STATUS: "Tag Status",
				TAG_STATUS_INFO: "Applicable for DQ Alerts only",
				USED_IN_MODEL: "Used in Model",
				DROPPED_TAGS: "Dropped Tags",
				WATCHERS: "Watchers",
				SEARCH_PLACEHOLDER: "Start typing to search",
				CLEAR_ALL: "Clear All",
			},
			COLUMNS: {
				NUMBER: "Number",
				ALERT_NAME: "Alert Name",
				STATUS: "Status",
				SYSTEM: "System",
				TYPE: "Type",
				DATE: "Date",
				CREATED_ON: "Created on",
				STATE: "State",
				OWNER: "Owner",
				WATCHERS: "Watchers",
				CATCH: "Catch",
				FORECAST: "Forecast",
				UPPER_LIMIT: "Upper Limit",
				VALUE: "Value",
				LOWER_LIMIT: "Lower Limit",
				LAST_SYSTEM_UPDATE: "Last System Update",
				LAST_USER_UPDATE: "Last User Update",
				TOTAL_VALUE: "Total Value",
				RELIABILITY_SAVINGS: "Reliability Savings",
				MAINTENANCE_SAVINGS: "Maintenance Savings",
				PERFORMANCE_SAVINGS: "Performance Savings",
				ALERT_DRIVEN_MAINTENANCE: "Alert Driven Maintenance",
				DISCUSSION: "Discussion",
				LOSS: "Loss (kWh)",
				START: "Start",
				STOP: "Stop",
				DURATION: "Duration",
			},
			NO_ALERTS: {
				TITLE: "No alerts found",
				SUBTITLE: "Modify the filters or date range to view results",
			},
			COLUMN_CONFIG: {
				SHOW_COLUMNS: "Show columns",
				SEARCH_PLACEHOLDER: "Start typing to search",
				SELECT_ALL: "Select All",
				RESET_TO_DEFAULT: "Reset to default",
			},
			PAGE_TITLE: "Alerts",
			OVERVIEW_TAB: "Overview",
			SEARCH_PLACEHOLDER: "Search...",
			NO_MATCHING_RESULTS: "No matching results",
			SEARCH_OWNER_PLACEHOLDER: "Search Owner...",
			SELECT_OWNERS: "Select Owners",
			ALL_STATUSES: "All Statuses",
			STATUS_FILTER: "Status Filter",
			CHOOSE_STATUSES: "Choose statuses to display",
			FILTERS: "Filters",
			GROUP_BY: "Group by",
			MORE: "More",
			SELECT_ALERTS_FOR_CASE: "Select the Alert(s) you want to tag in this case",
			SHOWING_RESULTS_FOR: 'Showing results for "{{term}}"',
			CHIP: {
				THRESHOLD: "Threshold",
				HIGH_ANOMALY_SHORT: "H. Anomaly",
				LOW_ANOMALY_SHORT: "L. Anomaly",
				DATA_QUALITY: "Data Quality",
				DIAGNOSIS: "Diagnosis",
			},
			TYPE: {
				THRESHOLD: "Threshold",
				HIGH_ANOMALY: "High Anomaly",
				LOW_ANOMALY: "Low Anomaly",
				DATA_QUALITY: "Data Quality",
				DIAGNOSIS: "Diagnosis",
			},
			AUTO_REFRESH: {
				LABEL: "Auto Refresh",
				OFF: "Off",
				LIVE: "Live",
				MIN_5: "5 minutes",
				MIN_15: "15 minutes",
				MIN_30: "30 minutes",
				HOUR_1: "1 hour",
			},
			MORE_MENU: {
				EXPORT_DATA: "Export Data",
				EXPAND_ALL_GROUPED: "Expand all grouped items",
				COLLAPSE_ALL_GROUPED: "Collapse all grouped items",
				EXPAND_ALL_WITHIN_GROUP: "Expand all items within group",
				COLLAPSE_ALL_WITHIN_GROUP: "Collapse all items within group",
				SWITCH_TO_CLASSIC: "Switch to Classic View",
			},
			TOOLTIP: {
				TYPE_NEW_EVENTS: "{{type}} new events",
				TYPE_ALERTS: "{{count}} {{type}} alerts",
				COUNT_NEW_EVENTS: "{{count}} new events",
				COUNT_TYPE_NEW_EVENTS: "{{count}} {{type}} new events",
				SYSTEM_OPEN_ALERTS: "System: {{name}}\nOpen Alerts: {{count}}",
				UNIT_OPEN_ALERTS: "Unit: {{name}}\nOpen Alerts: {{count}}",
				FACILITY_OPEN_ALERTS: "Facility: {{name}}\nOpen Alerts: {{count}}",
				EDIT_DISABLED_CLOSED: "Edit actions are disabled for Closed/Rejected alerts.",
			},
		},
		MODEL_WIZARD: {
			NO_CUSTOMER_TAGS_AVAILABLE: 'No customer tags available',
			MAP_CUSTOMER_TAGS_CONTENT: 'Add or import customer tags to map them with asset tags.',
		SYSTEM_SUMMARY: {
			TITLE: "System Technical Summary",
			GENERATE: "Generate Summary",
			PLACEHOLDER: "Provide a detailed technical summary of the system, or generate one from available documents and connected systems.",
			HELPER: "You can edit the generated summary or write one manually.",
			DRAWER_TITLE: "Generate System Technical Summary",
			SOURCE_DOCS: "Source Documents",
			SOURCE_DOCS_DESC: "Select documents that explain system design, operation, control logic, or equipment behavior.",
			DOCS_SELECTED: "Documents Selected",
			SELECT_DOCUMENTS: "Select Documents",
			UPLOAD_TITLE: "Upload Supporting Documents",
			UPLOAD_DESC: "Upload additional files that are not already available in Document Manager.",
			UPLOAD_FAILED: "Upload failed",
			VIEW_FILE: "View file",
			PROCESSING: "Processing...",
			COMPLETED: "Completed",
			FAILED: "Failed",
			DUPLICATE_UPLOAD: "\"{{name}}\" is already added — duplicate upload skipped.",
			ALREADY_UPLOADED_USED: "\"{{name}}\" is already uploaded and used for training.",
			CONNECTED_SYSTEMS: "Connected Systems",
			CONNECTED_DESC: "Add upstream, downstream, or parallel systems that influence this system's behavior.",
			UPSTREAM: "Upstream Systems",
			SELECT_UPSTREAM: "Select Upstream Systems",
			DOWNSTREAM: "Downstream Systems",
			SELECT_DOWNSTREAM: "Select Downstream Systems",
			PARALLEL: "Parallel Systems",
			SELECT_PARALLEL: "Select Parallel Systems",
			SEARCH_SYSTEM: "Search System",
			SEARCH_FACILITY: "Search Facility",
			SEARCH_UNIT: "Search Unit",
			NO_SYSTEMS: "No systems found",
			OPTIONAL_META: "Optional System Metadata",
			OPTIONAL_META_DESC: "Optional details can improve the quality of the generated technical summary.",
			PRIMARY_COMPONENT: "Primary Component",
			FLUID_MEDIUM: "Fluid / Medium",
			CRITICAL_CONTROL_NODES: "Critical Control Nodes",
			AUXILIARY_SYSTEMS: "Auxiliary Systems",
			DIAG_UPSTREAM: "Diagnostic Marker - Upstream Failure",
			DIAG_DOWNSTREAM: "Diagnostic Marker - Downstream Failure",
			ADDITIONAL_CONTEXT: "Add Additional Context",
			OPTIONAL: "Optional",
			DOCUMENTS_COUNT: "documents",
			CONNECTED_COUNT: "connected systems",
			VIEW_SOURCES: "View Sources",
			VIEW_SOURCES_DESC: "Documents and connected systems used to generate this description.",
			NO_DOCS_USED: "No documents were used to generate this description.",
			NO_SYSTEMS_USED: "No connected systems were used to generate this description.",
			NO_SOURCES: "No sources available",
			NO_SOURCES_DESC: "No documents or connected systems were used to generate this description.",
			REGENERATE: "Regenerate",
			CLICK_TO_EDIT: "Click to edit",
			GENERATION_STARTED: "Generating system description… this may take a moment.",
			ALREADY_IN_PROGRESS: "A system description is already being generated for this system. Please wait for it to finish before regenerating.",
			GENERATION_FAILED: "System description generation failed.",
			GENERATION_FAILED_TEXT: "System description generation failed please try again",
			LAST_UPDATED: "Last updated",
			BY: "by",
			DOCUMENTS: "Documents",
			SELECT_DOCS_TITLE: "Select Source Documents",
			SELECT_DOCS_DESC: "Select documents from Facility, Unit, or System level that explain system design, operation, control logic, or equipment behavior.",
			DOCUMENT_SCOPE: "Document Scope",
			SCOPE_FACILITY: "Facility",
			SCOPE_UNIT: "Unit",
			SCOPE_SYSTEM: "System",
			SEARCH_SCOPE_FACILITY: "Search Facility",
			SEARCH_SCOPE_UNIT: "Search Facility, Unit",
			SEARCH_SCOPE_SYSTEM: "Search Facility, Unit, System",
			SEARCH_SCOPE: "Search scope",
			NO_SCOPES: "No matching scopes found. Try a different keyword.",
			ALL_TYPES: "All Types",
			SEARCH_DOCS: "Search Documents...",
			UPDATED: "Updated",
			NO_DOCS_TITLE: "No documents found",
			NO_DOCS_DESC: "No matching documents are available. Try changing filters.",
			LOADING_MORE: "Loading more documents...",
			SELECTED_DOCS: "Selected Documents",
			ADD: "Add",
			DOCUMENTS_WORD: "Documents",
			ADD_DOCUMENTS: "Add Documents",
			CANCEL: "Cancel",
			REGENERATE_CONFIRM_TITLE: "Regenerate system description?",
			REGENERATE_CONFIRM_MESSAGE: "Regenerating will replace the current system description with a newly generated one. This action can't be undone.",
		},
			ESCALATION_CONFIG: {
				TITLE: "Escalation Configuration",
				DELAY_LABEL: "Escalation Delay (in Days)",
				LEVEL_LABEL: "Level",
				LEVEL_PLACEHOLDER: "Enter level",
				SELECT_USERS: "Select Users",
				SEARCH_USERS_PLACEHOLDER: "Search by Email IDs",
				NO_MATCHING_EMAIL: "No matching Email ID found",
				EMAILS_LABEL: "Add comma separated email ids",
				EMAILS_PLACEHOLDER: "abc@gmail.com, def@gmail.com",
				ADD_LEVEL: "+ Add level",
				ADD_LEVEL_TOOLTIP: "Add Level",
				REMOVE_TOOLTIP: "Remove",
				CONFIG_TYPE_UNIT: "Use Unit Configuration",
				CONFIG_TYPE_CUSTOM: "Use Custom Configuration",
				CONFIG_TYPE_NONE: "No Escalation Configuration",
			},
			NO_ASSET_TAGS_FOUND: "No asset tags available",
			NO_MAPPED_TAGS_FOUND: "No mapped tags available",
		ASSET_INFORMATION: "Asset Information",
			NO_ASSET_FOUND: "No asset found",
		EQUIPMENT: "Equipment",
		TEMPLATE: "Template",
		APPLICATION: "Application",
		INDUSTRY: "Industry",
		CONFIGURATION_COL: "Configuration",
		MODEL_CONFIGURATION: "Model Configuration",
		MODELING_TECHNIQUE: "Modeling Technique",
		SCALER: "Scaler",
		SMOOTHING: "Smoothing",
		SELECT_SMOOTHING_FUNCTION: "Select Smoothing Function",
		SMOOTHING_FUNCTION: "Smoothing Function",
		WINDOW_SIZE: "Window Size",
		IN_HOURS: "in hours",
		IN_DAYS: "(in days)",
		SIGMA: "Sigma",
		POLYNOMIAL_ORDER: "Polynomial Order",
		VALUE_REQUIRED: "Value is required",
		VALUE_MIN_1: "Value must be greater than or equal to 1",
		NONE: "None",
		ANOMALY_SCORE_CALC_METHOD: "Anomaly Score Calculation Method",
		ANOMALY_CALC_DEFAULT: "Default(RMS of all tags)",
		ANOMALY_CALC_NEW: "New(Sum of RMS of Asset tags)",
		PREDICTION_TIME_PERIOD: "Prediction Time Period",
		TRAINING_TIME_PERIOD: "Training Time Period",
		CALENDAR_SELECTION: "Calendar Selection",
		CHART_BASED_SELECTION: "Chart-based Selection",
		START_TIME: "Start Time",
		END_TIME: "End Time",
		START_TIME_REQUIRED: "Start time required",
		END_TIME_REQUIRED: "End time required",
		STARTUP_TRAINING_BUFFER: "Startup Training Buffer",
		SHUTDOWN_TRAINING_BUFFER: "Shutdown Training Buffer",
		TRAINING_BUFFER_GROUP: "Training Buffer",
		TRAINING_BUFFER_STARTUP_SHORT: "Startup (in days)",
		TRAINING_BUFFER_SHUTDOWN_SHORT: "Shutdown (in days)",
		TRAINING_CONDITIONS: "Training Conditions",
		METHOD1_RANGE_FILTER: "Method 1: Range Filter",
		METHOD2_CONDITION_FILTER: "Method 2: Condition Filter",
		LOAD_TAG: "Load Tag",
		REFERENCE_TAG: "Reference Tag",
		NUM_OF_BINS: "Num of Bins",
		QUANTILE_CONDITION: "Quantile Condition",
		LESS_THAN: "Less Than",
		GREATER_THAN: "Greater Than",
		EQUAL_TO: "Equal To",
		VALUE: "Value",
		TAG: "Tag",
		MIN: "Min",
		MAX: "Max",
		CONDITION: "Condition",
		AND: "And",
		OR: "Or",
		ADD: "Add",
		CLOSE: "Close",
		ADD_NOTE: "Add Note",
		VIEW_NOTE: "View Note",
		VIEW_EDIT_NOTE: "View / Edit Note",
		NOTE_FOR_DATE_RANGE: "for Date Range {{range}}",
		ENTER_NOTES: "Enter notes here",
		SEARCH_TAGS: "Search Tags...",
		NO_MATCHING_TAGS: "No matching tags found",
		SELECT_TRAINING_REGIONS: "Select training regions for me",
		ADD_TRAINING_RANGE: "Add Training Range",
		DELETE_TRAINING_RANGE: "Delete Training Range",
		NAME: "Name",
		TAG_ID: "TagId",
		UNIT_SETUP: "Unit Setup",
		SCHEMATIC: "Schematic",
		EQUIPMENT_LIST: "Equipment List",
		UNITS: 'Units',
		CAPACITY: 'Capacity',
		SYSTEM_INFORMATION: 'System Information',
		DESCRIPTION: 'Description',
		CRITICALITY: 'Criticality',
		COMMENTS: 'Comments',
		SEARCH: 'Search',
			NO_UNIT_FOUND: 'No unit found',
			NO_SYSTEM_FOUND: 'No system found',
		CUSTOMER: 'Customer',
		FACILITY: 'Facility',
		UNIT: 'Unit',
		SYSTEM: 'System',
		ORIGINAL_AUTHOR: 'Original Author',
		TRAINING_DATASET: 'Training Dataset',
		VALIDATION_LOSS: 'Validation Loss',
		LAST_DEPLOYED: 'Last Deployed',
		ON: 'On',
		SELECTED_VERSION: 'Selected Version',
		DEPLOYED_PERIOD: 'Deployed Period',
		STATUS: 'Status',
		MARK_AS_IMPORTANT: 'Mark It as Important',
		DISABLE: 'Disable',
		DELETE: 'Delete',
		DELETE_VERSION_TOOLTIP: 'Delete the version',
		TAB_FACILITY_SETUP: 'Facility Setup',
		TAB_TAG_MAPPING: 'Tag Mapping',
		TAB_DATA_SYNC: 'Data Sync',
		TAB_DATA_IMPORT: 'Data Import & Processing',
		TAG_MAPPING_REQUIRED_TOOLTIP: 'Tag mapping needs to be completed, then this tab will be enabled.',
		TAB_MODEL_BUILDING: 'Model Building',
		RECALCULATING_TOOLTIP: 'Recalculating Under Progress',
		CUSTOMER_TAG_LIST: 'Customer Tag List',
		TAGS_BTN: 'Tags',
		MODEL_BUILDING_CONFIG_TOOLTIP: 'Model Building Step Configuration',
		// model-tag-mapping
		TAGS_TO_BE_MAPPED: 'Tags To Be Mapped',
		UPLOAD_SYSTEM_TAGS: 'Upload System Tags',
		DOWNLOAD_FACILITY_TAGS: 'Download Facility Tags',
		ASSETS_PLACEHOLDER: 'ASSETS',
		SEARCH_IN_ALL_FIELDS: 'Search in all fields',
		COL_NAME: 'Name',
		COL_DESCRIPTION: 'Description',
		COL_UNIT: 'Unit',
		CUSTOMER_TAGS: 'Customer Tags',
		UPLOAD_TAGS_TOOLTIP: 'Upload Tags',
		DOWNLOAD_TAGS_TOOLTIP: 'Download Tags',
		TAG_MAPPING_NO_ASSET_TOOLTIP: 'At least 1 asset has to be created to perform Tag Mapping',
		MAP_SELECTED: 'Map Selected',
		IMPORT_WO_MAPPING: 'Import WO Mapping',
		TAGS_MAPPED: 'Tags Mapped',
		SAVE_CHANGES: 'Save Changes',
		UNMAP_SELECTED: 'Unmap Selected',
		UNMAPPED_TAGS: 'UnMapped Tags',
		COL_TAG_NAME: 'Tag Name',
		COL_ASSET: 'Asset',
		COL_TAG_ID: 'Tag Id',
		COL_THRESHOLD_HIGH: 'Threshold High',
		COL_THRESHOLD_LOW: 'Threshold Low',
		COL_TRIP_HIGH: 'Trip High',
		COL_TRIP_LOW: 'Trip Low',
		COL_ALARM_HIGH: 'Alarm High',
		COL_ALARM_LOW: 'Alarm Low',
		COL_DIRECTIONALITY: 'Directionality',
		COL_FLATLINE_DETECTION: 'Flatline Detection',
		COL_MISSING_DATA_DETECTION: 'Missing Data Detection',
		COL_OUTLIER_DETECTION: 'Outlier Detection',
		COL_RANGE_DETECTION: 'Range Detection',
		COL_FLATLINE_ALERT_GENERATION: 'Flatline Alert Generation',
		COL_MISSING_DATA_ALERT_GENERATION: 'Missing Data Alert Generation',
		COL_OUTLIER_ALERT_GENERATION: 'Outlier Alert Generation',
		COL_RANGE_ALERT_GENERATION: 'Out of Range Alert Generation',
		COL_ATTENTION: 'Attention',
		COL_THRESHOLD_NOTIFICATION: 'Threshold Notification',
		COL_KPI: 'KPI',
		SHOW_COLUMNS_TOOLTIP: 'Show columns',
		VIEW_CHANGES_TOOLTIP: 'View Changes',
		EDIT_TAG_TOOLTIP: 'Edit Tag',
		VIEW_PIDS_TOOLTIP: 'View PIDs',
		// bulk-tag-upload-alert
		IN_PROGRESS: 'In Progress',
		CORRECT_RECORDS_MSG: 'Please correct records with errors and upload.',
		DOWNLOAD_ERROR_RECORDS: 'Download error records',
		// tim-configuration-panel
		RELEVANT_INFORMATION: 'Relevant Information',
		PIDS_PANEL: 'P&IDs',
		IMAGES_PANEL: 'Images',
		TEST_REPORTS_PANEL: 'Test Reports',
		PROCEDURES_PANEL: 'Procedures',
		// model-data-import
		TAG_DATA: 'Tag Data',
		SEARCH_TAG: 'Search Tag',
		SEARCH_ASSET: 'Search Asset',
		EXPORT_DQ_METRICS_TOOLTIP: 'Export DQ Metrics',
		EXPORT: 'Export',
		TAG_SELECTION_PLACEHOLDER: 'Tag Selection',
		PREPROCESSING_STATS_PLACEHOLDER: 'Preprocessing Stats',
		TAG_MAPPING_PLACEHOLDER: 'Tag Mapping',
		TAG_TYPE_PLACEHOLDER: 'Tag Type',
		OPERATING_REGION_PLACEHOLDER: 'Operating Region',
		COL_PLOT: 'Plot',
		COL_CORR: 'Corr',
		COL_MODEL: 'Model',
		COL_TAGS: 'Tags',
		SHUTDOWN_TAG_TOOLTIP: 'Shutdown Tag',
		COL_MAX: 'Max',
		COL_MIN: 'Min',
		COL_STD_DEV: 'Std. Dev.',
		COL_AGGREGATE_TAG: 'Aggregate Tag',
		COL_MEAN_SHIFT: 'Mean Shift',
		COL_VARIANCE: 'Variance',
		COL_MEAN: 'Mean',
		COL_DEVIATION_SCORE: 'Deviation Score',
		COL_OP_UPPER: 'Op. Upper',
		COL_OP_LOWER: 'Op. Lower',
		COL_NANS: 'NaNs',
		COL_OUTLIERS: 'Outliers',
		COL_FLATLINE: 'Flatline',
		COL_OUT_OF_RANGE: 'Out of Range',
		COL_TOTAL_INVALID_DATA: 'Total Invalid Data',
		NO_RECORDS_FOUND: 'No records found',
		NO_DATA_AVAILABLE_SYSTEM: 'No data available for the selected system. Pull new data or upload',
		CHOOSE_MODEL_VERSION_MSG: 'Choose a model version to view tag plots',
		SELECT_PLOT_CHECKBOX_MSG: 'Select a tag\'s Plot checkbox to view the graph',
		TAG_CORRELATION_TITLE: 'Tag Correlation',
		TAG_CORRELATION_CONDITION_PLACEHOLDER: 'Tag Correlation Condition',
		CORR_GREATER_THAN_OPTION: 'Show Tags with Correlations Greater than',
		CORR_LESS_THAN_OPTION: 'Show Tags with Correlations Less than',
		CORR_VALUE_PLACEHOLDER: 'Corr value',
		SELECT_RANGE_LABEL: 'Select Range',
		SELECT_RANGE_TOOLTIP: 'Drag across the chart to choose a date range',
		REMOVE_RANGE_LABEL: 'Remove Range',
		REMOVE_RANGE_TOOLTIP: 'Drag across the chart to exclude a date range from modeling',
		SYSTEM_DATA_FILTER_LABEL: 'System Data Filter',
		SELECTED_DATE_RANGES_LABEL: 'Selected Date Range(s):',
		CONFIRM_SELECTION: 'Confirm Selection',
		REMOVED_DATE_RANGES_LABEL: 'Removed Date Range(s):',
		// edit-model-popup
		EDIT_MODEL_TITLE: 'Edit Model',
		FORM_ERROR_MSG: 'Oh snap! Change a few things up and try submitting again.',
		OP_LOWER_PLACEHOLDER: 'Op. Lower',
		OP_UPPER_PLACEHOLDER: 'Op. Upper',
		REQUIRED: 'Required',
		CANCEL_CHANGES_TOOLTIP: 'Cancel changes',
		CANCEL: 'Cancel',
		SAVE_DATA_TOOLTIP: 'Save Data',
		SAVE: 'Save',
		// model-building
		SIMULATION: 'Simulation',
		SHOW_FAILURE_INFO: 'Show Failure Info',
		OK: 'Ok',
		RESET_ASSET_SELECTION_TOOLTIP: 'Reset Asset Selection',
		CLOSE_CROSSHAIR_TOOLTIP: 'Close Crosshair',
		CROSSHAIR: 'Crosshair',
		LOADING: 'Loading...',
		NO_FAILURE_MODE_FOUND: 'No Failure mode found.',
		// mb-configuration-panel
		MODEL_PARAMETERS_PANEL: 'Model Parameters',
		BOILER_HEALTH_PANEL: 'Boiler Health',
		ALERT_PARAMETERS_PANEL: 'Alert Parameters',
		FAILURE_PARAMETERS_PANEL: 'Failure Parameters',
		APPLY_SOURCE_VERSION_FEEDBACK: 'Apply Source Version Feedback',
		COMMENT_PLACEHOLDER: 'Comment',
		SAVE_MODEL: 'Save Model',
		SAVE_MODEL_TOOLTIP: 'Save Model',
		RESAVE: 'Re-save',
		RESAVE_TOOLTIP: 'Re-save Model',
		DEPLOY_MODEL_TOOLTIP: 'Deploy Model',
		DEPLOY_TAG_UNMAPPED_TOOLTIP: 'Deploy is not allowed as {{version}} model contains tag(s) which have been unmapped from the system',
		DEPLOY: 'Deploy',
		GO_LIVE_CSV_TOOLTIP: 'Go Live with CSV Streaming/Historian',
		GO_LIVE: 'GO LIVE',
		// go-live-popup
		GO_LIVE_OPTIONS_TITLE: 'Go Live Options',
		DATA_SOURCE_TYPE_PLACEHOLDER: 'Data Source Type',
		HISTORIAN_OPTION: 'Historian',
		START_PREDICTION_FROM: 'Start Prediction From',
		FROM_DATE_REQUIRED: 'From Date is',
		GO_LIVE_BTN: 'Go Live',
		GO_LIVE_TOOLTIP: 'Go Live',
		// alert-form
		THRESHOLD_PLACEHOLDER: 'Threshold',
		AUTOMATIC_OPTION: 'Automatic',
		MANUAL_OPTION: 'Manual',
		RISK_PROFILE_PLACEHOLDER: 'Risk Profile',
		CREATE_CONDITION: 'Create Condition',
		RETURN_CONDITION: 'Return Condition',
		EXCEED_FOR_PLACEHOLDER: 'Exceed For',
		OUT_OF_PLACEHOLDER: 'Out of',
		DOWN_FOR_PLACEHOLDER: 'Down For',
		ALARM_THRESHOLD_PLACEHOLDER: 'Alarm Threshold',
		ADD_TOOLTIP: 'Add',
		GENERATE_ALERT_TOOLTIP: 'Generate Alert',
		UPDATE: 'Update',
		// boiler-form
		SELECT_DATE_PLACEHOLDER: 'Select Date',
		DATE_REQUIRED_ERROR: 'Date is',
		HEALTH_PLACEHOLDER: 'Health',
		REMOVE_TOOLTIP: 'Remove',
		GENERATE_BOILER_HEALTH_TOOLTIP: 'Generate Boiler Health',
		// failure-form
		ANOMALY_WT_THRESHOLD_PLACEHOLDER: 'Anomaly Wt. Threshold',
		LOW_OPTION: 'Low',
		MEDIUM_OPTION: 'Medium',
		HIGH_OPTION: 'High',
		CUTOFF_PARTIAL_MATCH: 'Cutoff for partial match',
		IN_PERCENTAGE_HINT: 'in Percentage',
		CUTOFF_FULL_MATCH: 'Cutoff for full match',
		UPDATE_FAILURE_TOOLTIP: 'Update Failure',
		// v2-alert-form
		START_DELAY_PLACEHOLDER: 'Start Delay',
		NO_OF_HOURS_HINT: '(no. of hours)',
		END_DELAY_PLACEHOLDER: 'End Delay',
		GROUPING: 'Grouping',
		DOWN_CONDITION_PLACEHOLDER: 'Down Condition',
		ANOMALY_SCORE_THRESHOLD: 'Anomaly Score Threshold',
		FILTER_FAILURE_PLACEHOLDER: 'Filter Failure',
		VALUE_BETWEEN_0_1: 'Enter value between 0 & 1',
		FEEDBACKS: 'Feedbacks',
		LIVE_FEEDBACKS: 'Live Feedbacks',
		PREVIOUS_FEEDBACKS: 'Previous Feedbacks',
		BAND_LEARNING_BEHAVIOUR: 'Band Learning Behaviour',
		CONSERVATIVE: 'Conservative',
		CONSERVATIVE_TOOLTIP: 'Creates narrower bands around the selected training region',
		MODERATE: 'Moderate',
		MODERATE_TOOLTIP: 'Creates balanced bands around the selected training region',
		AGGRESSIVE: 'Aggressive',
		AGGRESSIVE_TOOLTIP: 'Creates wider bands around the selected training region',
		UPDATE_FEEDBACK: 'Update Feedback',
		UPDATE_PARAMETERS_TOOLTIP: 'Update Parameters',
		// di-configuration-panel
		DATA_IMPORT_PANEL: 'Data Import',
		PRE_PROCESSING_PANEL: 'Pre-Processing',
		// data-import-form
		CSV_OPTION: 'CSV',
		UPLOADED_CSV_OPTION: 'Uploaded CSV',
		SELECT_SOURCE_HINT: 'Select Source for importing data',
		SAMPLING_RATE_PLACEHOLDER: 'Sampling Rate',
		SAMPLING_RATE_REQUIRED: 'Sampling Rate',
		IN_MINUTES_HINT: '(in minutes)',
		SELECT_CSV_FILE_PLACEHOLDER: 'Select CSV File',
		CSV_FILE_REQUIRED: 'CSV file is',
		SELECT_FILE_BTN: 'Select File',
		DATA_SYNC_MORE_DATA_TOOLTIP: 'To get more data, go to Data Sync tab and raise a data pull request.',
		DATA_SET_NAME_PLACEHOLDER: 'Data Set Name',
		IMPORT_TOOLTIP: 'Import',
		IMPORT_DATA: 'Import Data',
		// pre-processing-form
		STATE_IDENTIFICATION_PANEL: 'State Identification',
		EXCLUDE_REGION_PANEL: 'Exclude Region',
		PRE_PROCESSING_CONFIG_PANEL: 'Pre-Processing Configuration',
		MODEL_TAG_SELECTION_PANEL: 'Model Tag Selection',
		PROCESS_TOOLTIP: 'Process',
		PROCESS_DATA: 'Process Data',
		// state-identification-form
		SHUTDOWN_TAG_PLACEHOLDER: 'Shutdown Tag',
		CONDITION_PLACEHOLDER: 'Condition',
		LESS_THAN_OPTION: 'Less Than',
		GREATER_THAN_OPTION: 'Greater Than',
		EQUAL_TO_OPTION: 'Equal To',
		VALUE_PLACEHOLDER: 'Value',
		SHUTDOWN_CONDITION_PLACEHOLDER: 'Shutdown Condition',
		AND_OPTION: 'And',
		OR_OPTION: 'Or',
		SHUTDOWN_SPAN_PLACEHOLDER: 'Shutdown Span',
		IN_HOURS_HINT: '(in hours)',
		SHUTDOWN_TRANSITION_PLACEHOLDER: 'Shutdown Transition',
		STARTUP_TRANSITION_PLACEHOLDER: 'Startup Transition',
		// exclude-region-form
		EXCLUDE_REGION_TAG_PLACEHOLDER: 'Exclude Region Tag',
		EXCLUDE_CONDITION_PLACEHOLDER: 'Exclude Condition',
		// pre-processing-configuration-form
		OUTLIER_DETECTION_METHOD: 'Outlier Detection Method',
		OUTLIER_DETECTION_THRESHOLD: 'Outlier Detection Threshold',
		SIGMA_HINT: 'Sigma',
		INTERPOLATION_METHOD: 'Interpolation Method',
		INTERPOLATION_CONFIG: 'Interpolation Configuration',
		FLATLINE_THRESHOLD_TIME: 'Flatline Threshold Time',
		FLATLINE_TIME_BASE: 'Flatline Time Base',
		HOURS_OPTION: 'Hours',
		MINUTES_OPTION: 'Minutes',
		SECONDS_OPTION: 'Seconds',
		CROSS_CORRELATION: 'Cross-Correlation',
		// pre-processing-configuration-form: row group titles + short field labels
		OUTLIER_DETECTION_GROUP: 'Outlier Detection',
		INTERPOLATION_GROUP: 'Interpolation',
		FLATLINE_GROUP: 'Flatline',
		LABEL_METHOD: 'Method',
		LABEL_THRESHOLD: 'Threshold',
		LABEL_CONFIGURATION: 'Configuration',
		FLATLINE_DETECTION_SHORT: 'Detection',
		FLATLINE_THRESHOLD_TIME_SHORT: 'Threshold Time',
		FLATLINE_TIME_BASE_SHORT: 'Time Base',
		// model-tag-selection-form
		DATA_DENSITY_THRESHOLD: 'Data Density Threshold For Tag Selection',
		DATA_DENSITY_REQUIRED: 'Data Density Threshold is',
		GLOBAL_PREPROCESSING: 'Global preprocessing',
		RANGE_PREPROCESSING: 'Range preprocessing',
		DENSITY_HINT: 'Density',
		// data-sync
		REFRESH_TABLE_DATA_TOOLTIP: 'Refresh Table Data',
		LAST_DATA_PULL_LABEL: 'Last Data Pull:',
		UPLOAD_CSV_TOOLTIP: 'Upload CSV',
		NO_RAW_TAGS_TOOLTIP: 'There are no raw tags in this system hence file can\'t be uploaded',
		UPLOAD_BTN: 'Upload',
		ANOTHER_PROCESS_RUNNING_TOOLTIP: 'Another process is running',
		NO_RAW_TAG_MAPPED_TOOLTIP: 'No raw tag is mapped with this system',
		NEW_DATA_PULL_REQUEST: 'New Data Pull Request',
		ADD_NEW_DATA_PULL_TOOLTIP: 'Add New Data Pull Request',
		DELETE_SYSTEM_DATA_TOOLTIP: 'Delete System Data',
		STOP_DATA_PULL_TOOLTIP: 'Stop Data Pull',
		COL_SERIAL_NO: 'Sl. No.',
		COL_DATA_REQUESTED_FOR: 'Data Requested For',
		COL_REQUESTED_ON: 'Requested on',
		COL_ACCESS_METHOD: 'Access Method',
		COL_REQUEST_TYPE: 'Request Type',
		COL_FILE_NAME: 'File Name',
		COL_PULLED_BY: 'Pulled by',
		COL_DATA_RECEIVED: 'Data Received',
		COL_ACTIONS: 'Actions',
		DATA_REPULL_TOOLTIP: 'Data Re-pull',
		TAG_PULL_REQUEST: 'Tag Pull Request',
		COL_VALUE: 'Value',
		COL_MISSING: 'Missing',
		COL_OUTLIER: 'Outlier',
		TRIP_LIMIT_TOOLTIP: 'Trip Limit',
		TRIP_LABEL: 'Trip',
		ALARM_LIMIT_TOOLTIP: 'Alarm Limit',
		ALARM_LABEL: 'Alarm',
		THRESHOLD_LIMIT_TOOLTIP: 'Threshold Limit',
		THRESHOLD_LABEL: 'Threshold',
		INSTRUMENT_RANGE_TOOLTIP: 'Instrument Range',
		INSTRUMENT_LABEL: 'Instrument',
		HIGH_LABEL: 'High:',
		LOW_LABEL: 'Low:',
		AVG_LABEL: 'Avg:',
		// data-sync-popup
		DATA_PULL_REQUEST: 'Data Pull Request',
		SELECT_TAGS_PLACEHOLDER: 'Select Tags',
		FROM_DATE_PLACEHOLDER: 'From Date',
		SELECT_FROM_DATE_HINT: 'From Date',
		TO_DATE_PLACEHOLDER: 'To Date',
		TO_DATE_REQUIRED: 'To Date is',
		SELECT_TO_DATE_HINT: 'To Date',
		PULL_DATA_TOOLTIP: 'Pull Data',
		PULL_DATA: 'Pull Data',
		// upload-csv-popup
		STATUS_PANEL: {
			SUMMARY: 'Summary',
			TAG_SUMMARY: 'Tag Summary',
			RECORDS: 'Records',
			TOTAL_TAGS: 'Total Tags',
			TAGS_IN_MODEL: 'Tags in Model',
			TAGS_MAPPED_TO_FM: 'Tags Mapped to FM',
			TAGS_WITH_NO_FM: 'Tags with No FM',
			PROCESSING_TIME: 'Processing Time',
			TRAINING_TIME: 'Training Time',
			TOTAL_TAGS_DROPPED: 'Total Tags Dropped',
			ALERTS_GENERATED: 'Alerts Generated',
			PRECISION_PREVIOUS: 'Precision Previous',
			PRECISION_CURRENT: 'Precision Current',
			PHASE_DATA_IMPORT: 'Data Import',
			PHASE_PREPROCESSING: 'Data Preprocessing',
			PHASE_MODELING: 'Modeling',
			PHASE_ALERT_FEEDBACK: 'Alert Feedback',
			PHASE_READY_TO_DEPLOY: 'Ready to Deploy',
			DROPPED_TAGS: 'Dropped Tags',
			CALCULATED_TAGS_DROPPED: 'Calculated Tags Dropped',
			RAW_TAGS_DROPPED: 'Raw Tags Dropped',
			TAGS_DROPPED_PREPROCESSING: 'Tags Dropped in Preprocessing',
			TAGS_DROPPED_MANUALLY: 'Tags Dropped Manually',
			HIGH_DEVIATION_TAGS: 'High Deviation Tags',
			EXPORT: 'Export',
			COL_TAG_NAME: 'Tag Name',
			COL_TAG_ID: 'Tag Id',
			COL_DESCRIPTION: 'Description',
			COL_UNIT: 'Unit',
			COL_CALCULATED: 'Calculated',
			COL_DROPPED_DUE_TO: 'Dropped Due To',
			COL_REASON: 'Reason',
			YES: 'Yes',
			NO: 'No',
			DROPPED_DUE_IMPORT: 'Import',
			DROPPED_DUE_PREPROCESSING: 'Preprocessing',
			DROPPED_DUE_MANUAL: 'Manual',
			DROPPED_DUE_UNKNOWN: '—',
			NO_TAGS_DROPPED: 'No tags dropped yet',
			NO_HIGH_DEVIATION: 'Run Model Building to populate high deviation tags',
			NO_HIGH_DEVIATION_EMPTY: 'No high deviation tags found',

			PHASE_DEPLOYED: 'Deployed',
			DROPPED_DUE_CALCULATED: 'Calculated',
			STEP_STATUS: 'Status',
			STEP_STATUS_COMPLETED: 'Completed',
			STEP_PREPROCESSING_TIME: 'Preprocessing Time',
			STEP_TRAINING_TIME: 'Training Time',
			STEP_PREDICTION_TIME: 'Prediction Time',
			STEP_ALERTS_GENERATED: 'Alerts Generated',
			STEP_PRECISION_CURRENT: 'Precision Current',
			STEP_PRECISION_PREVIOUS: 'Precision Previous',
			REASON_UNSELECTED_FROM_MODEL: 'Unselected from Model',
			REASON_INVALID_DATA: '{{percent}}% invalid data',
			STEP_SECONDS_VALUE: '{{value}} sec',
		},
		UPLOAD_CSV_TITLE: 'Upload CSV',
		},
		CASES: {
			WORK_ORDER: {
				CREATE_TITLE: 'Create a Work Order Notification',
				CREATE_DESC: 'Create a work order notification for this case',
				DESCRIPTION: 'Description',
				DESCRIPTION_PLACEHOLDER: 'Describe the work to be done (required)',
				DESCRIPTION_REQUIRED: 'Description is required',
				PRIORITY: 'Priority',
				DUE_DATE: 'Due Date',
				ASSIGNED_TO: 'Assigned To',
				ESTIMATED_HOURS: 'Estimated Hours',
				HOURS_PLACEHOLDER: 'Enter hours',
				CANCEL: 'Cancel',
				CONFIRM: 'Confirm',
				UNASSIGNED: 'Unassigned',
				CREATED: 'Work order {{number}} created',
				CREATED_PLAIN: 'Work order created',
				FAILED: 'Could not create the work order',
				CREATE_BUTTON: 'Create Work Order',
				NONE_YET: 'No work order yet',
				VIEW_TITLE: 'Work Order {{number}}',
				VIEW_SUB: 'Work order created from this case',
				CREATED_BY: 'Created by {{name}}',
			},
			TRIAGE: {
				FROM_TRIAGE: 'Case from Alert Triage',
				FROM_TRIAGE_DESC: 'This case\'s alerts are in Alert Triage; open them there to see their telemetry and evidence',
				HIERARCHY: 'Alert triage hierarchy',
				NO_FLOC: 'No functional location',
				ALERTS: 'Triage alerts',
				ADD_ALERTS: 'Add alerts',
				ADD_ALERTS_TIP: 'Search triage alerts and add them to this case',
				AUTO_FIND: 'Auto find',
				AUTO_FIND_TIP: 'Alerts batched with this case\'s alerts or on the same FLOC around the event',
				AUTO_FIND_DESC: 'Batch group or same FLOC within the window around the source alert',
				EVENT_START: 'Event start',
				VIA_SOURCE: 'Source',
				VIA_MANUAL: 'Added',
				VIA_AUTO: 'Auto-found',
				ALERT_MISSING: 'No longer in the triage queue',
				OPEN_TRIAGE: 'Open in Alert Triage',
				REMOVE_ALERT: 'Remove from case',
				SEARCH_PLACEHOLDER: 'Search by alert ID, tag, name or FLOC…',
				SEARCHING: 'Searching…',
				NO_MATCH: 'No matching alerts',
				ADD: 'Add',
				NO_SUGGESTIONS: 'No other alerts in this window',
				REASON_GROUP: 'Same batch group',
				REASON_FLOC: 'Same FLOC within ±{{hours}} h',
				SELECT_ALL: 'Select all',
				ADD_SELECTED: 'Add selected ({{count}})',
				EVIDENCE: 'Evidence',
				KIND_FACT: 'Facts',
				KIND_TAG: 'Tags',
				KIND_MAINTENANCE: 'Maintenance',
				KIND_REPORT: 'Reports',
				KIND_NOTE: 'Notes',
				NO_EVIDENCE: 'No evidence yet',
				REMOVE_EVIDENCE: 'Remove evidence',
				ADD_EVIDENCE_PLACEHOLDER: 'Add to {{kind}}…',
				BY_AGENT: 'Triage agent',
				BY_ENGINEER: 'Engineer',
				ALERT_REMOVED: 'Alert removed from the case',
				ALERTS_ADDED: '{{count}} alert(s) added',
				EVIDENCE_ADDED: 'Evidence added',
				EVIDENCE_REMOVED: 'Evidence removed',
				ACTION_FAILED: 'The action failed',
				HIERARCHY_SOURCE: 'Hierarchy',
				SOURCE_TRIAGE: 'Alert triage',
				SOURCE_PLATFORM: 'Platform systems',
				SELECT_FLOC: 'Functional location',
				ROOT: 'All',
				FLOC_SEARCH: 'Search FLOC code or name…',
				FLOC_REQUIRED: 'Select a functional location',
				NO_CHILDREN: 'No lower levels',
				RELATED_TRIAGE_ALERTS: 'Triage alerts (optional)',
				SELECT_ALERTS: 'Select alert(s)',
			},
			SELECT_STATUS: 'Select Status',
			SELECT_CATEGORY: 'Select Category',
			UNASSIGNED: 'Unassigned',
			UNKNOWN_CREATOR: 'Unknown Creator',
			ALL_CASES: 'All Cases',
			CREATE_CASE: 'Create Case',
			CASE_MANAGEMENT: 'Case Management',
			UNKNOWN: 'Unknown',
			UNCATEGORIZED: 'Uncategorized',
			TITLE: 'Cases',
			SEARCH_PLACEHOLDER: 'Search...',
			NO_MATCHING_RESULTS: 'No matching results',
			SEARCH_OWNER_PLACEHOLDER: 'Search Owner...',
			SEARCH_WATCHERS_PLACEHOLDER: 'Search Watchers...',
			SELECT_OWNERS: 'Select Owners',
			FILTERS: 'Filters',
			GROUP_BY: 'Group by',
			MORE: 'more',
			CASES_COUNT: '{{count}} cases',
			NO_CASES_FOUND: 'No cases available',
			SYSTEM_TAGS: 'System Tags',
			CHECK_FILTERS_DATE_RANGE: 'Modify the filters or date range to view results',
			CHIP: {
				OPEN: 'Open',
				PENDING: 'Pending',
				CLOSED: 'Closed',
			},
			TOOLTIP: {
				OPEN_IN_NEW_TAB: 'Open in new tab',
				CUSTOMIZE_COLUMNS: 'Customize Columns',
				ONLY_OWNER_CATCH_TOOLTIP: 'Only the case owner can mark this as a catch',
				ONLY_OWNER_EDIT_TOOLTIP: 'Only the case owner or creator can modify this',
				MARKED_AS_CATCH_TOOLTIP: 'Marked as Catch. Open case details to update.',
				NOT_MARKED_AS_CATCH_TOOLTIP: 'Not marked as Catch. Open case details to change this.',
				OPEN_CASE: '{{count}} open case',
				OPEN_CASES: '{{count}} open cases',
				PENDING_CASE: '{{count}} pending case',
				PENDING_CASES: '{{count}} pending cases',
				OPEN_TOOLTIP: 'Open cases (includes):\nNotification to Customer\nNotification to Site\nSite Investigation',
				PENDING_TOOLTIP: 'Pending Action (includes):\nPending Maintenance\nDeferred Maintenance\nPending Shutdown',
				CLOSED_TOOLTIP: 'Closed Cases (includes):\nCase Resolved\nNo Action Needed'
			},
			GROUP_BY_OPTION: {
				NONE: 'None',
				STATUS: 'Status',
				CATEGORY: 'Category',
				SYSTEM: 'System',
				OWNER: 'Owner',
				CREATOR: 'Creator'
			},
			STATUS_OPTION: {
				1: 'Notification to Customer',
				2: 'Notification to Site',
				3: 'Site Investigation',
				4: 'Pending Maintenance',
				5: 'Deferred Maintenance',
				6: 'Pending Shutdown',
				7: 'Case Resolved',
				8: 'No Action Needed'
			},
			CATEGORY_OPTION: {
				1: 'Reliability',
				2: 'Process',
				3: 'Instrumentation',
				4: 'Mechanical',
				5: 'Electrical',
				6: 'Startup/Shutdown',
				7: 'Other'
			},
			COLUMNS: {
				SELECT: 'Select',
				NUMBER: 'Number',
				CASE_ID: 'Case ID',
				CASE_NAME: 'Case Name',
				SYSTEM_NAME: 'System Name',
				ALERT_NAME: 'Alert Name',
				CATEGORY: 'Category',
				STATUS: 'Status',
				CATCH: 'Catch',
				SOURCE: 'Source',
				OWNER: 'Owner',
				WATCHERS: 'Watchers',
				CREATED_BY: 'Created By',
				CREATED_ON: 'Created On',
				SYSTEM_ANALYSIS: 'System Analysis & Interpretation',
				DUE_DATE: 'Due Date',
				ESTIMATED_VALUE: 'Estimated Value',
				AGREED_VALUE: 'Agreed Value',
				LAST_MODIFIED: 'Last Modified',
				RCH: 'Root Cause Hypothesis',
				FEEDBACK_OUTCOME: 'Feedback & Outcome',
				WORK_ORDER: 'Work Order',
				POTENTIAL_IMPACT: 'Potential Impact',
			},
			MANAGEMENT: {
				FAILURE_MODE: 'Failure Mode',
				SELECTED_VIEW: 'Selected View',
				USER_PREFERENCE_SETTINGS: 'User Preference Settings',
				CASES_LAYOUT: 'Cases Layout',
				SIMPLIFIED: 'Simplified',
				ADVANCED_DEFAULT: 'Advanced (default)',
				LINKED_ALERT_REMOVED: 'Linked Alert Removed',
				LINKED_ALERT_REMOVED_DESC: "This case's linked alert is no longer available",
				LINK_NEW_ALERT: 'Link New Alert',
				DRAG_TO_REORDER: 'Click and drag to reorder',
				NO_TAGS_AVAILABLE_FOR_FM: 'No tags available for this failure mode.',
				NO_TAGS_AVAILABLE_FOR_ALERT: 'No tags available for this alert.',
				NO_TAGS_ADDED: 'No tags added',
				ADD_TAGS_FROM_DISPLAY_TAGS: 'Use the Display Tags panel on the right to add tags to this case',
				VIEW_SETTINGS: 'View Settings',
				DISPLAY_TAGS: 'Display Tags',
				ASSET: 'Asset',
				SELECT_STATUS: 'Select Status',
				SELECT_CATEGORY: 'Select Category',
				SEARCH_OWNER: 'Search Owner...',
				SEARCH_WATCHERS: 'Search Watchers..',
			},

			COMMON_DIALOG: {
				SELECT_ALL: 'Select All',
				REPORT_PDF_FILE_NAME: 'Report PDF File name',
				INCLUDE_EVIDENCE_ATTACHMENTS: 'Include evidence attachments',
				GENERATING_REPORT_FOR: 'You are generating a report for {{count}} tracked cases',
				SELECT_FMS_TIMELINE: 'Select failure modes from the timeline to add to the case.',
				SELECT_FMS_FOR_RECOMMENDATIONS: 'Select failure modes for recommendations',
				RECOMMENDATIONS_FOR: 'Recommendations for {{name}}',
				NO_RECS_FOR_FM: 'No recommendations for this failure mode.',
				NO_OPEN_FMS: 'No open failure modes.',
				NO_FMS_SELECTED: 'No failure modes selected. Select one or more to proceed.',
				FMS_SELECTED: '{{count}} Failure Mode(s) selected',
				SELECT_FMS_TO_CONTINUE: 'Select at least one failure mode to continue',
				SELECT_RECS_TO_CONTINUE: 'Select at least one recommendation to continue',
				SELECT_ANALYSIS_TO_CONTINUE: 'Select at least one analysis to continue',
				SELECT_VIEW_TO_CONTINUE: 'Select at least one view to continue',
				SELECT_ITEM_TO_CONTINUE: 'Select at least one item to continue',
				ADD_SELECTED_RECOMMENDATIONS: 'Add Selected Recommendations',
				ADD_SELECTED_ANALYSIS: 'Add Selected Analysis',
				ADD_SELECTED_VIEWS: 'Add Selected Views',
				ADD_SELECTED_FAILURE_MODES: 'Add Selected Failure Modes',
			},
			FILTER: {
				FILTER_BY: 'Filter by',
				SEARCH_PLACEHOLDER: 'Search by Name or ID...',
				STATUS: 'Status',
				CATEGORY: 'Category',
				CATCH: 'Catch',
				CREATED_BY: 'Created By',
				WATCHERS: 'Watchers',
				CLEAR_ALL: 'Clear All'
			},
			DETAILS: {
				CASE_NARRATIVE: 'Case Narrative',
				SYSTEM_ANALYSIS: 'System Analysis & Interpretation',
				RCH: 'Root Cause Hypothesis',
				POTENTIAL_IMPACT: 'Potential Impact',
				PROPOSED_ACTIONS: 'Proposed Actions',
				FEEDBACK_OUTCOME: 'Feedback & Outcome',
				WORK_ORDER: 'Work Order',
				MARK_AS_CATCH: 'Mark as a catch',
				SYSTEM_ANALYSIS_PLACEHOLDER: 'Summarize what was observed, when it started, and current operating condition…',
				RCH_PLACEHOLDER: 'Describe suspected or confirmed root cause. Link to FMs or events if relevant...',
				TAG_RELATED_FAILURE_MODES: 'Tag Related Failure Modes',
				ADD_FAILURE_MODES_TOOLTIP: 'Add Failure Modes',
				ADD_FMS: 'Add FMs',
				RECOMMENDED_ACTIONS: 'Recommended Action(s)',
				ADD_SELECTED: 'Add Selected',
				ADD_SELECTED_RECOMMENDATIONS_TOOLTIP: 'Add Selected Recommendations',
				ADD_RECOMMENDATIONS_TOOLTIP: 'Add Recommendations',
				ADD_MORE: 'Add More',
				ADD_MORE_RECOMMENDATIONS_TOOLTIP: 'Add More Recommendations',
				PROPOSED_ACTIONS_PLACEHOLDER: 'Proposed actions, timelines, risk if not executed...',
				POTENTIAL_IMPACT_PLACEHOLDER: 'Describe the potential business/operational impact (e.g., downtime risk, quality loss, safety, cost)...',
				FEEDBACK_OUTCOME_PLACEHOLDER: 'Notes from site, implemented actions, lessons learned…',
				WORK_ORDER_PLACEHOLDER: 'e.g. WO-2026-001248 (Enter the work order number or reference from your maintenance system.)',
				CANCEL: 'Cancel',
				SAVE: 'Save',
				EVIDENCE_ATTACHMENTS: 'Evidence and Attachments',
				SAVED_ANALYSIS: 'Saved Analysis',
				NO_SAVED_ANALYSIS_AVAILABLE: 'No Saved Analysis Available',
				ADD_SAVED_ANALYSIS: 'Add Saved analysis',
				ADD_ANALYSIS: 'Add Analysis',
				SAVED_VIEWS: 'Saved Views',
				ONLY_OWNERS_SAVE_TAG_VIEWS: 'Only the alert owner or case owner can save or modify tag views.',
				SAVE_CURRENT_TAG_VIEW: 'Save current tag View',
				SAVE_CURRENT_VIEW: 'Save Current View',
				NO_SAVED_VIEWS_AVAILABLE: 'No Saved Views available',
				ADD_SAVED_VIEWS: 'Add Saved views',
				LINK_ALERT_TO_ADD_ANALYSIS: 'Tag a related alert with saved analysis to add it here',
				LINK_ALERT_TO_ADD_VIEWS: 'Tag a related alert with saved views to add it here',
				ADD_VIEW: 'Add View',
				TAG_RELATED_ALERTS: 'Tag Related Alerts',
				ADD_ALERTS: 'Add Alerts',
				UPLOAD_EVIDENCES: 'Upload Evidences',
				UPLOAD_PLACEHOLDER: 'Attach, Drag & Drop or Paste Evidence…',
				VALUE_IMPACT: 'Value Impact',
				VALUE_CALCULATION_INPUTS: 'Value Calculation Inputs',
				LIKELIHOOD: 'Likelihood (%)',
				IMPACT: 'Impact',
				LIKELIHOOD_IMPACT_MATRIX: 'Likelihood Impact Matrix',
				SAVINGS: 'Savings',
				CONTRIBUTION_FACTOR: 'Contribution Factor',
				ESTIMATED_VALUE: 'Estimated Value (USD)',
				AGREED_VALUE: 'Agreed Value (USD)',
				TOTAL_PRODUCTION_LOST: 'Total Production Lost (KBOE)',
				TOTAL_FLARING_AVOIDED: 'Total Flaring Avoided (MT CO2)',
				PRODUCTIVITY: 'Productivity (Hours)',
				EMISSIONS: 'Emissions (Tons)',
				SELECT_VALUE: 'Select Value',
				ENTER_VALUE: 'Enter Value',
				EXPORT_AS_PDF: 'Export as PDF',
				SAVE_CASE_FIRST: 'Please Save The Case First',
				GENERATE_PDF: 'Generate PDF',
				SEND_VIA_EMAIL: 'Send via Email',
				SHARE_VIA_EMAIL: 'Share via Email',
				CLEAR_ALL: 'Clear All',
				CLEAR_ALL_TOOLTIP: 'Clear all Information',
				SAVE_TOOLTIP: 'Save Information',
				OPTIONAL_FIELD_SAVE_ERROR: 'Failed to save optional field changes'
			},
			EMAIL: {
				SEND_VIA_MAIL: 'Send Via Mail',
				RECEIVER_EMAIL_IDS: 'Receiver Email IDs',
				SEARCH_USER: 'Search User',
				SELECT_ENTER_EMAIL_IDS: 'Select/Enter Email IDs',
				DONE: 'Done',
				SELECT: 'Select',
				PLEASE_SELECT_RECIPIENTS: 'Please select the recipients',
				SUBJECT: 'Subject',
				DEFAULT_SUBJECT: 'Uptime AI: Case Created',
				ASSET: 'Asset',
				OWNER: 'Owner',
				CREATED_BY: 'Created By',
				CREATED_ON: 'Created On',
				CASE_STATUS: 'Case Status',
				CATEGORY: 'Category',
				MODIFIED_ON: 'Modified On',
				CASE_NAME: 'Case Name',
				USERS: 'Users',
				CANCEL: 'Cancel',
				SEND_EMAIL: 'Send Email',
				PLEASE_SELECT_RECIPIENTS_TOOLTIP: 'Please select Recipients',
			},
			NOTIFICATION: {
				FMS_ADDED_SUCCESS: 'Failure Modes Added Successfully',
				ANALYSIS_ADDED_SUCCESS: 'Selected Analysis Added Successfully',
				VIEWS_ADDED_SUCCESS: 'Selected Views Added Successfully',
				FMS_ADDED_SUCCESS_ALT: 'Selected Failure Modes Added Successfully',
				ALL_RECOMMENDATIONS_ADDED: 'All recommendations from approved failure modes added',
				RECOMMENDATIONS_ADDED_SUCCESS: 'Selected Recommendations added successfully',
				GENERATING_PDF: 'Generating your PDF… We’ll email it to you when it’s ready.',
				NO_VALID_FILES: 'No valid files selected. Only files with extensions {{extensions}} are allowed',
				UPLOAD_SIZE_LIMIT: '{{name}} failed to upload due to file size limit.',
				UPLOAD_FAILED: '{{name}} failed to upload.',
				FAILED_TO_GENERATE_PDF: 'Failed to generate PDF',
				BULK_REPORT_TITLE: 'Generating Aggregated Case Report',
				PREPARING_DOWNLOAD: 'Preparing your download. This may take a moment.',
				CSV_DOWNLOAD_SUCCESS: 'CSV downloaded successfully',
				CSV_DOWNLOAD_FAILED: 'Failed to export CSV',
				SELECT_STATUS_TO_SAVE: 'Please select Case Status to save the case',
				SELECT_CATEGORY_TO_SAVE: 'Please select Case Category to save the case',
				CASE_ADDED_SUCCESS: 'Case Added Successfully',
				CASE_UPDATED_SUCCESS: 'Case Updated Successfully',
				ENTER_TITLE_TO_PROCEED: 'Please enter a title to proceed'
			}
		},
		IOW: {
			FACILITY: 'Facility',
			SELECT_FACILITY: 'Select Facility',
			SEARCH_FACILITY: 'Search Facility...',
			NO_FACILITY_FOUND: 'No matching Facility found',
			UNIT: 'Unit',
			SELECT_UNIT: 'Select Unit',
			SEARCH_UNIT: 'Search Unit...',
			NO_UNIT_FOUND: 'No matching Unit found',
			SYSTEM: 'System',
			SELECT_SYSTEM: 'Select System',
			SEARCH_SYSTEM: 'Search System...',
			NO_SYSTEM_FOUND: 'No matching System found',
			TAGS: 'Tags',
			SELECT_TAGS: 'Select Tags',
			SEARCH_TAG: 'Search Tag...',
			NO_TAG_FOUND: 'No matching Tag found',
			CASE_STATUS: 'Case Status',
			EXCEEDANCE_TYPE: 'Exceedance Type',
			SELECT_EXCEEDANCE_TYPE: 'Select Exceedance Type',
			SELECT_ALL: 'Select All',
			ANALYSE_TOP_TRENDS: 'Analyse Top 20 Trends',
			SAVE: 'Save',
			COPY: 'Copy',
			ADD_NEW: 'Add New',
			EDIT: 'Edit',
			DELETE: 'Delete',
			DOWNLOAD: 'Download',
			ACTIVE_EXCEEDANCES: 'Active Exceedances',
			DATE_RANGE_DISABLED_TOOLTIP: 'Date range selection is not applicable when active exceedance filter is selected.',
			SELECT_DATE_RANGE: 'Select Date Range',
			ENTER_DATE_RANGE: 'Enter a date range',
			START_DATE: 'Start date',
			END_DATE: 'End date',
			APPLY_TIME_CHANGE: 'Apply Time change',
			SUMMARY: 'Summary',
			SELECT_SYSTEM_MESSAGE: 'Please select a system to see exceedances.',
			LOADING: 'Loading...',
			NO_EXCEEDANCE_FOUND: 'Ah, an empty vessel, no exceedance to be found.',
			NO_ACTIVE_EXCEEDANCE_FOUND: 'No active exceedance found.',
			NO_DATA_AVAILABLE: 'No data available for the selected time range',
			TRY_SELECTING_DIFFERENT_RANGE: 'Try selecting a different date range',
			CRUNCHING_DATA: 'Crunching data like a data-saurus! Hold tight!',
			TOTAL_EXCEEDANCES: 'Total Number of System Exceedances',
			GROUP_TRENDS: 'Group Trends',
			TRENDS_PER_CHART: 'Trends / Chart (up to 8)',
			CANCEL: 'Cancel',
			PROCEED: 'Proceed',
			SELECT: 'Select',
			SELECT_DATE_RANGE_LABEL: 'Select date range',
			DATE_RANGE: 'Date range',
			DATE_RANGE_REQUIRED: 'Date range is required.',
			REGROUP_EXCEEDENCES: 'Regroup Exceedences',
			DURATION_MINUTES: 'Duration (in min.)',
			DURATION_REQUIRED: 'Duration is required.',
			ENTER_VALID_NUMBER: 'Please enter valid number.',
			DOWNLOAD_TITLE: 'Download IOW Report',
			GROUP_BY_SYSTEM: 'Group by System',
			GROUP_BY_UOM: 'Group by Unit of Measure',
			GROUP_COUNT_REQUIRED: 'Group Count is required.',
			MIN_VALUE_2: 'Minimum value is 2.',
			MAX_VALUE_8: 'Maximum value is 8.',
			GROUP_COUNT_INVALID: 'Group Count is invalid.',
			WATCHERS: 'Watchers',
			CLOSE: 'Close',
		},
		CAPACITY_OPTIMIZATION: {
			COMMON: {
				SAVE: 'Save',
				CANCEL: 'Cancel',
				DELETE: 'Delete',
				EDIT: 'Edit',
				CLOSE: 'Close',
				LOADING: 'Loading...',
				SEARCH: 'Search...',
				ACTIONS: 'Actions',
				NAME: 'Name',
				DESCRIPTION: 'Description',
				STATUS: 'Status',
				TYPE: 'Type',
				CREATED: 'Created',
				LAST_UPDATED: 'Last Updated',
				DOWNLOAD: 'Download',
				UPLOAD: 'Upload',
				IMPORT: 'Import',
				EXPORT: 'Export',
				RUN: 'Run',
				STOP: 'Stop',
				YES: 'Yes',
				NO: 'No',
				APPLY: 'Apply',
				RESET: 'Reset',
				CONFIRM: 'Confirm',
				BACK: 'Back',
				NEXT: 'Next',
			},
			NAV: {
				SCENARIOS: 'Scenarios',
				DASHBOARD: 'Dashboard',
				COMPARISON: 'Comparison',
				SETTINGS: 'Settings',
				MODELS: 'Models',
				SIMULATION: 'Simulation',
				REALTIME: 'Realtime',
				TOPOLOGY: 'Topology',
				STRATEGIC: 'Strategic',
			},
			LANDING: {
				TITLE: 'Plant Optimization and Recommendation',
				SUBTITLE: 'Optimize power & water generation across your fleet',
			},
			SCENARIO: {
				TITLE: 'Scenario Library',
				NEW_SCENARIO: 'New Scenario',
				SEARCH_SCENARIO: 'Search scenario',
				DUPLICATE: 'Duplicate',
				RUN_OPTIMIZATION: 'Run Optimization',
				FORCE_STOP: 'Force Stop',
				VIEW_RESULTS: 'View Results',
				SCENARIO_NAME: 'Scenario Name',
				CLASSIFICATION: 'Classification',
				SOLVER: 'Solver',
				RUN_MODE: 'Run Mode',
				STATUS_READY: 'Ready',
				STATUS_RUNNING: 'Running',
				STATUS_COMPLETED: 'Completed',
				STATUS_FAILED: 'Failed',
				PROMOTE: 'Promote',
				ALTERNATIVE_SOLVER: 'Alternative Solver',
			},
			CONFIG: {
				TITLE: 'Scenario Configuration',
				TABS: {
					AVAILABILITY: 'Asset Availability',
					DEMAND: 'Demand Forecast',
					CONSTRAINTS: 'Constraints',
					SOLVER: 'Solver & Run',
					TESTING: 'Testing Profiles',
					GROWTH_FACTOR: 'Growth Factor',
					SWRO_AVAILABILITY: 'SWRO Availability',
				},
				HORIZON: 'Horizon (hrs)',
				STEP: 'Step (min)',
				START_HOUR: 'Start Hour',
				TARGET_DATE: 'Target Date',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				PERF_CURVE: 'Performance Curve Source',
				OEM_CURVES: 'OEM Design Curves',
				HISTORICAL_ML: 'Historical Data (ML)',
				PLANNING_OFFLINE: 'Planning (Offline)',
				LIVE_REALTIME: 'Live (Real-time)',
				UPLOAD_CSV: 'Upload CSV',
				DOWNLOAD_CSV: 'Download CSV',
				POWER_MW: 'Power (MW)',
				WATER_MIGD: 'Water (MIGD)',
				POWER_IMPORT: 'Power Import',
				POWER_EXPORT: 'Power Export',
				WATER_IMPORT: 'Water Import',
				WATER_EXPORT: 'Water Export',
				INITIAL_STATUS: 'Initial Status',
				DURATION_IN_STATE: 'Duration in State (Hours)',
				ON: 'ON',
				OFF: 'OFF',
			},
			CONSTRAINTS: {
				TITLE: 'Constraints Configuration',
				ANCILLARY_SERVICES: 'Ancillary Services',
				MIN_UP_DOWN_TIME: 'Min Up/Down Time',
				RAMP_LIMITS: 'Ramp Limits',
				FIXED_LOADS: 'Fixed Loads',
				AGC_DISPATCH: 'AGC Dispatch',
				ALLOW_LOAD_SHEDDING: 'Allow Load Shedding',
				ALLOW_WATER_SHORTAGE: 'Allow Water Shortage',
				ENFORCE_FUEL_LIMITS: 'Enforce Fuel Limits',
				SPINNING_RESERVE: 'Spinning Reserve (MW)',
				OPERATING_RESERVE: 'Operating Reserve (MW)',
				WATER_RESERVE: 'Water Reserve (MIGD)',
			},
			GROWTH_FACTOR: {
				TITLE: 'Growth Factor Configuration',
				ADJUSTMENT_TYPE: 'Adjustment Type',
				VALUE: 'Growth Factor Value',
				TARGET_METRIC: 'Target Metric',
				START_TIME: 'Start Time',
				END_TIME: 'End Time',
			},
			SWRO: {
				TITLE: 'SWRO Availability Configuration',
				SELECT_PLANTS: 'Select SWRO Plants',
				FLAT_VALUE: 'Flat Availability Value',
			},
			DASHBOARD: {
				TITLE: 'Optimization Results',
				STATION_FILTER: 'Station Filter',
				ALL_STATIONS: 'All Stations',
				TOTAL_COST: 'Total Cost',
				POWER_GENERATION: 'Power Generation',
				WATER_PRODUCTION: 'Water Production',
				FUEL_CONSUMPTION: 'Fuel Consumption',
			},
			COMPARISON: {
				TITLE: 'Scenario Comparison',
				SEARCH_SCENARIO: 'Search scenario',
				BASELINE: 'Baseline',
				SELECT_BASELINE: 'Select Baseline',
			},
			SETTINGS: {
				TITLE: 'Settings',
				PLATFORM: 'Platform Setup',
				DATA_MGMT: 'Data Management',
				MODULE_CONFIG: 'Module Configuration',
				TAGS: 'Tags',
				TEMPLATES: 'Templates',
				TOPOLOGY: 'Topology',
				TRAINING: 'Training',
				USERS: 'Users',
			},
			PLATFORM_SETUP: {
				TITLE: 'Platform & Facility Setup',
				ENTERPRISE_NAME: 'Enterprise Name',
				STREET_ADDRESS: 'Street Address',
				CITY: 'City',
				STATE: 'State',
				COUNTRY: 'Country',
				ZIP_CODE: 'ZIP Code',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				INDUSTRY: 'Industry',
				TIMEZONE: 'Timezone',
				BUSINESS: 'Business',
				NOTES: 'Notes',
				COST_PER_UNIT: 'Cost per Unit ($)',
				CAPACITY_PER_HOUR: 'Capacity per Hour',
				REVENUE_PER_HOUR: 'Revenue per Hour ($)',
				OPERATIONAL_MARGIN: 'Operational Margin (%)',
				TECHNICIAN_SALARY: 'Technician Salary ($/hr)',
				HELPER_SALARY: 'Helper Salary ($/hr)',
			},
			USER_MGMT: {
				TITLE: 'User Management',
				ADD_USER: 'Add User',
				USERNAME: 'Username',
				DISPLAY_NAME: 'Display Name',
				PASSWORD: 'Password',
				ROLE: 'Role',
				ADMIN: 'Admin',
				SUPER_USER: 'Super User',
				USER: 'User',
				NO_PERMISSION: 'You do not have permission to access this section.',
			},
			SIMULATION: {
				TITLE: 'Sensitivity Simulation',
				TARGET_EQUIPMENT: 'Target Equipment',
				SWEEP_PARAMETER: 'Sweep Parameter',
				START_VALUE: 'Start Value',
				END_VALUE: 'End Value',
				STEPS: 'Steps',
				RUN_SWEEP: 'Run Sweep',
			},
			REALTIME: {
				TITLE: 'Realtime Dashboard',
				CONFIRMED_TARGET: 'Confirmed Target',
				SELECT_DATE: 'Select Date',
				SCENARIO_NAME: 'Scenario Name',
				HORIZON_HOURS: 'Horizon (hours)',
				SOLVER: 'Solver',
				PERF_CURVE: 'Perf Curve',
				START_MODE: 'Start Mode',
				RAMP_LIMITS: 'Ramp Limits',
				MIN_UP_DOWN: 'Min Up/Down Time',
				ANCILLARY: 'Ancillary Services',
				IMPORT_SCENARIO: 'Import from Scenario',
			},
			TOPOLOGY: {
				TITLE: 'SPP Topology',
				POWER_VIEW: 'Power',
				WATER_VIEW: 'Water',
				AUTO_CORRECT: 'Auto-Correction',
				FLEET_OVERVIEW: 'Fleet Overview',
			},
			DEMAND: {
				HORIZON: 'Horizon (hrs)',
				STEP: 'Step (min)',
				START_HOUR: 'Start Hour',
				UPDATE_PLAN: 'Update Demand Plan',
				UPDATE_PLAN_TOOLTIP: 'Resample every schedule table onto the new time grid, interpolating the values already entered.',
				UPDATE_PLAN_HINT: 'Schedule parameters changed — click Update Demand Plan to resample the tables.',
				SOLAR_INPUT: 'Solar input',
				SOLAR_PHASES_ACTIVE: 'phases active',
			},
			TAG_EXPLORER: {
				TITLE: 'Tag Explorer',
				SUBTITLE: 'Plot historical values for any mapped tag. Points are aggregated server-side so a long range stays responsive.',
				TAGS: 'Tags',
				TAGS_PLACEHOLDER: 'Select up to 10 tags',
				TAGS_SEARCH_PLACEHOLDER: 'Search by parameter or tag name...',
				START_DATE: 'Start Date',
				END_DATE: 'End Date',
				PLOT: 'Plot',
				LOADING_TAGS: 'Loading tag list...',
				QUERYING: 'Querying historical data...',
				NO_DATA_FOR: 'No data in this range for:',
				UNITS_DROPPED: 'Chart shows two units at a time; series in {{units}} were not plotted.',
				BUCKET_HINT: 'Aggregated to {{bucket}} buckets.',
				COL_PARAMETER: 'Parameter',
				COL_TAG: 'Tag',
				COL_UNIT: 'Unit',
				COL_POINTS: 'Points',
				COL_MIN: 'Min',
				COL_MAX: 'Max',
				COL_AVERAGE: 'Average',
				GROUP_SYSTEM_DEMAND: 'System Demand',
				GRID_POWER_DEMAND: 'Grid Power Demand',
				GRID_WATER_DEMAND: 'Grid Water Demand',
				AXIS_TIME: 'Time',
				AXIS_VALUE: 'Value',
				REQUEST_FAILED: 'Request failed ({{status}})',
				SERVER_UNREACHABLE: 'Could not reach the server.',
			},
			PUMP_HYDRO: {
				TITLE: 'Pump Hydro Configuration',
				SUBTAB_LABEL: 'Pump Hydro',
				FIXED_MODE: 'Fixed Load Profile',
				FIXED_DESC: 'Specify fixed generation (unloading) and pumping (loading) schedule for Hatta units.',
				OPTIMIZE_MODE: 'Optimize Loading & Unloading Rates',
				OPTIMIZE_DESC: 'Allow optimizer to dynamically dispatch Hatta pumped hydro storage rates.',
				FUTURE_RELEASE: 'Future Release',
				HATTA_U1: 'Hatta Unit 1',
				HATTA_U2: 'Hatta Unit 2',
				RANGE_ASSIGN_TITLE: 'Assign Profile to Time Range',
				FROM_TIME: 'From Time',
				TO_TIME: 'To Time',
				TARGET_UNIT: 'Target Unit',
				BOTH_UNITS: 'Both Units (Hatta 1 & 2)',
				VALUE_MW: 'Load / Unload Value (MW)',
				APPLY_RANGE: 'Apply to Range',
				UPLOAD_SCHEDULE: 'Upload Schedule',
				DOWNLOAD_TEMPLATE: 'Download Template',
			},
		},
		DISPLAY_TAGS: {
			HEADER: 'Display Other Tags',
			CLOSE: 'Close',
			SEARCH_PLACEHOLDER: 'Search...',
			FILTER_TOOLTIP: 'Filter tags',
			SELECT_SYSTEM: 'Select System',
			ALL_SYSTEMS: 'All Systems',
			FILTER_BY: 'Filter by',
			ALL_TAGS: 'All Tags',
			MODELED_TAGS: 'Modeled tags',
			SHOW_CALCULATED_TAGS: 'Show calculated tags',
			NO_MATCHING_RESULTS: 'No matching results',
			START_TYPING: 'Start typing to see matching tags.',
		},
		PROCESS: {
      LIST_TABLE: {
				NO_CURRENT_BATCHES_TITLE: 'No current batches',
				NO_CURRENT_BATCHES_CONTENT: 'Active or running batches will appear here once a process starts.',
				NO_PAST_BATCHES_TITLE: 'No past batches',
				NO_PAST_BATCHES_CONTENT: 'Completed, stopped, or failed batches will appear here once a batch run is finished.'
			},
			LIST: {
				PAGE_TITLE: 'Process',
				SEARCH_PLACEHOLDER: 'Search by Batch ID',
				CURRENT_BATCHES_TAB: 'Current Batches',
				PAST_BATCHES_TAB: 'Past Batches',
				FILTER: {
					SYSTEM: 'System',
					SEARCH_SYSTEM: 'Search System',
					CREATED_BETWEEN: 'Created between',
					STARTED_ON: 'Started On',
					CLEAR_DATE: 'Clear Date',
					OWNER: 'Owner',
					SEARCH_OWNER: 'Search Owner',
				},
			},
			TABLE: {
				COL_BATCH_NAME_ID: 'Batch Name / ID',
				COL_START_DATE_TIME: 'Start Date / Time',
				COL_END_DATE_TIME: 'End Date / Time',
				COL_LAST_UPDATED: 'Last Updated',
				COL_DURATION: 'Duration',
				COL_RUN_TIME: 'Run Time',
				COL_STATUS: 'Status',
				COL_OWNER: 'Owner',
				COL_WATCHERS: 'Watchers',
				COL_PERCENT_COMPLETE: 'Percent Complete',
				COL_PROJECTED_PRODUCT: 'Projected Product',
				COL_FINAL_PRODUCT: 'Final Product',
				SELECT_COLUMNS: 'Select Columns',
				SAVE_VIEW: 'Save View',
				APPLY: 'Apply',
				LOADING: 'Loading...',
				NO_RECORDS: 'No records found',
			},
			DETAILS: {
				TITLE_PREFIX: 'Process Details',
				BATCH_NAME: 'Batch Name',
				FACILITY: 'Facility',
				UNIT: 'Unit',
				SYSTEM: 'System',
				STATUS: 'Status',
				START_DATE_TIME: 'Start Date / Time',
				LAST_UPDATED: 'Last Updated',
				OVERLAY: 'Overlay',
				STACKED: 'Stacked',
				GRID: 'Grid',
				SELECT_OWNER: 'Select Owner',
				WATCHERS_TOOLTIP: 'Watchers',
				FILTER: {
					LAB_PARAMETERS: 'Lab Parameters',
					BATCH: 'Batch',
					OTHERS: 'Others',
					SEARCH_BATCH: 'Search batch',
				},
				GOLDEN_BATCH_BAND: 'Golden Batch Band',
				PREDICTION: 'Prediction',
			},
		},
		DYNAMIC_DASHBOARD: {
			DASHBOARD_WIZARD: 'Dashboard Wizard',
			ADD_NEW_DASHBOARD: 'Add New Dashboard',
			CREATE_DASHBOARD: 'Create Dashboard',
			SEARCH: 'Search',
			EDIT_MODE: 'Edit Mode',
			SAVE_DASHBOARD: 'Save Dashboard',
			PUBLIC: 'Public',
			PRIVATE: 'Private',
			SENSOR_DATA: 'Sensor Data',
			NON_SENSOR_DATA: 'Non-Sensor Data',
			ENTER_DATE_RANGE: 'Enter a date range',
			START_DATE: 'Start date',
			END_DATE: 'End date',
			APPLY_TIME_CHANGE: 'Apply Time change',
			MORE: 'More',
			NOTHING_CREATED: "You haven't created anything yet",
			LOADING: 'Loading...',
			NO_DATA: 'No data available for selected attributes',
			CONFIGURE_ATTRIBUTES: 'Configure Attributes to Render',
			SELECT_CHART_TYPE: 'Select Chart Type',
			CONFIG_ONLY_WIDGET: 'This is a config only widget. No graphs will be shown for this',
			TYPE_OF_CONFIG: 'Type of config:',
			GROUP_KEY: 'Group Key:',
			SPECIFICATION_LIMIT: 'Specification Limit',
			PLEASE_ADD_STATS: 'Please add stats Card',
			ADD_ATTRIBUTES: 'Add Attributes to Display',
			PROCESSING_DATA: 'Processing data — please wait...',
			EDIT: 'Edit',
			DUPLICATE: 'Duplicate',
			REMOVE: 'Remove',
			CANCEL: 'Cancel',
			SAVE: 'Save',
			BACK: 'Back',
			PERFORMANCE_CURVE_OF: 'Performance Curve Of',
			NO_WIDGETS_AVAILABLE: 'No widgets available. Add a widget to get started',
			TAB_EMPTY_STATES: {
				ALL: {
					HEADING: 'No dashboards yet',
					CONTENT: 'Create your first dashboard to monitor key metrics, trends and insights in one place.',
				},
				MY_DASHBOARD: {
					HEADING: 'No dashboards created by you',
					CONTENT: 'Dashboards you create will appear here.',
				},
				SHARED: {
					HEADING: 'No shared dashboards yet',
					CONTENT: 'Dashboards shared with you by others will appear here.',
				},
				PRIVATE: {
					HEADING: 'No private dashboards yet',
					CONTENT: 'Dashboards you create and keep private will appear here.',
				},
				SEARCH: {
					HEADING: 'No dashboards found',
					CONTENT: 'Try a different keyword or clear the search.',
				},
			},
			SLICER_POPUP: {
				SELECT_ALL: 'Select All',
				PREVIEW: 'Preview',
				APPLY_AND_CLOSE: 'Apply & Close',
				APPLYING: 'Applying...',
      		},
			COLLABORATOR: {
				TITLE_SUFFIX: 'Collaborators',
				SEARCH_PLACEHOLDER: 'Search by Name or Email',
				COLLABORATED_WITH: 'Collaborated with',
				USERS: 'Users',
				ALL_USERS: 'All Users',
				OWNER: 'Owner',
				CANCEL: 'Cancel',
				SAVE: 'Save',
				CANCEL_CHANGES: 'Cancel changes',
				SAVE_CHANGES: 'Save changes',
				ROLE: {
					FULL: 'Full',
					FULL_DESC: 'Full access',
					EDIT: 'Edit',
					EDIT_DESC: 'View and edit access',
					VIEW: 'View',
					VIEW_DESC: 'View only access',
				},
			},
			EDIT_PANEL: {
				CREATE_PANEL: 'Create panel',
				EDIT_PANEL: 'Edit Panel',
				CANCEL: 'Cancel',
				SAVE: 'Save',
				SELECT_CHART_TYPE: 'Chart Type',
				ADD_TITLE: 'Title',
				PANEL_NAME: 'Panel Name',
				ADDITIONAL_GRAPH_OPTIONS: 'Additional Graph Options',
				SETTINGS: 'Settings',
			},
			DASHBOARD_POPUP: {
				TITLE: 'Dashboard',
				SELECT_TYPE: 'Select Dashboard Type',
				TYPE_DASHBOARD: 'Dashboard',
				TYPE_CONFIG: 'Config',
				TYPE_PERFORMANCE_CURVES: 'Performance Curves',
				NAME: 'Name',
				NAME_TAKEN: 'Name is Already taken',
				NAME_REQUIRED: 'Name is required',
				LEVEL: 'Level',
				SELECT_LEVEL: 'Select level',
				FACILITY: 'Facility',
				SELECT_FACILITY: 'Select Facility',
				FACILITY_REQUIRED: 'Facility is required',
				UNIT: 'Unit',
				SELECT_UNIT: 'Select Unit',
				UNIT_REQUIRED: 'Unit is required',
				CANCEL: 'Cancel',
				SAVE: 'Save',
			},
			TAG_PANEL: {
				ENABLE_QUICK_PLOT: 'Enable Quick Plot',
				SELECT_UNITS: 'Select Units',
				SEARCH_UNIT: 'Search Unit...',
				NO_UNIT_FOUND: 'No matching Unit found',
				SELECT_SYSTEMS: 'Select Systems',
				SEARCH_SYSTEM: 'Search System...',
				NO_SYSTEM_FOUND: 'No matching System found',
				ADD: 'Add',
				PREVIEW: 'Preview',
				PREVIEW_CHART: 'Preview Chart',
				DRAG_AND_DROP: 'Drag And Drop',
				COPY: 'Copy',
				DELETE: 'Delete',
				EDIT: 'Edit',
				LABEL: 'Label',
				TAG: 'Tag',
				X_TAG: 'X Tag',
				Y_TAG: 'Y Tag',
				Z_TAG: 'Z Tag',
				SEARCH_TAG: 'Search Tag...',
				NO_TAG_FOUND: 'No matching tag found',
				DESIGN_VALUE_TAG: 'Design Value Tag',
				CALC_TYPE: 'Calculation Type',
				CALC_ORIGINAL: 'Original',
				CALC_AVERAGE: 'Average',
				CALC_MOVING_AVG: 'Moving Avg',
				CALC_MAX: 'Max',
				CALC_MIN: 'Min',
				CALC_SUM: 'Sum',
				CALC_MEDIAN: 'Median',
				CALC_MOVING_DELTA: 'Moving Delta',
				CALC_COUNT_EVENT: 'Count Event',
				AGGREGATE: 'Aggregate',
				AGGREGATE_WINDOW: 'Aggregate Window',
				COUNT_WINDOW: 'Count Window',
				AGGREGATE_WINDOW_UNIT: 'Aggregate Window Unit',
				COUNT_WINDOW_UNIT: 'Count Window Unit',
				WINDOW_SIZE: 'Window size',
				MINUTES: 'Minute(s)',
				HOURS: 'Hour(s)',
				DAYS: 'Day(s)',
				WEEKS: 'Week(s)',
				GREATER_THAN: 'Greater than',
				LESS_THAN: 'Less than',
				EQUAL_TO: 'Equal to',
				RESET_FILTER: 'Reset filter',
				SELECT_AXIS: 'Select Axis',
				X_AXIS: 'X Axis',
				Y_AXIS: 'Y Axis',
				SPEC_LABEL: 'Label (max 6 character)',
				DESCRIPTION: 'Description',
				VALUE: 'Value',
				ENABLE_TREND_CHART: 'Enable Trend Chart',
				ADD_TITLE: 'Add a title',
				ADD_SUBTITLE: 'Add a subtitle',
				UNIT: 'Unit',
				SELECT_ICON: 'Select Icon',
				SEARCH_ICONS: 'Search Icons...',
				FORMULA: 'Formula',
				FORMULA_PLACEHOLDER: 'Write the formula. e.g (A+B)*C',
				ERROR_INVALID_VARS: 'Invalid variable(s) used',
				ERROR_INVALID_SYNTAX: 'Invalid mathematical expression',
				ERROR_FORMULA_REQUIRED: 'Formula is required',
				ERROR_LESS_THAN_THRESHOLD: "This should be less than 'Less than' threshold.",
				ERROR_GREATER_THAN_THRESHOLD: "This should be greater than 'Greater than' threshold.",
				SELECT_CHILDREN: 'Select children',
				AT_LEAST_ONE: 'At least 1 option has to be selected',
				TITLE_REQUIRED: 'Title is required',
				TITLE_DUPLICATE: 'This title is already used for another formula',
				ADD_A_TITLE: 'Add a title',
				DELETE_BUTTON: 'Delete',
			},
			SENSOR_TABLE_CONFIG: {
				ADD_ROW: 'Add Row',
				ADD_COLUMN: 'Add Column',
				COLUMN_NAME: 'Column Name',
				DELETE_COLUMN: 'Delete Column',
				DATE_FILTER: 'Date Filter',
				ROWS: 'Rows',
				NUMBER_OF_ROWS: 'Number of Rows',
				SELECT_TAG: 'Select Tag',
				CONFIGURE_TAG: 'Configure Tag',
				DELETE_ROW: 'Delete Row',
				APPLY_DATE_FILTERS: 'Apply date filters to the columns',
				NONE: 'None',
				SELECT_FY_START: 'Select 1st day of financial year',
				CANCEL: 'Cancel',
				APPLY: 'Apply',
				SEARCH_TAG: 'Search Tag...',
				NO_TAG_FOUND: 'No matching tag found',
				GREATER_THAN: 'Greater than',
				LESS_THAN: 'Less than',
				EQUAL_TO: 'Equal to',
				LESS_GREATER_ERROR: "'Less than' value must be greater than 'Greater than' value.",
				IGNORE_NULLS: 'Ignore nulls',
				AGGREGATION: 'Aggregation',
				DEFINE_COLOR: 'Define tag value to set text color',
				LESSER_THAN: 'Lesser than',
				PICK_COLOR: 'Pick Color',
				COLOR: 'Color',
				LESSER_THAN_ERROR: 'Value must be lesser than the defined greater value.',
				GREATER_THAN_ERROR: 'Value must be greater than the defined lesser value.',
				BETWEEN: 'Between',
				AND: 'And',
				BETWEEN_RANGE_ERROR: 'Enter a valid range — lower value should be less than upper value.',
			},
			RECENT: 'Recent',
			FAVOURITES: 'Favourites',
			CREATED_BY_ME: 'Created by me',
			TAB_ALL: 'All',
			TAB_MY_DASHBOARD: 'My Dashboard',
			TAB_SHARED: 'Shared',
			TAB_PRIVATE: 'Private',
			ALL_DASHBOARDS: 'All Dashboards',
			MY_DASHBOARDS: 'My Dashboards',
			SHARED_DASHBOARDS: 'Shared Dashboards',
			PRIVATE_DASHBOARDS: 'Private Dashboards',
			COL_NAME: 'Name',
			COL_CREATED_ON: 'Created on',
			COL_UPDATED_ON: 'Updated on',
			COL_OWNED_BY: 'Owned By',
			COL_SHARED: 'Shared',
			COPY_LINK: 'Copy link',
			RENAME: 'Rename',
			OPEN_IN_NEW_TAB: 'Open in new tab',
			SELECT: 'Select',
			SELECT_PERFORMANCE_CURVE: 'Select Performance Curve',
			MENU_EDIT_DASHBOARD: 'Edit Dashboard',
			MENU_COPY_DASHBOARD: 'Copy Dashboard',
			MENU_PUBLISH: 'Publish',
			MENU_UNPUBLISH: 'Un-Publish',
			MENU_DELETE_DASHBOARD: 'Delete Dashboard',
			MONGO: {
				SELECT_GRAPH_FIRST: '*Select Graph Type first',
				LABEL_USED: 'Label already used',
				REQUIRED: '*Required',
				DEFINE_RELATION: 'Define Relation',
				INVALID_VARIABLE: 'Invalid variable in the formula.',
				INVALID_RELATION: 'Invalid relation with source.',
				INVALID_FORMULA_SYNTAX: 'Invalid formula syntax.',
				SOURCE: 'Source',
				ATTRIBUTE: 'Attribute',
				DISPLAY_ATTRIBUTE: 'Display Attribute',
				GROUP_BY_ATTR: 'Group by',
				AGGREGATION: 'Aggregation',
				OPEN_FILTERS: 'Open Filters',
				REMOVE_COLUMN: 'Remove Column',
				ADD_ATTRIBUTE: 'Add Attribute',
				RAW_ATTRIBUTE: 'Raw Attribute',
				CALC_ATTRIBUTE: 'Calculated Attribute',
				ADD_RAW_ATTRIBUTE_COL: 'Add Raw Attribute Column',
				ADD_CALC_ATTRIBUTE_COL: 'Add Calculated Attribute Column',
				GROUP_BY: 'Group By',
				GROUP_DISPLAY_TYPE: 'Group Display Type',
				SORT_BY: 'Sort By',
				SORT_ASC: 'A → Z',
				SORT_DESC: 'Z → A',
				SIDE_BY: 'Side By',
				NA: 'NA',
				STACK_BY: 'Stack By',
				NO_OF_BINS: 'No. of Bins',
				SLICERS: 'Slicers (Select up to {{limit}})',
				SELECT_UP_TO: 'Select up to',
				DRILL_DOWN: 'Drill Down',
				DRILL_DOWN_ATTRS: 'Attributes for Drill Down (Select up to {{limit}})',
				SELECT_ATTRS: 'Select Attributes',
			},
			TAG_AGG: {
				SELECT_TAG: 'Select Tag',
				SELECT_AGGREGATE_TYPE: 'Select Aggregate Type',
				ENABLE_AGGREGATE: 'Enable Aggregate',
			},
			SIDE_PANEL: {
				SETTINGS: 'Settings',
				SAVE: 'Save',
				CLOSE: 'Close',
				PANEL: 'Panel',
				AXIS: 'Axis',
				GRAPH_OPTIONS: 'Graph Options',
				SELECT_CONFIG_TYPE: 'Select Configuration Type',
				EXCEL_CONFIG: 'Excel Config',
				TAG_GROUP: 'Tag Group',
				PANEL_DESCRIPTION: 'Panel description',
				X_AXIS_MIN: 'X Axis Min',
				X_AXIS_MAX: 'X Axis Max',
				X_AXIS_UNIT: 'X Axis Unit',
				Y_AXIS_UNIT: 'Y Axis Unit',
				SHOW_LEGEND: 'Show Legend',
				OVERLAP_LEGENDS: 'Overlap Legends',
				TABLE_MODE: 'Table Mode',
				TITLE_COLOR: 'Title Color',
				BORDER_COLOR: 'Border Color',
				TREND_CHART_COLOR: 'Trend Chart Color',
				UPLOAD: 'Upload',
				DOWNLOAD: 'Download',
				UPLOAD_BASE_CURVE: 'Upload Base Curve',
				BASE_CURVE_FORMAT: 'Base Curve Format',
				DELETE_CURVE_GRAPH: 'Delete Curve Graph',
			},
			SINGLE_STATS: {
				ADD_STAT: 'Add Stat',
				COLOR_PICKER: 'Color Picker',
				COLOR_TITLE: 'Title',
				COLOR_BORDER: 'Border',
				COLOR_ICON: 'Icon',
				COLOR_ICON_OUTLINE: 'Icon Outline',
				NO_ICON_FOUND: 'No matching Icon found',
			},
		},
		SCHEDULER: {
			LIST: {
				TITLE: 'Schedulers list',
				HEADER_TITLE: 'Report Scheduler',
				NEW_SCHEDULER_TOOLTIP: 'Create new scheduler',
				NEW_SCHEDULER: 'New scheduler',
				COL_TITLE: 'Title',
				COL_MEDIUM: 'Medium',
				COL_SUBJECT: 'Subject',
				COL_RUNS: 'Runs',
				COL_MODIFIED_ON: 'Modified On',
				COL_CREATED_ON: 'Created On',
				COL_ACTIONS: 'Actions',
				EDIT_TOOLTIP: 'Edit scheduler',
				DELETE_TOOLTIP: 'Delete schedule',
				MEDIUM_EMAIL: 'Email',
				MEDIUM_SMS: 'SMS',
				MEDIUM_CALL: 'Call',
				SCHEDULER_DELETED: 'Scheduler deleted',
				DELETE_FAILED: 'Failed to delete',
				OKAY: 'Okay',
				NO_REPORT: 'No reports found'
			},
			DETAILS: {
				TITLE: 'Scheduler',
				CREATE_TITLE: 'Create Scheduler',
				EDIT_DETAILS_TITLE: 'Edit Details',
				SCHEDULE_DETAILS_TITLE: 'Schedule Details',
				CANCEL: 'Cancel',
				SAVE: 'Save',
				SELECT_FACILITY: 'Select Facility',
				LOADING: 'Loading...',
				SCHEDULE_RECURRING_REPORTS: 'Schedule Recurring Reports',
				MONTHS: 'Months',
				ALL: 'All',
				DAY: 'Day',
				EVERY: 'Every',
				TH_DAY: 'th day',
				WEEKDAYS: 'Weekdays',
				TIME: 'Time',
				SELECT_TIME: 'Select time',
				HOUR: 'Hour',
				MINUTE: 'Minute',
				FILE_NAME_LABEL: 'File Name',
				REPORT_NAME_LABEL: 'Report Name',
				ENTER_NAME: 'Enter Name',
				REPORT_TITLE: 'Report Title (20 character max.)',
				ENTER_TITLE: 'Enter Title',
				REPORTING_INTERVAL: 'Reporting Interval',
				MEDIUM: 'Medium',
				TEMPLATE_NAME: 'Template Name',
				SUBJECT: 'Subject',
				ENTER_SUBJECT: 'Enter Subject',
				SELECT_USERS: 'Select Users',
				SEARCH_BY_EMAIL: 'Search by Email IDs',
				NO_MATCHING_EMAIL: 'No matching Email ID found',
				ADD_EMAILS_LABEL: 'Add comma separated email ids',
				OKAY: 'Okay',
				SELECT_AT_LEAST_ONE_UNIT: 'Select atleast one unit',
				SELECT_AT_LEAST_ONE_SYSTEM: 'Select atleast one system',
				SELECT_USER_OR_EMAIL: 'Select atleast one user or add email ID(s)',
				INVALID_EMAILS: 'Invalid email ID(s) entered',
			},
			TEMPLATES: {
				DAILY_REPORT: 'Daily Report',
				BIWEEKLY_REPORT: 'BiWeekly Report',
				KPI_REPORT_THERMAL: 'KPI Report - Thermal',
				ALERT_STATUS_UPDATE_REPORT: 'Alert Status Update Report',
				DATA_QUALITY_REPORT: 'Data Quality Report',
				DATA_LAG_REPORT: 'Data Lag Report',
				IOW_REPORT: 'IOW Report',
				SERVER_EXCEPTION_REPORT: 'Server Exception Report',
			},
			REPORTING_INTERVALS: {
				LAST_8_HOURS: 'Last 8 Hours',
				LAST_12_HOURS: 'Last 12 Hours',
				LAST_24_HOURS: 'Last 24 Hours',
				TODAY: 'Today',
				YESTERDAY: 'Yesterday',
				LAST_7_DAYS: 'Last 7 Days',
				THIS_WEEK: 'This Week',
				PREVIOUS_WEEK: 'Previous Week',
				LAST_15_DAYS: 'Last 15 Days',
				LAST_30_DAYS: 'Last 30 Days',
				THIS_MONTH: 'This Month',
				PREVIOUS_MONTH: 'Previous Month',
				THIS_QUARTER: 'This Quarter',
				PREVIOUS_QUARTER: 'Previous Quarter',
				LAST_3_MONTHS: 'Last 3 Months',
				LAST_6_MONTHS: 'Last 6 Months',
				LAST_12_MONTHS: 'Last 12 Months',
				THIS_YEAR: 'This Year',
				PREVIOUS_YEAR: 'Previous Year',
			},
		},
		ANALYSIS_VIEWS: {
			UNABLE_TO_CREATE_ANALYSIS_TEMPLATE: 'Unable to create an analysis template from multiple facilities',
			TITLE: 'Analysis & Views',
			CLOSE: 'Close',
			EXPORT_TO_EXTERNAL: 'Export Selected Tags to External System',
			SAVED_ANALYSIS: 'Saved Analysis',
			CREATE_NEW: 'Create New',
			SAVED_VIEWS: 'Saved Views',
			SAVE_CURRENT_VIEW: 'Save Current View',
			SAVE_DISABLED_TOOLTIP: 'Only the alert owner can save or modify tag views.',
			TEMPLATE_TAG: '[Template]',
			SNAPSHOT_TAG: '[Snapshot]',
			EDIT: 'Edit',
			DELETE: 'Delete',
			SAVED_DASHBOARDS: 'Saved Dashboards',
			NO_DASHBOARDS: 'No saved dashboards available',
		},
		THRESHOLD_PANEL: {
			TITLE: 'Threshold',
			CLOSE: 'Close',
			ONGOING: 'Ongoing',
			SHOW_LESS: 'Show less',
			SEE_MORE: 'See more',
		},
		ACTIVITY_LOGS: {
			TITLE: 'Activity logs',
			ACTIONS: 'Actions ({{count}})',
			CLOSE: 'Close',
			SEARCH_PLACEHOLDER: 'Search...',
		},
		FEEDBACK_RIGHT_NAV: {
			TITLE: 'Feedback',
			CLOSE: 'Close',
			APPROVED: 'Approved',
			RELEARNED: 'Relearned',
			QUOTE_APPROVED_HYPOTHESIS: 'Approved Hypothesis',
			QUOTE_RELEARNED_HYPOTHESIS: 'Relearned Hypothesis',
			QUOTE_APPROVED_CAUSAL: 'Approved Causal Chain Step',
			QUOTE_RELEARNED_CAUSAL: 'Relearned Causal Chain Step',
			QUOTE_APPROVED_RECOMMENDATION: 'Approved Recommendation',
			QUOTE_RELEARNED_RECOMMENDATION: 'Relearned Recommendation',
			QUOTE_OTHER: 'Other',
			FILE_ALT: 'File',
			EMPTY_HEADING: 'No Feedbacks Available',
			EMPTY_CONTENT: 'Please approve or relearn to add a feedback.',
		},
		DISCUSSION: {
			TITLE: 'Discussion',
			COMMENTS_COUNT: 'Comments ({{count}})',
			CLOSE: 'Close',
			CREATE_CASE_TITLE: 'Create a case to manage follow-ups',
			CREATE_CASE: 'Create case',
			BACK: 'Back',
			THREAD_BY: 'Thread by',
			SEARCH_PLACEHOLDER: 'Search...',
			NO_COMMENTS_HEADING: 'No Comments Here',
			NO_COMMENTS_BODY: 'Please leave your first comment to start the discussion on this topic.',
			EDITED: 'Edited',
			RCA_VERSION_DELETED: 'RCA version deleted',
			COMMENT_DELETED: 'This comment was deleted.',
			COMMENT_DELETED_ALT: 'This comment has been deleted.',
			REPLY_SINGULAR: 'reply',
			REPLY_PLURAL: 'replies',
			LAST_REPLY: 'Last reply',
			REPLY_PROMPT: 'Reply...',
			COMMENT_PLACEHOLDER: 'Add a comment, use @ to tag team members',
			REPLY_TO_COMMENT_PLACEHOLDER: 'Reply to comment...',
		},
		RETRAIN_MODEL: {
			TITLE: 'Retrain Model',
			CLOSE: 'Close',
			CURRENT_MODEL_DETAILS: 'Current Model Details',
			DEPLOYED_VERSION_LABEL: 'Deployed Version - Date / Time',
			LAST_PREDICTION_LABEL: 'Last Prediction - Date / Time',
			FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
			TRAINING_PERIOD: 'Training Period',
			DATE_RANGE_SELECTION_METHOD: 'Date Range Selection Method',
			SELECT_TRAINING_MODE_ARIA: 'Select training selection mode',
			CALENDAR_SELECTION: 'Calendar Selection',
			CHART_BASED_SELECTION: 'Chart-based Selection',
			VIEW_EDIT_NOTE: 'View / Edit Note',
			ADD_NOTE: 'Add Note',
			ADD_TRAINING_RANGE: 'Add Training Range',
			DELETE_TRAINING_RANGE: 'Delete Training Range',
			ADVANCED_SETTINGS: 'Advanced Settings',
			BAND_LEARNING_BEHAVIOUR: 'Band Learning Behaviour',
			SELECT_BAND_LEARNING_ARIA: 'Select band learning behaviour',
			CONSERVATIVE_TOOLTIP: 'Creates narrower bands around the selected training region',
			CONSERVATIVE: 'Conservative',
			MODERATE_TOOLTIP: 'Creates balanced bands around the selected training region',
			MODERATE: 'Moderate',
			AGGRESSIVE_TOOLTIP: 'Creates wider bands around the selected training region',
			AGGRESSIVE: 'Aggresive',
			PREDICTION_SMOOTHING_SETTINGS: 'Prediction Smoothing Settings',
			SMOOTHING: 'Smoothing',
			WINDOW_SIZE: 'Window Size',
			WINDOW_SIZE_PLACEHOLDER: 'Window Size (in hours)',
			VALUE_IS: 'Value is',
			REQUIRED: 'required',
			VALUE_MIN: 'Value must be greater than or equal to',
			POLYNOMIAL_ORDER: 'Polynomial Order',
			SIGMA: 'Sigma',
			SELECT_ATTENTION_TAGS: 'Select Attention Tags',
			SEARCH_PLACEHOLDER: 'Search...',
			NO_MATCHING_TAGS: 'No matching tags found',
			SHOW_ALL_TAGS: 'Show all tags',
			SHOW_ATTENTION_TAGS_ONLY: 'Show attention tags only',
			MODELING_TECHNIQUE: 'Modeling Technique',
			AUTO_ENCODER: 'Auto Encoder',
			ATTENTION_AUTO_ENCODER: 'Attention Auto Encoder',
			CANCEL_TOOLTIP: 'Cancel changes',
			CANCEL: 'Cancel',
			RETRAIN_DEPLOY_TOOLTIP: 'Retrain & Deploy',
		},
		ROOT_CAUSE_RECOMMENDATION: {
			CLOSE: 'Close',
			ICON_ALT: 'Root Cause Icon',
			NOT_GENERATED_MESSAGE: 'You haven\'t generated the Root Cause Analysis yet. Please generate it to proceed.',
			FAILED_MESSAGE: 'Your last Root Cause Analysis failed.<br> Please generate it again to proceed.',
			GENERATE_NOW: 'Generate Now',
			REFRESH: 'Refresh',
			LAST_GENERATED: 'Last generated',
			GENERATING: 'Generating Root Cause Analysis',
			LOADER_ALT: 'loader',
			LIKE_ALT: 'Like',
			DISLIKE_ALT: 'Dislike Icon',
			MONETARY_VALUE: 'Monetary Value',
			FAILURE_HISTORY: 'Failure History',
			INFO_CARD_ARIA: 'Info Card',
			PREVIOUS_FAILURE_MODES: 'Previous Failure Modes',
			HYPOTHESIS_PREFIX: 'Hypothesis',
			MOST_LIKELY: '(Most Likely)',
			CASCADES_AS_FOLLOWS: '.This root cause likely cascades as follows:',
			AGREE: 'Agree',
			PARTIALLY_AGREE: 'Partially Agree',
			DISAGREE: 'Disagree',
			TELL_US_MORE: 'Tell us more:',
			FEEDBACK_PLACEHOLDER: 'Feel free to add specific details',
			CANCEL: 'Cancel',
			SUBMIT: 'Submit',
		},
		RIGHT_PANEL_DOCUMENTS: {
			TITLE: 'Documents',
			CLOSE: 'Close',
			SEARCH_PLACEHOLDER: 'Search...',
			FILTER_TAGS: 'Filter tags',
			EMPTY_HEADING: 'No documents available',
		},
		MONETORY_VALUE_DIALOG: {
			TITLE: 'Monetary Values',
			CURRENCY_HINT: 'Monetary values are entered in {{currency}}',
			RELIABILITY: 'Reliability',
			MAINTENANCE: 'Maintenance',
			PERFORMANCE: 'Performance',
			POTENTIAL_SUFFIX: ' (Potential)',
			ENTER_VALUE: 'Enter Value',
			COMMENT_REQUIRED_ERROR: 'Comment cannot be empty.',
			AMOUNT_REQUIRED_ERROR: 'At least one value must be entered.',
			COMMENT: 'Comment',
			COMMENT_PLACEHOLDER: 'Add your comment',
			CANCEL: 'Cancel',
			SAVE: 'Save',
		},
		FAILURE_MODE_DETAILS: {
			TITLE: 'Failure mode details',
			OPEN_ALERT: 'Open Alert',
			TTF_ALT: 'TTF',
			ADD_MONETARY_VALUE: 'Add monetary value',
			CMMS_NUMBER_TOOLTIP: 'CMMS Number',
			MORE_SUFFIX: 'more',
			ADD_CMMS_NUMBER: 'Add CMMS number',
			BREAKDOWN_CATEGORY: 'Breakdown Category',
			BREAKDOWN_COMPONENT: 'Breakdown Component',
			ERROR_LABEL: 'Error',
			TAG_CHARTS_SUFFIX: 'tag charts',
		},
		DATA_QUALITY_PANEL: {
			TITLE: 'Data Quality',
			CLOSE: 'Close',
			SEE_LESS: 'See less',
			SEE_MORE: 'See more',
		},
		FAILURE_TIMELINE_PANEL: {
			SORT_BY: 'Sort by:',
			ASSET: 'Asset:',
			REASON: 'Reason:',
			RECOMMENDATIONS: 'Recommendations:',
			NA: 'NA',
		},
		REPORT_ISSUE_SIDEPANEL: {
			TITLE: 'Report an issue',
			SUBTITLE: 'Tell us what went wrong with the RCA agent.',
			CLOSE: 'Close',
			WARNING_BANNER: 'This will not update or rerun the current RCA. To improve a hypothesis, causal chain, or recommendation, use the feedback options within the RCA.',
			SECTION_TITLE: 'What went wrong?',
			SECTION_HINT: 'Select all that apply.',
			ISSUES_ERROR: 'Select at least one option.',
			DETAILS_ERROR: 'Add details about the issue you experienced.',
			DETAILS_LABEL_REQUIRED: 'Additional details (Required)',
			DETAILS_LABEL_OPTIONAL: 'Additional details (Optional)',
			DETAILS_PLACEHOLDER: 'For example, the RCA identified the correct pressure trend but concluded that the pump caused the event, even though the maintenance history indicated a valve failure.',
			DISCLAIMER: 'By submitting this report, relevant RCA data and activity logs will be shared with authorized UptimeAI Team for investigation.',
			CANCEL: 'Cancel',
			SUBMIT_REPORT: 'Submit Report',
			RUN_RCA_FIRST: 'Run an RCA before reporting an issue with the agent.',
			SUBMITTED_SUCCESS: 'Issue reported successfully',
			SUBMIT_FAILED: 'Failed to report issue. Please try again.',
			OPT_PLATFORM_DATA_LABEL: 'Relevant platform data was not considered',
			OPT_PLATFORM_DATA_HINT: 'The RCA did not use all relevant alerts, tags, trends, events, or other data available on the platform.',
			OPT_EVIDENCE_LABEL: 'Documents or evidence were not considered correctly',
			OPT_EVIDENCE_HINT: 'Uploaded documents, proposed evidence, or other supporting information were ignored or interpreted incorrectly.',
			OPT_USER_INPUT_LABEL: 'My input was not considered properly',
			OPT_USER_INPUT_HINT: 'The RCA did not properly consider the context, instructions, notes, or feedback I provided during this investigation or in previous reruns.',
			OPT_CAUSAL_LABEL: 'The causal reasoning was incorrect',
			OPT_CAUSAL_HINT: 'The RCA considered relevant information but reached an incorrect conclusion.',
			OPT_WEIGHTED_LABEL: 'Evidence was weighted incorrectly',
			OPT_WEIGHTED_HINT: 'The RCA focused too heavily on one data point and did not sufficiently consider other important evidence.',
			OPT_UNSUPPORTED_LABEL: 'A conclusion was not supported by evidence',
			OPT_UNSUPPORTED_HINT: 'The RCA generated a claim or conclusion without sufficient supporting data or evidence.',
			OPT_RECOMMENDATION_LABEL: 'The recommendation was not actionable',
			OPT_RECOMMENDATION_HINT: 'The recommendation was too general, impractical, or not operationally useful.',
			OPT_UNCLEAR_LABEL: 'The explanation was unclear',
			OPT_UNCLEAR_HINT: 'The reasoning was difficult to understand or did not provide enough justification.',
			OPT_OTHER_LABEL: 'Other',
			OPT_OTHER_HINT: 'Report an issue that is not listed above.',
		},
		LIBRARY: {
			TITLE: 'Library',
			SUBTITLE: 'P&ID drawings and engineering documents (manuals, datasheets, alarm / trip lists) in one place.',
			SEARCH: 'Search drawings, documents, equipment or a tag (e.g. PT-0940)…',
			TAB_PIDS: 'P&IDs',
			TAB_DOCS: 'Manuals & data',
			PIDS: {
				LOADING: 'Loading drawings…',
				FAILED: 'Drawings could not be loaded.',
				LOCATED: 'Drawings showing {{tag}}',
				NOT_LOCATED: '{{tag}} is on no indexed drawing.',
				NO_MATCH: 'No drawing matches the search.',
				TAGS: '{{count}} tags',
				PICK: 'Pick a drawing on the left, or search for a tag to find the drawings that show it.',
				VIEW_DRAWING: 'Drawing',
				VIEW_PDF: 'Full PDF',
				PDF_LOADING: 'Loading the PDF…',
				PDF_FAILED: 'The PDF of this drawing is not available.',
				OTHER: 'Other drawings',
				REFERENCE: 'Legends & drawing indexes',
			},
			DOCS: {
				LOADING: 'Loading documents…',
				FAILED: 'Documents could not be loaded.',
				EMPTY: 'No documents.',
				NO_MATCH: 'No document matches the search.',
				PICK: 'Pick a document to read it here.',
				GROUP_ITEM: 'On this location',
				GROUP_ABOVE: 'From {{floc}}',
				GROUP_BELOW: 'Below this location',
				GROUP_TYPE: '{{type}}',
			},
		},
		ASSET_EXPLORER: {
			FLOC: {
				TITLE: '{{facility}} asset tree (SAP functional locations)',
				SEARCH_PLACEHOLDER: 'Search FLOC, equipment or historian tag…',
				SEARCH_HINT: 'Matching assets are listed below; pick a tag suggestion to show it on the P&ID.',
				HIDE_EMPTY: 'Hide locations without tags',
				HIDE_EMPTY_HINT: 'Hides functional locations with no historian tag in their sub-tree. Packages and unassigned groups are always shown.',
				NODE_HITS: 'Matching assets ({{count}})',
				CLOSE_HITS: 'Close results',
				NODE_SEARCH_FAILED: 'Asset search failed. Try again.',
				NO_NODE_HITS: 'No asset matches “{{query}}”.',
				REVEAL_FAILED: 'Could not open this asset in the tree.',
				TREE_EMPTY: 'The asset tree is empty.',
				TREE_HIDDEN: '{{count}} locations without tags hidden',
				CHILDREN_FAILED: 'Could not load the children of this node.',
				CHILDREN_HIDDEN: '{{count}} child locations without historian tags are hidden.',
				COUNT_TIP: '{{count}} historian tags in this sub-tree',
				PATH: 'Asset path',
				UNASSIGNED_NAME: 'Unassigned tags',
				UNASSIGNED_TIP: 'Historian tags with no FLOC or package mapping, grouped by the system code in the tag name',
				UNASSIGNED_NOTE: 'These historian tags have no SAP functional location and no equipment package. They are grouped here only by the system code in the tag name (or at site level when there is none); their equipment is unknown.',
				PACKAGE_NOTE: 'Rotating-equipment package: its tags are mapped to the package as a whole, not to a single SAP functional location.',
				LEVEL_SITE: 'Site',
				LEVEL_SYSTEM: 'System',
				LEVEL_SUBSYSTEM: 'Sub-system',
				LEVEL_EQUIPMENT: 'Equipment',
				LEVEL_PACKAGE: 'Package',
				LEVEL_UNASSIGNED: 'Unassigned',
				KIND_FLOC: 'SAP functional location',
				KIND_PACKAGE: 'Equipment package',
				KIND_UNASSIGNED: 'Unassigned tag group',
				SUBTREE_TAGS: '{{count}} tags in sub-tree',
				LOOP_TAGS_BADGE: '{{count}} same-loop package tags',
				PIDS_SHOWING: 'On {{count}} P&ID(s)',
				PROP_FLOC: 'FLOC code',
				PROP_CODE: 'Package code',
				PROP_LEVEL: 'Level',
				PROP_KIND: 'Kind',
				PROP_LOOP: 'Loop number',
				PROP_OWN_TAGS: 'Tags on this node',
				PROP_SUBTREE_TAGS: 'Tags in sub-tree',
				WITH_DATA: '{{count}} with data',
				N_TAGS: '{{count}} tags',
				INCLUDE_SUBTREE: 'Include sub-tree',
				TAGS_OWN_NOTE: 'Tags placed directly on this node.',
				TAGS_SUBTREE_NOTE: 'Tags placed on this node and on every node below it.',
				DETAIL_FAILED: 'Could not load this node. Try again.',
				NO_OWN_TAGS: 'No historian tags are placed on this node.',
				NO_OWN_TAGS_LOOP: 'No historian tags are placed on this functional location itself; the package tags that share its loop number are listed below.',
				TRUNCATED: 'Showing the first {{shown}} of {{total}} tags.',
				FILTER_TAGS: 'Filter tags…',
				NO_FILTER_MATCH: 'No tag matches the filter.',
				COL_RULE: 'Placement rule',
				COL_DATA: 'Data',
				PLACED_AT: 'On',
				LOOP_TITLE: 'Package tags sharing this loop number ({{count}})',
				LOOP_EXPLAIN: 'These tags belong to rotating-equipment packages, not to this functional location. They are listed because their tag names carry loop number {{loop}}, the same as this equipment. They are not counted in this node’s tag totals.',
				LOOP_GROUP: 'Loop {{loop}} · package {{package}} ({{count}})',
				OPEN_PACKAGE: 'Open package',
				PID_GROUP_NODE: 'Showing {{name}}',
				PID_NODE_FOUND: '{{name}} (its equipment symbol or tags) appears on {{count}} drawing(s).',
				PID_NODE_NONE: 'No digitized P&ID shows {{name}} or its first tags.',
				CHIPS_MORE: 'Showing {{shown}} of {{total}} node tags; add others from the Overview table or the search.',
				RULE_FLOC_CURATED: 'FLOC (curated)',
				RULE_FLOC_CURATED_HINT: 'FLOC from the curated tag–equipment mapping sheet.',
				RULE_FLOC_BACKFILLED: 'FLOC (backfilled)',
				RULE_FLOC_BACKFILLED_HINT: 'FLOC from the historian’s tag-to-asset mapping, used where the curated sheet has none.',
				RULE_FLOC_WELL: 'FLOC via subsea well',
				RULE_FLOC_WELL_HINT: 'Subsea tag placed on its well’s production-tree FLOC (or the well FLOC) from the well number in the tag name.',
				RULE_FLOC_LOOP: 'FLOC via loop number',
				RULE_FLOC_LOOP_HINT: 'Placed on the only equipment FLOC whose code ends in the tag’s loop number.',
				RULE_PACKAGE_PREFIX: 'Package via tag prefix',
				RULE_PACKAGE_PREFIX_HINT: 'Mapped to an equipment package; placed under the sub-system encoded in the tag name.',
				RULE_PACKAGE_SITE: 'Package (site)',
				RULE_PACKAGE_SITE_HINT: 'Mapped to an equipment package; the tag name encodes no sub-system, so it sits at site level.',
				RULE_UNASSIGNED: 'Unassigned (tag prefix)',
				RULE_UNASSIGNED_HINT: 'No FLOC or package; grouped under the sub-system encoded in the tag name.',
				RULE_SITE: 'Site',
				RULE_SITE_HINT: 'No FLOC, package or sub-system code; kept at site level.',
			},
			TITLE: '{{facility}} asset hierarchy',
			BREADCRUMB: 'Asset Explorer',
			RELOAD: 'Reload',
			LOADING_TREE: 'Loading asset hierarchy…',
			LOAD_FAILED: 'Could not load the asset hierarchy. Try again.',
			SEARCH_PLACEHOLDER: 'Search equipment or historian tag…',
			SEARCH_HINT: 'Typing filters the tree; pick a tag to show it on the P&ID.',
			TREE_EMPTY: 'No assets match the search.',
			EXPAND: 'Expand',
			COLLAPSE: 'Collapse',
			LEVEL_KICKER: 'Level {{level}}',
			NODE_ID: 'ID',
			TAGS_MAPPED: '{{count}} historian tags',
			PIDS_LINKED: '{{count}} linked P&IDs',
			TAB_OVERVIEW: 'Overview',
			TAB_PID: 'P&ID',
			TAB_TELEMETRY: 'Time series',
			TAB_DOCS: 'Documents',
			DOCS: {
				VIEW: 'Documents ({{count}})',
				HINT: 'Manuals, datasheets and alarm / trip lists for {{name}} and the locations above it.',
				ALSO_PIDS: 'Also on {{count}} P&ID sheets',
				OPEN_LIBRARY: 'Open the library',
				EMPTY: 'No documents are linked to this location or the locations above it.',
			},
			OPEN_KG: 'Open in Knowledge Graph',
			VIEW_ALERTS: 'View alerts',
			VIEW_PID: 'View P&ID',
			VIEW_TELEMETRY: 'View time series',
			DESCRIPTION: 'Description',
			NO_DESCRIPTION: 'No description recorded for this asset.',
			CHILDREN: 'Child assets ({{count}})',
			PROPERTIES: 'Properties',
			TAGS_TITLE: 'Historian tags ({{count}})',
			NO_TAGS: 'No historian tags are mapped to this asset.',
			COL_TAG: 'Tag',
			COL_COMPONENT: 'Component',
			COL_RANGE: 'Operating range',
			COL_UNIT: 'Unit',
			COL_ACTIONS: 'Actions',
			LOCATE_ON_PID: 'Show on P&ID',
			PLOT: 'Plot',
			NO_SELECTION: 'Select an asset in the hierarchy or search for a tag.',
			LEVEL: {
				FACILITY: 'Facility',
				SYSTEM: 'System',
				SUBSYSTEM: 'Subsystem',
				EQUIPMENT: 'Equipment',
				COMPONENT: 'Component',
				INSTRUMENT: 'Instrument',
			},
			PID: {
				SHEET: 'Drawing',
				SEARCH_SHEETS: 'Search drawings…',
				SEARCH_ON_DRAWING: 'Find a tag on this drawing…',
				NO_MATCHES: 'No tag on this drawing matches.',
				FILTER_ALL: 'All',
				FILTER_INSTRUMENTS: 'Instruments',
				FILTER_EQUIPMENT: 'Equipment',
				FILTER_NONE: 'None',
				GROUP_LOCATED: 'Drawings showing {{tag}}',
				GROUP_NODE: 'Linked to {{name}}',
				GROUP_ALL: 'All drawings ({{count}})',
				SOURCE_DIGITISED: 'digitized',
				SOURCE_TEXT: 'text-indexed',
				SOURCE_NEEDS_OCR: 'needs OCR',
				SOURCE_CATALOGUED: 'catalogued',
				SOURCE_BLANK: 'no text',
				DETECTIONS: '{{count}} items',
				LOCATING: 'Finding {{tag}} on the P&IDs…',
				LOCATE_FAILED: 'Could not look up {{tag}} on the P&IDs.',
				NOT_ON_PID: '{{tag}} is not shown on any digitized P&ID.',
				FOUND_ON: '{{tag}} is on {{count}} drawing(s)',
				CLEAR_LOCATE: 'Clear',
				TYPE_INSTRUMENT: 'Instrument',
				TYPE_EQUIPMENT: 'Equipment',
				CONFIDENCE: '{{pct}}% confidence',
				CANONICAL: 'Canonical tag',
				HISTORIAN_TAG: 'Historian tag',
				NOT_LINKED: 'Not linked to a historian tag',
				PLOT: 'Plot in time series',
			},
			PID_VIEWER: {
				ZOOM_IN: 'Zoom in',
				ZOOM_OUT: 'Zoom out',
				FIT: 'Fit to view',
				FOCUS_HIGHLIGHT: 'Go to highlighted tag',
				FULLSCREEN: 'Full screen',
				EXIT_FULLSCREEN: 'Exit full screen',
				LOADING: 'Loading drawing…',
				NO_DRAWING: 'No drawing selected.',
				LOAD_FAILED: 'Could not load this drawing.',
				NO_IMAGE: 'No image for this drawing',
				NO_IMAGE_HINT: 'The drawing is digitized ({{count}} items, {{highlighted}} highlighted) but its image is not available.',
				PAN_HINT: 'Drag to pan · scroll to zoom',
				ASPECT_WARNING: 'Image and drawing sizes differ; boxes may be offset.',
				HISTORIAN_TAG: 'Historian tag',
				NOT_LINKED: 'Not linked',
				CLICK_HINT: 'Click to select',
				UNTAGGED: 'Untagged item',
			},
			TAG_SEARCH: {
				SEARCHING: 'Searching…',
				FAILED: 'Tag search failed. Try again.',
				NO_RESULTS: 'No historian tag matches “{{query}}”.',
				HAS_DATA: 'Has data',
				NO_DATA: 'No data',
				ALREADY_ADDED: 'Already selected',
			},
			TELEMETRY: {
				ACTIVE_TAGS: 'Tags on chart ({{count}} / {{max}})',
				SEARCH_PLACEHOLDER: 'Search historian tags to add…',
				DROPPED: 'Up to {{max}} tags: {{tag}} was removed to make room.',
				REMOVE: 'Remove from chart',
				WINDOW: 'Time window',
				WINDOW_7D: '7D',
				WINDOW_30D: '30D',
				WINDOW_90D: '90D',
				WINDOW_1Y: '1Y',
				CHART_TITLE: 'Historian time series',
				POINTS: '{{count}} points',
				LOADING: 'Loading time series…',
				NO_DATA: 'No readings for the selected tags in this window.',
				NO_TAGS: 'Search for a tag or pick one above to plot it.',
				SUMMARY: 'Summary',
				LATEST: 'Latest',
				MIN: 'Min',
				MAX: 'Max',
				MEAN: 'Mean',
			},
		},
		TRIAGE: {
			RULE_SIGNALS: {
				TITLE: 'What this rule measures',
				MEASURED: 'Measured',
				CONTEXT: 'Context',
				HAS_READINGS: 'Readings before the alert',
				NO_READINGS: 'No readings in the 24 h before the alert',
				SOURCE: 'Mapping from {{source}}',
				GUESSED: 'Shell\'s configuration does not list this rule\'s inputs; the charted signals were chosen by the agent from the well\'s sensors.',
			},
			BASIS: {
				NO_RESULT: 'No decision yet: run the agent on this alert.',
				RECOMMENDATIONS: 'Recommendations',
				NO_RECOMMENDATIONS: 'The agent made no recommendations for this alert.',
				FINAL_HYPOTHESES: 'Final hypotheses (adjudicator)',
				NO_FACT_SPAN: 'This run did not record which evidence it read.',
				LINK_RCA: 'Deep RCA · {{count}} verified facts',
				LINK_EVIDENCE: 'Evidence used',
			},
			PFLOW: {
				ALERT_DRAWINGS: 'Drawings the alert equipment is on (open with the alert context)',
				TAB: 'Process flow',
				TITLE: 'Block flow (process units)',
				CHECKED_LEGEND: 'Checked by the agent ({{n}})',
				OPEN_MAP: 'Open process map',
				OPEN_ON_MAP: 'Show on process map',
				ALERT_UNIT: 'Alert\'s unit',
				STATE_MOVED: 'Moved',
				STATE_HELD: 'Steady',
				STATE_NODATA: 'No data',
				TIMING_BEFORE: 'before the alert',
				TIMING_TOGETHER: 'with the alert',
				TIMING_AFTER: 'after the alert',
				TIMING_EARLIER: '> 48 h earlier',
				KEY_SENSORS: 'Key sensors (click to chart)',
				CHART_IT: 'chart it on the right',
				ON_DRAWING: 'Equipment on the alert\'s drawing',
			},
			STEP_PANEL: {
				DQ: 'Data quality of the readings before the alert',
				NO_DQ: 'No data-quality assessment was recorded for this alert.',
				STATE: 'Alert tag with the machine\'s run indicator',
				LIMITS: 'Limits of this tag and when they applied',
				RULE: 'The detector and the tags it watches',
				EQUIPMENT: 'Sensors on this equipment — click one to chart it on the right',
				PROCESS: 'Live P&ID — click a tag to chart it on the right',
				NO_ANOMALY: 'The run has no anomaly-model analysis for this alert.',
			},
			DOCPAGE: {
				MAXIMIZE: 'Maximize',
				RESTORE: 'Restore',
				MARKING: 'Finding the cited passage on this page…',
				MARKING_TERMS: 'Finding the search words on this page…',
				MARK_FAILED: 'The page is shown, but the passage could not be located on it.',
				PAGE_OF: 'page {{page}} of {{pages}}',
				PREV: 'Previous page',
				NEXT: 'Next page',
				CITED_FOUND: 'The red box marks the passage the triage relied on.',
				OCR: 'This page is a scan, read by OCR, so the box position is approximate.',
				CITED_MISSING: 'The cited words could not be found on this page image (the scan reads differently); the passage is the one quoted in the triage.',
				CITED_ON: 'The cited passage is on page {{page}}.',
				LOADING: 'Loading the page…',
				CLOSE: 'Close',
			},
			DOCS: {
				REFERRED: 'Referred documents',
				ALL: 'All documents',
				SEARCH_PLACEHOLDER: 'Filter by name — press Enter to search inside the documents',
				SEARCH_INSIDE: 'Search inside',
				WHOLE_SITE: 'Whole site',
				RESULTS: 'Pages matching “{{q}}”',
				NO_RESULTS: 'No page matches these words.',
				PAGE: 'p.{{n}}',
				USED: 'Passages the triage used',
				USED_HINT: 'Click a passage to open its page with the passage in a red box',
				CITED: 'cited',
				VIEW_PAGE: 'View page',
			},
			SEE: {
				RULE: 'Rule, delay and replay: see Source Alert',
				SENSORS: 'Sensors on this machine: see System Details',
				TAGS: 'Plot them: see Tags',
				CONNECTED: 'Upstream and downstream units: see System details › Process flow',
				PID: 'P&ID drawings: see System details',
				WORK_ORDERS: 'Open work: see Work Orders',
				ALERTS: 'Earlier alerts: see Alerts',
				REPORTS: 'Shift reports: see Reports',
				REASONING: 'How the agent reasoned: see Reasoning',
			},
			PANE_SPLIT_HINT: 'Drag to resize; double-click to reset',
			RELATED: {
				TITLE: 'Related alerts',
				HELP: 'Found by the known-issue check: earlier alerts on this equipment known before this alert\'s cut-off, and later alerts that linked to this one. Each alert keeps its own label.',
				NONE: 'No related alert found.',
				ISSUE_SIZE: 'Issue of {{n}} alerts',
				REL_COVERED_BY: 'Service already raised',
				REL_SAME_CONDITION: 'Same condition',
				REL_SAME_EVENT: 'Same event',
				DIR_EARLIER: 'earlier alert',
				DIR_LATER: 'later alert',
				SCORE: 'score {{s}}',
				STATUS_PROPOSED: 'Proposed',
				STATUS_CONFIRMED: 'Confirmed',
				STATUS_REJECTED: 'Rejected',
				CONFIRM: 'Confirm',
				REJECT: 'Reject',
				CHIP: 'Same issue as {{n}} other alert(s)',
				CHIP_TIP: 'The known-issue check found {{n}} other alert(s) on the same condition. Open the alert to see them under Related alerts, and confirm or reject the link.',
				CHIP_PROPOSED: 'Some links still await review.',
			},
			QUEUE_RUN: {
				BUTTON: 'Triage selected',
				HINT: 'Run the Triage Agent on each selected alert, one alert at a time per run (never grouped); a few run at once.',
				STARTED: 'Triaging {{n}} alerts individually',
				PROGRESS: 'Triage: {{done}} of {{total}} done, {{running}} running',
				DONE: 'Triage finished for {{n}} alerts ({{failed}} failed)',
			},
			LABEL_SETTINGS: {
				PROPOSALS_TITLE: 'Proposed mapping changes ({{n}})',
				PROPOSALS_HELP: 'Reviewers agreed with the agent\'s finding but expected another customer label. Apply moves the finding in the editor below; it is accepted when you save the new version.',
				N_ALERTS: '{{n}} alerts',
				APPLY: 'Apply to mapping',
				APPLIED: 'Applied — save to accept',
				REJECT: 'Reject',
				TAB_SETTINGS: 'Settings',
				TAB_LABELS: 'Labels',
				INTRO: 'The agent decides an internal finding; the mapping turns it into the label the customer sees. A change saves a new version (v{{v}} is in force) and relabels every alert at once, without re-running triage.',
				EXTERNAL_TITLE: 'External labels',
				EXTERNAL_HELP: 'The labels shown in the queue and reported to the customer. The outcome drives the approve button: close, act (raise the action type) or hold for review. Saved labels cannot be deleted, only retired; their keys are permanent.',
				COL_NAME: 'Name / key',
				COL_CUSTOMER: 'Customer value',
				COL_OUTCOME: 'Outcome',
				COL_ACTION: 'Action type',
				COL_COLOR: 'Colour',
				COL_SCORED: 'Scored as',
				COL_ACTIVE: 'Active',
				UP: 'Move up',
				DOWN: 'Move down',
				REMOVE: 'Remove (never saved)',
				FALLBACK: 'fallback',
				CUSTOMER_NONE: 'Not exported',
				ACTION_PH: 'e.g. service_notification',
				OUTCOME_CLOSE: 'Close',
				OUTCOME_ACTION: 'Action',
				OUTCOME_HOLD: 'Hold for review',
				NOT_SCORED: 'Not scored',
				NEW_KEY: 'New key, e.g. valid_monitor',
				NEW_NAME: 'Name shown to users',
				ADD: 'Add label',
				KEY_RULE: 'Key: 3–41 lower-case letters, digits or underscores, starting with a letter.',
				KEY_TAKEN: 'That key is already used (keys are never reused, even after retiring).',
				NAME_REQUIRED: 'Give the label a name.',
				FALLBACK_LABEL: 'Fallback label',
				FALLBACK_HELP: 'Used when a finding has no mapping. Must be active and hold for review.',
				MAPPING_TITLE: 'Mapping: external label ← internal findings',
				MAPPING_HELP: 'Each external label (left) owns the agent findings on the right. Every finding belongs to exactly one label. Click a finding to move it. Amber findings differ from the default mapping.',
				UNMAPPED: '{{n}} findings are not mapped; they would show as the fallback label.',
				N_FINDINGS: '{{n}} findings',
				NONE: 'No findings mapped',
				RETIRED_NONE: 'Retired: owns no findings',
				DEFAULT_WAS: 'default: {{x}}',
				CHECK_N: 'Check {{n}}',
				MOVE_TO: 'Move “{{x}}” to',
				BY_CHECK: 'View by triage check',
				NO_CHANGES: 'No changes.',
				PREVIEWING: 'Checking the change…',
				MOVING: '{{n}} triaged alerts would change label.',
				DISCARD: 'Discard',
				SAVE: 'Save new version',
				SAVED: 'Label mapping v{{v}} saved',
				HISTORY: 'Versions',
				IN_FORCE: 'in force',
				RESTORE: 'Load into editor',
				RESTORE_REASON: 'Restore the mapping of v{{v}}',
			},
			LABELS: {
				FINDING_TIP: 'Shown to Shell as “{{label}}” (label mapping v{{v}}, Settings → Labels).',
				FINDING: 'Finding',
				SOURCE_AGENT: 'Agent',
				SOURCE_POLICY: 'Policy',
				SOURCE_HUMAN: 'Reviewer',
				SOURCE_DERIVED: 'Derived',
				MAPPING: 'Mapping v{{v}} → {{label}}',
				MAPPING_TIP: 'The finding is turned into the customer label by the label mapping in Settings › Labels. Changing the mapping relabels alerts without re-running triage.',
				ALSO_FOUND: 'Also found',
				CHECK: 'check {{n}}',
				SECONDARY_ACTION: 'Also found: {{names}}. That finding leads to an action, but the main finding closes the alert. Review before closing.',
				INTERNAL_COLUMN: 'Finding',
			},
			ACT: {
				APPROVED_CLOSED: 'Approved and closed',
				CLOSED: 'Closed – False alert',
				CLOSED_FLAGGED: 'Closed – False alert · rule flagged for tuning',
				CLOSE_ALERT: 'Close alert',
				CLOSE_CONFIRM: 'Close alert',
				CLOSE_TITLE: 'Close as False – No Action',
				CREATE_INSTRUMENT_WO: 'Create instrument WO',
				CREATE_SERVICE: 'Create Service',
				DUE_DATE: 'Due date',
				EQUIPMENT: 'Equipment',
				EVIDENCE_ATTACHED: 'Evidence attached (click to leave one out)',
				FEED_CONFIRM: 'Report issue',
				FEED_LEAD: 'The alert was raised on values that are not measurements. The issue goes to {{owner}}; no work order is raised because no transmitter is broken.',
				FEED_REPORTED: 'Data-feed issue reported to {{owner}}',
				FEED_TITLE: 'Report data-feed issue',
				FEWER_FIELDS: 'Show fewer fields',
				FLAG_RULE: 'Flag rule for tuning',
				FROM_AGENT: 'from the agent',
				FROM_DQ_POLICY: 'from DQ policy',
				LINKED: 'Linked to {{id}} and closed',
				LINKED_ALERT: 'Linked alert',
				LINK_CLOSE: 'Link & close',
				LINK_CONFIRM: 'Link & close',
				LINK_LEAD: 'This condition is already covered by an open record. The alert is linked to it and closed as Valid – No Action.',
				LINK_TITLE: 'Link to the known issue',
				LOADING: 'Preparing the form…',
				MORE_FIELDS: 'Show more fields',
				NOTE: 'Note (optional)',
				NOTE_PLACEHOLDER: 'Add context for the SME team…',
				NO_EVIDENCE: 'Nothing cited to attach',
				NO_REPLAY: 'The detector\'s rule could not be replayed on the raw data, so no fix is suggested.',
				OPEN_CASE: 'Open case',
				OWNER: 'Owner',
				OWNER_ME: 'Me',
				PREFILLED: 'prefilled',
				PRIORITY: 'Priority',
				PROBLEM: 'Problem',
				RECOMMENDATION: 'Recommendation',
				REPORT_FEED: 'Report data-feed issue',
				ROUTE_TO: 'Route to',
				SENT_TO: 'Sent to {{owner}}.',
				SERVICE_CONFIRM: 'Create Service',
				SERVICE_CREATED: 'Service case #{{id}} created',
				SERVICE_NAME: 'Title',
				SERVICE_TITLE: 'Create Service',
				TAG: 'Tag',
				UNDO: 'Undo',
				UNDONE: 'Action undone',
				WO_CONFIRM: 'Create work order',
				WO_CREATED: 'Work order {{id}} created · {{route}}',
				WO_TITLE: 'Create instrument work order',
			},
			CHIPS: {
				UNACK_HINT: '{{n}} not yet acknowledged',
			},
			RULE: {
				FLAGGED_SHORT: 'Rule flagged',
				FLAGGED_TIP: 'The detector rule was flagged for tuning',
			},
			SETTINGS: {
				DEFAULT: 'Default',
				FROM_DEFAULT: 'default',
				FROM_FACILITY: 'facility',
				FROM_EQUIPMENT: 'this equipment',
				HISTORY: 'Change history',
				LOADING: 'Loading settings…',
				NO_HISTORY: 'No change yet: every value is the code default.',
				N_CHANGED: '{{n}} changed',
				OPEN: 'Triage settings',
				OPEN_HINT: 'Flatline, delays, HIL in memory, routing',
				READ_ONLY: 'Only an administrator can change these settings.',
				REASON: 'Reason for the change (required)',
				RESET: 'Reset',
				RE_EVAL: 'changes results',
				RE_EVAL_CHANGED: 'Run the golden set before relying on this change',
				RE_EVAL_HINT: 'Changing this changes triage results: run the golden set before relying on it',
				RE_EVAL_NOTE: 'Each change is a new version; every triage run records the version it used. Settings marked "changes results" need a golden-set run before you rely on them.',
				SAVE: 'Save',
				SAVED: 'Settings saved as version {{v}}',
				SAVE_FAILED: 'The settings could not be saved',
				SCOPE: 'Applies to',
				SCOPE_FACILITY: 'The whole facility',
				SUBTITLE: 'Version {{v}}',
				TITLE: 'Alert Triage settings',
			},
			TREE: {
				ALL_OPEN: 'All open alerts',
				CLEAR_FILTER: 'Show all nodes',
				NO_ACTION_TOTAL: 'No action',
				SHOWING_ONLY: 'Showing: {{cls}} only',
				SHOW_NODES_WITH: 'Show nodes with',
			},
			KG: {
				CLICK_TO_COLLAPSE: 'Click to collapse',
				NO_EXACT: 'No node is named “{{tag}}”',
				PICK_MATCH: 'These partially match it, one per part of the plant — pick one to explore:',
				BREADCRUMB_OPS: 'Offshore Operations',
				BREADCRUMB_TWINS: 'Topological Twins',
				BREADCRUMB_GRAPH: 'Shell Vito Knowledge Graph',
				TITLE: 'Interactive Plant Knowledge Graph',
				NODES: '{{n}} nodes',
				RELATIONSHIPS: '{{n}} relationships',
				LIVE: 'Neo4j live',
				CENTER_PLACEHOLDER: 'Centre tag (e.g. PT-1502, MTR-0900)…',
				EXPLORE: 'Explore',
				HOPS: 'Depth',
				HOPS_1: '1 hop: direct neighbours',
				HOPS_2: '2 hops: neighbouring equipment',
				HOPS_3: '3 hops: wider topology',
				SHOW_TYPE: 'Show this type',
				HIDE_TYPE: 'Hide this type',
				ZOOM_IN: 'Zoom in',
				ZOOM_OUT: 'Zoom out',
				FIT: 'Fit to screen',
				SHOWING: 'Showing {{shown}} of {{total}} nodes',
				SHOW_MORE: 'Show {{n}} more',
				EXPAND_ALL: 'Expand all groups',
				COLLAPSE_ALL: 'Collapse groups',
				HINT: 'Hover for names · click a group to expand it · click a node to inspect · drag to pan, scroll to zoom',
				LOADING: 'Reading the knowledge graph…',
				LOAD_FAILED: 'Failed to load the knowledge graph',
				CLICK_TO_EXPAND: 'Click to list and expand',
				GROUP: 'GROUPED NODES',
				COLLAPSE_GROUP: 'Collapse group',
				CENTER_ON_NODE: 'Centre graph on this node',
				PROPERTIES: 'Node properties',
				LOADING_RELATIONS: 'Loading relationships…',
				OUTGOING: 'Outgoing relationships ({{n}})',
				INCOMING: 'Incoming relationships ({{n}})',
				TYPE: {
					Equipment: 'Equipment',
					ControlValve: 'Control valve',
					Instrument: 'Instrument',
					Event: 'Alert',
					Event_PostJune2026: 'Alert (after June 2026)',
					Alert: 'Alert',
					TripEvent: 'Trip event',
					RootCause: 'Root cause',
					PhaScenario: 'PHA scenario',
					Detector: 'Detector',
					Measurement: 'Measurement',
					Document: 'Document',
					PIDDrawing: 'P&ID drawing',
					FLOC: 'FLOC',
					ProcessLine: 'Process line',
					System: 'System',
				},
			},
			LIBRARY: {
				TITLE: 'Library specialist',
				EXCERPTS_N: '{{n}} excerpts · {{docs}} documents',
				NONE: 'No manual in scope',
				LIMITS_N: '{{n}} stated limits',
				SCOPE: 'Searched for',
				HINT: 'OEM manuals, datasheets and alarm & trip lists filed for this equipment (by FLOC), searched by meaning and words. The agent cites them as LIB-n.',
				QUESTIONS: 'Questions asked',
				NONE_HINT: 'No manual or datasheet is filed for this equipment or its FLOC ancestors.',
				STATED_LIMITS: 'Limits stated for this instrument',
				EXCERPTS: 'Excerpts',
			},
			LIMITS: {
				ROW_FOUND: 'The red box marks the row this limit was read from.',
				OPEN_PAGE: 'Open the source page',
				OPEN_ROW: 'Open the source row',
				HIDE_SOURCE: 'Hide the source',
				SHEET_TITLE: 'Source row in the Shell workbook',
				SHEET_UNAVAILABLE: 'The workbook could not be read.',
				SHEET_ROWS: '{{n}} row(s) name this tag, of {{total}}',
				SHEET_NO_ROW: 'No row in this sheet names the tag.',
				SHEET_ROW: 'Row {{n}}',
				AT_ALERT: 'In force at the alert ({{t}}) marked',
				IN_FORCE: 'in force',
				NOT_IN_FORCE: 'not in force then',
				FROM: 'from {{from}}',
				QUOTED_FROM: 'quoted {{from}} – {{to}}',
				MAPPING_REVIEW: 'instrument ↔ tag mapping under review',
				DCS: 'DCS limit tags (historian)',
				AT_ALERT_VALUE: 'at the alert: {{v}}',
				TITLE: 'Limits',
				CLOSEST: '{{kind}} {{value}} · {{headroom}}% headroom',
				NONE: 'No limit known',
				RULE_BREACHED: 'TMP rate rule met',
				HINT: 'Every engineering limit known for the alert tag (Shell TMP PSV set point / DCS / PTM, SimpleLimits, manual values in the same unit) against the last reading and the 24 h peak or trough before the alert.',
				NONE_HINT: 'No TMP, SimpleLimits, detector configuration or manual-stated limit is known for this tag.',
				SOURCE: 'Source',
				LIMIT: 'Limit',
				VALUE: 'Value',
				EXTREME_24H: '24 h peak / trough',
				HEADROOM: 'Headroom',
				STATUS: 'Status',
				RATE_RULES: 'TMP rate rules',
				LARGEST_CHANGE: 'largest change {{value}}',
				BREACHED: 'Breached',
				NOT_BREACHED: 'Not breached',
				DETECTOR: 'Detector configuration',
				CONFLICT: 'Conflicting TMP values:',
				REACHED: 'Reached',
				NEAR: 'Near',
				CLEAR: 'Clear',
				NO_READING: 'No reading',
			},
			PREFS: {
				TITLE: 'Preferences',
				HEIGHT: 'Tag graph preferred height',
				CONDENSED: 'Condensed',
				NORMAL: 'Normal',
				EXPANDED: 'Expanded',
				LIMITS_AND_VALUES: 'Tag limits and values',
				SHOW: 'Show',
				HIDE: 'Hide',
				OTHER: 'Limit lines drawn by default',
				TRIP_LINE: 'Trip line',
				ALARM_LINE: 'Alarm line',
				THRESHOLD_LINE: 'Threshold line',
				INSTRUMENT_LINE: 'Instrument range line',
				NOTE: 'Applies to every triage chart. The shaded band is the failure-mode episode (signal start to return to normal). Limits come only from loaded Shell data (TMP, SimpleLimits).',
				RESET: 'Reset to defaults',
			},
			PLAYBOOK: {
				TITLE: 'Site playbook checks',
				META: '{{count}} rules evaluated',
				META_HINT: 'Rules mined from the site’s vetting notes for this detector, in effect at the alert time, tested on the evidence before the cut-off',
				LEGEND: '✓ held · ✗ did not hold · ? could not be evaluated. An UNLESS check that holds blocks the rule; parts no check can express are judged by the agent.',
				OPEN_RULE: 'Open the rule in Learnings',
				DISPOSITION_HINT: 'What site practice does when this rule applies',
				UNLESS_HINT: 'Exceptions: if one holds, the rule does not apply',
				JUDGED_BY_AGENT: 'Judged by the agent',
				JUDGED_HINT: 'No machine check can express this part; the agent weighs it from the evidence',
				VALUE_YES: 'held',
				VALUE_NO: 'did not hold',
				VALUE_UNKNOWN: 'could not be evaluated',
				ST_MATCHED: 'Matched',
				ST_MATCHED_HINT: 'Every WHEN check held and no exception did',
				ST_PARTLY: 'Partly matched',
				ST_PARTLY_HINT: 'The machine checks held; the parts judged by the agent decide whether it fully applies',
				ST_EXCEPTED: 'Excepted',
				ST_EXCEPTED_HINT: 'It would apply, but an exception (UNLESS) held',
				ST_UNDETERMINED: 'Undetermined',
				ST_UNDETERMINED_HINT: 'A check could not be evaluated from the evidence before the cut-off',
				ST_NOT_MATCHED: 'Not matched',
				ST_NOT_MATCHED_HINT: 'A WHEN check did not hold',
			},
			LEARNING_CHECK: {
				OR: 'or',
				HOURS: '{{n}} h',
				DAYS: '{{n}} days',
				ON_ITEM: 'on this item',
				V_STOPPED: 'stopped',
				V_STARTED: 'started',
				V_RESTARTED: 'restarted',
				V_SHUTDOWN_OR_STARTUP: 'shut down or started up',
				V_NO_SIGNIFICANT_CHANGE: 'no significant change',
				V_PROCESS_OR_OPERATING_CHANGE: 'a process or operating change',
				V_SINGLE_TAG_DEPARTURE: 'a single tag departing alone',
				V_MIXED: 'mixed patterns',
				V_CONSISTENT: 'consistent with normal',
				V_MOVED_TOGETHER: 'moved together with it',
				MACHINE_EVENT: 'machine {{events}} within {{window}}',
				MACHINE_EVENT_NO_WINDOW: 'machine {{events}}',
				MACHINE_EVENT_ANY: 'a machine stop or start within {{window}}',
				SINCE_RESTART: 'machine restarted no more than {{window}} before the alert',
				RUNNING: 'machine running at the alert time',
				NOT_RUNNING: 'machine not running at the alert time',
				WITHIN_BASELINE: 'alert tag back within its normal band at the alert time',
				OUTSIDE_BASELINE: 'alert tag outside its normal band at the alert time',
				SUSTAINED: 'a sustained departure from normal',
				NOT_SUSTAINED: 'no sustained departure from normal',
				CHART_PATTERN: 'charts show {{patterns}}',
				CHART_PATTERN_ANY: 'a chart pattern is read',
				MULTIVARIATE: 'the multivariate model reads {{values}}',
				MULTIVARIATE_ANY: 'the multivariate model has a verdict',
				CONNECTED: 'connected systems: {{values}}',
				CONNECTED_ANY: 'connected systems were read',
				MOVED_TOGETHER: 'related tags moved together',
				NOT_MOVED_TOGETHER: 'related tags did not move together',
				OPEN_WORK: 'open notification or work order on this item',
				NO_OPEN_WORK: 'no open notification or work order on this item',
				COHORT: 'many alerts in the same system at once (common cause)',
				NO_COHORT: 'no burst of alerts in the same system',
				SENSOR_FAULT: 'the sensor is faulty or its data unusable',
				SENSOR_OK: 'the sensor data are usable',
				RETURNED: 'the signal returned to normal before the alert time',
				NOT_RETURNED: 'the signal had not returned to normal by the alert time',
				SHIFT_LOG: 'a shift log in the last {{window}} mentions ‘{{query}}’',
				NO_SHIFT_LOG: 'no shift log in the last {{window}} mentions ‘{{query}}’',
				RECENT_WORK: 'maintenance work in the last {{window}} matching ‘{{query}}’',
				NO_RECENT_WORK: 'no maintenance work in the last {{window}} matching ‘{{query}}’',
				OTHER_ALERTS: 'at least {{n}} other alerts from the same detector within {{window}}',
				PRIOR_ALERTS: 'at least {{n}} earlier alerts on this tag in the last {{window}}',
				PRIOR_ALERTS_EVER: 'at least {{n}} earlier alerts on this tag',
			},
			LEARNING_EDIT: {
				TITLE: 'Edit learning',
				ASOF_WARNING: 'Saving writes version v{{next}}, in effect from now on. Triage of earlier alerts keeps the version that was in effect at their time (as-of).',
				F_TITLE: 'Title',
				RECOMPILE: 'The machine checks will be recompiled from the new condition.',
				ACTIVE_HINT: 'the agent consults it',
				RETIRED_HINT: 'withdrawn from now on',
				REASON: 'Reason for the change',
				REASON_HINT: 'Kept with the new version and shown in its history.',
				NO_CHANGES: 'Nothing changed yet.',
				SAVE: 'Save new version',
				SAVED: 'Saved as v{{version}}, in effect from now on; earlier triage keeps the previous version.',
			},
			LEARNING_DETAIL: {
				TITLE: 'Learning',
				EDIT: 'Edit',
				CLOSE: 'Close',
				EFFECTIVE: 'in effect since {{date}}',
				SUPPORT: 'Support: {{support}}',
				CONSISTENCY: 'consistency {{pct}}',
				MANUAL_FIELDS: 'set by hand: {{fields}}',
				CONDITION: 'Condition',
				EXCEPTIONS: 'Exceptions',
				CHECKS: 'Machine checks',
				CHECKS_HINT: 'The condition compiled into facts the agent can test on the evidence at the alert time; the rest is judged by the agent.',
				CHECKS_STALE: 'The condition was edited: its machine checks are being recompiled and are not used until they are.',
				WHEN: 'When',
				UNLESS: 'Unless',
				MANUAL: 'Judged by the agent',
				NO_CHECKS: 'No machine-checkable condition',
				GROUPS: 'Sensor groups its alerts concern',
				TYPICAL_TAGS: 'Typical tags',
				QUOTES: 'From the vetting notes',
				GRAPH: 'Knowledge-graph neighbourhood',
				GRAPH_MISSING: 'Not in the knowledge graph yet.',
				REL_DETECTOR: 'For detector',
				REL_FLOC: 'On functional location',
				REL_SUPERSEDES: 'Supersedes',
				NO_LINKS: 'No detector, location or earlier-version links.',
				SIMILAR: 'Similar learnings',
				NO_SIMILAR: 'No active learning close in meaning.',
				OPEN_SIMILAR: 'Open this learning',
				ASOF_NOTE: 'Versions are never changed in place: a triage at time t uses the version in effect at t.',
				NOW: 'now',
				CHANGED: 'Changed:',
				SHOW_DIFF: 'Show rule diff',
				HIDE_DIFF: 'Hide diff',
				F_TITLE: 'title',
				F_RULE: 'rule',
				F_DISPOSITION: 'disposition',
				F_STATUS: 'status',
				F_CONDITION: 'condition',
				F_EXCEPTIONS: 'exceptions',
				F_SUPPORT: 'support',
				SHOW_ALL_SOURCES: 'Show all {{count}}',
			},
			PID: {
				CLICK_TO_PLOT: 'Click to plot',
				NO_HISTORIAN_DATA: 'No historian data',
				MORE_TAGS: '+{{count}} more tags on this item',
				NO_DATA_AT_ALERT: 'No readings in the 72 h before the alert',
				CLICKABLE_COUNT: '{{clickable}} of {{total}} tags have data',
				TAGS_FAILED: 'Could not load the tags of this drawing',
				HIDE_LEGEND: 'Hide legend',
				SHOW_LEGEND: 'Show legend',
				LEGEND_DATA: 'Has historian data (click)',
				LEGEND_NO_DATA: 'No historian data',
				LEGEND_ALERT: 'Alert tag',
				LEGEND_RELATED: 'Same equipment / loop as the alert',
				LEGEND_SUGGESTED: 'Suggested to look at',
				ONLY_WITH_DATA: 'Only tags with data',
				SHEET_N: 'sheet {{sheet}}',
				BACK: 'Back',
				BACK_TIP: 'Back to the previous sheet ({{count}} in history)',
				SHOW_PANEL: 'Show panel',
				HIDE_PANEL: 'Hide panel',
				FROM_UPSTREAM: 'From upstream',
				TO_DOWNSTREAM: 'To downstream',
				RESIZE: 'Drag to resize the panel',
				ON_DRAWING: 'On drawing',
				LOCATE_ITEM: 'Show on the drawing',
				FROM_OTHER_SHEET: 'Selected on another sheet',
				ITEM_TAGS: 'Tags on this item ({{count}})',
				SWITCH_TIP: 'click to chart this tag instead',
				ADD_TO_CHART: 'Add to chart',
				REMOVE_FROM_CHART: 'Remove from chart',
				ON_CHART: '{{count}} / {{max}} on chart',
				ALERT_WINDOW: 'Alert at {{asOf}} · 3 days before to 1 day after',
				LAST_DAYS: 'Last {{days}} days of available data',
				CHART_FULL: 'At most {{max}} tags can be charted together',
				TIME_SERIES: 'Time series',
				LOOK_NEXT: 'Look next',
				CONTEXT_FAILED: 'Could not load related tags',
				CONTEXT_UNKNOWN: 'This tag is not in the sensor catalogue',
				LOOP_N: 'Loop {{loop}}',
				SAME_LOOP: 'Same loop',
				SAME_EQUIPMENT: 'Same equipment',
				UPSTREAM: 'Upstream units',
				DOWNSTREAM: 'Downstream units',
				SERVICE: 'Serving utilities',
				NONE_WITH_DATA: 'None with historian data',
				SHOW_MORE: 'Show {{count}} more',
				NO_UNITS: 'No connected units',
				HOPS: '{{count}} hop(s)',
				OPEN_DRAWING: 'Open drawing',
				MORE_SENSORS: '+{{count}} more sensors',
				TWIN: 'Twin train: {{unit}}',
				TWIN_ON_CHART: 'Twin tag is on the chart',
				COMPARE_TWIN: 'Compare with twin',
				TWIN_NO_TAG: 'No same-position tag known on {{unit}}',
				TWIN_SAME_MEASURE: 'Same measure on {{unit}}',
				LOCATE_ON_SHEET: 'Show on this sheet',
				OTHER_CONNECTORS: 'Utilities & relief ({{count}})',
				OTHER_CONNECTORS_TIP: 'Control, utility and relief connectors on this sheet',
				SIDE_BY_SIDE: 'Side by side',
				SIDE_BY_SIDE_TIP: 'Full screen: drawing and panel side by side',
				REL: {
					ALERT: 'Alert tag',
					LOOP: 'Same loop',
					EQUIPMENT: 'Same equipment',
				},
			},
			BATCH: {
				TOGGLE: 'Batch',
				TOGGLE_HINT: 'Batch mode: list groups of alerts on the same FLOC within a time window and triage each group together',
				TOGGLE_OFF_HINT: 'Back to the list of single alerts',
				WINDOW_LABEL: '{{hours}} h window',
				WINDOW_HINT: 'Batch window: alerts on one FLOC within this many hours of the first one form a group',
				WINDOW_TITLE: 'Batch window',
				WINDOW_OPTION: '{{hours}} h',
				HELP: 'Alerts are grouped by FLOC. The window is anchored at the first alert of the group; the cut-off is the latest member, so every member is assessed with what was known at that moment. One investigation covers the group and gives each member its own disposition. Groups use the date, search, FLOC, target and status filters.',
				GROUPS_TITLE: 'Batches · {{hours}} h window',
				GROUPS_COUNT: '({{groups}} groups · {{alerts}} of {{considered}} alerts)',
				NEWEST_FIRST: 'Newest first',
				EMPTY: 'No batches',
				EMPTY_HINT: 'No FLOC has two or more alerts within the window under the current filters.',
				COL_SIZE: 'Size',
				COL_SPAN: 'Time span',
				COL_DETECTORS: 'Detectors',
				COL_CLASSES: 'Current classes',
				COL_TAG: 'Tag',
				COL_AS_OF: 'As of',
				TOGGLE_MEMBERS: 'Show or hide the alerts of this group',
				N_ALERTS: '{{count}} alerts',
				SPAN: '{{count}} alerts in {{span}}',
				MINUTES: '{{count}} min',
				HOURS_MINUTES: '{{hours}} h {{minutes}} min',
				CUTOFF: 'cut-off',
				N_UNTRIAGED: '{{count}} untriaged',
				ALL_TRIAGED: 'All triaged',
				RUNNING: 'Batch run in progress',
				TRIAGE_BATCH: 'Triage batch ({{count}})',
				TRIAGE_SELECTED: 'Triage {{count}} selected',
				TRIAGE_HINT: 'One investigation of these alerts together, as of the latest member; each alert gets its own disposition',
				SELECT_MIN: 'Select at least {{count}} alerts of this group',
				SELECT_MAX: 'A batch takes at most {{count}} alerts: select up to {{count}}',
				PAGE_HINT: 'Paging counts groups',
				RANGE: '{{start}}–{{end}} of {{total}} groups',
				DONE: 'Batch of {{count}} alerts triaged',
				GATED: 'Batch not analysed: the data-quality gate blocked the run (see the canvas)',
				FAILED: 'The batch run did not complete',
				ROW_CHIP: 'batch of {{count}}',
				ROW_CHIP_TIP: 'The latest run triaged this alert together with {{count}} alerts on its FLOC (one investigation, one disposition per alert)',
				CARD_TITLE: 'Group triage',
				CARD_META: 'Batch of {{count}} · {{hours}} h window · cut-off {{time}}',
				EPISODE_CLASS: 'Episode',
				EPISODE_HINT: 'Classification of the group as a whole',
				THIS_MEMBER: 'This alert',
				MEMBERS: 'Alerts in the batch',
				THIS_ALERT: 'this alert',
				NOW_IN_GROUP: 'This alert now sits in a group of {{count}} on its FLOC ({{hours}} h window, {{span}} min, {{untriaged}} untriaged).',
				MORE_DETECTORS: '+{{count}} more',
				TRIAGE_WITH: 'Triage with {{count}} alerts on this FLOC',
			},
			UEV: {
				TITLE: 'Evidence & feedback',
				HINT: 'Field observations, SAP notifications, historian tags and files you add here go to the agent on a re-run, marked as user-supplied and weighed separately from the as-of record.',
				BADGE_N: '{{count}} item(s)',
				BADGE_CHANGED: 'changed the answer',
				EMPTY: 'No evidence added yet.',
				LOAD_ERROR: 'Could not load the evidence',
				ADD: 'Add evidence',
				ADDED: 'Evidence added',
				UPDATED: 'Evidence updated',
				REMOVED_NOTICE: 'Evidence removed',
				TYPE_OBSERVATION: 'Feedback / observation',
				TYPE_SAP: 'SAP notification',
				TYPE_TAG: 'Historian tag',
				TYPE_FILE: 'File',
				TEXT_LABEL: 'What was observed or measured',
				TEXT_PLACEHOLDER: 'e.g. local gauge reads 30 scfm; drain valve found passing',
				CONTEXT_LABEL: 'Why it matters for this alert',
				CONTEXT_PLACEHOLDER: 'Context note for the agent (optional)',
				NOTIF_LABEL: 'Notification number',
				LOOKUP: 'Look up',
				NOTIF_NOT_FOUND: 'Notification not found',
				NOTIF_AFTER: 'Raised {{hours}} h after the alert',
				NOTIF_BEFORE: 'Raised before the alert',
				NOTIF_NAMES_TAG: 'Names the alert tag {{tag}}',
				FLOC_EQUIPMENT: 'Same equipment',
				FLOC_UNIT: 'Same unit',
				FLOC_FACILITY: 'Other equipment',
				RAISED: 'Raised {{time}}',
				COMPLETED: 'Completed {{time}}',
				TAG_LABEL: 'Historian tag',
				TAG_PLACEHOLDER: 'Search tags (e.g. LIC0920)',
				TAG_HINT: 'The agent reads this tag as of the alert time, like every other tag.',
				FILE_CHOOSE: 'Choose file',
				FILE_HINT: 'PDF, image, text, CSV, Word or Excel, up to 10 MB',
				FILE_TYPE_ERROR: 'Unsupported file type: upload a PDF, PNG, JPG, text, CSV, Word or Excel file',
				FILE_SIZE_ERROR: 'The file is larger than 10 MB',
				FILE_META: '{{pages}} page(s), {{size}} KB',
				FILE_NO_TEXT: 'no text extracted ({{note}})',
				OPEN_FILE: 'Open file',
				SAVE: 'Add',
				CANCEL: 'Cancel',
				EDIT: 'Edit',
				REMOVE: 'Remove',
				REMOVE_CONFIRM: 'Remove this item? Earlier versions are kept, and runs that used them still name them.',
				REASON: 'Reason (optional)',
				SAVE_EDIT: 'Save as new version',
				VERSIONS: 'History',
				REMOVED: 'Removed',
				SHOW_REMOVED: 'Show removed',
				HIDE_REMOVED: 'Hide removed',
				BY: 'Added by {{name}} · {{time}}',
				EDITED_BY: 'v{{n}} by {{name}} · {{time}}',
				AFTER_CUTOFF: 'after the cut-off',
				RERUN: 'Re-run with evidence',
				RERUN_HINT: 'Runs the Triage Agent again with the {{count}} active item(s); follow it live on the run canvas',
				RERUN_BATCH: 'Re-run batch ({{count}} alerts)',
				RERUN_BATCH_HINT: 'Runs the batch again with the active evidence on all its members',
				LAST_RUN: 'Last re-run used {{refs}}',
				OUTCOME_CHANGED: 'Changed the answer: {{from}} → {{to}}',
				OUTCOME_UNCHANGED: 'Answer unchanged',
				OUTCOME_NOT_ATTRIBUTED: 'Answer changed ({{from}} → {{to}}), not attributed to the evidence',
				OUTCOME_NO_BASELINE: 'The agent says the evidence decided the answer',
				AGENT_LINE: 'Answer from a re-run with user evidence {{refs}}',
				NODE: 'User evidence',
				CANVAS_BADGE: 'User evidence · {{count}}',
				CANVAS_HINT: 'Re-run with user-supplied evidence: {{refs}}',
				PICKER: 'user evidence',
				INSPECTOR_ITEMS: 'Items used ({{count}})',
				INSPECTOR_BASELINE: 'Answer without this evidence: {{cls}}',
				INSPECTOR_NO_BASELINE: 'No earlier run without user evidence',
				INSPECTOR_AUDIT: 'User-supplied items are kept out of the as-of view; the leak check covers the harness facts only.',
				ATTRIBUTION_USER_EVIDENCE: 'Changed by the evidence: {{from}} → {{to}}',
				ATTRIBUTION_USER_EVIDENCE_NO_BASELINE: 'Decided by the evidence (no earlier run)',
				ATTRIBUTION_NOT_ATTRIBUTED: 'Changed, not attributed: {{from}} → {{to}}',
				ATTRIBUTION_UNCHANGED: 'Unchanged',
				EFFECT_CHANGED_ANSWER: 'changed the answer',
				EFFECT_SUPPORTED_ANSWER: 'supports the answer',
				EFFECT_CONTRADICTED: 'contradicts, not adopted',
				EFFECT_NO_BEARING: 'no bearing',
				EFFECT_NOT_ADDRESSED: 'not addressed',
			},
			WATCH: {
				STATUS_WATCHING: 'Watching',
				ACTION: 'Watch',
				ACTION_HINT: 'Look at this alert again later, with the data recorded after this assessment',
				UNWATCH: 'Un-watch',
				DIALOG_TITLE: 'Watch alert',
				DIALOG_LEAD: 'The alert stays on watch until the due date; then it can be re-assessed with everything recorded since this assessment.',
				ASSESSED_AS_OF: 'Current assessment as of',
				ASSESSED_HINT: 'The cut-off of the assessment you are looking at. Presets count from this time, not from today.',
				LOOK_AGAIN: 'Look again',
				PRESET_HOURS: '+{{count}} h',
				PRESET_DAYS: '+{{count}} d',
				PRESET_CUSTOM: 'Date & time',
				DUE_AT: 'Due at',
				DUE_LINE: 'Due {{time}}',
				DUE_BEFORE_ASSESSMENT: 'must be after the assessment',
				SUGGESTED: 'Suggested by the agent',
				USE_SUGGESTION: 'Use as reason',
				REASON: 'Reason',
				REASON_HINT: 'What to check when it is due (required)',
				CONFIRM: 'Watch',
				SET_NOTICE: 'Alert put on watch',
				BANNER_DUE: 'Watch due',
				BANNER_WAITING: 'On watch',
				CHIP_DUE: 'Due · {{time}}',
				CHIP_WAITING: 'Watching · due {{time}}',
				TIP_DUE: 'On watch, due since {{time}}: re-assess with the new data',
				TIP_WAITING: 'On watch until {{time}}',
				SET_BY: 'Set by {{name}} on {{date}}',
				BASELINE: 'Watching the assessment as of {{time}}',
				CHECKING: 'Checking what was recorded since…',
				NOTHING_NEW: 'Nothing new recorded since the assessment yet.',
				LATER_ALERTS: 'Later alerts',
				BEYOND: '+{{count}} after',
				OPEN_LATER: 'Open this alert',
				SAP_RECORDS: 'SAP records',
				SUPERVISOR_REPORTS: 'Supervisor reports',
				HISTORIAN: 'Historian',
				HOURS: '{{count}} h',
				ON_TAGS: 'on {{count}} tags',
				WINDOW: 'New data from {{from}} to {{to}}',
				REASSESS: 'Re-assess with new data',
				REASSESS_HINT: 'Re-triage with the cut-off moved to the due date (never past now); the canvas follows the run',
				REASSESS_WAIT: 'Available when the watch is due',
				NEW_DATA: 'new data',
				NEW_DATA_DOT: 'Due, with data recorded since the assessment',
				FILTER_LABEL: 'Watch',
				FILTER_DUE: 'Due',
				FILTER_WAITING: 'Watching (not due)',
				REASSESSED_HEADER: 'Re-assessed as of {{time}} (first assessed as of {{previous}}: {{cls}})',
			},
			SHELL: {
				TOGGLE: 'Show HIL labels',
				TOGGLE_HINT: 'Add the human-in-the-loop (HIL) vetting label and comment as columns to compare. Validation data only: never an input to the triage agent.',
				VALIDATION_ONLY: 'HIL (human-in-the-loop) labels are validation data. They are never an input to the triage agent.',
				COLUMN: 'HIL label',
				NOT_VETTED: 'Not vetted',
				NOT_VETTED_TIP: 'No HIL label for this alert',
				STATE: 'HIL state',
				COMMENT: 'Comment',
				ACTION_TAKEN: 'Action taken',
				RELIABILITY: 'Reliability',
				INHERITED: 'Inherited from the parent episode',
				AGREES: 'Agrees with HIL',
				DIFFERS: 'Differs from HIL',
				AGREES_TIP: 'Our classification agrees with the HIL label',
				DIFFERS_TIP: 'Ours: {{ours}} · HIL: {{shell}}',
				AGREEMENT: 'Agrees with HIL on {{agree}} of {{compared}} triaged',
				AGREEMENT_TIP: 'Filtered alerts that are triaged (not pending) and carry a HIL label, and how many have the same class.\nHIL labels are validation data, never an input to the agent.',
				CARD_TITLE: 'HIL vetting',
				FILTER_LABEL: 'HIL label',
				FILTER_NONE: 'Not vetted',
				COLUMN_COMMENT: 'HIL comment',
			},
			FACTS: {
				TITLE: 'Evidence read — oldest → newest (all before the cut-off)',
				HINT: 'Time range of the facts the run read from each source. Every query stops at the cut-off.',
				CUTOFF: 'Cut-off {{time}}',
				COL_SOURCE: 'Source',
				COL_OLDEST: 'Oldest',
				COL_NEWEST: 'Newest',
				COL_GAP: 'Before cut-off',
				SOURCE_HISTORIAN: 'Historian',
				SOURCE_SAP_NOTIFICATION: 'SAP notifications',
				SOURCE_SAP_WORKORDER: 'SAP work orders',
				SOURCE_SUPERVISOR_REPORT: 'Supervisor reports',
				SOURCE_ALERTS: 'Alerts',
				SOURCE_MEMORY: 'Memory',
				NOT_READ: 'No facts read',
				POST_ALERT: 'Post-alert records',
				POST_ALERT_NONE: 'none fetched: every query stops at the cut-off',
				AFTER_CUTOFF: 'after the cut-off',
				GAP_SECONDS: '{{count}} s',
				GAP_MINUTES: '{{count}} min',
				GAP_HOURS: '{{count}} h',
				GAP_DAYS: '{{count}} d',
			},
			SENSOR: {
				MEASURE: {
					temperature: 'Temperature',
					pressure: 'Pressure',
					differential_pressure: 'Differential pressure',
					level: 'Level',
					flow: 'Flow',
					vibration: 'Vibration',
					axial_position: 'Axial position',
					speed: 'Speed',
					current: 'Current',
					power: 'Power',
					voltage: 'Voltage',
					valve_position: 'Valve position',
					status: 'Status',
					composition: 'Composition',
				},
				GROUP: {
					vibration: 'Vibration',
					bearing_temperature: 'Bearing temperature',
					axial_position: 'Axial position',
					speed_run: 'Speed & run state',
					lube_oil: 'Lube oil',
					seal_gas: 'Seal gas',
					suction: 'Suction',
					discharge: 'Discharge',
					cooling: 'Cooling',
					anti_surge: 'Anti-surge',
					scrubber_level: 'Scrubber level',
					control_valve: 'Control valve',
					motor_electrical: 'Motor electrical',
					turbine: 'Turbine',
				},
				ROLE: {
					process_value: 'Process value',
					setpoint: 'Setpoint',
					controller_output: 'Controller output',
					limit: 'Limit',
					mode: 'Mode',
					totaliser: 'Totaliser',
				},
				GROUP_NONE: 'Other',
				COL_SENSOR: 'Sensor',
				CONVENTION_ONLY: 'tag convention only',
				TIP_MEASURES: 'Measures: {{value}}',
				TIP_WHY: 'Why it is monitored (Technical Monitoring Plan)',
				TIP_NO_REASON: 'No monitoring reason is recorded for this sensor.',
				TIP_CONVENTION: 'Described by the P&ID tag convention only; the monitoring plan does not cover it.',
				TIP_ACTION: 'Recommended action',
				TIP_UNIT: 'Unit: {{unit}}',
				TIP_LIMITS: 'Limits: {{value}}',
				TIP_SOURCES: 'Sources: {{value}}',
				TIP_LOW: 'Only the tag naming describes this sensor, so its meaning is less certain.',
				LIMIT_LOW: 'low',
				LIMIT_HIGH: 'high',
			},
			CONNECTED: {
				USUALLY_LEADS: 'usually leads by {{t}} (r {{r}})',
				USUALLY_LAGS: 'usually lags by {{t}} (r {{r}})',
				USUALLY_WITH: 'usually moves with it (r {{r}})',
				NOT_COUPLED: 'not usually coupled (r {{r}})',
				USUAL_DELAY: 'moved with its usual delay',
				NOT_USUAL_DELAY: 'not with its usual delay',
				COUPLING_HINT: 'How this sensor usually relates to the alert tag over the running baseline: the delay of best correlation and its r. “Usual delay” compares this time’s timing with it.',
				TITLE: 'Connected systems',
				VERDICT: {
					upstream_led: 'Upstream moved first',
					service_related: 'A serving utility moved with it',
					downstream_followed: 'Downstream followed — the change starts here',
					moved_together: 'Connected units moved together',
					isolated: 'Connected systems held — local to this equipment',
					background_drift: 'Connected units off baseline for days (background)',
					moved_unordered: 'Connected units moved, order unclear',
					insufficient: 'Too few sensors to judge',
				},
				UPSTREAM: 'Upstream',
				DOWNSTREAM: 'Downstream',
				SERVICE: 'Serving utilities',
				REL_UPSTREAM: 'upstream',
				REL_DOWNSTREAM: 'downstream',
				REL_SERVICE: 'serving utility',
				AS_OF: 'Read as of alert time — nothing recorded after the alert is used',
				OF_SENSORS: 'of {{total}} sensors with data',
				RATIO_HINT: 'Interface sensors of the neighbouring units that had usable readings before the alert',
				ANCHOR_ONSET: 'Alert tag onset',
				PLOT: 'Alert tag and interface sensors',
				PLOT_TITLE: 'Connected systems plot',
				PLOT_CAPTION: 'Black = alert tag · grey shading = machine stopped · dashed line = alert-tag onset · grey band = within ±3 sd of the running baseline. Click to enlarge.',
				NEIGHBOURS: 'Connected units',
				NEIGHBOURS_META: '{{total}} connected units read, {{moved}} moved',
				EXPAND_ALL: 'Expand all',
				COLLAPSE_ALL: 'Collapse held',
				NO_NEIGHBOURS: 'No connected units were read.',
				OPEN_UNIT: 'Open this unit in the process view',
				LINK_HIGH: 'link: high',
				LINK_MEDIUM: 'link: medium',
				LINK_LOW: 'link: low',
				LINK_HINT: 'How certain the drawings are that these two units are connected',
				STATE_MOVED: 'moved',
				STATE_HELD: 'held',
				STATE_NO_DATA: 'no data',
				SENSORS_N: '{{count}} sensors',
				COL_SENSOR: 'Interface sensor',
				COL_STATE: 'State',
				COL_Z_LAST: 'z last',
				COL_Z_LAST_HINT: 'Distance of the last reading before the alert from the running baseline, in standard deviations',
				COL_Z_DAY: 'z 24 h',
				COL_Z_DAY_HINT: 'Median distance from the running baseline over the last 24 h before the alert, in standard deviations',
				COL_ONSET: 'Departure began',
				NO_READINGS: 'No usable readings before the alert',
				RELIEF: 'Relief headers',
				MORE: 'Show more',
				LESS: 'Show less',
				DUR_MIN: '{{n}} min',
				DUR_H: '{{n}} h',
				DUR_D: '{{n}} days',
				TIMING_BEFORE: 'moved {{t}} before the alert tag',
				TIMING_BEFORE_SHORT: '{{t}} before',
				TIMING_AFTER: 'moved {{t}} after the alert tag',
				TIMING_AFTER_SHORT: '{{t}} after',
				TIMING_TOGETHER: 'moved together with the alert tag',
				TIMING_TOGETHER_SHORT: 'together',
				TIMING_EARLIER: 'began {{t}} before the alert tag — background',
				TIMING_EARLIER_SHORT: '{{t}} earlier · background',
				TIMING_EARLIER_NO_DUR: 'began long before the alert tag — background',
				TIMING_EARLIER_NO_DUR_SHORT: 'long before · background',
				TIMING_HELD: 'held near its baseline',
				TIMING_NO_DATA: 'no usable readings before the alert',
				TIMING_UNCLEAR: 'moved, timing unclear',
			},
			GAPS: {
				TITLE: 'Expected sensors without a tag ({{count}})',
				LINK: 'Expected sensors without a tag ({{count}})',
				LINK_HINT: 'Sensors the machine template expects that have no historian tag',
				EXPLAIN: 'These are sensors the C3 asset template expects for this machine, but they could not be matched to a historian tag id, so no data can be read for them. This list is informational and cannot be edited here.',
				NONE: 'No unmatched sensors.',
				COL_MACHINE: 'Machine',
				COL_SENSOR: 'Expected sensor',
				COL_FAILURE_GROUP: 'Failure group',
				COL_UNIT_TYPE: 'Unit type',
			},
			FLOC: {
				LEVEL_1: 'Asset',
				LEVEL_2: 'Facility',
				LEVEL_3: 'System',
				LEVEL_4: 'Sub-system',
				LEVEL_5: 'Equipment',
				PATH: 'FLOC path',
				LEGEND_TITLE: 'FLOC levels',
				LEGEND_HINT: 'Every location is identified by its SAP functional location (FLOC) code. Levels run from the asset down to the equipment.',
				TREE_FILTER_PLACEHOLDER: 'Find a system or equipment (name or FLOC)…',
				SCOPE_N: '{{count}} FLOCs',
				SCOPE_TIP: 'The queue is filtered to this FLOC and everything below it',
				SCOPE_CLEAR: 'Clear location filter',
				UNPLACED_TIP: 'Alerts with no functional location',
				ALERTS_TOTAL: '{{count}} alerts',
				SOURCE_ASSET_CODE: 'Placed by asset name code',
				SOURCE_WELL: 'Placed by subsea well number',
				SOURCE_TRAIN: 'Placed by train or package code',
				SOURCE_TAG_MAPPING: 'Placed by historian tag mapping',
				EXTRACT_HAD: 'the alert extract had {{floc}}',
			},
			PMAP: {
				KEY_SENSORS: 'Key sensors ({{count}})',
				KEY_SENSORS_HINT: 'The sensors that best describe this unit\'s state',
				TITLE: 'Process view',
				BUTTON: 'Process view',
				OPEN: 'Open the process view',
				OPEN_HINT: 'Plant areas and process units, connected as on the P&IDs',
				BACK: 'Back to queue',
				UNITS_META: '{{units}} process units in {{areas}} areas',
				LAYERS: 'Connection layers',
				SECONDARY: 'Show secondary links ({{count}})',
				RELIEF: 'Relief / flare ({{count}})',
				UTILITY: 'Utilities ({{count}})',
				CONTROL: 'Control signals ({{count}})',
				TARGET_ONLY: 'Target only',
				LEGEND_BACKBONE: 'Process link',
				LEGEND_LINK: 'Secondary link',
				LEGEND_RELIEF: 'Relief / flare',
				LEGEND_UTILITY: 'Utility',
				LEGEND_CONTROL: 'Control signal',
				LEGEND_UP: 'Upstream',
				LEGEND_DOWN: 'Downstream',
				LEGEND_TARGET: 'Holds target FLOCs',
				LEGEND_LOAD: 'Alert load',
				LANE_META: 'Units: {{units}} · Alerts: {{alerts}}',
				LANE_TIP: '{{units}} units, {{alerts}} alerts, {{targets}} units with target FLOCs',
				EXPAND_LANE: 'Expand {{name}}',
				COLLAPSE_LANE: 'Collapse {{name}}',
				LINKS: 'Connections between process units',
				EDGE_ARIA: 'Connection {{from}} to {{to}}, {{medium}}',
				UNIT_ALERTS: '{{total}} alerts ({{scope}} in scope)',
				IN_SCOPE_N: '{{count}} in scope',
				TARGETS_N: '{{count}} target FLOCs',
				SHEET_N: 'sheet {{sheet}}',
				CHIP: 'Process: {{name}}',
				CHIP_HINT: 'Open the process view on this unit',
				UNITS_LABEL: 'Process units',
				N_MORE: '+{{count}} more',
				FROM_TO: '{{from}} → {{to}}',
				MEDIUM: 'Medium',
				CONFIDENCE: 'Confidence',
				CONF_HIGH: 'High',
				CONF_MEDIUM: 'Medium',
				CONF_LOW: 'Low',
				WEAK: 'weak link',
				ONE_END: 'seen on one drawing only',
				TYPE: 'Type',
				LAYER_BACKBONE: 'Process link',
				LAYER_LINK: 'Secondary link',
				LAYER_RELIEF: 'Relief / flare',
				LAYER_UTILITY: 'Utility',
				LAYER_CONTROL: 'Control signal',
				CONNECTORS_N: '{{count}} connectors on the drawings',
				EVIDENCE_LOADING: 'Reading the drawing evidence…',
				PANEL_ARIA: 'Process unit details',
				LOADING: 'Loading…',
				SHOW_ALERTS: 'Show alerts for this unit',
				OPEN_EXPLORER: 'Open in asset explorer',
				ALERTS: 'Alerts',
				NO_ALERTS: 'No alerts',
				DRAWINGS: 'Drawings ({{count}})',
				NO_DRAWINGS: 'No drawing is linked to this unit',
				OPEN_DRAWING: 'Open the P&ID',
				FLOCS: 'FLOCs ({{count}})',
				NO_FLOCS: 'No FLOC is placed on this unit',
				OPEN_NODE: 'Open in asset explorer',
				SHOW_FLOC_ALERTS: 'Show alerts for this FLOC',
				SHARED_FLOCS: 'Shared with other units ({{count}})',
				INBOUND: 'Inbound ({{count}})',
				OUTBOUND: 'Outbound ({{count}})',
				NO_CONNECTIONS: 'No connections found on the drawings',
				SHOW_ALL: 'Show all {{count}}',
				SHOW_FEWER: 'Show fewer',
			},
			SEARCH_ALERTS_PLACEHOLDER: 'Search alert, ID, definition ID, tag, FLOC…',
			CANVAS: {
				CAUSAL: {
					QUERIES: 'Questions ({{n}})',
					COL_HYPOTHESIS: 'Hypothesis',
					COL_FACET: 'Facet',
					COL_QUERY: 'Question',
					COL_ADMITTED: 'Admitted',
					NOTHING: 'nothing admitted',
					ADMITTED: 'Admitted excerpts ({{n}})',
					EXCERPTS_FROM_TRACE: 'Excerpts shown from the step trace (first six); rejected hits appear once the run document has loaded.',
					REJECTED: 'Rejected hits ({{n}})',
					NONE_REJECTED: 'No hit was rejected.',
					FACET_DESIGN_BASIS: 'Design basis / envelope',
					FACET_ORIGINATING_CHANGE: 'Originating change',
					FACET_MECHANISM_SENSITIVITY: 'Mechanism sensitivity',
					FACET_PROTECTION_DETECTION: 'Protection / detection',
					FACET_SYMPTOM_DIAGNOSTIC: 'Symptom / diagnostic',
					FACET_CORRECTIVE_ACTION: 'Corrective action',
				},
				TIER: {
					STAGE_QUICK: 'Stage 1 · Quick triage (mini-agent)',
					STAGE_DEEP: 'Stage 2 · Deep investigation',
					QUICK_ANSWER: 'Quick answer',
					FINAL_ANSWER: 'Final answer',
					OUTCOME: 'Outcome',
					ACCEPTED: 'Accepted',
					ESCALATED: 'Escalated',
					ROUTE_ACCEPTED: 'Accepted → Outcome',
					ROUTE_ESCALATED: 'Escalated → Stage 2',
					NO_GATE: 'Not gated (quick-only run)',
					DECIDING: 'Checking the quick answer…',
					WAITING: 'Waits for the quick answer',
					NOT_NEEDED: 'Not needed — the quick answer passed the gate, so the deep investigation\'s time and tokens were saved.',
					NOT_RUN: 'Not run — this run was quick triage only.',
					WOULD_HAVE_RUN: 'Would have run',
					DEEP_SPECIALISTS: 'Slow specialists',
					SKIP_VERDICTS: 'Verdicts re-check',
					SKIP_ADJUDICATION: 'Completeness check and second adjudication',
					CHECK_NO_ACTION: 'No-action answer',
					CHECK_CONFIDENCE: 'Confidence',
					CHECK_NOT_CAPPED: 'Not capped',
					CHECK_MODEL: 'Model answered',
					CHECK_NO_REAL_EVENT: 'No real-event verdict',
					CEILING: 'ceiling {{pct}}',
					RULE_FALLBACK: 'rule fallback',
					QUICK_NODE_NOTE: 'Stage 1 · quick triage: this is the mini-agent\'s pass, before the gate.',
					ESCALATED_NOTE: 'Escalated: at least one check failed, so the deep investigation ran.',
					ACCEPTED_NOTE: 'Accepted: every check passed; the quick answer is the outcome.',
					CHECKS: 'Gate checks',
					COL_CHECK: 'Check',
					COL_VALUE: 'Value',
					COL_THRESHOLD: 'Threshold',
					COL_RESULT: 'Result',
					PASSED: 'Passed',
					FAILED: 'Failed',
					REASONS: 'Why it escalated',
					QUICK_VS_FINAL: 'Quick vs final answer',
				},
				TITLE: 'Run canvas',
				OPEN: 'Open canvas',
				OPEN_HINT: 'Follow the run step by step: every agent, model call and look-up',
				BACK: 'Back to alert',
				RUN_PICKER: 'Run',
				RUN_PICKER_EMPTY: 'No runs yet',
				LIVE: 'Live',
				LIVE_HINT: 'Following the run as it happens (refreshes every 1.5 s)',
				ELAPSED: 'Elapsed',
				DURATION: 'Duration',
				TOKENS: '{{input}} in / {{output}} out tokens',
				EVALUATION: 'Evaluation',
				EVENTS_N: '{{count}} events',
				EVENTS_HINT: '{{llm}} model calls · {{lookups}} look-ups',
				ZOOM_FIT: 'Fit to width',
				ZOOM_100: 'Actual size',
				POLL_ERROR: 'Could not fetch new events: {{error}} — retrying',
				LOADING: 'Loading the run…',
				NO_RUNS: 'This alert has no runs yet',
				NO_EVENTS: 'No events were recorded for this run (it predates the run canvas)',
				PICK_NODE: 'Select a node to see what it received and produced',
				IN_PROGRESS: 'The Triage Agent is running. The run continues even if you leave this page.',
				STALLED_NOTICE: 'Lost contact with the run; its result will appear once the page is refreshed.',
				RECONSTRUCTED: 'Reconstructed from the run\'s saved trace: this run predates the event stream, so inputs, outputs, model calls and look-ups are not available.',
				PASS_N: 'Pass {{n}}',
				ROUND_N: 'Round {{n}}',
				STATUS: {
					RUNNING: 'Running',
					COMPLETED: 'Completed',
					FAILED: 'Failed',
					GATED: 'Not analysed',
					PENDING: 'Pending',
					NO_DATA: 'No data',
					SKIPPED: 'Skipped',
					STALLED: 'Connection lost',
				},
				COL: {
					PRE_RUN: 'Pre-run',
					RESOLVE: 'Resolve & signal',
					SPECIALISTS: 'Specialists',
					VERDICTS: 'Verdicts',
					LOOP: 'Reasoning loop',
					DECISION: 'Decision',
				},
				NODE: {
					LIBRARY_CAUSAL: 'Library · causal grounding',
					ESCALATION: 'Escalation gate',
					LIBRARY: 'Library specialist',
					CONNECTED: 'Connected Systems',
					GATE: 'DQ gate',
					TOPOLOGY: 'Topology',
					EVIDENCE: 'Evidence',
					VIEW: 'As-of view',
					FINAL: 'Outcome',
					RESOLVER: 'Resolver',
					SIGNAL: 'Signal',
					COHORT: 'Cohort',
					MAINTENANCE: 'Maintenance',
					MANUAL_PRECEDENT: 'Alert precedent',
					LEARNINGS: 'Learnings',
					PROFILE: 'Profile',
					MULTIVARIATE: 'Multivariate',
					TMP: 'TMP',
					SHIFT_DPR: 'Shift & DPR',
					VISUAL: 'Visual analyst',
					VERDICTS: 'Verdicts',
					HYPOTHESIZE: 'Hypothesize',
					INVESTIGATE: 'Investigate',
					COMPLETENESS: 'Completeness',
					ADJUDICATOR: 'Adjudicator',
					SUPERVISOR: 'Supervisor',
				},
				BADGE: {
					CAUSAL_N: '{{admitted}} excerpts · {{queries}} questions',
					HEADROOM: '{{kind}} {{value}} · {{pct}}%',
					LIBRARY_N: '{{n}} excerpts · {{docs}} docs',
					LIBRARY_LIMITS: '{{n}} excerpts · {{limits}} stated limits',
					GATE_PASS: 'Pass',
					GATE_FAIL: 'Fail',
					TAGS_N: '{{count}} tags',
					RECORDS_N: '{{count}} records',
					WITHHELD_N: '{{count}} withheld',
					RESOLVED: 'Resolved',
					NOT_RESOLVED: 'Not resolved',
					ALERTS_N: '{{count}} alerts',
					FACTS_N: '{{count}} facts',
					PRIOR_N: '{{count}} prior',
					LEARNINGS_N: '{{count}} learnings',
					LOADED: 'Loaded',
					NONE: 'None',
					MOVED_N: '{{moved}} of {{of}} moved',
					VERDICTS_N: '{{count}} verdicts',
					LOOKUPS_N: '{{count}} look-ups',
					CHECKS_N: '{{ran}} of {{of}} checks',
					SPECIALISTS_N: '{{n}} of {{of}} specialists',
				},
				BATCH_BADGE: 'Batch of {{count}} alerts on {{floc}}',
				BATCH_HINT: 'Triaged together as one episode: {{ids}}',
				REASSESS_BADGE: 'Re-assessment as of {{t}}',
				REASSESS_HINT: 'Earlier assessment: {{cls}}',
				ZONE: {
					EVIDENCE: 'Evidence gathering',
					PARALLEL: 'in parallel',
					LOOP: 'Reasoning loop',
					DECISION: 'Decision',
				},
				LOOP: {
					CAUSAL_HINT: 'After the first board pass the Library asks each hypothesis\'s engineering questions (design basis, change, sensitivity, protection, diagnostics, corrective action) and admits only excerpts about this instrument or equipment as LIB-n evidence',
					BOARD: 'Hypothesis Board',
					INVESTIGATOR: 'Investigator',
					ROUND_OF: 'Round {{n}} of max {{max}}',
					HINT: 'the board proposes and asks, the Investigator looks up, the board re-weighs',
					ROUNDS_USED: '{{n}} of max {{max}} rounds',
					REQUESTS_N: '{{count}} requests',
					REWEIGH: 'results → re-weigh',
					LEAD_HINT: 'Leading hypothesis, its weight and the change since the previous pass',
					WEIGHING: 'Weighing hypotheses…',
					NEXT_PASS: 'Next pass: re-weighing',
					CALL_NO_HINT: 'Call {{n}} of {{tool}} in this run',
					CITED_HINT: 'Cited by the next pass: {{hyps}}',
					REPEAT_OF: 'same as round {{n}}',
					CALLING: 'Running look-ups…',
					MOVED: 'Pass {{n}}:',
					MOVED_HINT: 'How the board moved after reading this round\'s results',
					SETTLED_FIRST: 'Settled on pass {{n}}: no look-ups needed',
					SETTLED_AT: 'Settled on pass {{n}}: no more look-ups needed',
					BUDGET_SPENT: 'Round budget spent ({{max}} of {{max}})',
					SHELF: 'Tool shelf',
					SHELF_HINT: 'the Investigator may call any tool, as often as needed, with different arguments',
					UNUSED: 'not used in this run',
				},
				TOOL: {
					SEARCH_LIBRARY: 'Search library',
					SEARCH_LEARNINGS: 'Search learnings',
					CONNECTED_EQUIPMENT: 'Connected equipment',
					UNIT_SENSORS: 'Unit sensors',
					FIND_SENSORS: 'Find sensors',
					PARALLEL_SYSTEMS: 'Parallel systems',
					SISTER_TRAIN: 'Sister train',
					UNIT_ALERTS: 'Unit alerts',
					TAG_WINDOW: 'Tag window',
					TAG_HISTORY: 'Tag history',
					SEARCH_RECORDS: 'Search records',
					SEARCH_REPORTS: 'Search reports',
				},
				TOOL_HINT: {
					SEARCH_LEARNINGS: 'Learnings and site playbook rules in effect at the alert time, ranked by meaning against a question.',
					CONNECTED_EQUIPMENT: 'Upstream, downstream or sibling process units (from the flow-scheme connectors), their interface sensors, and whether they moved before, with or after the alert tag.',
					UNIT_SENSORS: 'How one named process unit behaved, sensor by sensor, for the requested measures.',
					FIND_SENSORS: 'Which sensors exist for a question and what each one measures.',
					PARALLEL_SYSTEMS: 'The twin train (FGC A ↔ B, GLC A ↔ B …): its sensors and alerts in the same hours — common cause or local?',
					SISTER_TRAIN: 'The other train or the redundant probe of the same loop: common cause or local?',
					UNIT_ALERTS: 'Surveillance alerts raised on a unit (upstream, downstream, twin) in the hours before the alert.',
					TAG_WINDOW: 'Statistics of any tag over the last N hours before the alert.',
					TAG_HISTORY: 'How often a tag left its band over up to 180 days, and whether work followed.',
					SEARCH_RECORDS: 'Search of SAP notifications and work orders (1 year) and shift reports (6 months), by meaning and words.',
					SEARCH_REPORTS: 'Supervisor and production reports up to a year back, by meaning and words; passages returned.',
				},
				CALL: {
					NTH: 'Call #{{n}} of {{tool}} in this run',
					ARGS: 'Arguments',
					NO_ARGS: 'No arguments',
					REPEAT_NOTE: 'Identical to the request in round {{n}}: not re-run, the earlier result was carried over.',
					CITED: 'Cited by pass {{n}}',
					CALLS_N: '{{count}} calls',
					ROUNDS_LIST: 'rounds {{rounds}}',
					NOT_USED: 'The Investigator did not use this tool in this run.',
					GROUPED: '{{count}} look-ups · tools used: {{tools}}',
					CARRIED: '{{count}} observations from earlier rounds carried',
				},
				EVO: {
					TITLE: 'How evidence moved belief: hypothesis weight per pass',
					HYPOTHESIS: 'Hypothesis',
					AFTER_N: 'after round {{n}} · {{count}} look-ups',
					NOT_ON_BOARD: 'Not on the board in this pass',
					AFTER_ROUND: 'after round {{n}} ({{count}} look-ups)',
					CITES: 'new evidence cites {{calls}}',
					MOVE_AFTER: 'After round {{n}}:',
					PRECEDED_BY: 'look-ups that preceded it:',
				},
				INSPECTOR: {
					TAB_INPUT: 'Input',
					TAB_OUTPUT: 'Output',
					TAB_MODEL_CALLS: 'Model calls',
					TAB_LOOKUPS: 'Look-ups',
					TAB_TRACE: 'Trace',
					EMPTY: 'empty',
					NOT_STARTED: 'This step has not started yet',
					NO_INPUT: 'No input was recorded for this step',
					STILL_RUNNING: 'Still running — the output appears when the step completes',
					NO_OUTPUT: 'No output was recorded',
					HYPOTHESES_N: '{{count}} hypotheses',
					REQUESTS: 'Look-ups requested',
					WINDOWS: 'Per-window readings',
					LEAK_CHECK: 'Leak check: {{value}}',
					MACHINE_STATE: 'Machine state',
					PACKAGE_TEXT: 'Signal package as the model reads it',
					ANOMALY_TEXT: 'Anomaly model text',
					NO_LOOKUPS: 'No look-ups in this step',
					RAW: 'All output as data',
					NO_MODEL_CALLS: 'No model calls in this step',
					ATTEMPT_N: 'Attempt {{n}}',
					PROMPT: 'Prompt',
					PROMPT_SIZE: '{{chars}} characters, {{images}} images',
					IMAGE_PART: 'image ({{kb}} KB)',
					RESPONSE: 'Response',
					NO_TRACE: 'No trace line for this node',
				},
			},
			VALIDATION: {
				COLUMN: 'Validated',
				FILTER: 'Validation',
				HUMAN: 'Human',
				AGENT: 'Agent',
				NONE: 'Not triaged',
				HUMAN_VALIDATED: 'Human validated',
				HUMAN_CORRECTED: 'Human corrected',
				AGENT_VALIDATED: 'Agent validated',
				TIP_AGENT: 'Triaged by the agent; no person has reviewed it yet',
				TIP_HUMAN_UNKNOWN: 'Validated by a person',
				TIP_REPLAY: 'HIL label replayed by {{reviewer}} on {{date}}',
				TIP_UI: 'Reviewed in UptimeAI by {{reviewer}} on {{date}}',
				TIP_CORRECTED: 'Human corrected the agent: {{agent}} → {{human}}',
				TIP_ABSTAINED: 'Agent left it for human review; human classified it {{human}}',
				TIP_AGREED: 'Human agreed with the agent: {{human}}',
				CSV: {
					VALIDATED_BY: 'Validated by',
					REVIEWER: 'Reviewer',
					REVIEW_SOURCE: 'Review source',
				},
			},
			REVIEW: {
				TITLE: 'SME review',
				SOURCE_REPLAY: 'HIL label (replayed)',
				SOURCE_UI: 'Reviewed in UptimeAI',
				BY: '{{reviewer}} · {{date}}',
				N_REVIEWS: '{{count}} reviews',
				LABEL: 'Label',
				RELIABILITY: 'Reliability: {{value}}',
				RELIABILITY_HIGH: 'high',
				RELIABILITY_MEDIUM: 'medium',
				RELIABILITY_LOW: 'low',
				RELIABILITY_HINT: 'How far the label can be trusted as ground truth — human labels are fallible',
				ACTION_TAKEN: 'Action taken',
				NO_LABEL: 'No label recorded',
				AGENT_VS_HUMAN: 'Agent vs human',
				AGREEMENT_AGREE: 'Agree',
				AGREEMENT_DISAGREE: 'Disagree',
				AGREEMENT_ABSTAINED: 'Abstained',
				AGENT_CONFIDENCE: 'Agent confidence {{value}}',
				OUTCOMES: 'SAP notifications in the 30 days after (hindsight)',
				REASONS: 'Reasons',
				AGENT_SAW_CHART: 'Agent’s chart judgement',
				AGENT_SAW_STATE: 'Machine state at the time',
				LEARNINGS_CHANGED: 'Learnings changed by this review ({{count}})',
				EARLIER: 'Earlier reviews',
				VERDICT: {
					CONFIRMED: 'Confirmed',
					CONFIRMED_HINT: 'Agent and human chose the same class.',
					AGENT_WRONG: 'Agent wrong',
					AGENT_WRONG_HINT: 'The reviewer’s class stands over the agent’s; the agent was corrected.',
					AGENT_ABSTAINED: 'Agent abstained',
					AGENT_ABSTAINED_HINT: 'The agent left it for human review; the human label sets the class.',
					HUMAN_LIKELY_WRONG: 'Human likely wrong',
					HUMAN_LIKELY_WRONG_HINT: 'Labelled no action, but SAP notifications followed on this equipment within 30 days; kept out of memory.',
					CONTESTED: 'Contested',
					CONTESTED_HINT: 'Agent and human disagree and the follow-up evidence does not settle it.',
					HUMAN_OVERRIDE: 'Human override',
					HUMAN_OVERRIDE_HINT: 'A person in UptimeAI chose a different class than the agent; their call stands.',
				},
			},
			MEMORY: {
				SIMILAR: 'similar {{sim}}',
				SIMILAR_HINT: 'Not in this alert’s own scope: added because its meaning is close to the alert (similarity 0–1)',
				PROFILE: 'Detector profile',
				TITLE: 'Operational memory used',
				CHIP: 'Memory: {{learnings}} learnings, {{precedents}} reviewed precedents',
				CHIP_HINT: 'Learnings and human-reviewed precedents known before this alert that the agent consulted',
				NO_LEARNINGS: 'No learning applied',
				PRECEDENTS: '{{count}} reviewed precedents',
				SHOW_TRACE: 'Show in trace',
			},
			LEARNINGS: {
				STATUS_RETIRED: 'Retired',
				SCOPE_PLAYBOOK: 'Site playbook',
				SCOPE_PROFILE: 'Detector profile',
				ALL_SCOPES: 'All scope types',
				MEANING_PLACEHOLDER: 'Search by meaning, e.g. bearing temperature after restart',
				MEANING_SEARCH: 'Search',
				MEANING_HINT: 'Ranks the current learnings by how close their meaning is to your words (embeddings), not by exact words. Press Enter to search; clear the box to list all.',
				RANKED_BY: 'Ranked by meaning: “{{q}}”',
				COL_SIMILARITY: 'Similarity',
				SIMILARITY_HINT: 'Cosine similarity of meaning (0–1); above about 0.8 is a close match',
				COL_LEARNING: 'Learning',
				COL_EDITED: 'Edited by',
				EDITED_BY: 'Edited by {{name}}',
				EDIT_REASON: 'Reason: {{reason}}',
				NO_DISPOSITION: 'none (context)',
				N_ALERTS: '{{count}} alerts',
				NO_MATCH: 'Nothing close in meaning',
				NO_MATCH_HINT: 'Try other words, or clear the search to list every learning.',
				BUTTON: 'Learnings',
				BUTTON_HINT: 'Learnings & operational memory from human reviews',
				TITLE: 'Learnings & Operational Memory',
				SUBTITLE: 'Rules distilled from human reviews of comparable alerts; the agent consults only those known before each alert',
				REFRESH: 'Refresh',
				STAT_REVIEWS: 'Human reviews',
				STAT_REPLAYED: '{{count}} HIL labels replayed',
				STAT_IN_APP: '{{count}} in UptimeAI',
				STAT_AGREEMENT: 'Agent vs human',
				STAT_RECONCILIATION: 'Reconciliation',
				STAT_LEARNINGS: 'Learnings',
				STATUS_ACTIVE: 'Active',
				STATUS_CANDIDATE: 'Candidate',
				STATUS_CONTESTED: 'Contested',
				SCOPE_SIGNAL: 'Signal',
				SCOPE_EQUIPMENT: 'Equipment + detector',
				SCOPE_DETECTOR: 'Detector',
				SEARCH: 'Search scope, detector or rule',
				N_SHOWN: '{{shown}} of {{total}}',
				EMPTY: 'No learnings yet',
				EMPTY_HINT: 'Learnings appear once people review triaged alerts.',
				COL_SCOPE: 'Scope',
				COL_SCOPE_TYPE: 'Scope type',
				COL_DISPOSITION: 'Disposition',
				COL_SUPPORT: 'Support',
				COL_SUPPORT_HINT: 'Reviews agreeing with the disposition / reviews in scope · consistency',
				COL_STATUS: 'Status',
				COL_EFFECTIVE: 'Effective from',
				COL_CORRECTED: 'Agent corrected',
				COL_CORRECTED_HINT: 'Reviews in which the person corrected the agent',
				COL_VERSION: 'Version',
				RULE: 'Operational rule',
				AUTHOR: 'Author: {{author}}',
				CLASS_COUNTS: 'Human classes',
				REASONS: 'Reasons',
				CHART_PATTERNS: 'Chart patterns',
				MACHINE_STATES: 'Machine states',
				SOURCE_ALERTS: 'Source alerts ({{count}})',
				OPEN_ALERT: 'Open alert',
				VERSIONS: 'Version history',
				SUPERSEDED: 'Superseded',
				CURRENT: 'Current',
			},
			PROCESS: {
				TITLE: 'Process topology & hierarchy',
				FLOW_SUMMARY: '{{up}} upstream · {{down}} downstream',
				FLOW_SUMMARY_UNITS: '{{up}} upstream · {{down}} downstream (process units)',
				PROCESS_UNITS: 'Process units (PEFS)',
				NO_PID_LINE: 'No line traced on the digitised P&IDs; links from the flow-scheme connectors',
				IN_UNIT: 'Process unit: {{name}}',
				SERVING: 'Serving utilities',
				RELIEF: 'Relief',
				UNIT_TIP: '{{hops}} hop(s) · {{media}} · confidence {{confidence}}',
				SOURCE_PID: 'Equipment flow from the digitised P&IDs (lines traced on one drawing).',
				SOURCE_BOTH: 'Equipment flow from the digitised P&IDs (one drawing at a time); process units from the PEFS off-page connectors, the same view the Connected systems analysis reads.',
				HIERARCHY: 'Asset hierarchy',
				LEVEL_SITE: 'Site',
				LEVEL_SYSTEM: 'System',
				LEVEL_SUBSYSTEM: 'Sub-system',
				LEVEL_EQUIPMENT: 'Equipment',
				LEVEL_PACKAGE: 'Package',
				LEVEL_OTHER: 'Level',
				NOT_IN_TREE: 'Not in the asset tree',
				NOT_IN_TREE_HINT: 'The alert equipment has no functional location in the SAP asset tree.',
				PARTIAL_TREE: 'Only part of the path could be placed in the asset tree.',
				SIBLINGS: '{{count}} other equipment in {{parent}}',
				SHOW_ALL: 'Show all {{count}}',
				SHOW_FEWER: 'Show fewer',
				N_TAGS: '{{count}} tags',
				NO_TREE_TAGS: 'No historian tags placed on this node',
				FLOW: 'Process flow',
				UPSTREAM: 'Upstream',
				DOWNSTREAM: 'Downstream',
				ALERT_EQUIPMENT: 'Alert equipment',
				MEASURED_BY: 'Alert instrument',
				HOPS: '{{count}} hop(s) away',
				NONE_UPSTREAM: 'Nothing upstream',
				NONE_DOWNSTREAM: 'Nothing downstream',
				NO_FLOW: 'No process-flow links for this equipment in the digitized P&IDs',
				NOT_IN_PIDS: 'Equipment not found in the digitized P&IDs',
				NOT_IN_PIDS_HINT: 'Upstream and downstream items cannot be shown without a P&ID match for the alert equipment.',
				CONNECTED: 'Connected items',
				NO_CONNECTED: 'No other items are connected to this equipment in the digitized P&IDs.',
				EDGE_SERVES: 'Serves',
				EDGE_SENSES: 'Senses',
				EDGE_CONTROLS: 'Controls',
				EDGE_PROTECTS: 'Protects',
				EDGE_SAME_LINE: 'Same process line',
				EDGE_MEASURES: 'Measures',
				EDGE_FLOWS_TO: 'Flows to',
				EDGE_OTHER: 'Other links',
				CHART_TAGS: 'Chart this item\'s tags in the Tags tab',
				NO_TAGS_FOR_ITEM: 'No historian tags are linked to this item',
				NO_DATA_TAGS: 'The asset tree places no tags on this item',
				TAGS_FAILED: 'Could not load the tags of this item',
				FROM_TREE: 'Tag count from the asset tree',
				CLICK_HINT: 'Click an item to chart its historian tags (up to 8, tags with data first).',
			},
			ANALYSIS: {
				FOUND_BY_MEANING: 'found by meaning',
				FOUND_BY_MEANING_SIM: 'found by meaning · {{sim}}',
				FOUND_BY_MEANING_HINT: 'Hybrid search: records are found by their words and by their meaning (embeddings). This one was added by the meaning search from the same sub-system; the number is its similarity to the alert (0–1).',
				LEVEL_SHIFTS: 'Level shifts',
				LEVEL_SHIFTS_HINT: 'Points before the cut-off where a modelled tag stepped to a new level and stayed there (size in baseline standard deviations, mean before → after).',
				MODEL_CACHED: 'model reused (trained once per machine per day)',
				MODEL_CACHED_HINT: 'The same machine already had a model trained for this day, on data that all ends before this cut-off; it was reused instead of retrained.',
				REGIMES: 'Fitted per operating regime of {{tag}}: {{parts}} ({{sep}} sd apart)',
				REGIMES_HINT: 'The run tag showed two distinct operating levels (share of time @ level), so normal was learned separately for each.',
				TRAINED_ON: 'Trained on {{from}} – {{to}}',
				WINDOW_3M: '3 months',
				WINDOW_1W: '1 week',
				WINDOW_1D: '1 day',
				REASONING: 'Reasoning',
				SETTLED: 'Settled',
				UNSETTLED: 'Unsettled',
				SETTLED_HINT: 'The hypothesis board stopped because no further look-up could change the leading hypothesis',
				UNSETTLED_HINT: 'The board stopped at its pass limit with look-ups still requested',
				BOARD_META: '{{passes}} passes · {{lookups}} look-ups',
				HYPOTHESES: 'Hypotheses',
				WEIGHT_HINT: 'Weight of this hypothesis on the board (all hypotheses sum to 100%)',
				IMPLIES_HINT: 'Classification this hypothesis implies if it holds',
				STATUS_VALIDATED: 'Validated',
				STATUS_REFINED: 'Refined',
				STATUS_DEBUNKED: 'Debunked',
				STATUS_OPEN: 'Open',
				FOR: 'For',
				AGAINST: 'Against',
				NONE: 'None',
				CONFLICTS: 'Conflicts',
				LOOKUPS: 'Investigator look-ups',
				ROUND_N: 'Round {{n}}',
				ROUND_OTHER: 'Other look-ups',
				WHY_ASKED: 'Why asked:',
				RESULT: 'Result',
				SIGNAL_TITLE: 'Signal & machine',
				N_TAGS: '{{n}} tags',
				RUNNING_AT_CUTOFF: 'Running at cut-off',
				STOPPED_AT_CUTOFF: 'Stopped at cut-off',
				SINCE_RESTART: 'Since restart',
				SINCE_STOP: 'Since stop',
				HOURS: '{{n}} h',
				LAST_SHUTDOWN: 'Last shutdown',
				ONGOING: 'ongoing',
				RUN_SOURCE: 'Run state: {{source}} ({{tag}})',
				RUNNING_PCT_HINT: 'Share of the window the machine was running (green) vs stopped (red)',
				RUNNING: 'running',
				SHUTDOWNS: 'shutdowns',
				DOWN: 'down',
				MACHINE_UNKNOWN: 'Machine run state unknown: no run-status tag for this equipment.',
				CHARTS_READ: 'Charts read by the model',
				ANOMALY_SCORE: 'Anomaly score',
				ENLARGE: 'Click to enlarge',
				READ_ALERT_TAG: 'Alert tag',
				READ_RELATED: 'Related tags',
				READ_MACHINE: 'Machine',
				READ_ANOMALY: 'Model reading',
				CONSISTENT_WITH_HISTORY: 'Consistent with history',
				NOT_CONSISTENT_WITH_HISTORY: 'Not consistent with history',
				STATS_TITLE: 'Statistics vs baseline',
				STATS_HINT: '— hover a cell for p5–p95, slope and first 3 sd excursion',
				COL_TAG: 'Tag',
				COL_MEDIAN: 'Median',
				COL_LAST: 'Last',
				COL_Z: 'z (med)',
				COL_Z_HINT: 'Window median in baseline standard deviations',
				COL_OUT: '% out',
				COL_OUT_HINT: 'Share of readings outside the baseline p5–p95 band',
				ALERT_TAG: 'alert',
				RUN_TAG: 'run',
				TIP_BASELINE: 'Baseline: median {{median}} ± {{sd}} sd, p5–p95 {{p5}}–{{p95}} {{unit}}',
				TIP_SPIKES: 'Spikes removed: {{value}}',
				TIP_MASKED: 'Fault readings masked: {{n}}',
				TIP_RANGE: 'p5–p95: {{p5}} – {{p95}} {{unit}}',
				TIP_SLOPE: 'Slope: {{value}} {{unit}}/day',
				TIP_Z_LAST: 'z (last): {{value}} · max |z|: {{max}}',
				TIP_FIRST_3SD: 'First beyond 3 sd: {{value}} UTC',
				TIP_NEVER_3SD: 'Never beyond 3 sd in this window',
				FOOT_SPIKES: 'Isolated spikes removed before the statistics: {{value}}.',
				FOOT_MASKED: '{{n}} fault readings (bad quality / out of range) masked.',
				ANOMALY_TITLE: 'Anomaly model',
				NOT_AVAILABLE: 'Not available',
				VERDICT_CONSISTENT: 'Consistent',
				VERDICT_CHANGED: 'Changed',
				VERDICT_STARTUP: 'Start-up transient',
				VERDICT_INSUFFICIENT: 'Insufficient data',
				MODEL_META: 'PCA {{k}} comp. · {{pct}} variance · {{rows}} training rows',
				ONSET: 'Sustained onset',
				NO_ONSET: 'none',
				FIRST_TO_DEVIATE: 'First tag to deviate',
				ABOVE_LIMIT_24H: 'Last 24 h above limit',
				T2_SPE_HINT: 'Scores are relative to the training 99.5th percentile (1.0 = limit). T² high = the tags moved together to an unusual operating point; SPE high = a tag no longer agrees with the others (local fault or instrument); AE = autoencoder reconstruction error.',
				AT_CUTOFF: 'At cut-off',
				AT_PEAK: 'Peak of last 24 h',
				IN_TRANSIENT: 'Inside start-up transient',
				SCORE: 'Score',
				KIND_NORMAL: 'Within normal',
				KIND_SPE: 'Relationship broken (SPE): a tag no longer agrees with the others',
				KIND_T2: 'Operating point moved (T²): tags moved together, relationships kept',
				KIND_BOTH: 'Unusual operating point and broken relationships',
				ACTUAL_VS_EXPECTED: 'Actual vs expected from the other tags',
				NOT_MODELLED: 'Not modelled (too little running history): {{tags}}',
				RECORDS_TITLE: 'Records read',
				OPEN_KNOWN_ISSUE: 'Open known issue',
				NO_OPEN_KNOWN_ISSUE: 'No open known issue',
				OPEN_KNOWN_ISSUE_HINT: 'Whether an open notification or work order already covers this condition at the alert time',
				RECORDS_COUNT: '{{read}} of {{total}} records read · {{cited}} cited',
				RECORDS_COUNT_HINT: 'Records on file before the alert: {{work}} maintenance, {{reports}} shift reports, {{deferments}} deferments; the top-ranked were read',
				OPERATING_EVENTS: 'Operating events before the alert',
				FACTS: 'Facts cited',
				NO_FACTS: 'No record bears on this alert.',
				RELEVANCE_DIRECT: 'Direct',
				RELEVANCE_RELATED: 'Related',
				RELEVANCE_BACKGROUND: 'Background',
				IMPL_KNOWN_ISSUE: 'Known issue open',
				IMPL_RECENT_WORK: 'Recent work explains',
				IMPL_OPERATING_EVENT: 'Operating event',
				IMPL_INSTRUMENT: 'Instrument issue',
				IMPL_DEGRADATION: 'Degradation signal',
				DIR_NO_ACTION: 'For no action',
				DIR_SERVICE: 'For service',
				DIR_NEUTRAL: 'Neutral',
				OPEN_IN_MAINTENANCE: 'Show in the Maintenance tab',
				OPEN_IN_REPORTS: 'Show in the Reports tab',
				DROPPED: '{{n}} read but not relevant: {{ids}}',
			},
			VISUAL: {
				TITLE: 'Chart review',
				PATTERN_TOGETHER: 'Tags moved together',
				PATTERN_DEPARTED: 'One tag departed alone',
				PATTERN_SHUTDOWN: 'Shutdown / startup',
				PATTERN_NO_CHANGE: 'No significant change',
				PATTERN_SPLIT: 'Related tags split',
				PATTERN_INSUFFICIENT: 'Too sparse to judge',
				PATTERN_UNKNOWN: 'Unclassified',
				CONFIDENCE: '{{value}} confidence',
				CONFIDENCE_HINT: 'Confidence of the final judgement',
				MOVED_TOGETHER_YES: 'Moved together',
				MOVED_TOGETHER_NO: 'Did not move together',
				DISAGREE: 'Statistics and charts disagree — review the charts before relying on this judgement.',
				AGREE: 'Charts agree with the statistics',
				STATISTICS_SAY: 'Statistics say',
				CHARTS_SAY: 'Charts say',
				LED_BY: 'Led by',
				LED_BY_HINT: 'The tag that moved first',
				DEPARTED_ALONE: 'Departed alone',
				DEPARTED_ALONE_HINT: 'The tag that moved while its related tags held',
				REASONING: 'Reasoning',
				CHARTS: 'Charts read by the model ({{count}})',
				NO_CHARTS: 'No chart images were stored for this run.',
				OPEN_CHART: 'Open chart {{n}}',
				CHART_ALT: 'Chart {{n}} up to the alert time',
				CHART_FAILED: 'Chart image could not be loaded',
				CHART_N_OF: 'Chart {{n}} of {{total}}',
				CHART_DIALOG_HINT: 'Charts end just before the alert time. Use ← / → to browse.',
				PREV_CHART: 'Previous chart',
				NEXT_CHART: 'Next chart',
				REVIEWS: 'Per-tag reviews ({{count}})',
				LEVEL: 'Level: {{value}}',
				FLUCTUATION: 'Fluctuation: {{value}}',
				MODEL: 'Reviewed by {{model}}',
			},
			CONTEXT: {
				MODE_PID: 'P&ID',
				MODE_GRAPH: 'Context graph',
				CHOOSE_DRAWING: 'Choose drawing',
				ITEMS_COUNT: '{{count}} highlighted',
				HAS_INSTRUMENT: 'alert instrument',
				HAS_EQUIPMENT: 'alert equipment',
				TITLE_INSTRUMENT: 'Highlighted instrument location for {{tag}}',
				TITLE_EQUIPMENT: 'Highlighted equipment location for {{tag}}',
				LOADING: 'Loading process context…',
				LOAD_FAILED: 'Could not load the process context for this alert.',
				UNRESOLVED: 'The alert’s equipment and instrument are not in the knowledge graph',
				UNRESOLVED_HINT: 'No P&ID location or connected assets can be shown.',
				NO_DRAWING: 'No digitized P&ID shows this equipment',
				NO_DRAWING_HINT: 'Use the context graph to see connected assets.',
				SAME_LINE: 'On the same line',
				SAME_LINE_EMPTY: 'No items on the same process line.',
				CONNECTED_ON_DRAWING: 'Connected on the drawing',
				CONNECTED_EMPTY: 'No connected items on this drawing.',
				CONNECTED_ELSEWHERE: 'Connected, not on this drawing',
				LOCATE: 'Show on the drawing',
				ADD_TO_CHART: 'Add {{tag}} to the charts',
				NOT_LINKED: 'not linked',
				GRAPH_EMPTY: 'No connected assets found for this alert.',
				GRAPH_HINT: 'Size = tag count · click a node with a historian tag to chart it',
				ROLE: {
					ALERT_EQUIPMENT: 'Alert equipment',
					ALERT_INSTRUMENT: 'Alert instrument',
					CONNECTED: 'Connected',
					SAME_LINE: 'Same process line',
					OTHER: 'Other',
				},
				EDGE: {
					FLOWS_TO: 'Flows to',
					SERVES: 'Serves',
					SENSES: 'Senses',
					CONTROLS: 'Controls',
					PROTECTS: 'Protects',
					SAME_LINE: 'Same line',
					MEASURES: 'Measures',
					RELATED: 'Related',
				},
				NODE_TYPE: {
					EQUIPMENT: 'Equipment',
					INSTRUMENT: 'Instrument',
					CONTROLVALVE: 'Control valve',
					PROCESSLINE: 'Process line',
				},
				TOOLTIP: {
					TAG: 'Tag',
					HISTORIAN_TAG: 'Historian tag',
					TYPE: 'Type',
					ROLE: 'Role',
					TAG_COUNT: 'Historian tags',
					LINE: 'Line',
					DRAWING: 'Drawing',
				},
			},
			PAGE_TITLE: 'Alerts',
			ENTERPRISE: 'Shell',
			SEARCH_PLACEHOLDER: 'Search...',
			SEARCH_OWNER: 'Search owner...',
			OWNER_FILTER: 'Filter by owner',
			CHOOSE_STATUSES: 'Choose statuses to display',
			ALL_STATUSES: 'All Statuses',
			FILTERS: 'Filters',
			MORE: 'More',
			WATCHERS: 'Watchers',
			COLLAPSE_PANEL: 'Collapse panel',
			EXPAND_PANEL: 'Expand panel',
			RETRY: 'Retry',
			CLOSE: 'Close',
			PREVIOUS: 'Previous alert',
			NEXT: 'Next alert',
			SCORE: 'Score',
			SEE_MORE: 'See More',
			SEE_LESS: 'See Less',
			CLASS: {
				FALSE_NO_ACTION: 'False – No Action',
				FALSE_DQ: 'False – DQ',
				VALID_NO_ACTION: 'Valid – No Action',
				CREATE_SERVICE: 'Valid – Create Service',
				HUMAN_REVIEW: 'SME Review',
				PENDING: 'Pending',
			},
			CLASS_OPTION: {
				FALSE_DQ: 'False – DQ (raised on bad data: instrument or data feed)',
				HUMAN_REVIEW: 'SME Review (Manual Assessment Required)',
				CREATE_SERVICE: 'Create Case (Start Investigation & Action)',
				VALID_NO_ACTION: 'Valid No Action (Close Event – No Service)',
				FALSE_NO_ACTION: 'False No Action (Close Event – No Service)',
			},
			STATUS: {
				ACKNOWLEDGED: 'Acknowledged',
				UNACKNOWLEDGED: 'Unacknowledged',
				DEFECT_RAISED: 'Pending – Defect Raised',
				UNACTIONED: 'Unactioned',
				APPROVED: 'Approved',
				RELEARNED: 'Relearned',
			},
			STATE: {
				ACTIVE: 'Active',
				RETURNED_TO_NORMAL: 'Returned to Normal',
			},
			TELEMETRY: {
				TITLE: 'Time Series',
				AVAILABLE: 'Available',
				MISSING: 'Missing',
				TIP_AVAILABLE: 'Historian readings for {{tag}} in the 24 h before the alert',
				TIP_NO_DATA: 'No historian readings for {{tag}} in the 24 h before the alert',
				TIP_NOT_IN_HISTORIAN: '{{tag}} is not in the historian',
				TIP_NO_TAG: 'The alert names no historian tag',
				UNUSABLE: 'Not usable',
				TIP_UNKNOWN: 'Availability could not be checked',
			},
			TAGX: {
				THIS_EQUIPMENT: 'This equipment',
				ALL_EQUIPMENT: 'All related equipment ({{count}})',
				FILTER: 'Filter',
				HISTORIAN_RESULTS: 'Historian search',
				MODE_FUNCTION: 'By function',
				MODE_RELATION: 'By relation',
				FILTER_MEASURE: 'Filter by what is measured',
				FILTER_GROUP: 'Filter by function group',
				CLEAR_FILTERS: 'Clear filters',
				SHOW_ALL: 'Show all ({{count}} more)',
				NO_MATCHES_FILTERED: 'No matches for the selected filters',
				TITLE: 'Display other tags',
				SEARCH_PLACEHOLDER: 'Search tags by name or description',
				MIN_CHARS: 'Type at least 2 characters',
				SEARCHING: 'Searching…',
				NO_MATCHES: 'No matching tags',
				HAS_DATA: 'Historian data available',
				NO_DATA: 'No historian data',
				SELECTED: '{{count}} / {{max}} selected',
				MAX_REACHED: 'At most {{max}} tags can be selected',
				CLEAR: 'Clear selection',
				CHART_TOGETHER: 'Chart together',
				HIDE_CHART: 'Hide chart',
				IN_LIST: 'In list',
				VIA: 'via {{via}}',
				GROUP_ALERT: 'Alert tag',
				GROUP_COMPONENT: 'Same component',
				GROUP_EQUIPMENT: 'Same package / equipment',
				GROUP_CONNECTED: 'Connected equipment',
				GROUP_PID: 'P&ID instruments',
				GROUP_OTHER: 'Other related',
				GROUP_SEARCH: 'Added from search',
				NO_TAGS: 'No related tags found',
				LOADING: 'Loading related tags…',
				FILTER_EMPTY: 'No related tags match "{{q}}"',
			},
			QUEUE: {
				DATE_FIELD: 'Filter by date field',
				DATE_FIELD_EVENT: 'Event Time',
				DATE_FIELD_RAISED: 'Raised',
				SORT_OLDEST: 'Oldest first (click to flip)',
				SORT_NEWEST: 'Newest first (click to flip)',
				PAGE_SIZE: 'Rows per page',
				RANGE: '{{start}}–{{end}} of {{total}}',
				FIRST_PAGE: 'First page',
				PREV_PAGE: 'Previous page',
				NEXT_PAGE: 'Next page',
				LAST_PAGE: 'Last page',
				GROUPED_PAGE_HINT: 'Groups are built from the alerts on this page',
				ON_THIS_PAGE: 'on this page',
				SIGNAL_START: 'Event start',
				RAISED: 'Created on',
				RETURNED_TO_NORMAL_AT: 'Last active (returned to normal)',
				BASELINE_REF: 'Baseline ref',
				BASELINE_REF_TIP: 'Detector baseline reference ({{time}}): the "last recorded on …" time quoted in the alert description. It is not the event time.',
				NOT_ANALYSED: 'Not analysed: {{reason}}',
				NOT_ON_PAGE: 'Recurring occurrence not on this page. Open it for details.',
				COLUMNS: 'Columns',
				RESET_COLUMNS: 'Show all columns',
				SET_STATUS: 'Set status of selected alerts',
				CSV: {
					PROCESS_UNIT: 'PROCESS_UNIT',
					FLOC: 'FLOC',
					POINTS: 'TAGS',
					DEFINITION_ID: 'DEFINITION_ID',
					NUMBER: '#',
					ALERT_ID: 'Alert ID',
					SYSTEM_NAME: 'System Name',
					SYSTEM: 'System',
					STATUS: 'Status',
					CLASSIFICATION: 'Classification',
					CONFIDENCE: 'Confidence',
					ALERT_NAME: 'Alert Name',
					SOURCE: 'Source',
					EVENT_TIME: 'Event Start (signal start)',
					RAISED: 'Created On',
					RETURNED_TO_NORMAL: 'Last Active (returned to normal)',
					BASELINE_REF: 'Baseline Ref',
					STATE: 'State',
					TIME_SERIES: 'Time Series',
					ANCHOR_TAG: 'Anchor Tag',
					NOT_ANALYSED: 'Not Analysed (DQ gate)',
					OWNER: 'Owner',
				},
				COLUMN_NUMBER: 'Number',
				SORT_BY_COLUMN: 'Sort by this column',
				DATE_ON_EVENT: 'Date range applies to Event Start',
				DATE_ON_CREATED: 'Date range applies to Created On (sorted column)',
				SHOW_COLUMNS: 'Show Columns',
				SEARCH_COLUMNS: 'Search...',
				SELECT_ALL_COLUMNS: 'Select All',
				RESET_DEFAULT_COLUMNS: 'Reset to Default',
				RESIZE_COLUMN: 'Drag to resize',
				STILL_ACTIVE: 'Still active',
			},
			GROUP_BY: {
				TITLE: 'Group by',
				EQUIPMENT: 'Equipment',
				NONE: 'None',
				SYSTEM: 'System',
				FACILITY: 'Facility',
				SOURCE: 'Source',
				CLASSIFICATION: 'Classification',
				ALERT_STATUS: 'Alert Status',
			},
			MENU: {
				EXPORT: 'Export Data',
				COLLAPSE_GROUPS: 'Collapse all grouped items',
				EXPAND_WITHIN_GROUP: 'Expand all items within group',
				AUTO_REFRESH: 'Auto Refresh',
			},
			AUTO_REFRESH: {
				OFF: 'Off',
				LIVE: 'Live',
				MIN_5: '5 minutes',
				MIN_15: '15 minutes',
				MIN_30: '30 minutes',
				HOUR_1: '1 hour',
			},
			FILTER: {
				TITLE: 'Filter by',
				SEARCH_ALERT_NAME: 'Search by alert name...',
				START_TYPING: 'Start typing to search',
				APPLY: 'Apply',
				CLEAR_ALL: 'Clear All',
				TARGET_ONLY: 'Target FLOCs only',
				TARGET_TIP: 'Only alerts on the target FLOCs listed in Asset Hierarchies → FLOC Hierarchy',
				TARGET_COUNT: '{{count}} alerts in the current view',
			},
			TABLE: {
				STEP: 'Step',
				STEP_HINT: 'The triage-path step that decided the alert (amber: held for SME review)',
				TYPE: 'Type',
				PLUS_TAGS: '+{{count}} tags',
				DEFINITION_ID: 'Definition ID',
				ALERTS: 'Alerts',
				N_ALERTS: '{{count}} alerts',
				SYSTEM_NAME: 'System Name',
				STATUS: 'Status',
				CLASSIFICATION: 'Classification',
				CONFIDENCE: 'Conf.',
				ALERT_NAME: 'Alert Name',
				SOURCE: 'Source',
				EVENT_TIME: 'Event Start',
				STATE: 'State',
				OWNER: 'Owner',
				EMPTY: 'No alerts match the current filters',
				RECURRING: 'Recurring: {{count}} occurrences in this episode',
				TOGGLE_RECURRING: 'Show recurring alerts',
				CREATED_ON: 'Created On',
				LAST_ACTIVE: 'Last Active',
			},
			BULK: {
				ITEMS: 'items',
				ASSIGN_OWNER: 'Assign owner to selected alerts',
				CHANGE_CLASSIFICATION: 'Change classification',
				DONE: '{{count}} alerts updated',
				PARTIAL: '{{ok}} alerts updated, {{failed}} could not be updated',
			},
			ACTIONS: {
				APPROVE: 'Approve',
				APPROVED: 'Approved',
				RELEARN: 'Relearn',
				RELEARNED: 'Relearned',
				CLASSIFY: 'Classify',
			},
			DETECTOR: {
				POINTS_FROM_SIGNAL_TEXT: 'Tags read from SignalMeasurementText',
				POINTS_FROM_DESCRIPTION: 'Tags read from the alert description',
				PRIMARY: 'primary',
				TAGS_TIP: 'Tags this alert is about ({{count}}):',
				TAGS_N: 'Tags ({{count}})',
				LABEL: 'Detector',
				MECHANISM: 'Detection Mechanism',
				MONITORED_TAG: 'Monitored Tag',
				CLUSTER_SIZE: 'Cluster Size',
				FREQUENCY: 'Frequency',
				WINDOW_SPAN: 'Window Span',
				N_ALERTS: '{{count}} Alerts',
				PER_HOUR: '{{value}} alerts/hr',
				HOURS: '{{value}} Hours',
			},
			DQ: {
				STATUS_UNUSABLE: 'Unusable',
				PENDING_DEFECT: 'Defect raised',
				PENDING_DEFECT_TIP: 'Instrument work order {{wo}}: pending',
				TITLE: 'Data Quality (DQ) Assessment',
				FROZEN: 'Flatline',
				IMPOSSIBLE_ROC: 'Rate of Change',
				DOMAIN_RANGE: 'Out of Range',
				JITTER: 'Erratic',
				PASS_FROZEN: 'Passed (Dynamic)',
				PASS_IMPOSSIBLE_ROC: 'Passed',
				PASS_DOMAIN_RANGE: 'Within Limits',
				PASS_JITTER: 'Normal Signal',
				FAIL_FROZEN: 'Frozen',
				FAIL_IMPOSSIBLE_ROC: 'Failed',
				FAIL_DOMAIN_RANGE: 'Out of Range',
				FAIL_JITTER: 'Erratic Signal',
				NOT_ASSESSED: 'Not assessed',
				STATUS_PASS: 'Passed',
				STATUS_WARN: 'Warning',
				STATUS_FAIL: 'Failed',
				STATUS_NO_DATA: 'No data',
				STATUS_UNKNOWN: 'Not assessed',
				NOT_ANALYSED: 'Not analysed',
				READINGS: '{{n}} readings · {{bad}} masked',
				CHECK_INFO: 'Informational',
				NO_GATE: 'Data quality has not been assessed for this alert',
				SCORE: 'DQ Score: {{status}}',
			},
			AGENT: {
				NO_RUN: 'Not triaged yet',
				TIER_ACCEPTED: 'Quick triage · accepted at {{pct}} ({{time}} · {{tokens}} tokens) — deep investigation not needed',
				TIER_QUICK_ONLY: 'Quick triage only · {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_ESCALATED: 'Escalated to deep investigation:',
				TIER_QUICK_WAS: 'Quick answer: {{cls}} {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_FINAL_IS: 'final: {{cls}} {{pct}}',
				MANUAL_CHIP: 'Manual · {{label}}',
				TITLE: 'Triage Agent',
				RECOMMENDATION: 'Recommendation',
				NOT_RUN: 'Triage agent has not been run for this alert yet. Click the Run Triage Agent button to auto-classify this alert.',
				NO_RECOMMENDATION: 'No recommendation recorded.',
				RUN: 'Run Triage Agent',
				RUNNING: 'Running…',
				RERUN: 'Re-run Triage Agent',
				CREATES_CASE: 'Creates case',
				CONFIDENCE: '{{value}} Confidence',
				CAPPED: 'capped',
				CAPPED_HINT: 'Confidence capped at {{value}} because some evidence checks could not run',
				VERIFIED_FACTS: 'Verified Facts & Telemetry',
				N_VERIFIED: '{{count}} verified',
				HYPOTHESIS: 'Working Hypothesis & Physical Mechanism (Why)',
				SUPPORTING_TAGS: 'Supporting tags',
				FMEA: 'Dynamic FMEA',
				FAILURE_MODE: 'Failure mode',
				MECHANISM: 'Physical mechanism',
				IMPACT: 'Systemic impact',
				REMEDIATION: 'Remediation',
				DISCIPLINE: 'Discipline',
				ACTIONABLE: 'Actionable Engineering Recommendations',
				WHAT_WOULD_CHANGE: 'What would change this',
				DECIDED_BY: 'Adjudicated by {{model}}',
				HARNESS_VERSION: 'harness {{v}}',
				STALE_RUN: "Stale: run before the {{date}} harness update; re-run to see the current agent",
				DEGRADED: 'Rule fallback',
				DEGRADED_HINT: 'The adjudicator LLM was unavailable; this disposition came from deterministic rules. Review before approving.',
			},
			DIALOG: {
				APPROVE_TITLE: 'Approve classification',
				APPROVING: 'You agree with the agent: {{x}}',
				FEEDBACK_OPTIONAL: 'Optional: anything the agent should learn from this case',
				CORRECT_FINDING: 'Correct finding',
				SELECT_FINDING: 'Select the finding…',
				MAPS_TO: 'Shown to the customer as: {{x}} (mapping in force)',
				PROPOSE_TOGGLE: 'The finding “{{x}}” is right; the customer label should be different',
				PROPOSE_HELP: 'The alert keeps its finding. An administrator sees the proposal in Settings › Labels; a mapping change relabels every alert with this finding.',
				WANTED_LABEL: 'Label the customer expects',
				PROPOSED: 'Mapping change proposed to the administrators',
				RELEARN_TITLE: 'Relearn Classification',
				CLASSIFY_TITLE: 'Classify',
				CORRECT_CLASSIFICATION: 'Correct Classification',
				SELECT_CLASS: 'Select new classification category...',
				FEEDBACK: 'Feedback',
				FEEDBACK_REQUIRED: 'Required for revision',
				CANCEL: 'Cancel',
				CONFIRM: 'Confirm',
			},
			EVIDENCE: {
				GROUP: {
					SERIES: 'Time series',
					RECORDS: 'Plant records',
				},
				ALL_TAGS: 'All tags',
				ON_DRAWING: 'Picked on the drawing:',
				CONTEXT_GRAPH: 'Context graph',
				SEARCH_REPORTS: 'Search the reports (any word in any section)',
				SEARCH_MATCHES: '{{n}} report(s) match',
				CITED_HERE: 'cited',
				AXES_UNIT: 'Axis per unit',
				AXES_TAG: 'Axis per tag',
				AXES_HINT: 'Overlay y-axes: share one axis per unit, or give every tag its own',
				SOURCE_ALERT: 'Source Alert',
				SOURCE_ALERT_FROM: 'Source alert · {{source}}',
				SYSTEM_DETAILS: 'System Details',
				REASONING_NOT_IN_RUN: 'Not recorded in this run (runs from before this section existed).',
				DROP_TAGS_HINT: 'Drag tags from the Display Tags panel to add charts',
				TAGS: 'Tags',
				MAINTENANCE: 'Maintenance',
				REPORTS: 'Reports',
				ALERTS: 'Alerts',
				DOCUMENTS: 'Documents',
				REASONING: 'Reasoning',
				REASONING_SECTION: {
					DECISION: 'Decision',
					BOARD: 'Hypothesis board',
					EVIDENCE: 'Evidence used',
					MEMORY: 'Learnings used',
					LIBRARY: 'Library',
					LIMITS: 'Limits',
					REASONING: 'Reasoning',
					PLAYBOOK: 'Playbook checks',
					SIGNAL: 'Signal & machine',
					CONNECTED: 'Connected systems',
					ANOMALY: 'Anomaly model',
					RECORDS: 'Records read',
				},
				NO_TELEMETRY: 'No historian data for these tags',
				NO_TELEMETRY_HINT: 'The historian does not cover the alert window for the evidence tags.',
				NO_DATA_FOR: 'No historian data for',
				NOTIFICATIONS: 'Notifications',
				NOTIFICATION: 'Notification',
				WORK_ORDERS: 'Work Orders',
				WORK_ORDER: 'Work Order',
				NONE: 'None on record',
				ON_THIS_ITEM: 'On this item',
				DESCRIPTION: 'Description',
				NOTIFICATION_NO: 'Notification #',
				TYPE: 'Type',
				PRIORITY: 'Priority',
				RAISED_ON: 'Raised On',
				COMPLETED_ON: 'Completed On',
				FLOC: 'Functional Location',
				HIERARCHY_TIER: 'Hierarchy Tier',
				SUPERVISOR_REPORTS: 'Supervisor Reports',
				SHIFT_LOGS: 'Shift Logs',
				RECENT_ALERTS: 'Recent Alerts',
				RELATED_ALERTS: 'Related Alerts',
				FIRED_AT: 'Fired at',
				CONTEXT: 'Context',
				SHOW_AFTER_ALERT: 'Show records after the alert',
				HINDSIGHT_HINT: 'Off: only what was on record when the alert was raised, as the agent saw it. On: also records created afterwards.',
				HINDSIGHT_ON: 'Hindsight on: records created after the alert are shown and marked "After alert". The agent did not see them.',
				AFTER_ALERT: 'After alert',
				HIDDEN_AFTER_ALERT: '{{n}} recorded after the alert hidden',
				NONE_AT_ALERT: 'None on record at the alert time',
				NOT_ANALYSED: 'Not analysed',
				NO_TIME_SERIES: 'No time series: {{reason}}',
				TELEMETRY_NO_DATA: 'the historian holds no readings for the alert tag in the 24 h before the alert',
				TELEMETRY_NOT_IN_HISTORIAN: 'the alert tag is not in the historian',
				TELEMETRY_NO_TAG: 'the alert has no monitored tag',
				TELEMETRY_UNKNOWN: 'historian availability is unknown',
				ADD_TAGS: 'Add tags',
				HIDE_TAG_LIST: 'Hide tag list',
				INCLUDE_BASELINE: 'Include baseline reference',
				ALERT_WINDOW: 'Alert window',
				BASELINE_REF_AT: 'Detector baseline reference: {{at}}',
				CHARTED_TOGETHER: 'Tags charted together',
				NO_TAGS_CHARTED: 'No tags charted',
				NO_TAGS_CHARTED_HINT: 'Search or pick related tags in the tag list to chart them.',
				TAG_LOAD_FAILED: 'Could not load this tag',
				OVERLAY: 'Overlay – actual values, one y-axis per unit',
				OVERLAY_NORMALISED: 'All tags on one axis (z-score, units differ)',
				STATUS_AT_ALERT: 'Status at alert',
				STATUS_NOW: 'now',
				OPEN_AT_ALERT: 'Open at alert',
				CLOSED_AT_ALERT: 'Closed at alert',
				NOT_RAISED_AT_ALERT: 'Not raised at alert',
				SCOPE_ITEM: 'This item',
				SCOPE_PARENT: 'Parent',
				BREAKDOWN: 'Breakdown',
				NUMBER: 'Number',
				EQUIPMENT: 'Equipment',
				REPORTED_BY: 'Reported by',
				PLANNING_GROUP: 'Planning group',
				WORK_CENTER: 'Work center',
				SYMPTOM: 'Symptom',
				CREATED_ON: 'Created on',
				SCHEDULED_START: 'Scheduled start',
				SCHEDULED_FINISH: 'Scheduled finish',
				ESTIMATED_DURATION: 'Estimated duration',
				HOURS_N: '{{n}} h',
				COST_ESTIMATE: 'Cost estimate',
				KNOWN_AT: 'On record since',
				LONG_TEXT: 'Details',
				STATUS_HISTORY: 'Status history',
				PRODUCTION_REPORTS: 'Production Reports',
				DEFERMENT_REPORTS: 'Deferment Reports',
				SUPERVISOR_REPORT: 'Supervisor report',
				PRODUCTION_REPORT: 'Daily production report',
				DEFERMENT_REPORT: 'Deferment report',
				FULL_SCREEN: 'Full Screen',
				EXIT_FULL_SCREEN: 'Exit Full Screen',
				BACK_TO_DOCUMENTS: 'Back to Documents',
				DOWNLOAD: 'Download',
				HSSE: 'HSSE',
				PRODUCTION: 'Production',
				HSSE_GRADE: 'HSSE grade',
				PRODUCTION_GRADE: 'Production grade',
				REPORT_DATE: 'Report date',
				SOURCE_FILE: 'Source file',
				SUMMARY: 'Summary',
				PRODUCTION_COMMENT: 'Production comment',
				SUPERVISOR_COMMENTS: 'Supervisor comments',
				ACTIVITIES: 'Activities',
				FORECAST: 'Forecast / look-ahead',
				ALARMS: 'Alarms',
				DEFERMENT: 'Deferment',
				OOS: 'Out-of-service equipment',
				IOW: 'DOW / IOW exceedances',
				MOCS: 'Temporary MOCs',
				NO_REPORT_TEXT: 'No report text',
				CATEGORY: 'Category',
				MAIN_CAUSE: 'Main cause',
				SUB_CAUSE: 'Sub cause',
				EQUIPMENT_SYSTEM: 'Equipment system',
				EQUIPMENT_TYPE: 'Equipment type',
				EVENT_START: 'Event start',
				EVENT_END: 'Event end',
				ENDED_BEFORE_ALERT: 'Ended before alert',
				ONGOING_AT_ALERT: 'Ongoing at alert',
				RECENT_ALERTS_HINT: 'on this tag / functional location',
				RELATED_ALERTS_HINT: 'within ±60 min, same system first',
				SUB_ALERTS: 'Episode sub-alerts',
				SUB_ALERTS_HINT: 'grouped into this episode',
				SAME_SYSTEM: 'Same system',
				OPEN_ALERT: 'Open this alert',
				NO_DOCUMENTS: 'No documents linked to this equipment',
				PID: 'P&ID',
				PAGES_N: '{{n}} pages',
				UPDATED: 'Updated',
				SOURCE: 'Source',
				REVISION: 'Revision',
				DOCUMENT_TYPE: 'Document type',
				DOCUMENT_PREVIEW: 'Document preview',
				FILE_NAME: 'File name',
				PREVIEW_UNAVAILABLE: 'Preview not available',
				PREVIEW_UNAVAILABLE_HINT: 'The file for this document is not in the document store.',
				SHOWING_ALL_WO: 'Showing all {{shown}} of {{total}} work orders & notifications',
				SHOWING_EVIDENCE_WO: 'Showing {{shown}} condition-evidence records (of {{total}} total)',
				SHOW_ALL_EQUIPMENT_WO: 'Show all work orders for {{equipment}}',
				CITED_IN_PATH: 'Cited',
				LINKED_WO: 'Linked WO',
				ROOT_CAUSE: 'Root Cause',
				AGENT_READ_SUMMARY: 'In its latest run the agent read {{read}} supervisor reports and cited {{cited}} — read the cited ones first.',
				ONLY_AGENT_READ: 'Only reports the agent read',
				AGENT_CITED: 'Agent cited · {{relevance}}',
				AGENT_READ: 'Agent read · not cited',
			},
			CHART: {
				JUDGED_AT: 'Judged at (raised later)',
				NO_DATA: 'No data in the historian',
				SEPARATE: 'Separate',
				OVERLAY: 'Overlay',
				SEPARATE_HINT: 'One panel per tag, sharing the time axis',
				OVERLAY_HINT: 'All tags on one panel, one y-axis per unit',
				ALL_READINGS: '*All good readings in the window',
				INSTRUMENT_RANGE: 'Instrument range',
				MEDIAN: 'Median',
				STEADY_ONLY: '*Steady running only (shutdown and start-up excluded)',
				THRESHOLD_LIMIT: 'Threshold limit',
				TRIP_LIMIT: 'Trip limit',
				LIMIT_TRIP: 'Trip',
				LIMIT_ALARM: 'Alarm',
				LIMIT_THRESHOLD: 'Threshold',
				LIMIT_INSTRUMENT: 'Instrument',
				LIMIT: 'limit',
				LIMIT_NONE: 'No value loaded for this tag',
				TAG_LEGEND: 'Tag legend',
				MASKED_HIDDEN: '{{count}} masked readings (data quality) left out of the plot',
				NO_UNIT: 'No unit',
				HIGH: 'High',
				LOW: 'Low',
				AVERAGE: 'Average',
				ACTUAL: 'Actual',
				BASELINE: 'Baseline',
				SIGNAL_START: 'Signal start',
				RAISED: 'Raised',
				RTN: 'Last Active',
				BASELINE_REF: 'Baseline ref.',
				NORMAL_MIN: 'Normal min',
				NORMAL_MAX: 'Normal max',
				MASKED: 'Masked readings (DQ)',
				MASKED_HOVER: 'Masked reading',
				ARTEFACT: 'Feed substitution / data artefact',
				ARTEFACT_HOVER: 'Data artefact (not a process reading)',
				TIME_AXIS: 'Time ({{zone}})',
				OFF_SCALE: 'off-scale',
				MIN: 'min',
				MAX: 'max',
				RANGE_BAND: 'Min–max',
				LOADING: 'Loading data…',
				LOAD_ERROR: 'Could not load data for this range',
				NO_DATA_IN_WINDOW: 'No readings in this window',
				HISTORIAN_SPAN: 'Historian holds data from {{first}} to {{last}}',
				CLOSE: 'Close chart',
				ZOOM_HINT: 'Drag to zoom or pan — more data loads automatically. Double-click to reset.',
				LAYOUT_STACKED: 'Stacked',
				LAYOUT_OVERLAY: 'Overlay',
				NORM_NONE: 'Raw values',
				NORM_ZSCORE: 'Z-score',
				NORM_RANGE: '% of range',
				NORMALISED_Z: 'z-score (σ)',
				NORMALISED_PCT: '% of range',
				REMOVE_TAG: 'Remove tag',
				NO_TAGS: 'Select tags to chart together',
				TOGETHER_TITLE: 'Tags charted together',
			},
			DETAIL: {
				CHANGE_STATUS: 'Change status',
				ACK_HINT: 'Approve the current classification',
				REOPEN_HINT: 'Undo the last decision',
				REOPENED: 'Alert reopened',
				TARGET_FLOC: 'Target FLOC',
				OPEN_ALERT: 'Open Alert',
				BACK_TO_QUEUE: 'Back to alerts',
				ALERT_ANALYSIS: 'Alert Analysis',
				EVIDENCE: 'Evidence',
				EVENT_TIME: 'Event time',
				EVENT_TIME_HINT: 'When the signal started (the excursion began)',
				RAISED: 'Raised',
				RAISED_HINT: 'When the surveillance system created the alert. The agent only uses what was known by then.',
				RTN: 'Returned to normal',
				BASELINE_REF: 'Baseline ref',
				BASELINE_REF_HINT: 'The detector\'s reference time (when its baseline was last recorded), not the event time',
				CLASSIFICATION_HINT: 'Current classification. Pick another class to classify or relearn this alert.',
				CHANGE_CLASS: 'Change classification',
				CURRENT_CLASS: 'Current classification: {{value}}',
				PREVIOUSLY_APPROVED: 'Previously Approved',
				PREVIOUSLY_RELEARNED: 'Previously Relearned',
				HUMAN_REVIEW_REQUIRED: 'SME Review — manual assessment required',
				NOT_CLASSIFIED: 'Not classified yet',
				AGENT_PROPOSED: 'Proposed by the Triage Agent',
				NOT_ANALYSED_HINT: 'The Triage Agent does not analyse this alert: its data did not pass the pre-alert checks. Classify it manually if needed.',
				NOT_ANALYSED_REASON: 'Not analysed: {{reason}}',
				RUN_BLOCKED: 'Not analysable',
				RUN_BLOCKED_WHY: 'Won\'t analyse: {{reason}}',
				RUN_GATED: 'Not analysed',
				EVENT_START: 'Event Start',
				CREATED_ON: 'Created On',
				LAST_ACTIVE: 'Last Active',
				LAST_ACTIVE_HINT: 'When the alert returned to normal (last active); "Active" while it is still active',
			},
			CASE: {
				CHIP: 'Case #{{id}}',
				CREATE: 'Create Service',
				MANAGE_HINT: 'Create a case to manage follow-ups',
				CREATED: 'Case #{{id}} created',
				EXISTS: 'Case #{{id}} is already linked to this alert',
				CREATE_FAILED: 'Could not create the case',
				BULK_CREATED: '{{count}} case(s) created.',
			},
			RAIL: {
				LIMITS: 'Limits',
				ACTIVITY: 'Activity logs',
				DISCUSSION: 'Discussion',
				TRACES: 'Traces',
				PREFERENCES: 'Preferences',
				ANALYSIS: 'Analysis & Views',
				OTHER_TAGS: 'Display Tags',
				OTHER_TAGS_HINT: 'Click a tag, or drag it onto the charts, to add it to the Tags tab.',
				DOCUMENTS: 'Documents',
				NO_DOCUMENTS: 'No documents linked to this alert',
				NO_DOCUMENTS_HINT: 'No manuals, P&IDs or reports reference this equipment.',
				OPEN_IN_DOCUMENTS: 'Show in the Documents tab',
				REVISION: 'Rev {{value}}',
				PID: 'P&ID',
				EXPORT_TAGS: 'Export Selected Tags to External System',
				SAVED_ANALYSIS: 'Saved Analysis',
				SAVED_VIEWS: 'Saved Views',
				SAVED_DASHBOARDS: 'Saved Dashboards',
				NOT_AVAILABLE: 'Not yet available for triage alerts',
				PREFERENCES_NOTE: 'Shutdown region shading and trip / alarm / threshold lines are not available for triage charts yet.',
			},
			ACTIVITY: {
				N_ACTIONS: 'Actions ({{count}})',
				EMPTY: 'No activity yet',
			},
			DISCUSSION: {
				N_COMMENTS: 'Comments ({{count}})',
				EMPTY: 'No comments yet',
				PLACEHOLDER: 'Write a comment...',
				REPLY: 'Reply',
				REPLY_PLACEHOLDER: 'Write a reply...',
				SEND: 'Send',
			},
			TRACE: {
				SEARCH: 'Search the trace (agent, finding, record id…)',
				SEARCH_MATCHES: '{{n}} agent(s) match',
				TMP_NOT_APPLIED: 'TMP row filed under {{component}}, not applied',
				TITLE: 'Agent Pipeline Trace',
				EXPAND_ALL: 'Expand All',
				COLLAPSE_ALL: 'Collapse All',
				COMPLETED: 'Completed',
				FAILED: 'Failed',
				N_AGENTS: '{{count}} Agents',
				NO_RUN: 'No pipeline run yet',
				NO_RUN_HINT: 'Run the Triage Agent to see the step-by-step trace of all 14 agents.',
				STATUS_COMPLETED: 'Completed',
				STATUS_NO_DATA: 'No data available',
				STATUS_FAILED: 'Failed',
				STATUS_SKIPPED: 'Skipped',
				TOKENS: 'LLM tokens: {{input}} in / {{output}} out',
			},
			ERRORS: {
				LOAD: 'Could not load triage data',
				ACTION: 'The action could not be completed',
				RUN_FAILED: 'The Triage Agent run failed',
			},
			TIMELINE: {
				TITLE: 'Event timeline',
				N_EVENTS: '{{n}} events',
				RELATED_ALERTS: 'Recent & related alerts',
				RANGE_ALL: 'All',
				RANGE_90D: '90 d',
				RANGE_30D: '30 d',
				RANGE_7D: '7 d',
				RANGE_1D: '24 h',
				RESET_ZOOM: 'Reset zoom',
				ZOOM_IN: 'Zoom in',
				N_MORE: '+{{n}} more',
				EMPTY: 'No work orders, notifications, reports or deferments on record for this alert.',
				CLICK_TO_OPEN: 'Click to open it below',
				MINUTES: '{{n}} min',
				HOURS: '{{n}} h',
				DAYS: '{{n}} days',
				N_ALERTS_IN: '{{n}} alerts within {{span}}',
				N_EVENTS_IN: '{{n}} events within {{span}}',
				KIND_SELF: 'This alert',
				KIND_ALERT: 'Alert',
				KIND_WORK_ORDER: 'Work order',
				KIND_NOTIFICATION: 'Notification',
				KIND_SUPERVISOR: 'Supervisor report',
				KIND_PRODUCTION: 'Production report',
				KIND_DEFERMENT: 'Deferment',
			},
			CANCEL: 'Cancel',
			SAVE: 'Save',
			PATH: {
				CITE_HINT: 'Open this record on the right',
				LAST_RECORDED: 'Detector: last recorded',
				LAST_RECORDED_TIP: 'The time the detector states in its text ("last recorded on …"); its meaning depends on the detector.',
				PLAIN_PENDING: 'A plain-language explanation is being written; reopen in a moment.',
				WHY: 'Why',
				STEP: 'Decided at',
				SHOW_DATA: 'Show data',
				HIDE_DATA: 'Hide data',
				DATA: 'Data',
				DETECTOR_CROSSED: 'crossed: why the alert fired',
				DETECTOR_OWN: 'the detector\'s rule',
				DETECTOR_OWN_TIP: 'The detector\'s own threshold. Crossing it is what raised the alert, so it is not evidence for a service; only an independent engineering limit is.',
				AGENT_DECIDED: 'agent decided',
				AGENT_DECISION: 'Agent decision',
				BASELINE: 'Baseline',
				CHECK: {
					FROZEN: 'Frozen',
					IMPOSSIBLE_ROC: 'Spikes',
					DOMAIN_RANGE: 'Out of range / codes',
					JITTER: 'Jitter',
					NODE_SUBSTITUTION: 'Feed substitution',
					TRIGGER_READINGS: 'Trigger readings',
				},
				CLEAR: 'clear',
				CONF_HIGH: 'High',
				CONF_LOW: 'Low',
				CONF_MEDIUM: 'Medium',
				DECIDED_AT: 'Decided at step {{n}} · {{title}}',
				DELAY: 'Delay',
				DISAGREE: 'The first check that matched (step {{n}}) points to {{outcome}}; the agent chose {{agent}}.',
				DISAGREE_SHORT: 'differs from path',
				DISAGREE_SHORT_TIP: 'The first matching check (step {{n}}) gives another class than the agent chose',
				DQ_ROUTE_FEED: 'Route: data-feed issue for the PI / historian owner (no work order)',
				DQ_ROUTE_INSTRUMENT: 'Route: instrument work order (I&E)',
				EXPORT_PDF: 'Export as PDF',
				FIRST_MATCH_AT: 'First match at step {{n}} · {{title}}',
				HELD_AT: 'Held at step {{n}} · {{title}}',
				JUSTIFICATION_STEP: 'Agent justification · step {{n}}',
				LIMIT: 'Limit',
				LINK_CLOSE: 'Valid – No Action (link)',
				MACHINE_SENSORS: 'Sensors on the machine',
				MATCHED: 'matched',
				NEAR: 'near',
				NONE: 'none',
				NOT_RUNNING: 'Not running steadily:',
				NO_FINDING: 'No finding recorded for this check',
				NO_LIMITS: 'No engineering limit is known for this tag',
				PEAK_24H: '24 h peak',
				PILL_ABNORMAL: 'Abnormal → continue',
				PILL_DECIDED: 'Decided',
				PILL_HELD: 'Held: not enough evidence',
				PILL_MATCHED: 'Matched',
				PILL_NOT_REACHED: 'Not reached',
				PILL_NO_MATCH: 'No match → continue',
				PROCESS_TOPOLOGY: 'Process topology',
				REACHED: 'reached',
				RECOMMENDATIONS: 'Recommendations ({{n}})',
				REPLAY_NO: 'Rule did not reproduce on raw data',
				REPLAY_YES: 'Rule reproduced on raw data',
				RULE: 'Rule',
				RUN_AT: 'Run {{at}}',
				RUN_INDICATOR: 'Run indicator',
				SELECT_SENSOR: 'select a sensor to chart it',
				SME_INTERNAL: 'SME / HIL label (internal, validation only; never an agent input)',
				STEP_AGREE: 'This check is right',
				STEP_DISAGREE: 'This check is wrong',
				STEP_EVIDENCE: '{{tags}} tags, {{records}} records, {{docs}} docs',
				SUBTITLE: '{{n}} checks · select a step',
				TITLE: 'Triage path',
				TRUST: 'Status',
				UNTRUSTED: 'not trusted',
				VALUE: 'Value',
				DECISION_TITLE: 'Decision',
				RCA_TITLE: 'Decision & Triage Path',
				RCA_PANE_TITLE: 'Decision & Triage Path',
				PROPOSED_EVIDENCE_TITLE: 'Proposed Evidence',
				MINI_TITLE: '8-Step Triage Path',
				JUSTIFICATION: 'Justification',
				ORDERED_TITLE: 'Ordered 8-Step Triage Path',
				ORDERED_SUBTITLE: '7 checks in order — the first check that matches decides the outcome',
				STEP_PASSED: 'Passed',
				STEP_NOT_REACHED: 'Not Reached',
				RULE_FLAGGED: 'Rule Flagged for Tuning',
				RULE_FLAGGED_NOTICE: 'Alert approved & detector rule flagged for tuning',
				FLAG_RULE_CTA: 'Close & Flag Rule for Tuning',
				CREATE_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_TITLE: 'Create Instrument Work Order (Data Quality Policy)',
				INSTRUMENT_WO_POLICY: 'Routed to I&E Discipline',
				INSTRUMENT_TAG: 'Instrument Tag',
				DEFECT_DESCRIPTION: 'Defect Description',
				SUBMIT_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_CREATED: 'Instrument Work Order {{id}} raised — Status moved to Pending – Defect Raised',
				ROOTY: 'Rooty',
				ROOTY_HINT: 'Ask Rooty or open discussion on this alert',
				ASK_ROOTY_STEP: 'Ask Rooty about this step',
				STEP_COMMENT: 'Comment on this step',
				STEP_COMMENT_PLACEHOLDER: 'Add a note on this triage step…',
				PLOT_TAG_HINT: 'Plot this tag in Proposed Evidence',
				PLOT_ALL_STEP_TAGS: 'Plot all {{count}} step tags',
				OPEN_WO_HINT: 'Open this Work Order in the Work Orders tab',
				OPEN_ALERT_EVIDENCE_HINT: 'Open this alert in the Alerts tab',
				STEP3_VISUAL_TITLE: 'Machine Diagram & Operating State',
				STEP3_VISUAL_HINT: 'Click any sensor to plot it on the right',
				STEP4_VISUAL_TITLE: 'P&ID Process Flow & Event Timeline',
				STEP4_VISUAL_HINT: 'Driver and response tags are plotted on the right',
				STEP5_VISUAL_TITLE: 'Event Timeline — Cited Work Orders & Open Alerts',
				STEP5_VISUAL_HINT: 'Click a marker or chip to inspect the Work Order or Alert on the right',
				DEEP_DETAILS: 'Deep RCA Details (Verified Facts, Hypotheses & FMEA)',
			},
		},
	}
};
